import * as i0 from '@angular/core';
import { Injectable, Input, Component, NgModule, ChangeDetectionStrategy, PLATFORM_ID, Inject, Directive, EventEmitter, Output, forwardRef, InjectionToken, inject, ViewChild, ContentChild } from '@angular/core';
import { TeacherStatusEnum, nativeSpokenLevel, SubjectCategoryEnum, CurrencyEnum, currencies, PlanPeriodEnum, BillingOperationStatusEnum, BillingPlan, CCurrencyAmount, Parser, AccountBalanceTypeEnum, TenantEnum, MeetingBeginEnum, MeetingTypeEnum, BillingMeetingChargingEnum, MeetingAccessEnum, FeatureEnum, Classroom, Meeting, ESchoolParticipantRole, UserRoleEnum, SubjectLevel, otherSubjectLevelId, CPriceTier, Currency, NoticeTypeEnum } from 'lingo2-models';
import { debounceTime, first, takeUntil, take, map, distinctUntilChanged, tap as tap$1, filter, catchError, mergeAll, switchMap } from 'rxjs/operators';
import * as i2 from '@angular/common';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as i3 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { animation, style, animate, trigger, transition, useAnimation } from '@angular/animations';
import * as i1 from 'ngx-device-detector';
import { BehaviorSubject, Subject, timer, interval, ReplaySubject, fromEvent, Subscription, debounceTime as debounceTime$1, takeUntil as takeUntil$1, tap, first as first$1, combineLatest, map as map$1, zip, throwError, of, filter as filter$1, mergeMap, forkJoin, catchError as catchError$1 } from 'rxjs';
import * as i4 from '@angular/forms';
import { FormsModule, UntypedFormGroup, UntypedFormArray, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators, ControlContainer } from '@angular/forms';
import * as i3$1 from 'ng-click-outside';
import { ClickOutsideModule } from 'ng-click-outside';
import { addMilliseconds, format, differenceInHours, startOfDay, addMonths, addMinutes, startOfHour, parseISO, addHours, addSeconds } from 'date-fns';
import * as i16 from 'onclass-ui';
import { OnUiTextareaModule, OnUiButtonModule, OnUiReceiptModule, OnUiCoverModule, OnUiCheckboxModule, OnUiCardMenuModule, OnUiPopoverModule, OnUiSelectModule, OnUiInputModule, OnUiDateModule } from 'onclass-ui';
import * as i6 from 'lingo2-ngx-date-fns';
import { DateFnsModule, FormatPipeModule, FormatPipe } from 'lingo2-ngx-date-fns';
import * as i1$2 from '@angular/router';
import { RouterModule } from '@angular/router';
import { assign, pick, isEqual } from 'lodash-es';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import * as i1$1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { BillingCorePaymentStatusEnum } from '@lingo2-billing-sdk/models/src/billing-core/billing-core-payment/types/enums/billing-core-payment-status.enum';
import * as i3$2 from '@angular/platform-browser';
import { BillingCoreChargeStatusEnum } from '@lingo2-billing-sdk/models/src/billing-core/billing-core-charge/types/enums/billing-core-charge-status.enum';
import * as i2$1 from '@ngrx/store';
import { utcToZonedTime, getTimezoneOffset } from 'date-fns-tz';
import * as i7 from '@angular/material/core';
import * as i8 from '@le2xx/ngx-drag-scroll';
import { DragScrollComponent, DragScrollItemDirective } from '@le2xx/ngx-drag-scroll';
import 'reflect-metadata';
const _c0 = ["*"];
function FormFieldComponent_div_5_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Minimum ", ctx_r0.control.errors.min.min, "");
  }
}
function FormFieldComponent_div_5_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Maximum ", ctx_r0.control.errors.max.max, "");
  }
}
function FormFieldComponent_div_5_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "This field is required");
    i0.ɵɵelementEnd();
  }
}
function FormFieldComponent_div_5_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "This field is required");
    i0.ɵɵelementEnd();
  }
}
function FormFieldComponent_div_5_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("At least ", ctx_r0.control.errors.minlength.requiredLength, " characters");
  }
}
function FormFieldComponent_div_5_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("No more than ", ctx_r0.control.errors.maxlength.requiredLength, " characters");
  }
}
function FormFieldComponent_div_5_span_8_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.patternError);
  }
}
function FormFieldComponent_div_5_span_8_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Pattern does not match");
    i0.ɵɵelementEnd();
  }
}
function FormFieldComponent_div_5_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, FormFieldComponent_div_5_span_8_span_1_Template, 2, 1, "span", 8)(2, FormFieldComponent_div_5_span_8_span_2_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.patternError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.patternError);
  }
}
function FormFieldComponent_div_5_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.control.errors[ctx_r0.errorKey].text), " ");
  }
}
function FormFieldComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementContainerStart(1, 5);
    i0.ɵɵtemplate(2, FormFieldComponent_div_5_span_2_Template, 2, 1, "span", 6)(3, FormFieldComponent_div_5_span_3_Template, 2, 1, "span", 6)(4, FormFieldComponent_div_5_span_4_Template, 2, 0, "span", 6)(5, FormFieldComponent_div_5_span_5_Template, 2, 0, "span", 6)(6, FormFieldComponent_div_5_span_6_Template, 2, 1, "span", 6)(7, FormFieldComponent_div_5_span_7_Template, 2, 1, "span", 6)(8, FormFieldComponent_div_5_span_8_Template, 3, 2, "span", 6)(9, FormFieldComponent_div_5_span_9_Template, 3, 3, "span", 7);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@error", undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r0.errorKey);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "min");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "max");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "required");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "requiredTrue");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "minlength");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "maxlength");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "pattern");
  }
}
function SubjectSelectorComponent_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.langType(ctx_r1.selectedSubject)));
  }
}
function SubjectSelectorComponent_ng_template_13_ng_template_0_li_3_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filtered_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.langType(filtered_r4)));
  }
}
function SubjectSelectorComponent_ng_template_13_ng_template_0_li_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 18);
    i0.ɵɵlistener("click", function SubjectSelectorComponent_ng_template_13_ng_template_0_li_3_Template_li_click_0_listener($event) {
      const filtered_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSelectSubject($event, filtered_r4));
    });
    i0.ɵɵelementStart(1, "span", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SubjectSelectorComponent_ng_template_13_ng_template_0_li_3_span_3_Template, 3, 3, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filtered_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(filtered_r4.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.langType(filtered_r4));
  }
}
function SubjectSelectorComponent_ng_template_13_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "ul", 16);
    i0.ɵɵtemplate(3, SubjectSelectorComponent_ng_template_13_ng_template_0_li_3_Template, 4, 2, "li", 17);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.filteredSubjects)("ngForTrackBy", ctx_r1.trackByFn);
  }
}
function SubjectSelectorComponent_ng_template_13_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "span", 21);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "lingo2-forms.subject-selector.not-subject"));
  }
}
function SubjectSelectorComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SubjectSelectorComponent_ng_template_13_ng_template_0_Template, 4, 2, "ng-template", 12)(1, SubjectSelectorComponent_ng_template_13_ng_template_1_Template, 4, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const newSubjects_r5 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.filteredSubjects.length)("ngIfElse", newSubjects_r5);
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_0_li_5_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const recent_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.langType(recent_r7)));
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_0_li_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 30);
    i0.ɵɵlistener("click", function SubjectSelectorComponent_ng_template_14_ng_template_0_li_5_Template_li_click_0_listener($event) {
      const recent_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSelectSubject($event, recent_r7));
    });
    i0.ɵɵelementStart(1, "span", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SubjectSelectorComponent_ng_template_14_ng_template_0_li_5_span_3_Template, 3, 3, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const recent_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(recent_r7.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.langType(recent_r7));
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "span", 26);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ul", 27);
    i0.ɵɵtemplate(5, SubjectSelectorComponent_ng_template_14_ng_template_0_li_5_Template, 4, 2, "li", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "hr", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "lingo2-forms.subject-selector.recent-title"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.subjects["recent"])("ngForTrackBy", ctx_r1.trackByFn);
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_2__svg_svg_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 35);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("subject-select-arrow"), null, "xlink");
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_8_li_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 40);
    i0.ɵɵlistener("click", function SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_8_li_0_Template_li_click_0_listener($event) {
      const subjectLvl2_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onSelectSubject($event, subjectLvl2_r13));
    });
    i0.ɵɵelementStart(1, "span", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const subjectLvl2_r13 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(subjectLvl2_r13.title);
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_8_li_0_Template, 3, 1, "li", 39);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.subjects["user"])("ngForTrackBy", ctx_r1.trackByFn);
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_9_li_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 40);
    i0.ɵɵlistener("click", function SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_9_li_0_Template_li_click_0_listener($event) {
      const subjectLvl2_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onSelectSubject($event, subjectLvl2_r15));
    });
    i0.ɵɵelementStart(1, "span", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const subjectLvl2_r15 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(subjectLvl2_r15.title);
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_9_li_0_Template, 3, 1, "li", 39);
  }
  if (rf & 2) {
    const subjectLvl1_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.subjects[subjectLvl1_r10.name])("ngForTrackBy", ctx_r1.trackByFn);
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 15)(2, "ul", 37)(3, "p", 38);
    i0.ɵɵlistener("click", function SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_Template_p_click_3_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.optionsExpandedLvl2 = null);
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 35);
    i0.ɵɵelement(5, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_8_Template, 1, 2, "ng-template", 12)(9, SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_ng_template_9_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const rest_r16 = i0.ɵɵreference(10);
    const ctx_r16 = i0.ɵɵnextContext();
    const subjectLvl1_r10 = ctx_r16.$implicit;
    const i_r9 = ctx_r16.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("expand", ctx_r1.optionsExpandedLvl2 === i_r9);
    i0.ɵɵadvance(5);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("subject-select-arrow"), null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, subjectLvl1_r10.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", subjectLvl1_r10.name === "other")("ngIfElse", rest_r16);
  }
}
function SubjectSelectorComponent_ng_template_14_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 32);
    i0.ɵɵlistener("mouseover", function SubjectSelectorComponent_ng_template_14_ng_template_2_Template_li_mouseover_0_listener() {
      const i_r9 = i0.ɵɵrestoreView(_r8).index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.optionsExpandedLvl2 = i_r9);
    })("mouseout", function SubjectSelectorComponent_ng_template_14_ng_template_2_Template_li_mouseout_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.optionsExpandedLvl2 = null);
    });
    i0.ɵɵelementStart(1, "span", 33);
    i0.ɵɵlistener("click", function SubjectSelectorComponent_ng_template_14_ng_template_2_Template_span_click_1_listener($event) {
      const subjectLvl1_r10 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onCreateOther($event, subjectLvl1_r10));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SubjectSelectorComponent_ng_template_14_ng_template_2__svg_svg_4_Template, 2, 1, "svg", 34)(5, SubjectSelectorComponent_ng_template_14_ng_template_2_ng_template_5_Template, 11, 8, "ng-template", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const subjectLvl1_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, subjectLvl1_r10.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", subjectLvl1_r10.name !== "other");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.subjects[subjectLvl1_r10.name].length && (subjectLvl1_r10.name !== "other" || ctx_r1.subjects["user"].length));
  }
}
function SubjectSelectorComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SubjectSelectorComponent_ng_template_14_ng_template_0_Template, 7, 5, "ng-template", 22);
    i0.ɵɵelementStart(1, "ul", 23);
    i0.ɵɵtemplate(2, SubjectSelectorComponent_ng_template_14_ng_template_2_Template, 6, 5, "ng-template", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.subjects["recent"].length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.optionsLevel1);
  }
}
const _c1 = (a0, a1) => ({
  "width": a0,
  "height": a1
});
function PaymentFormCardSelectorComponent_ng_template_1_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 9);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r2.svgsetIcon("master-card"), null, "xlink");
  }
}
function PaymentFormCardSelectorComponent_ng_template_1_div_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 10);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r2.svgsetIcon("visa"), null, "xlink");
  }
}
function PaymentFormCardSelectorComponent_ng_template_1_div_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 11);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r2.svgsetIcon("mir"), null, "xlink");
  }
}
function PaymentFormCardSelectorComponent_ng_template_1_div_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " other card ");
    i0.ɵɵelementContainerEnd();
  }
}
function PaymentFormCardSelectorComponent_ng_template_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function PaymentFormCardSelectorComponent_ng_template_1_div_1_Template_div_click_0_listener() {
      const card_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.selectCard(card_r2));
    });
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtemplate(4, PaymentFormCardSelectorComponent_ng_template_1_div_1_ng_container_4_Template, 3, 1, "ng-container", 7)(5, PaymentFormCardSelectorComponent_ng_template_1_div_1_ng_container_5_Template, 3, 1, "ng-container", 7)(6, PaymentFormCardSelectorComponent_ng_template_1_div_1_ng_container_6_Template, 3, 1, "ng-container", 7)(7, PaymentFormCardSelectorComponent_ng_template_1_div_1_ng_container_7_Template, 2, 0, "ng-container", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const card_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("selected", (ctx_r2.selectedCard == null ? null : ctx_r2.selectedCard.id) === card_r2.id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(card_r2.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r2.cardType(card_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.bankCardType.master_card);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.bankCardType.visa);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.bankCardType.mir);
  }
}
function PaymentFormCardSelectorComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, PaymentFormCardSelectorComponent_ng_template_1_div_1_Template, 8, 7, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.cards)("ngForTrackBy", ctx_r2.trackByFn);
  }
}
const _c2 = (a0, a1) => ({
  "terms1": a0,
  "terms2": a1
});
const _c3 = a0 => ({
  "date": a0
});
const _c4 = a0 => ({
  "plan": a0
});
function FinancePlanActivateFormComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormComponent_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormComponent_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanActivateFormComponent_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 9)(1, FinancePlanActivateFormComponent_ng_template_2_ng_container_1_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const content_r1 = i0.ɵɵreference(8);
    const actions_r2 = i0.ɵɵreference(12);
    i0.ɵɵproperty("ngTemplateOutlet", content_r1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r2);
  }
}
function FinancePlanActivateFormComponent_ng_template_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormComponent_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanActivateFormComponent_ng_template_3_ng_container_0_Template, 1, 0, "ng-container", 9)(1, FinancePlanActivateFormComponent_ng_template_3_ng_container_1_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const payment_r3 = i0.ɵɵreference(10);
    const paymentActions_r4 = i0.ɵɵreference(14);
    i0.ɵɵproperty("ngTemplateOutlet", payment_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", paymentActions_r4);
  }
}
function FinancePlanActivateFormComponent_ng_template_5_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 22);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "lingo2-forms.subscription-plans.forms.cancel-text"));
  }
}
function FinancePlanActivateFormComponent_ng_template_5_ng_container_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 22);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 23)(5, "span", 24);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, "\xA0 ");
    i0.ɵɵelementStart(8, "span", 25);
    i0.ɵɵtext(9);
    i0.ɵɵelementStart(10, "span", 26);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 6, "lingo2-forms.subscription-plans.forms.activate-text"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.formatCurrencyAmount(ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.old_price));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("color", ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r4.formatCurrencyAmount(ctx_r4.currentPrice), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" /", i0.ɵɵpipeBind1(12, 8, "lingo2-forms.subscription-plans.periods." + ctx_r4.planPeriodEnum[ctx_r4.plan.period]), "");
  }
}
function FinancePlanActivateFormComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 13);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "div", 14)(5, "span", 15);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 16);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 17);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "div", 18)(15, "div", 19);
    i0.ɵɵtemplate(16, FinancePlanActivateFormComponent_ng_template_5_ng_container_16_Template, 4, 3, "ng-container", 20)(17, FinancePlanActivateFormComponent_ng_template_5_ng_container_17_Template, 13, 10, "ng-container", 21);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("fill", ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r4.svgsetIcon("finance-plan"), null, "xlink");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 7, "lingo2-forms.subscription-plans.forms.header-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 9, "lingo2-forms." + (ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.title)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 11, "lingo2-forms." + (ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.subtitle)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r4.displayMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "cancel");
  }
}
function FinancePlanActivateFormComponent_ng_template_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30)(2, "p", 31);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 32);
    i0.ɵɵelement(6, "on-ui-textarea", 33);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", ctx_r4.userName, ", ", i0.ɵɵpipeBind1(4, 2, "lingo2-forms.subscription-plans.forms.cancel-mode-text"), "");
  }
}
function FinancePlanActivateFormComponent_ng_template_7_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 34);
    i0.ɵɵelementContainerEnd();
  }
}
function FinancePlanActivateFormComponent_ng_template_7_ng_container_6_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "loading-line", 35);
  }
}
function FinancePlanActivateFormComponent_ng_template_7_ng_container_6_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37)(2, "span", 38);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 39);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(6, "svg", 40);
    i0.ɵɵelement(7, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(8, "span", 41);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "div", 42)(12, "span", 38);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span", 43)(16, "span", 44);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "span", 43)(21, "span", 44);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "span", 45);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(28, "div", 46)(29, "p", 47);
    i0.ɵɵtext(30);
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "span", 48);
    i0.ɵɵtext(33);
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 14, "lingo2-forms.subscription-plans.forms.cancellation-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("fill", ctx_r4.defaultPlan == null ? null : ctx_r4.defaultPlan.details == null ? null : ctx_r4.defaultPlan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r4.svgsetIcon("finance-plan"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 16, "lingo2-forms." + (ctx_r4.defaultPlan == null ? null : ctx_r4.defaultPlan.details == null ? null : ctx_r4.defaultPlan.details.title)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 18, "lingo2-forms.subscription-plans.forms.cancellation-label2"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 20, "lingo2-forms.subscription-plans.forms.by-subscription"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.getCreditsBySource("subscription"), " \uD83D\uDD25 ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 22, "lingo2-forms.subscription-plans.forms.purchased"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.getCreditsBySource("purchased"), " \uD83D\uDD25 ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(27, 24, "lingo2-forms.subscription-plans.forms.bonus"), " ", ctx_r4.getCreditsBySource("bonus"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(31, 26, "lingo2-forms.subscription-plans.forms.alert-text"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(34, 28, "lingo2-forms.subscription-plans.forms.total-credit"), " ", ctx_r4.getCreditsBySource("total_left"), "");
  }
}
function FinancePlanActivateFormComponent_ng_template_7_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FinancePlanActivateFormComponent_ng_template_7_ng_container_6_ng_template_1_Template, 1, 0, "ng-template", 10)(2, FinancePlanActivateFormComponent_ng_template_7_ng_container_6_ng_template_2_Template, 35, 30, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cancel_r6 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.loaded)("ngIfElse", cancel_r6);
  }
}
function FinancePlanActivateFormComponent_ng_template_7_ng_container_7_div_6_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60)(1, "span", 61);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "\xA0 ");
    i0.ɵɵelementStart(4, "span", 62);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const term_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(term_r7 == null ? null : term_r7.side == null ? null : term_r7.side.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(term_r7 == null ? null : term_r7.side == null ? null : term_r7.side.text);
  }
}
function FinancePlanActivateFormComponent_ng_template_7_ng_container_7_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54)(1, "div", 55);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 56);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "div", 57);
    i0.ɵɵelement(5, "span", 58);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, FinancePlanActivateFormComponent_ng_template_7_ng_container_7_div_6_ng_template_7_Template, 6, 2, "ng-template", 59);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const term_r7 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("stroke", ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r4.svgsetIcon("finance-plan-property"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r4.replaceValues(i0.ɵɵpipeBind1(6, 4, "lingo2-forms." + (term_r7 == null ? null : term_r7.label))), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", term_r7 == null ? null : term_r7.side);
  }
}
function FinancePlanActivateFormComponent_ng_template_7_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 49)(2, "h2", 50);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 51);
    i0.ɵɵtemplate(6, FinancePlanActivateFormComponent_ng_template_7_ng_container_7_div_6_Template, 8, 6, "div", 52);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 53)(8, "span", 31);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵpipe(11, "dfnsFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 31);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span", 31);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "lingo2-forms.subscription-plans.forms.activate-text"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.tariff_terms);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(10, 8, "lingo2-forms.subscription-plans.forms.next-payment"), " ", i0.ɵɵpipeBind2(11, 10, ctx_r4.planExpired, "dd MMMM yyyy"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 13, "lingo2-forms.subscription-plans.forms.next-payment-text1"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 15, "lingo2-forms.subscription-plans.forms.next-payment-text2"));
  }
}
function FinancePlanActivateFormComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementContainerStart(1, 28);
    i0.ɵɵtemplate(2, FinancePlanActivateFormComponent_ng_template_7_ng_container_2_Template, 7, 4, "ng-container", 20)(3, FinancePlanActivateFormComponent_ng_template_7_ng_container_3_Template, 2, 0, "ng-container", 21);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(4, "div", 29);
    i0.ɵɵelementContainerStart(5, 28);
    i0.ɵɵtemplate(6, FinancePlanActivateFormComponent_ng_template_7_ng_container_6_Template, 4, 2, "ng-container", 20)(7, FinancePlanActivateFormComponent_ng_template_7_ng_container_7_Template, 18, 17, "ng-container", 21);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r4.displayMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "cancel");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngSwitch", ctx_r4.displayMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "cancel");
  }
}
function FinancePlanActivateFormComponent_ng_template_9_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 64);
    i0.ɵɵelement(2, "path", 65)(3, "rect", 66)(4, "rect", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 17);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "dfnsFormat");
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 2, "user-service-checkout-wizard.unsub-success"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 7, "user-service-checkout-wizard.unsubscribe.completetext", i0.ɵɵpureFunction1(10, _c3, i0.ɵɵpipeBind2(10, 4, ctx_r4.planExpired, "dd MMMM yyyy"))));
  }
}
function FinancePlanActivateFormComponent_ng_template_9_ng_container_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 64);
    i0.ɵɵelement(2, "path", 65)(3, "rect", 66)(4, "rect", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 1, "user-service-checkout-wizard.unsub-failed"));
  }
}
function FinancePlanActivateFormComponent_ng_template_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FinancePlanActivateFormComponent_ng_template_9_ng_container_1_ng_template_1_Template, 12, 12, "ng-template", 59)(2, FinancePlanActivateFormComponent_ng_template_9_ng_container_1_ng_template_2_Template, 8, 3, "ng-template", 59);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.accountPlan.plan_id !== ctx_r4.accountPlan.next_plan_id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.accountPlan.plan_id === ctx_r4.accountPlan.next_plan_id);
  }
}
function FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69)(1, "app-payment-form-universal", 70);
    i0.ɵɵlistener("cardSelected", function FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_1_Template_app_payment_form_universal_cardSelected_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.onCardSelected($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("transaction", ctx_r4.switchOperation);
  }
}
function FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "spinner2");
  }
}
function FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 64);
    i0.ɵɵelement(2, "path", 71)(3, "path", 72);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 17);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 2, "user-service-checkout-wizard.pay-success"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(10, 6, "user-service-checkout-wizard.subscribe.completetext", i0.ɵɵpureFunction1(9, _c4, i0.ɵɵpipeBind1(9, 4, "lingo2-forms." + (ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.title)))));
  }
}
function FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 64);
    i0.ɵɵelement(2, "path", 65)(3, "rect", 66)(4, "rect", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 1, "user-service-checkout-wizard.pay-failed"));
  }
}
function FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_2_ng_template_0_Template, 1, 0, "ng-template", 59)(1, FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_2_ng_template_1_Template, 11, 11, "ng-template", 59)(2, FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_2_ng_template_2_Template, 8, 3, "ng-template", 59);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r4.billingOperation.status === ctx_r4.billingOperationStatusEnum.pending);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.billingOperation.status === ctx_r4.billingOperationStatusEnum.succeed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.billingOperation.status === ctx_r4.billingOperationStatusEnum.failed);
  }
}
function FinancePlanActivateFormComponent_ng_template_9_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_1_Template, 2, 1, "ng-template", 10)(2, FinancePlanActivateFormComponent_ng_template_9_ng_container_2_ng_template_2_Template, 3, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const billingOperationStatus_r9 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.billingOperation)("ngIfElse", billingOperationStatus_r9);
  }
}
function FinancePlanActivateFormComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 28);
    i0.ɵɵtemplate(1, FinancePlanActivateFormComponent_ng_template_9_ng_container_1_Template, 3, 2, "ng-container", 20)(2, FinancePlanActivateFormComponent_ng_template_9_ng_container_2_Template, 4, 2, "ng-container", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r4.displayMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "cancel");
  }
}
function FinancePlanActivateFormComponent_ng_template_11_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 75);
    i0.ɵɵlistener("click", function FinancePlanActivateFormComponent_ng_template_11_ng_container_6_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.onCancelPlan());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", !ctx_r4.consentToPrivacyPolicy);
    i0.ɵɵproperty("hidden", ctx_r4.accountPlan && ctx_r4.accountPlan.plan_id !== ctx_r4.accountPlan.next_plan_id || ctx_r4.finalStep);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "lingo2-forms.subscription-plans.forms.action-cancel"));
  }
}
function FinancePlanActivateFormComponent_ng_template_11_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 76)(2, "input", 77);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function FinancePlanActivateFormComponent_ng_template_11_ng_container_7_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r4 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r4.promoCode, $event) || (ctx_r4.promoCode = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 78);
    i0.ɵɵlistener("click", function FinancePlanActivateFormComponent_ng_template_11_ng_container_7_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.onApplyPromo());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "on-ui-button", 79);
    i0.ɵɵlistener("onclick", function FinancePlanActivateFormComponent_ng_template_11_ng_container_7_Template_on_ui_button_onclick_7_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.onOpenPaymentTemplate());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r4.applyPromoFlag);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 9, "lingo2-forms.subscription-plans.forms.promo-placeholder"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r4.promoCode);
    i0.ɵɵproperty("disabled", ctx_r4.applyPromoFlag);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("apply-disabled", ctx_r4.applyPromoFlag);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 11, "lingo2-forms.subscription-plans.forms.action-apply"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", (!ctx_r4.consentToPrivacyPolicy || ctx_r4.openPaymentTemplate) && !ctx_r4.billingOperation);
  }
}
function FinancePlanActivateFormComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 73)(1, "app-agreement-terms-field", 74);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtwoWayListener("valueChange", function FinancePlanActivateFormComponent_ng_template_11_Template_app_agreement_terms_field_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r4 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r4.consentToPrivacyPolicy, $event) || (ctx_r4.consentToPrivacyPolicy = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(5, 28);
    i0.ɵɵtemplate(6, FinancePlanActivateFormComponent_ng_template_11_ng_container_6_Template, 4, 6, "ng-container", 20)(7, FinancePlanActivateFormComponent_ng_template_11_ng_container_7_Template, 8, 13, "ng-container", 21);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("value", ctx_r4.consentToPrivacyPolicy);
    i0.ɵɵproperty("agreementText", i0.ɵɵpipeBind2(4, 8, "lingo2-forms.subscription-plans.forms.agreements", i0.ɵɵpureFunction2(11, _c2, "<a href=\"/terms\" class=\"link normal\" target=\"_blank\">" + i0.ɵɵpipeBind1(2, 4, "lingo2-forms.subscription-plans.forms.agreements-terms1") + "</a>", "<a href=\"/privacy\" class=\"link normal\" target=\"_blank\">" + i0.ɵɵpipeBind1(3, 6, "lingo2-forms.subscription-plans.forms.agreements-terms2") + "</a>")));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngSwitch", ctx_r4.displayMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "cancel");
  }
}
function FinancePlanActivateFormComponent_ng_template_13_on_ui_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "on-ui-button", 82);
    i0.ɵɵlistener("onclick", function FinancePlanActivateFormComponent_ng_template_13_on_ui_button_1_Template_on_ui_button_onclick_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.onSubmitPlan());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r4.selectedCard);
  }
}
function FinancePlanActivateFormComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵtemplate(1, FinancePlanActivateFormComponent_ng_template_13_on_ui_button_1_Template, 1, 1, "on-ui-button", 80);
    i0.ɵɵelementStart(2, "button", 81);
    i0.ɵɵlistener("click", function FinancePlanActivateFormComponent_ng_template_13_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.closeModal());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r4.billingOperation && ctx_r4.billingOperation.status === ctx_r4.billingOperationStatusEnum.succeed || ctx_r4.finalStep));
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r4.finalStep);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "lingo2-forms.subscription-plans.forms.close"), " ");
  }
}
const _c5 = [[["app-mobile-modal-ad"]], [["app-mobile-modal-body"]], [["app-mobile-modal-actions"]], [["app-mobile-modal-title"]]];
const _c6 = ["app-mobile-modal-ad", "app-mobile-modal-body", "app-mobile-modal-actions", "app-mobile-modal-title"];
function MobileModalComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "app-icon", 6);
    i0.ɵɵlistener("click", function MobileModalComponent_div_0_div_1_Template_app_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵprojection(3, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "app-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("width", 11)("height", 20);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 5)("height", 19);
  }
}
function MobileModalComponent_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "app-icon", 11);
    i0.ɵɵlistener("click", function MobileModalComponent_div_0_div_2_Template_app_icon_click_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.customTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("width", 10)("height", 10);
  }
}
function MobileModalComponent_div_0_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
  }
}
function MobileModalComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, MobileModalComponent_div_0_div_1_Template, 5, 4, "div", 2)(2, MobileModalComponent_div_0_div_2_Template, 4, 3, "div", 3);
    i0.ɵɵprojection(3);
    i0.ɵɵprojection(4, 1);
    i0.ɵɵprojection(5, 2);
    i0.ɵɵtemplate(6, MobileModalComponent_div_0_ng_template_6_Template, 1, 0, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("footer-visible", ctx_r1.footerVisible);
    i0.ɵɵproperty("@modalAnimation", undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.titleVisible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.withCloseButton);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.footerVisible);
  }
}
function ModalAdComponent_ng_content_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ifIsBrowser", ""]);
  }
}
function ModalBodyComponent_ng_content_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ifIsBrowser", ""]);
  }
}
function ModalTitleComponent_ng_content_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ifIsBrowser", ""]);
  }
}
function ModalActionsComponent_ng_content_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ifIsBrowser", ""]);
  }
}
const _c7 = ["gridCenter"];
const _c8 = ["scrollHolder"];
const _c9 = ["background"];
const _c10 = ["modalBody"];
const _c11 = [[["app-modal-ad"]], [["app-modal-body"]]];
const _c12 = ["app-modal-ad", "app-modal-body"];
const _c13 = a0 => ({
  "transform": a0
});
const _c14 = a0 => ({
  "min-height": a0
});
const _c15 = a0 => ({
  "prev-btn--disabled": a0
});
function ModalComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function ModalComponent_div_1_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵlistener("click", function ModalComponent_div_1_div_13_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onCloseBtn($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 24);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("close"), null, "xlink");
  }
}
function ModalComponent_div_1_div_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵlistener("click", function ModalComponent_div_1_div_15_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onCloseBtn($event));
    })("mouseover", function ModalComponent_div_1_div_15_Template_div_mouseover_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hover($event));
    })("mouseout", function ModalComponent_div_1_div_15_Template_div_mouseout_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hover($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 26);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("modal-close"), null, "xlink");
  }
}
function ModalComponent_div_1_div_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 28);
    i0.ɵɵlistener("click", function ModalComponent_div_1_div_16_Template_svg_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.scalePlus());
    });
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 29);
    i0.ɵɵlistener("click", function ModalComponent_div_1_div_16_Template_div_click_3_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.scaleNumber = 1);
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 28);
    i0.ɵɵlistener("click", function ModalComponent_div_1_div_16_Template_svg_click_5_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.scaleMinus());
    });
    i0.ɵɵelement(6, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("zoom-plus"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.scaleValue, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("zoom-minus"), null, "xlink");
  }
}
function ModalComponent_div_1_div_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵlistener("click", function ModalComponent_div_1_div_17_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPrev());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 31);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c13, "translateY(" + ctx_r1.scrollTop + "px)"))("ngClass", i0.ɵɵpureFunction1(5, _c15, ctx_r1.isReachedPrev));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("modal-arrow"), null, "xlink");
  }
}
function ModalComponent_div_1_div_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵlistener("click", function ModalComponent_div_1_div_18_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onNext());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 31);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c13, "rotate(180deg) translateY(" + -ctx_r1.scrollTop + "px)"))("ngClass", i0.ɵɵpureFunction1(5, _c15, ctx_r1.isReachedNext));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("modal-arrow"), null, "xlink");
  }
}
function ModalComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7, 0)(3, "div", 8, 1)(5, "div", 9)(6, "div", 10)(7, "div", 11);
    i0.ɵɵlistener("click", function ModalComponent_div_1_Template_div_click_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 12, 2)(10, "div", 13);
    i0.ɵɵlistener("click", function ModalComponent_div_1_Template_div_click_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 14, 3);
    i0.ɵɵtemplate(13, ModalComponent_div_1_div_13_Template, 3, 1, "div", 15);
    i0.ɵɵelementStart(14, "div", 16);
    i0.ɵɵtemplate(15, ModalComponent_div_1_div_15_Template, 3, 1, "div", 17)(16, ModalComponent_div_1_div_16_Template, 7, 3, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, ModalComponent_div_1_div_17_Template, 3, 7, "div", 19)(18, ModalComponent_div_1_div_18_Template, 3, 7, "div", 20);
    i0.ɵɵprojection(19, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 21);
    i0.ɵɵlistener("click", function ModalComponent_div_1_Template_div_click_20_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 22);
    i0.ɵɵlistener("click", function ModalComponent_div_1_Template_div_click_21_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose($event));
    });
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("hide", !ctx_r1.isVisible);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("height", ctx_r1.customHeight, "px");
    i0.ɵɵclassProp("dark", !ctx_r1.canClose || ctx_r1.shadeDark)("gray", ctx_r1.shadeGray)("hover", ctx_r1.hoverFlag)("none", ctx_r1.complain)("light", ctx_r1.shadeLight);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(52, _c13, "scale(" + ctx_r1.scaleNumber + ")"));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("shadow", !ctx_r1.canClose)("short", ctx_r1.short)("long", ctx_r1.long)("wide", ctx_r1.wide)("middle", ctx_r1.middle)("schedule", ctx_r1.schedule)("narrow", ctx_r1.narrow)("narrow2", ctx_r1.narrow2)("auth", ctx_r1.auth)("wide2", ctx_r1.wide2)("complain", ctx_r1.complain)("editor", ctx_r1.editor)("canGoBack", ctx_r1.canGoBack);
    i0.ɵɵproperty("ngClass", ctx_r1.answerState ? ctx_r1.answerState : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.complain);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("transform", "translateY(" + ctx_r1.scrollTop + "px)");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.canClose);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.scale);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.prevNext);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.prevNext);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("hide-footer", ctx_r1.showToFooter);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(54, _c14, ctx_r1.calcHeader + "px"));
  }
}
function StepsComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("click", function StepsComponent_div_1_Template_div_click_0_listener() {
      const step_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.goStep(step_r2));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const step_r2 = ctx.$implicit;
    const idx_r4 = ctx.index;
    i0.ɵɵclassProp("passed", step_r2.complete)("active", step_r2.active);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(idx_r4 + 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, step_r2.title), "");
  }
}
const _c16 = [[["", "content", ""]], [["", "header-details", ""]], [["", "footer-details", ""]], [["", "footer-actions", ""]]];
const _c17 = ["[content]", "[header-details]", "[footer-details]", "[footer-actions]"];
function StepByStepWizardComponent_div_1_div_2_app_steps_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-steps", 8);
    i0.ɵɵlistener("activeStep", function StepByStepWizardComponent_div_1_div_2_app_steps_1_Template_app_steps_activeStep_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onStepChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("steps", ctx_r1.steps);
  }
}
function StepByStepWizardComponent_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, StepByStepWizardComponent_div_1_div_2_app_steps_1_Template, 1, 1, "app-steps", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.steps);
  }
}
function StepByStepWizardComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵtemplate(2, StepByStepWizardComponent_div_1_div_2_Template, 2, 1, "div", 4);
    i0.ɵɵelement(3, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showSteps);
  }
}
function StepByStepWizardComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 5);
    i0.ɵɵprojection(2, 2);
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵprojection(4, 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("footer ", ctx_r1.activeStep, "");
  }
}
function PaymentOrderComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 3, "payment-form.order.processing_fee"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", ctx_r0.order.taxAmount, " ", ctx_r0.order.currencyCode, "");
  }
}
function PaymentOrderComponent_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(2, 3, "payment-form.order.approximate"), " ", ctx_r0.order.approximateCurrencyCode, ": ", ctx_r0.order.approximateAmountToPay, " ");
  }
}
function PaymentOrderComponent_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "ul")(2, "li");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "li");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "payment-form.order.additional_text1"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 5, "payment-form.order.additional_text2"), " ", ctx_r0.order.currencyCode, ".");
  }
}
function PaymentWidgetMerchantProcessingComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "spinner2");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "payment-form.payment-in-progress"));
  }
}
function PaymentWidgetMerchantProcessingComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.error));
  }
}
function PaymentWidgetMerchantProcessingComponent_ng_template_2_iframe_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "iframe", 7);
    i0.ɵɵlistener("load", function PaymentWidgetMerchantProcessingComponent_ng_template_2_iframe_0_Template_iframe_load_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.watchFrameLoad());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("mobile", ctx_r0.deviceService.isMobile());
    i0.ɵɵproperty("src", ctx_r0.safePaymentUrl, i0.ɵɵsanitizeResourceUrl);
  }
}
function PaymentWidgetMerchantProcessingComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PaymentWidgetMerchantProcessingComponent_ng_template_2_iframe_0_Template, 1, 3, "iframe", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.safePaymentUrl);
  }
}
function PaymentCardComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PaymentCardComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PaymentCardComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const simple_r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", simple_r1);
  }
}
function PaymentCardComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PaymentCardComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PaymentCardComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const full_r2 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", full_r2);
  }
}
function PaymentCardComponent_ng_template_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "finance-page.card.expiry-text"));
  }
}
function PaymentCardComponent_ng_template_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "profile-steps.test-bank-card"), " ");
  }
}
function PaymentCardComponent_ng_template_3__svg_svg_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 15);
    i0.ɵɵelement(1, "path", 16)(2, "path", 17)(3, "path", 18)(4, "path", 19)(5, "path", 20)(6, "path", 21)(7, "path", 22)(8, "path", 23)(9, "path", 24)(10, "path", 25)(11, "path", 26)(12, "path", 27);
    i0.ɵɵelementEnd();
  }
}
function PaymentCardComponent_ng_template_3__svg_svg_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 15);
    i0.ɵɵelement(1, "path", 28);
    i0.ɵɵelementStart(2, "defs")(3, "linearGradient", 29);
    i0.ɵɵelement(4, "stop", 30)(5, "stop", 31);
    i0.ɵɵelementEnd()()();
  }
}
function PaymentCardComponent_ng_template_3__svg_svg_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 32);
    i0.ɵɵelement(1, "defs", 33);
    i0.ɵɵelementStart(2, "style", 34);
    i0.ɵɵtext(3, " .st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);} .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#4DB45F;} ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "linearGradient", 35);
    i0.ɵɵelement(5, "stop", 36)(6, "stop", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "path", 38)(8, "path", 39)(9, "path", 40)(10, "path", 41);
    i0.ɵɵelementEnd();
  }
}
function PaymentCardComponent_ng_template_3__svg_svg_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 42);
    i0.ɵɵelement(1, "path", 43);
    i0.ɵɵelementEnd();
  }
}
function PaymentCardComponent_ng_template_3__svg_svg_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 42);
    i0.ɵɵelement(1, "path", 43);
    i0.ɵɵelementEnd();
  }
}
function PaymentCardComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function PaymentCardComponent_ng_template_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.selectAcc());
    });
    i0.ɵɵtemplate(1, PaymentCardComponent_ng_template_3_div_1_Template, 3, 3, "div", 6)(2, PaymentCardComponent_ng_template_3_div_2_Template, 3, 3, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵtemplate(6, PaymentCardComponent_ng_template_3__svg_svg_6_Template, 13, 0, "svg", 10)(7, PaymentCardComponent_ng_template_3__svg_svg_7_Template, 6, 0, "svg", 10)(8, PaymentCardComponent_ng_template_3__svg_svg_8_Template, 11, 0, "svg", 11)(9, PaymentCardComponent_ng_template_3__svg_svg_9_Template, 2, 0, "svg", 12)(10, PaymentCardComponent_ng_template_3__svg_svg_10_Template, 2, 0, "svg", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("account ", ctx_r3.view, "");
    i0.ɵɵclassProp("expired", ctx_r3.accountExpire)("selected", ctx_r3.selected)("test", ctx_r3.isTestCard());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.accountExpire);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.isTestCard());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.accountLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.accountType === "mastercard");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.accountType === "visa");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.accountType === "mir");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.accountType === "card");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.accountType === "---");
  }
}
function PaymentCardComponent_ng_template_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "finance-page.card.expiry-text"));
  }
}
function PaymentCardComponent_ng_template_5__svg_svg_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 56);
    i0.ɵɵelement(1, "path", 16)(2, "path", 17)(3, "path", 18)(4, "path", 19)(5, "path", 20)(6, "path", 21)(7, "path", 22)(8, "path", 23)(9, "path", 24)(10, "path", 25)(11, "path", 26)(12, "path", 27);
    i0.ɵɵelementEnd();
  }
}
function PaymentCardComponent_ng_template_5__svg_svg_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 56);
    i0.ɵɵelement(1, "path", 28);
    i0.ɵɵelementStart(2, "defs")(3, "linearGradient", 29);
    i0.ɵɵelement(4, "stop", 30)(5, "stop", 31);
    i0.ɵɵelementEnd()()();
  }
}
function PaymentCardComponent_ng_template_5__svg_svg_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 57);
    i0.ɵɵelement(1, "defs", 33);
    i0.ɵɵelementStart(2, "style", 34);
    i0.ɵɵtext(3, " .st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);} .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#4DB45F;} ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "linearGradient", 35);
    i0.ɵɵelement(5, "stop", 36)(6, "stop", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "path", 38)(8, "path", 39)(9, "path", 40)(10, "path", 41);
    i0.ɵɵelementEnd();
  }
}
function PaymentCardComponent_ng_template_5__svg_svg_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 58);
    i0.ɵɵelement(1, "path", 43);
    i0.ɵɵelementEnd();
  }
}
function PaymentCardComponent_ng_template_5_div_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵlistener("click", function PaymentCardComponent_ng_template_5_div_18_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.setDefault());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("disabled", ctx_r3.accountExpire);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, "finance-page.card.set-as-main"));
  }
}
function PaymentCardComponent_ng_template_5_div_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("disabled", ctx_r3.accountExpire);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, "finance-page.card.main-card"));
  }
}
function PaymentCardComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function PaymentCardComponent_ng_template_5_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.selectAcc());
    });
    i0.ɵɵtemplate(1, PaymentCardComponent_ng_template_5_div_1_Template, 3, 3, "div", 6);
    i0.ɵɵelementStart(2, "div", 44)(3, "div", 45);
    i0.ɵɵtemplate(4, PaymentCardComponent_ng_template_5__svg_svg_4_Template, 13, 0, "svg", 46)(5, PaymentCardComponent_ng_template_5__svg_svg_5_Template, 6, 0, "svg", 46)(6, PaymentCardComponent_ng_template_5__svg_svg_6_Template, 11, 0, "svg", 47)(7, PaymentCardComponent_ng_template_5__svg_svg_7_Template, 2, 0, "svg", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 49)(9, "div", 50)(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 51);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementStart(15, "span");
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(17, "div", 52);
    i0.ɵɵtemplate(18, PaymentCardComponent_ng_template_5_div_18_Template, 3, 5, "div", 53)(19, PaymentCardComponent_ng_template_5_div_19_Template, 3, 5, "div", 54);
    i0.ɵɵelementStart(20, "div", 55);
    i0.ɵɵlistener("click", function PaymentCardComponent_ng_template_5_Template_div_click_20_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.deleteAccount());
    });
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("account ", ctx_r3.view, "");
    i0.ɵɵclassProp("expired", ctx_r3.accountExpire)("selected", ctx_r3.selected);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.accountExpire);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.accountType === "mastercard");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.accountType === "visa");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.accountType === "mir");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.accountType === "---");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.accountLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 18, "finance-page.card.expiry-date"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.accountExpirationMY);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.isDefault);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.isDefault);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 20, "finance-page.card.remove"));
  }
}
function PaymentWidgetPaymentMethodSelectorComponent_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "app-payment-card", 4);
    i0.ɵɵlistener("onSelect", function PaymentWidgetPaymentMethodSelectorComponent_ng_template_1_ng_container_1_Template_app_payment_card_onSelect_1_listener() {
      const account_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onSelect(account_r2, "account"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const account_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selected", (ctx_r2.selected == null ? null : ctx_r2.selected.paymentMethod == null ? null : ctx_r2.selected.paymentMethod.id) === account_r2.id)("is_test", ctx_r2.isTestCard(account_r2))("account", account_r2)("view", "simple");
  }
}
function PaymentWidgetPaymentMethodSelectorComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, PaymentWidgetPaymentMethodSelectorComponent_ng_template_1_ng_container_1_Template, 2, 4, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.paymentMethods)("ngForTrackBy", ctx_r2.trackByFn);
  }
}
function PaymentWidgetComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const initRef_r1 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", initRef_r1);
  }
}
function PaymentWidgetComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const cardsRef_r2 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cardsRef_r2);
  }
}
function PaymentWidgetComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const processingRef_r3 = i0.ɵɵreference(12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", processingRef_r3);
  }
}
function PaymentWidgetComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const successRef_r4 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", successRef_r4);
  }
}
function PaymentWidgetComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const failedRef_r5 = i0.ɵɵreference(16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", failedRef_r5);
  }
}
function PaymentWidgetComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "spinner2");
  }
}
function PaymentWidgetComponent_ng_template_9_div_7_ng_template_4_Template(rf, ctx) {}
function PaymentWidgetComponent_ng_template_9_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵlistener("clickOutside", function PaymentWidgetComponent_ng_template_9_div_7_Template_div_clickOutside_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r7 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r7.closeAddPaymentMethods());
    })("click", function PaymentWidgetComponent_ng_template_9_div_7_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r7 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r7.showAddPaymentMethods());
    });
    i0.ɵɵelementStart(1, "span", 26);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PaymentWidgetComponent_ng_template_9_div_7_ng_template_4_Template, 0, 0, "ng-template", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    const addPaymentMethodsRef_r9 = i0.ɵɵreference(18);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "payment-form.payment-method"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.showAddMethods)("ngIfThen", addPaymentMethodsRef_r9);
  }
}
function PaymentWidgetComponent_ng_template_9_div_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "payment-form.payment-method-not-selected"), " ");
  }
}
function PaymentWidgetComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "div", 12)(3, "div", 13)(4, "div", 14);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PaymentWidgetComponent_ng_template_9_div_7_Template, 5, 5, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 16);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(9, "svg", 17);
    i0.ɵɵelement(10, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "svg", 18);
    i0.ɵɵelement(12, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "svg", 19);
    i0.ɵɵelement(14, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "svg", 20);
    i0.ɵɵelement(16, "use");
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(17, "div", 21)(18, "app-payment-widget-payment-method-selector", 22);
    i0.ɵɵlistener("paymentMethodSelected", function PaymentWidgetComponent_ng_template_9_Template_app_payment_widget_payment_method_selector_paymentMethodSelected_18_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r7 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r7.onSelectPaymentMethod($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "app-payment-order", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(20, PaymentWidgetComponent_ng_template_9_div_20_Template, 3, 3, "div", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 13, "meetings.wizard.select-payment"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.paymentProviders == null ? null : ctx_r7.paymentProviders.length);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r7.svgsetIcon("pci-grey"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r7.svgsetIcon("mastercard-grey"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r7.svgsetIcon("visa-grey"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r7.svgsetIcon("mir-grey"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("paymentMethods", ctx_r7.paymentMethods)("selectedAccountId", ctx_r7.checkData == null ? null : ctx_r7.checkData.selectedAccountId)("paymentProviders", ctx_r7.paymentProviders)("initAdd", ctx_r7.showAddMethods);
    i0.ɵɵadvance();
    i0.ɵɵproperty("payment", ctx_r7.checkData)("free", ctx_r7.buyTrial);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r7.payClicked && !ctx_r7.selected);
  }
}
function PaymentWidgetComponent_ng_template_11_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31)(1, "div", 32);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "spinner2");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "payment-form.payment-in-progress"));
  }
}
function PaymentWidgetComponent_ng_template_11_app_payment_widget_merchant_processing_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-payment-widget-merchant-processing", 33);
    i0.ɵɵlistener("succeed", function PaymentWidgetComponent_ng_template_11_app_payment_widget_merchant_processing_1_Template_app_payment_widget_merchant_processing_succeed_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r7 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r7.onSuccess());
    })("failed", function PaymentWidgetComponent_ng_template_11_app_payment_widget_merchant_processing_1_Template_app_payment_widget_merchant_processing_failed_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r7 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r7.onFail($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("payment", ctx_r7.payment)("isAccountPayment", ctx_r7.isAccountPayment)("merchant", ctx_r7.merchant);
  }
}
function PaymentWidgetComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PaymentWidgetComponent_ng_template_11_div_0_Template, 5, 3, "div", 29)(1, PaymentWidgetComponent_ng_template_11_app_payment_widget_merchant_processing_1_Template, 1, 3, "app-payment-widget-merchant-processing", 30);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r7.payment);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r7.payment);
  }
}
function PaymentWidgetComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34)(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 35);
    i0.ɵɵelement(5, "path", 36)(6, "path", 37);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "meetings.wizard.pay-success"));
  }
}
function PaymentWidgetComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38)(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 35);
    i0.ɵɵelement(5, "path", 39)(6, "rect", 40)(7, "rect", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(8, "div", 42);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "meetings.wizard.pay-fail"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r7.errorDescription);
  }
}
function PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "profile-steps.test-provider"), " ");
  }
}
function PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 52);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const provider_r12 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "profile-steps.bank-card-world"), " ", ctx_r7.isTestProvider(provider_r12) ? "(" + (provider_r12 == null ? null : provider_r12.note) + ")" : null, " ");
  }
}
function PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 52);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const provider_r12 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "profile-steps.bank-card-rus"), " ", ctx_r7.isTestProvider(provider_r12) ? "(" + (provider_r12 == null ? null : provider_r12.note) + ")" : null, " ");
  }
}
function PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 53);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "svg", 54);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r7.svgsetIcon("master-card"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r7.svgsetIcon("visa"), null, "xlink");
  }
}
function PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 55);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r7.svgsetIcon("mir"), null, "xlink");
  }
}
function PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵlistener("click", function PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const provider_r12 = i0.ɵɵnextContext().$implicit;
      const ctx_r7 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r7.addNewAccount(provider_r12));
    });
    i0.ɵɵtemplate(1, PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_div_1_Template, 3, 3, "div", 49)(2, PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_ng_template_2_Template, 3, 4, "ng-template", 44)(3, PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_ng_template_3_Template, 3, 4, "ng-template", 44);
    i0.ɵɵelementStart(4, "div", 50);
    i0.ɵɵtemplate(5, PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_ng_template_5_Template, 4, 2, "ng-template", 44)(6, PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_ng_template_6_Template, 2, 1, "ng-template", 44);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const provider_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("test", ctx_r7.isTestProvider(provider_r12))("selected", (ctx_r7.selected == null ? null : ctx_r7.selected.provider == null ? null : ctx_r7.selected.provider.id) === provider_r12.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r7.isTestProvider(provider_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r7.isForNotRussia(provider_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r7.isForNotRussia(provider_r12));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.isForNotRussia(provider_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r7.isForNotRussia(provider_r12));
  }
}
function PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_div_1_Template, 7, 9, "div", 47);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const provider_r12 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r7.isApprovedProviders(provider_r12));
  }
}
function PaymentWidgetComponent_ng_template_17_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtemplate(1, PaymentWidgetComponent_ng_template_17_ng_template_1_ng_container_1_Template, 2, 1, "ng-container", 46);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r7.paymentProviders);
  }
}
function PaymentWidgetComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtemplate(1, PaymentWidgetComponent_ng_template_17_ng_template_1_Template, 2, 1, "ng-template", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("error", !ctx_r7.paymentMethods.length && ctx_r7.payClicked);
    i0.ɵɵproperty("ngClass", ctx_r7.screenClasses());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r7.paymentProviders == null ? null : ctx_r7.paymentProviders.length);
  }
}
function PayButtonComponent_ng_template_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PayButtonComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "on-ui-button", 2);
    i0.ɵɵlistener("click", function PayButtonComponent_ng_template_0_Template_on_ui_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onStart());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(1, PayButtonComponent_ng_template_0_ng_container_1_Template, 1, 0, "ng-container", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const protected_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("state", ctx_r1.state)("disabled", ctx_r1.disabled)("label", ctx_r1.startLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", protected_r3);
  }
}
function PayButtonComponent_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PayButtonComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "on-ui-button", 4);
    i0.ɵɵlistener("onclick", function PayButtonComponent_ng_template_1_Template_on_ui_button_onclick_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCancel());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(1, PayButtonComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const protected_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("label", ctx_r1.closeLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", protected_r3);
  }
}
function PayButtonComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "on-ui-button", 4);
    i0.ɵɵlistener("onclick", function PayButtonComponent_ng_template_2_Template_on_ui_button_onclick_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCancel());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", ctx_r1.cancelLabel);
  }
}
function PayButtonComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 6);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("web", !ctx_r1.deviceService.isMobile());
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("protected"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, "lingo2-forms.pretected-payment"));
  }
}
const _c18 = "@charset \"UTF-8\";[_nghost-%COMP%]{width:100%}.headers-details[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center}.headers-details[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{width:61px;height:61px;text-align:center;object-fit:cover;margin-right:20px;border-radius:50%;overflow:hidden}.headers-details[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;height:100%}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{max-width:100%;margin-top:5px;display:flex;flex-direction:column;justify-content:center;align-items:flex-start}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:18px;line-height:24px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;width:100%}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]{display:flex;flex-direction:column}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars.norating[_ngcontent-%COMP%]   .rating-icon[_ngcontent-%COMP%]{fill:#a4b0c3}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars.norating[_ngcontent-%COMP%]   .rating-count[_ngcontent-%COMP%]{color:#a4b0c3}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars[_ngcontent-%COMP%]   .rating-icon[_ngcontent-%COMP%]{width:16px;height:15px;margin-right:5px;fill:#fd0}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars[_ngcontent-%COMP%]   .rating-count[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 5px 0 0;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;color:#fd0}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .review-count[_ngcontent-%COMP%]{color:#41a1d9;font-family:LatoWeb,sans-serif;font-weight:inherit;text-decoration:none;-webkit-user-select:none;user-select:none;margin:0;font-size:14px;line-height:18px}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .school-participants[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px}.headers-details[_ngcontent-%COMP%]   .info.credit[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:flex-start;margin:0}.headers-details[_ngcontent-%COMP%]   .info.credit[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.headers-details[_ngcontent-%COMP%]   .info.credit[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:22px;line-height:26px}.headers-details[_ngcontent-%COMP%]   .info.credit[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#a4b0c3;font-size:16px;line-height:19px}.headers-details[_ngcontent-%COMP%]   .info.trial[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:flex-start;gap:5px}.headers-details[_ngcontent-%COMP%]   .info.trial[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.headers-details[_ngcontent-%COMP%]   .info.trial[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:22px;line-height:26px}.headers-details[_ngcontent-%COMP%]   .info.trial[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#a4b0c3;font-size:16px;line-height:19px}.headers-details.mobile[_ngcontent-%COMP%]{width:100%;justify-content:flex-start}.headers-details.mobile[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{margin-top:0}.headers-details.mobile[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{margin-bottom:5px}.headers-details.no-steps[_ngcontent-%COMP%]{align-items:center;justify-content:space-between}.headers-details.no-steps[_ngcontent-%COMP%]   .left-info[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center}.headers-details.no-steps[_ngcontent-%COMP%]   .right-info[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:16px;line-height:20px;text-align:right;margin-bottom:5px}.headers-details.no-steps[_ngcontent-%COMP%]   .right-info[_ngcontent-%COMP%]   .amount-holder[_ngcontent-%COMP%]{text-align:right;color:#41a1d9}.headers-details.no-steps[_ngcontent-%COMP%]   .right-info[_ngcontent-%COMP%]   .amount-holder[_ngcontent-%COMP%]   .amount[_ngcontent-%COMP%]{font-size:24px;line-height:29px}.headers-details.no-steps[_ngcontent-%COMP%]   .right-info[_ngcontent-%COMP%]   .amount-holder[_ngcontent-%COMP%]   .sup-amount[_ngcontent-%COMP%]{font-size:14px;line-height:17px}";
function AddCardWizardDialogComponent_app_modal_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-modal", 5);
    i0.ɵɵlistener("closed", function AddCardWizardDialogComponent_app_modal_0_Template_app_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementStart(1, "app-modal-body");
    i0.ɵɵelementContainer(2, 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentRef_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("canClose", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", contentRef_r3);
  }
}
function AddCardWizardDialogComponent_app_mobile_modal_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-mobile-modal", 7);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("closed", function AddCardWizardDialogComponent_app_mobile_modal_1_Template_app_mobile_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementStart(2, "app-mobile-modal-body")(3, "div", 8);
    i0.ɵɵelementContainer(4, 6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentRef_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("titleVisible", false)("withCloseButton", true)("customTitle", i0.ɵɵpipeBind1(1, 4, "user-profile.promo-info.sign-lesson"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", contentRef_r3);
  }
}
function AddCardWizardDialogComponent_ng_template_2_ng_container_5_ng_template_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "spinner2");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "payment-form.payment-in-progress"));
  }
}
function AddCardWizardDialogComponent_ng_template_2_ng_container_5_ng_template_1_app_payment_widget_merchant_processing_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-payment-widget-merchant-processing", 21);
    i0.ɵɵlistener("succeed", function AddCardWizardDialogComponent_ng_template_2_ng_container_5_ng_template_1_app_payment_widget_merchant_processing_7_Template_app_payment_widget_merchant_processing_succeed_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onSuccess());
    })("failed", function AddCardWizardDialogComponent_ng_template_2_ng_container_5_ng_template_1_app_payment_widget_merchant_processing_7_Template_app_payment_widget_merchant_processing_failed_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onFail($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("payment", ctx_r1.payment)("isAccountPayment", false)("merchant", ctx_r1.merchant);
  }
}
function AddCardWizardDialogComponent_ng_template_2_ng_container_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, AddCardWizardDialogComponent_ng_template_2_ng_container_5_ng_template_1_div_6_Template, 5, 3, "div", 17)(7, AddCardWizardDialogComponent_ng_template_2_ng_container_5_ng_template_1_app_payment_widget_merchant_processing_7_Template, 1, 3, "app-payment-widget-merchant-processing", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 6, "profile-form.card.hint-title"));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("mobile", ctx_r1.deviceService.isMobile());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 8, "profile-form.card.hint-description"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.payment);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.payment);
  }
}
function AddCardWizardDialogComponent_ng_template_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddCardWizardDialogComponent_ng_template_2_ng_container_5_ng_template_1_Template, 8, 10, "ng-template", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.screen === "frame");
  }
}
function AddCardWizardDialogComponent_ng_template_2_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const successRef_r6 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", successRef_r6);
  }
}
function AddCardWizardDialogComponent_ng_template_2_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const failedRef_r7 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", failedRef_r7);
  }
}
function AddCardWizardDialogComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-step-by-step-wizard", 9);
    i0.ɵɵelementContainerStart(1, 10);
    i0.ɵɵelement(2, "app-add-card-header-details");
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(3, 11)(4, 12);
    i0.ɵɵtemplate(5, AddCardWizardDialogComponent_ng_template_2_ng_container_5_Template, 2, 1, "ng-container", 13)(6, AddCardWizardDialogComponent_ng_template_2_ng_template_6_Template, 1, 1, "ng-template", 14)(7, AddCardWizardDialogComponent_ng_template_2_ng_template_7_Template, 1, 1, "ng-template", 14);
    i0.ɵɵelementContainerEnd()();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("steps", ctx_r1.steps)("showHeader", true)("showFooter", false);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngSwitch", ctx_r1.activeView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "payment");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.screen === "success");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.screen === "fail");
  }
}
function AddCardWizardDialogComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 24);
    i0.ɵɵelement(5, "path", 25)(6, "path", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "meetings.wizard.add-card-success"));
  }
}
function AddCardWizardDialogComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 24);
    i0.ɵɵelement(5, "path", 28)(6, "rect", 29)(7, "rect", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(8, "div", 31);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "meetings.wizard.pay-fail"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.errorDescription);
  }
}
const _c19 = a0 => ({
  "amount": a0
});
function PlansCheckoutWizardDialogComponent_app_modal_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-modal", 4);
    i0.ɵɵlistener("closed", function PlansCheckoutWizardDialogComponent_app_modal_0_Template_app_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementStart(1, "app-modal-body");
    i0.ɵɵelementContainer(2, 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentRef_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("canClose", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", contentRef_r3);
  }
}
function PlansCheckoutWizardDialogComponent_app_mobile_modal_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-mobile-modal", 6);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("closed", function PlansCheckoutWizardDialogComponent_app_mobile_modal_1_Template_app_mobile_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementStart(2, "app-mobile-modal-body")(3, "div", 7);
    i0.ɵɵelementContainer(4, 5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentRef_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("titleVisible", false)("withCloseButton", true)("customTitle", i0.ɵɵpipeBind1(1, 4, "user-service-checkout-wizard.purchasing-tariff"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", contentRef_r3);
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_5_app_payment_widget_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-payment-widget", 20);
    i0.ɵɵlistener("configured", function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_5_app_payment_widget_1_Template_app_payment_widget_configured_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentConfigured($event));
    })("succeed", function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_5_app_payment_widget_1_Template_app_payment_widget_succeed_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentSucceed());
    })("failed", function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_5_app_payment_widget_1_Template_app_payment_widget_failed_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentFailed($event));
    })("processing", function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_5_app_payment_widget_1_Template_app_payment_widget_processing_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentProcessing($event));
    })("addAccount", function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_5_app_payment_widget_1_Template_app_payment_widget_addAccount_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onAddAccount($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("options", ctx_r1.paymentOptions)("payClicked", ctx_r1.payClicked)("needUpdate", ctx_r1.afterAddAccountNeedUpdate);
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_5_app_payment_widget_1_Template, 1, 3, "app-payment-widget", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.paymentOptions);
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_6_pre_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.paymentProcessingError);
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_6_pre_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.errorMessage);
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, "\u041A\u0430\u043A\u0430\u044F-\u0442\u043E \u043E\u0448\u0438\u0431\u043A\u0430");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4, "error");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_6_pre_5_Template, 2, 1, "pre", 21)(6, PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_6_pre_6_Template, 2, 1, "pre", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.paymentProcessingError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage);
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_div_7_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("paymentProcessingError = ", i0.ɵɵpipeBind1(2, 1, ctx_r1.paymentProcessingError), "");
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_div_7_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("errorMessage = ", i0.ɵɵpipeBind1(2, 1, ctx_r1.errorMessage), "");
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "pre");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, PlansCheckoutWizardDialogComponent_ng_template_2_div_7_div_10_Template, 3, 3, "div", 21)(11, PlansCheckoutWizardDialogComponent_ng_template_2_div_7_div_11_Template, 3, 3, "div", 21);
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "hr");
    i0.ɵɵelementStart(16, "pre");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "json");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("activeView = ", i0.ɵɵpipeBind1(3, 7, ctx_r1.activeView), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("paymentOptions = ", i0.ɵɵpipeBind1(6, 9, ctx_r1.paymentOptions), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("paymentConfigured = ", i0.ɵɵpipeBind1(9, 11, ctx_r1.paymentConfigured), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.paymentProcessingError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("canExecutePayment = ", i0.ɵɵpipeBind1(14, 13, ctx_r1.canExecutePayment()), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 15, ctx_r1.steps == null ? null : ctx_r1.steps.dump));
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_app_pay_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-pay-button", 23);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("start", function PlansCheckoutWizardDialogComponent_ng_template_2_app_pay_button_12_Template_app_pay_button_start_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onStartPayment());
    })("retry", function PlansCheckoutWizardDialogComponent_ng_template_2_app_pay_button_12_Template_app_pay_button_retry_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRetryPayment());
    })("cancel", function PlansCheckoutWizardDialogComponent_ng_template_2_app_pay_button_12_Template_app_pay_button_cancel_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("state", ctx_r1.payButtonsState)("disabled", !ctx_r1.canExecutePayment())("startLabel", i0.ɵɵpipeBind2(1, 6, "user-service-checkout-wizard.newpay", i0.ɵɵpureFunction1(15, _c19, ctx_r1.totalAmount.format())))("closeLabel", i0.ɵɵpipeBind1(2, 9, "user-service-checkout-wizard.close"))("cancelLabel", i0.ɵɵpipeBind1(3, 11, "user-service-checkout-wizard.to-complete"))("retryLabel", i0.ɵɵpipeBind1(4, 13, "user-service-checkout-wizard.try-again"));
  }
}
function PlansCheckoutWizardDialogComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-step-by-step-wizard", 8);
    i0.ɵɵelementContainerStart(1, 9);
    i0.ɵɵelement(2, "app-plans-header-details", 10);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(3, 11)(4, 12);
    i0.ɵɵtemplate(5, PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_5_Template, 2, 1, "ng-container", 13)(6, PlansCheckoutWizardDialogComponent_ng_template_2_ng_container_6_Template, 7, 2, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(7, PlansCheckoutWizardDialogComponent_ng_template_2_div_7_Template, 19, 17, "div", 14);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(9, 15);
    i0.ɵɵelement(10, "div", 16);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(11, 17);
    i0.ɵɵtemplate(12, PlansCheckoutWizardDialogComponent_ng_template_2_app_pay_button_12_Template, 5, 17, "app-pay-button", 18);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_10_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("steps", ctx_r1.steps)("showHeader", true)("showFooter", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", ctx_r1.activePlan);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r1.activeView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "payment");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "error");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 9, ctx_r1.debug$));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", (tmp_10_0 = ctx_r1.steps.get("payment")) == null ? null : tmp_10_0.active);
  }
}
function PlansCheckoutWizardDialogComponent_app_add_card_wizard_dialog_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-add-card-wizard-dialog", 24);
    i0.ɵɵlistener("closed", function PlansCheckoutWizardDialogComponent_app_add_card_wizard_dialog_4_Template_app_add_card_wizard_dialog_closed_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCloseAddAccount());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("providerId", ctx_r1.addAccountProviderId);
  }
}
function FinancePlanActivateFormV2Component_app_modal_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_modal_0_ng_template_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_modal_0_ng_template_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_modal_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanActivateFormV2Component_app_modal_0_ng_template_4_ng_container_0_Template, 1, 0, "ng-container", 11)(1, FinancePlanActivateFormV2Component_app_modal_0_ng_template_4_ng_container_1_Template, 1, 0, "ng-container", 11);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const content_r3 = i0.ɵɵreference(5);
    const actions_r4 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r4);
  }
}
function FinancePlanActivateFormV2Component_app_modal_0_ng_template_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_modal_0_ng_template_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_modal_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanActivateFormV2Component_app_modal_0_ng_template_5_ng_container_0_Template, 1, 0, "ng-container", 11)(1, FinancePlanActivateFormV2Component_app_modal_0_ng_template_5_ng_container_1_Template, 1, 0, "ng-container", 11);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const payment_r5 = i0.ɵɵreference(7);
    const paymentActions_r6 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", payment_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", paymentActions_r6);
  }
}
function FinancePlanActivateFormV2Component_app_modal_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-modal", 9);
    i0.ɵɵlistener("closed", function FinancePlanActivateFormV2Component_app_modal_0_Template_app_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal());
    });
    i0.ɵɵelementStart(1, "app-modal-body")(2, "section", 10);
    i0.ɵɵtemplate(3, FinancePlanActivateFormV2Component_app_modal_0_ng_container_3_Template, 1, 0, "ng-container", 11)(4, FinancePlanActivateFormV2Component_app_modal_0_ng_template_4_Template, 2, 2, "ng-template", 12)(5, FinancePlanActivateFormV2Component_app_modal_0_ng_template_5_Template, 2, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const paymentTemplate_r7 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    const header_r8 = i0.ɵɵreference(3);
    i0.ɵɵproperty("canClose", false);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("mobile", ctx_r1.deviceService.isMobile());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", header_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.openPaymentTemplate)("ngIfElse", paymentTemplate_r7);
  }
}
function FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_5_ng_container_0_Template, 1, 0, "ng-container", 11)(1, FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_5_ng_container_1_Template, 1, 0, "ng-container", 11);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const content_r3 = i0.ɵɵreference(5);
    const actions_r4 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r4);
  }
}
function FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_6_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_6_ng_container_0_Template, 1, 0, "ng-container", 11)(1, FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_6_ng_container_1_Template, 1, 0, "ng-container", 11);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const payment_r5 = i0.ɵɵreference(7);
    const paymentActions_r6 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", payment_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", paymentActions_r6);
  }
}
function FinancePlanActivateFormV2Component_app_mobile_modal_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-mobile-modal", 13);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("closed", function FinancePlanActivateFormV2Component_app_mobile_modal_1_Template_app_mobile_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal());
    });
    i0.ɵɵelementStart(2, "app-mobile-modal-body")(3, "section", 10);
    i0.ɵɵtemplate(4, FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_container_4_Template, 1, 0, "ng-container", 11)(5, FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_5_Template, 2, 2, "ng-template", 12)(6, FinancePlanActivateFormV2Component_app_mobile_modal_1_ng_template_6_Template, 2, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const paymentTemplate_r10 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext();
    const header_r8 = i0.ɵɵreference(3);
    i0.ɵɵproperty("titleVisible", false)("withCloseButton", true)("customTitle", i0.ɵɵpipeBind1(1, 8, "user-profile.promo-info.sign-lesson"));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("mobile", ctx_r1.deviceService.isMobile());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", header_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.openPaymentTemplate)("ngIfElse", paymentTemplate_r10);
  }
}
function FinancePlanActivateFormV2Component_ng_template_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 20);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 21)(4, "span", 22);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 23);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("fill", ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r1.svgSetIcon("finance-plan"), null, "xlink");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 5, "lingo2-forms.subscription-plans.forms.cancel-text"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(9, 7, "lingo2-forms.subscription-plans.forms.current-plan"), ": ", i0.ɵɵpipeBind1(10, 9, "lingo2-forms." + (ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.title)), "");
  }
}
function FinancePlanActivateFormV2Component_ng_template_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 20);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 24)(4, "span", 25);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 22);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 23);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("fill", ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r1.svgSetIcon("finance-plan"), null, "xlink");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 5, "lingo2-forms.subscription-plans.forms.header-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 7, "lingo2-forms." + (ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.title)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 9, "lingo2-forms." + (ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.subtitle)));
  }
}
function FinancePlanActivateFormV2Component_ng_template_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 26);
    i0.ɵɵelementContainerEnd();
  }
}
function FinancePlanActivateFormV2Component_ng_template_2_ng_container_7_div_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.formatCurrencyAmount(ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.old_price));
  }
}
function FinancePlanActivateFormV2Component_ng_template_2_ng_container_7_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, FinancePlanActivateFormV2Component_ng_template_2_ng_container_7_div_4_span_1_Template, 2, 1, "span", 29);
    i0.ɵɵtext(2, "\xA0 ");
    i0.ɵɵelementStart(3, "span", 30);
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "span", 31);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.old_price);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("color", ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentPrice, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" /", i0.ɵɵpipeBind1(7, 5, "lingo2-forms.subscription-plans.periods." + ctx_r1.planPeriodEnum[ctx_r1.plan.period]), "");
  }
}
function FinancePlanActivateFormV2Component_ng_template_2_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 26);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FinancePlanActivateFormV2Component_ng_template_2_ng_container_7_div_4_Template, 8, 7, "div", 27);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "lingo2-forms.subscription-plans.forms.activate-text"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.currentPrice);
  }
}
function FinancePlanActivateFormV2Component_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtemplate(2, FinancePlanActivateFormV2Component_ng_template_2_ng_container_2_Template, 11, 11, "ng-container", 16)(3, FinancePlanActivateFormV2Component_ng_template_2_ng_container_3_Template, 13, 11, "ng-container", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 18)(5, "div", 19);
    i0.ɵɵtemplate(6, FinancePlanActivateFormV2Component_ng_template_2_ng_container_6_Template, 2, 0, "ng-container", 16)(7, FinancePlanActivateFormV2Component_ng_template_2_ng_container_7_Template, 5, 4, "ng-container", 17);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r1.displayMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "cancel");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r1.displayMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "cancel");
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "p", 37);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 38);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "p", 39);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 3, "lingo2-forms.subscription-plans.forms.subscription-will-canceled"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 5, ctx_r1.activePlan == null ? null : ctx_r1.activePlan.expires_at, "dd.MM.yyyy"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 8, "lingo2-forms.subscription-plans.forms.cancel-mode-text2"));
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FinancePlanActivateFormV2Component_ng_template_4_ng_container_2_div_1_Template, 10, 10, "div", 35);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r1.activePlan == null ? null : ctx_r1.activePlan.next_plan_id) || !(ctx_r1.activePlan == null ? null : ctx_r1.activePlan.plan == null ? null : ctx_r1.activePlan.plan.is_default));
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 40);
    i0.ɵɵelementContainerEnd();
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_ng_container_6_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "loading-line", 41);
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_ng_container_6_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42)(1, "div", 43)(2, "span", 44);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 45);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 46);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 46);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 11, "lingo2-forms.subscription-plans.forms.total-credits-amount"), ": ", ctx_r1.getTotalCredits(), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(7, 13, "lingo2-forms.subscription-plans.forms.by-subscription"), " ", ctx_r1.getCreditsBySource("subscription"), " - ", i0.ɵɵpipeBind1(8, 15, "lingo2-forms.subscription-plans.forms.cancelled"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(11, 17, "lingo2-forms.subscription-plans.forms.purchased"), " ", ctx_r1.getCreditsBySource("purchased"), " - ", i0.ɵɵpipeBind1(12, 19, "lingo2-forms.subscription-plans.forms.persist"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate3("", i0.ɵɵpipeBind1(15, 21, "lingo2-forms.subscription-plans.forms.bonus"), " ", ctx_r1.getCreditsBySource("bonus"), " - ", i0.ɵɵpipeBind1(16, 23, "lingo2-forms.subscription-plans.forms.persist"), "");
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FinancePlanActivateFormV2Component_ng_template_4_ng_container_6_ng_template_1_Template, 1, 0, "ng-template", 12)(2, FinancePlanActivateFormV2Component_ng_template_4_ng_container_6_ng_template_2_Template, 17, 25, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cancel_r11 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.loaded)("ngIfElse", cancel_r11);
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_ng_container_7_div_6_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58)(1, "span", 59);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "\xA0 ");
    i0.ɵɵelementStart(4, "span", 60);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const term_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(term_r12 == null ? null : term_r12.side == null ? null : term_r12.side.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(term_r12 == null ? null : term_r12.side == null ? null : term_r12.side.text);
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_ng_container_7_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52)(1, "div", 53);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 54);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "div", 55);
    i0.ɵɵelement(5, "span", 56);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, FinancePlanActivateFormV2Component_ng_template_4_ng_container_7_div_6_ng_template_7_Template, 6, 2, "ng-template", 57);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const term_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("stroke", ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r1.svgSetIcon("finance-plan-property"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.replaceValues(i0.ɵɵpipeBind1(6, 4, "lingo2-forms." + (term_r12 == null ? null : term_r12.label))), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", term_r12 == null ? null : term_r12.side);
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 47)(2, "h2", 48);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 49);
    i0.ɵɵtemplate(6, FinancePlanActivateFormV2Component_ng_template_4_ng_container_7_div_6_Template, 8, 6, "div", 50);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 51)(8, "span", 39);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵpipe(11, "dfnsFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 39);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span", 39);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "lingo2-forms.subscription-plans.forms.activate-text"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.tariff_terms);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(10, 8, "lingo2-forms.subscription-plans.forms.next-payment"), " ", i0.ɵɵpipeBind2(11, 10, ctx_r1.planExpired, "dd MMMM yyyy"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 13, "lingo2-forms.subscription-plans.forms.next-payment-text1"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 15, "lingo2-forms.subscription-plans.forms.next-payment-text2"));
  }
}
function FinancePlanActivateFormV2Component_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementContainerStart(1, 33);
    i0.ɵɵtemplate(2, FinancePlanActivateFormV2Component_ng_template_4_ng_container_2_Template, 2, 1, "ng-container", 16)(3, FinancePlanActivateFormV2Component_ng_template_4_ng_container_3_Template, 2, 0, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(4, "div", 34);
    i0.ɵɵelementContainerStart(5, 33);
    i0.ɵɵtemplate(6, FinancePlanActivateFormV2Component_ng_template_4_ng_container_6_Template, 4, 2, "ng-container", 16)(7, FinancePlanActivateFormV2Component_ng_template_4_ng_container_7_Template, 18, 17, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("content ", ctx_r1.displayMode, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r1.displayMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "cancel");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngSwitch", ctx_r1.displayMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "cancel");
  }
}
function FinancePlanActivateFormV2Component_ng_template_6_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61)(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 62);
    i0.ɵɵelement(5, "path", 63)(6, "path", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(7, "div", 23);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "dfnsFormat");
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "user-service-checkout-wizard.unsub-success"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(10, 7, "user-service-checkout-wizard.unsubscribe.completetext", i0.ɵɵpureFunction1(10, _c3, i0.ɵɵpipeBind2(9, 4, ctx_r1.planExpired, "dd MMMM yyyy"))));
  }
}
function FinancePlanActivateFormV2Component_ng_template_6_ng_container_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65)(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 62);
    i0.ɵɵelement(5, "path", 66)(6, "rect", 67)(7, "rect", 68);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "user-service-checkout-wizard.unsub-failed"));
  }
}
function FinancePlanActivateFormV2Component_ng_template_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FinancePlanActivateFormV2Component_ng_template_6_ng_container_1_ng_template_1_Template, 11, 12, "ng-template", 57)(2, FinancePlanActivateFormV2Component_ng_template_6_ng_container_1_ng_template_2_Template, 8, 3, "ng-template", 57);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.accountPlan.plan_id !== ctx_r1.accountPlan.next_plan_id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.accountPlan.plan_id === ctx_r1.accountPlan.next_plan_id);
  }
}
function FinancePlanActivateFormV2Component_ng_template_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 69)(2, "app-plans-checkout-wizard-dialog", 70);
    i0.ɵɵlistener("succeed", function FinancePlanActivateFormV2Component_ng_template_6_ng_container_2_Template_app_plans_checkout_wizard_dialog_succeed_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSuccess());
    })("closed", function FinancePlanActivateFormV2Component_ng_template_6_ng_container_2_Template_app_plans_checkout_wizard_dialog_closed_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeModal());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", ctx_r1.plan)("checkoutInfo", ctx_r1.switchOperation);
  }
}
function FinancePlanActivateFormV2Component_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 33);
    i0.ɵɵtemplate(1, FinancePlanActivateFormV2Component_ng_template_6_ng_container_1_Template, 3, 2, "ng-container", 16)(2, FinancePlanActivateFormV2Component_ng_template_6_ng_container_2_Template, 3, 2, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r1.displayMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "cancel");
  }
}
function FinancePlanActivateFormV2Component_ng_template_8_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 74)(1, "div", 75)(2, "span", 44);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 76);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 77);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementStart(11, "span", 38);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "lingo2-forms.subscription-plans.forms.cancellation-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "lingo2-forms." + (ctx_r1.defaultPlan == null ? null : ctx_r1.defaultPlan.details == null ? null : ctx_r1.defaultPlan.details.title)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 8, "lingo2-forms.subscription-plans.forms.activated"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(13, 10, ctx_r1.activePlan == null ? null : ctx_r1.activePlan.expires_at, "dd.MM.yyyy"), " ");
  }
}
function FinancePlanActivateFormV2Component_ng_template_8_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FinancePlanActivateFormV2Component_ng_template_8_ng_container_2_div_1_Template, 14, 13, "div", 72);
    i0.ɵɵelementStart(2, "on-ui-button", 73);
    i0.ɵɵlistener("onclick", function FinancePlanActivateFormV2Component_ng_template_8_ng_container_2_Template_on_ui_button_onclick_2_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onCancelPlan());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isLimitedVersion);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.accountPlan && ctx_r1.accountPlan.plan_id !== ctx_r1.accountPlan.next_plan_id || ctx_r1.finalStep);
  }
}
function FinancePlanActivateFormV2Component_ng_template_8_ng_container_3_on_ui_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "on-ui-button", 81);
    i0.ɵɵlistener("onclick", function FinancePlanActivateFormV2Component_ng_template_8_ng_container_3_on_ui_button_2_Template_on_ui_button_onclick_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCancelPlan());
    });
    i0.ɵɵelementEnd();
  }
}
function FinancePlanActivateFormV2Component_ng_template_8_ng_container_3_on_ui_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "on-ui-button", 82);
    i0.ɵɵlistener("onclick", function FinancePlanActivateFormV2Component_ng_template_8_ng_container_3_on_ui_button_3_Template_on_ui_button_onclick_0_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onOpenPaymentTemplate());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r1.openPaymentTemplate && !ctx_r1.billingOperation);
  }
}
function FinancePlanActivateFormV2Component_ng_template_8_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 78);
    i0.ɵɵtemplate(2, FinancePlanActivateFormV2Component_ng_template_8_ng_container_3_on_ui_button_2_Template, 1, 0, "on-ui-button", 79)(3, FinancePlanActivateFormV2Component_ng_template_8_ng_container_3_on_ui_button_3_Template, 1, 1, "on-ui-button", 80);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isFreePlan);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isFreePlan);
  }
}
function FinancePlanActivateFormV2Component_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 71);
    i0.ɵɵelementContainerStart(1, 33);
    i0.ɵɵtemplate(2, FinancePlanActivateFormV2Component_ng_template_8_ng_container_2_Template, 3, 2, "ng-container", 16)(3, FinancePlanActivateFormV2Component_ng_template_8_ng_container_3_Template, 4, 2, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("limited", ctx_r1.isLimitedVersion);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r1.displayMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "cancel");
  }
}
function FinancePlanActivateFormV2Component_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 71);
    i0.ɵɵelement(1, "div", 74);
    i0.ɵɵelementStart(2, "on-ui-button", 83);
    i0.ɵɵlistener("onclick", function FinancePlanActivateFormV2Component_ng_template_10_Template_on_ui_button_onclick_2_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", !ctx_r1.finalStep);
  }
}
const _c20 = ["input_credits"];
const _c21 = (a0, a1) => ({
  "credits": a0,
  "discount": a1
});
function FinancePlanBuyCreditsFormComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanBuyCreditsFormComponent_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 9)(1, FinancePlanBuyCreditsFormComponent_ng_template_2_ng_container_1_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const content_r1 = i0.ɵɵreference(8);
    const actions_r2 = i0.ɵɵreference(12);
    i0.ɵɵproperty("ngTemplateOutlet", content_r1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r2);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanBuyCreditsFormComponent_ng_template_3_ng_container_0_Template, 1, 0, "ng-container", 9)(1, FinancePlanBuyCreditsFormComponent_ng_template_3_ng_container_1_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const payment_r3 = i0.ɵɵreference(10);
    const paymentActions_r4 = i0.ɵɵreference(14);
    i0.ɵɵproperty("ngTemplateOutlet", payment_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", paymentActions_r4);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 13);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "div", 14)(5, "span", 15);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 16);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 17);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "div", 18)(15, "div", 19)(16, "span", 20);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("fill", ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r4.svgsetIcon("finance-plan"), null, "xlink");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "lingo2-forms.subscription-plans.forms.header-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "lingo2-forms." + (ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.title)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 10, "lingo2-forms." + (ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.subtitle)));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 12, "lingo2-forms.subscription-plans.forms.buying-credits"));
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_7_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 33);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "span", 32);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementStart(9, "span", 33);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "span", 34);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 35)(16, "on-ui-button", 36);
    i0.ɵɵlistener("onclick", function FinancePlanBuyCreditsFormComponent_ng_template_7_ng_template_4_Template_on_ui_button_onclick_16_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.onActivatePlan());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 5, "lingo2-forms.subscription-plans.forms.your-plan"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 7, "lingo2-forms." + (ctx_r4.plan == null ? null : ctx_r4.plan.details == null ? null : ctx_r4.plan.details.title)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(8, 9, "lingo2-forms.subscription-plans.forms.recommended-plan"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 11, "lingo2-forms." + (ctx_r4.recommendedPlan == null ? null : ctx_r4.recommendedPlan.details == null ? null : ctx_r4.recommendedPlan.details.title)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(14, 13, "lingo2-forms.subscription-plans.forms.why-plan-text", i0.ɵɵpureFunction2(16, _c21, ctx_r4.diffCredits(), ctx_r4.diffDiscount())), " ");
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "div", 22);
    i0.ɵɵelementStart(2, "div", 23)(3, "div", 24);
    i0.ɵɵtemplate(4, FinancePlanBuyCreditsFormComponent_ng_template_7_ng_template_4_Template, 17, 19, "ng-template", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 26)(6, "div", 27)(7, "span", 28);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementStart(10, "input", 29, 6);
    i0.ɵɵtwoWayListener("ngModelChange", function FinancePlanBuyCreditsFormComponent_ng_template_7_Template_input_ngModelChange_10_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r4 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r4.creditsAmountValue, $event) || (ctx_r4.creditsAmountValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function FinancePlanBuyCreditsFormComponent_ng_template_7_Template_input_change_10_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onAmountChange());
    })("keydown", function FinancePlanBuyCreditsFormComponent_ng_template_7_Template_input_keydown_10_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onKeydown($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "span", 30);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementStart(15, "span", 31);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.recommendedPlan);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 6, "lingo2-forms.subscription-plans.forms.amount-credits"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r4.creditsAmountValue);
    i0.ɵɵproperty("disabled", ctx_r4.inputCreditsDisabled);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 8, "lingo2-forms.subscription-plans.forms.total-pay"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.formatCurrencyAmount(ctx_r4.currencyAmountValue));
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_9_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37)(1, "app-payment-form-universal", 38);
    i0.ɵɵlistener("cardSelected", function FinancePlanBuyCreditsFormComponent_ng_template_9_ng_template_0_Template_app_payment_form_universal_cardSelected_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.onCardSelected($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("transaction", ctx_r4.buyCreditsOperation);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_9_ng_template_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39)(1, "div", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 40);
    i0.ɵɵelement(5, "path", 41)(6, "path", 42);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "user-service-checkout-wizard.pay-success"));
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_9_ng_template_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43)(1, "div", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 40);
    i0.ɵɵelement(5, "path", 44)(6, "rect", 45)(7, "rect", 46);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "user-service-checkout-wizard.pay-failed"));
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_9_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanBuyCreditsFormComponent_ng_template_9_ng_template_1_ng_template_0_Template, 7, 3, "ng-template", 25)(1, FinancePlanBuyCreditsFormComponent_ng_template_9_ng_template_1_ng_template_1_Template, 8, 3, "ng-template", 25);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r4.billingOperation.status === ctx_r4.billingOperationStatusEnum.succeed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.billingOperation.status === ctx_r4.billingOperationStatusEnum.failed);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FinancePlanBuyCreditsFormComponent_ng_template_9_ng_template_0_Template, 2, 1, "ng-template", 10)(1, FinancePlanBuyCreditsFormComponent_ng_template_9_ng_template_1_Template, 2, 2, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const billingOperationStatus_r9 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r4.billingOperation)("ngIfElse", billingOperationStatus_r9);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47)(1, "button", 48);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "app-agreement-terms-field", 49);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtwoWayListener("valueChange", function FinancePlanBuyCreditsFormComponent_ng_template_11_Template_app_agreement_terms_field_valueChange_4_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r4 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r4.consentToPrivacyPolicy, $event) || (ctx_r4.consentToPrivacyPolicy = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "on-ui-button", 50);
    i0.ɵɵlistener("onclick", function FinancePlanBuyCreditsFormComponent_ng_template_11_Template_on_ui_button_onclick_8_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.buyCredits());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "lingo2-forms.subscription-plans.forms.action-buy-credits"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("value", ctx_r4.consentToPrivacyPolicy);
    i0.ɵɵproperty("agreementText", i0.ɵɵpipeBind2(7, 10, "lingo2-forms.subscription-plans.forms.agreements", i0.ɵɵpureFunction2(13, _c2, "<a href=\"/terms\" class=\"link normal\" target=\"_blank\">" + i0.ɵɵpipeBind1(5, 6, "lingo2-forms.subscription-plans.forms.agreements-terms1") + "</a>", "<a href=\"/privacy\" class=\"link normal\" target=\"_blank\">" + i0.ɵɵpipeBind1(6, 8, "lingo2-forms.subscription-plans.forms.agreements-terms2") + "</a>")));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r4.creditsAmountValue || !ctx_r4.consentToPrivacyPolicy || ctx_r4.openPaymentTemplate);
  }
}
function FinancePlanBuyCreditsFormComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47)(1, "on-ui-button", 51);
    i0.ɵɵlistener("onclick", function FinancePlanBuyCreditsFormComponent_ng_template_13_Template_on_ui_button_onclick_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onBuyCredits());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r4.selectedCard);
  }
}
function CreditCheckoutWizardDialogComponent_app_modal_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-modal", 6);
    i0.ɵɵlistener("closed", function CreditCheckoutWizardDialogComponent_app_modal_0_Template_app_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementStart(1, "app-modal-body");
    i0.ɵɵelementContainer(2, 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentRef_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("canClose", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", contentRef_r3);
  }
}
function CreditCheckoutWizardDialogComponent_app_mobile_modal_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-mobile-modal", 8);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("closed", function CreditCheckoutWizardDialogComponent_app_mobile_modal_1_Template_app_mobile_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementStart(2, "app-mobile-modal-body")(3, "div", 9);
    i0.ɵɵelementContainer(4, 7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentRef_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("titleVisible", false)("withCloseButton", true)("customTitle", i0.ɵɵpipeBind1(1, 4, "user-service-checkout-wizard.purchasing-credits"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", contentRef_r3);
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const credits_r5 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", credits_r5);
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-payment-widget", 24);
    i0.ɵɵlistener("configured", function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_configured_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentConfigured($event));
    })("succeed", function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_succeed_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentSucceed());
    })("failed", function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_failed_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentFailed($event));
    })("processing", function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_processing_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentProcessing($event));
    })("addAccount", function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_addAccount_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onAddAccount($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("options", ctx_r1.paymentOptions)("payClicked", ctx_r1.payClicked)("needUpdate", ctx_r1.afterAddAccountNeedUpdate);
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template, 1, 3, "app-payment-widget", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.paymentOptions);
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_7_pre_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.paymentProcessingError);
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_7_pre_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.errorMessage);
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, "\u041A\u0430\u043A\u0430\u044F-\u0442\u043E \u043E\u0448\u0438\u0431\u043A\u0430");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4, "error");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_7_pre_5_Template, 2, 1, "pre", 25)(6, CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_7_pre_6_Template, 2, 1, "pre", 25);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.paymentProcessingError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage);
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_div_8_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("paymentProcessingError = ", i0.ɵɵpipeBind1(2, 1, ctx_r1.paymentProcessingError), "");
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_div_8_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("errorMessage = ", i0.ɵɵpipeBind1(2, 1, ctx_r1.errorMessage), "");
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "pre");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, CreditCheckoutWizardDialogComponent_ng_template_2_div_8_div_10_Template, 3, 3, "div", 25)(11, CreditCheckoutWizardDialogComponent_ng_template_2_div_8_div_11_Template, 3, 3, "div", 25);
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "hr");
    i0.ɵɵelementStart(16, "pre");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "json");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("activeView = ", i0.ɵɵpipeBind1(3, 7, ctx_r1.activeView), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("paymentOptions = ", i0.ɵɵpipeBind1(6, 9, ctx_r1.paymentOptions), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("paymentConfigured = ", i0.ɵɵpipeBind1(9, 11, ctx_r1.paymentConfigured), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.paymentProcessingError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("canExecutePayment = ", i0.ɵɵpipeBind1(14, 13, ctx_r1.canExecutePayment()), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 15, ctx_r1.steps == null ? null : ctx_r1.steps.dump));
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_on_ui_button_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "on-ui-button", 27);
    i0.ɵɵlistener("click", function CreditCheckoutWizardDialogComponent_ng_template_2_on_ui_button_13_Template_on_ui_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.buyCredits());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("state", "default")("label", "meetings.wizard.next");
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_app_pay_button_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-pay-button", 28);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("start", function CreditCheckoutWizardDialogComponent_ng_template_2_app_pay_button_14_Template_app_pay_button_start_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onStartPayment());
    })("retry", function CreditCheckoutWizardDialogComponent_ng_template_2_app_pay_button_14_Template_app_pay_button_retry_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRetryPayment());
    })("cancel", function CreditCheckoutWizardDialogComponent_ng_template_2_app_pay_button_14_Template_app_pay_button_cancel_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("state", ctx_r1.payButtonsState)("disabled", !ctx_r1.canExecutePayment())("startLabel", i0.ɵɵpipeBind2(1, 6, "user-service-checkout-wizard.newpay", i0.ɵɵpureFunction1(15, _c19, ctx_r1.totalAmount.format())))("closeLabel", i0.ɵɵpipeBind1(2, 9, "user-service-checkout-wizard.close"))("cancelLabel", i0.ɵɵpipeBind1(3, 11, "user-service-checkout-wizard.to-complete"))("retryLabel", i0.ɵɵpipeBind1(4, 13, "user-service-checkout-wizard.try-again"));
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-step-by-step-wizard", 10);
    i0.ɵɵelementContainerStart(1, 11);
    i0.ɵɵelement(2, "app-credit-header-details", 12);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(3, 13)(4, 14);
    i0.ɵɵtemplate(5, CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_5_Template, 2, 1, "ng-container", 15)(6, CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_6_Template, 2, 1, "ng-container", 15)(7, CreditCheckoutWizardDialogComponent_ng_template_2_ng_container_7_Template, 7, 2, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(8, CreditCheckoutWizardDialogComponent_ng_template_2_div_8_Template, 19, 17, "div", 16);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(10, 17);
    i0.ɵɵelement(11, "div", 18);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(12, 19);
    i0.ɵɵtemplate(13, CreditCheckoutWizardDialogComponent_ng_template_2_on_ui_button_13_Template, 1, 2, "on-ui-button", 20)(14, CreditCheckoutWizardDialogComponent_ng_template_2_app_pay_button_14_Template, 5, 17, "app-pay-button", 21);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_12_0;
    let tmp_13_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("steps", ctx_r1.steps)("showHeader", true)("showFooter", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", ctx_r1.activePlan);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r1.activeView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "credits");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "payment");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "error");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(9, 11, ctx_r1.debug$));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", (tmp_12_0 = ctx_r1.steps.get("credits")) == null ? null : tmp_12_0.active);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (tmp_13_0 = ctx_r1.steps.get("payment")) == null ? null : tmp_13_0.active);
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_4_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 40);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 41);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "span", 40);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementStart(9, "span", 41);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "span", 42);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 43)(16, "on-ui-button", 44);
    i0.ɵɵlistener("onclick", function CreditCheckoutWizardDialogComponent_ng_template_4_ng_template_4_Template_on_ui_button_onclick_16_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onActivatePlan());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 5, "lingo2-forms.subscription-plans.forms.your-plan"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 7, "lingo2-forms." + (ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.title)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(8, 9, "lingo2-forms.subscription-plans.forms.recommended-plan"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 11, "lingo2-forms." + (ctx_r1.recommendedPlan == null ? null : ctx_r1.recommendedPlan.details == null ? null : ctx_r1.recommendedPlan.details.title)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(14, 13, "lingo2-forms.subscription-plans.forms.why-plan-text", i0.ɵɵpureFunction2(16, _c21, ctx_r1.diffCredits(), ctx_r1.diffDiscount())), " ");
  }
}
function CreditCheckoutWizardDialogComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelement(1, "div", 30);
    i0.ɵɵelementStart(2, "div", 31)(3, "div", 32);
    i0.ɵɵtemplate(4, CreditCheckoutWizardDialogComponent_ng_template_4_ng_template_4_Template, 17, 19, "ng-template", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 34)(6, "div", 35)(7, "span", 36);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementStart(10, "input", 37, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function CreditCheckoutWizardDialogComponent_ng_template_4_Template_input_ngModelChange_10_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.creditsAmountValue, $event) || (ctx_r1.creditsAmountValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function CreditCheckoutWizardDialogComponent_ng_template_4_Template_input_change_10_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAmountChange());
    })("input", function CreditCheckoutWizardDialogComponent_ng_template_4_Template_input_input_10_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAmountChange());
    })("keydown", function CreditCheckoutWizardDialogComponent_ng_template_4_Template_input_keydown_10_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onKeydown($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "span", 38);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementStart(15, "span", 39);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.screenClasses());
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.recommendedPlan);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 7, "lingo2-forms.subscription-plans.forms.amount-credits"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.creditsAmountValue);
    i0.ɵɵproperty("disabled", ctx_r1.inputCreditsDisabled);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 9, "lingo2-forms.subscription-plans.forms.total-pay"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.formatCurrencyAmount(ctx_r1.currencyAmountValue));
  }
}
function CreditCheckoutWizardDialogComponent_app_add_card_wizard_dialog_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-add-card-wizard-dialog", 45);
    i0.ɵɵlistener("closed", function CreditCheckoutWizardDialogComponent_app_add_card_wizard_dialog_6_Template_app_add_card_wizard_dialog_closed_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCloseAddAccount());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("providerId", ctx_r1.addAccountProviderId);
  }
}
function MeetingSelectComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.placeholder));
  }
}
function MeetingSelectComponent_ng_template_5_app_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-icon", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("icon", ctx_r1.selectedOption.icon)("width", 24)("height", 24);
  }
}
function MeetingSelectComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, MeetingSelectComponent_ng_template_5_app_icon_1_Template, 1, 3, "app-icon", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedOption == null ? null : ctx_r1.selectedOption.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, ctx_r1.selectedOption.title), " ");
  }
}
function MeetingSelectComponent_div_7_div_1_app_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-icon", 8);
  }
  if (rf & 2) {
    const option_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("icon", option_r4.icon)("width", 24)("height", 24);
  }
}
function MeetingSelectComponent_div_7_div_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r4.subtitle);
  }
}
function MeetingSelectComponent_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function MeetingSelectComponent_div_7_div_1_Template_div_click_0_listener() {
      const option_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onChanged(option_r4));
    });
    i0.ɵɵtemplate(1, MeetingSelectComponent_div_7_div_1_app_icon_1_Template, 1, 3, "app-icon", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, MeetingSelectComponent_div_7_div_1_span_4_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r4 == null ? null : option_r4.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, option_r4.title), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", option_r4 == null ? null : option_r4.subtitle);
  }
}
function MeetingSelectComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, MeetingSelectComponent_div_7_div_1_Template, 5, 5, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.options)("ngForTrackBy", ctx_r1.trackByFn);
  }
}
function TabClassroomsComponent_ng_container_4_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "app-classroom-panel", 7);
    i0.ɵɵlistener("click", function TabClassroomsComponent_ng_container_4_ng_container_5_Template_app_classroom_panel_click_1_listener() {
      const classroom_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.selectClassroom(classroom_r3));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const classroom_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("classroom", classroom_r3);
  }
}
function TabClassroomsComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtemplate(5, TabClassroomsComponent_ng_container_4_ng_container_5_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "lingo2-forms.meetings.classrooms.continue-class"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r3.classrooms);
  }
}
function TabClassroomsComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 9);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "lingo2-forms.meetings.classrooms.no-classes"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(5, 4, "lingo2-forms.meetings.classrooms.no-classes-description"), i0.ɵɵsanitizeHtml);
  }
}
const _c22 = ".empty[_ngcontent-%COMP%]{font-size:14px;line-height:100%;color:#a4b0c3;text-align:center;padding:20px}";
function MeetingSelectClassComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, ctx_r1.classroom_id === "new" ? "lingo2-forms.meetings.placeholders.tab" : ctx_r1.placeholder), " ");
  }
}
function MeetingSelectClassComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-classroom-panel", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hasHover", false)("classroom", ctx_r1.selectedClassroom);
  }
}
function MeetingSelectClassComponent_div_7_app_tab_classrooms_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-tab-classrooms", 12);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("changed", function MeetingSelectClassComponent_div_7_app_tab_classrooms_2_Template_app_tab_classrooms_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onClassroomChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("classrooms", ctx_r1.classrooms)("placeholder", i0.ɵɵpipeBind1(1, 2, "lingo2-forms.meetings.placeholders.tab"));
  }
}
function MeetingSelectClassComponent_div_7_app_tab_students_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-tab-students");
  }
}
function MeetingSelectClassComponent_div_7_app_tab_groups_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-tab-groups");
  }
}
function MeetingSelectClassComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementContainerStart(1, 9);
    i0.ɵɵtemplate(2, MeetingSelectClassComponent_div_7_app_tab_classrooms_2_Template, 2, 4, "app-tab-classrooms", 10)(3, MeetingSelectClassComponent_div_7_app_tab_students_3_Template, 1, 0, "app-tab-students", 11)(4, MeetingSelectClassComponent_div_7_app_tab_groups_4_Template, 1, 0, "app-tab-groups", 11);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r1.activeTabId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.tabsEnum.all);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.tabsEnum.students);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.tabsEnum.groups);
  }
}
function AuthorItemComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 7);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 9);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.svgSetIcon("rating"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.changeRateFormat);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" (", ctx_r0.stats == null ? null : ctx_r0.stats.reviews_count, " ", i0.ɵɵpipeBind1(7, 4, "lingo2-forms.meetings.meeting-select-author.reviews-count"), ") ");
  }
}
function AuthorItemComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵelement(2, "on-ui-cover", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AuthorItemComponent_div_0_div_5_Template, 8, 6, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cover", ctx_r0.cover);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.fullName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.stats == null ? null : ctx_r0.stats.reviews_count);
  }
}
function MeetingSelectAuthorComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-author-item", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("author", ctx_r1.selectedOption);
  }
}
function MeetingSelectAuthorComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "lingo2-forms.meetings.meeting-select-author.select-tutor"), " ");
  }
}
function MeetingSelectAuthorComponent_div_7_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function MeetingSelectAuthorComponent_div_7_ng_container_2_div_1_Template_div_click_0_listener() {
      const author_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onChanged(author_r4));
    });
    i0.ɵɵelement(1, "app-author-item", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const author_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("author", author_r4);
  }
}
function MeetingSelectAuthorComponent_div_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MeetingSelectAuthorComponent_div_7_ng_container_2_div_1_Template, 2, 1, "div", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.schoolParticipants)("ngForTrackBy", ctx_r1.trackByFn);
  }
}
function MeetingSelectAuthorComponent_div_7_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "lingo2-forms.meetings.meeting-select-author.no-tutor-message"), " ");
  }
}
function MeetingSelectAuthorComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵtemplate(2, MeetingSelectAuthorComponent_div_7_ng_container_2_Template, 2, 2, "ng-container", 5)(3, MeetingSelectAuthorComponent_div_7_ng_template_3_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const emptyDropdown_r5 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.schoolParticipants.length)("ngIfElse", emptyDropdown_r5);
  }
}
const _c23 = a0 => ({
  "teacher-error": a0
});
function NotAvailableTimeInformerComponent_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\xA0 ");
    i0.ɵɵelementStart(5, "span", 14);
    i0.ɵɵtext(6, "Tess Luthor");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "lingo2-forms.meetings.not-available-time-informer.student"), "");
  }
}
function NotAvailableTimeInformerComponent_span_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵlistener("click", function NotAvailableTimeInformerComponent_span_16_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.writeUser());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "lingo2-forms.meetings.not-available-time-informer.send-message"), " ");
  }
}
function NotAvailableTimeInformerComponent_div_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17)(2, "on-ui-button", 18);
    i0.ɵɵlistener("onclick", function NotAvailableTimeInformerComponent_div_20_Template_on_ui_button_onclick_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCancel());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 17)(4, "on-ui-button", 19);
    i0.ɵɵlistener("onclick", function NotAvailableTimeInformerComponent_div_20_Template_on_ui_button_onclick_4_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onReschedule());
    });
    i0.ɵɵelementEnd()()();
  }
}
function MeetingHeaderComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 5);
    i0.ɵɵlistener("click", function MeetingHeaderComponent_div_4_Template_span_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBuyCredits());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(3, 3, "lingo2-forms.meetings.form-credits-available"), " ", ctx_r1.creditsAmount || 0, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, "lingo2-forms.meetings.form-buy-credits-header"), " ");
  }
}
const _c24 = [[["", "image-upload", ""]], [["", "timezone", ""]]];
const _c25 = ["[image-upload]", "[timezone]"];
const _c26 = (a0, a1) => ({
  term1: a0,
  term2: a1
});
function MeetingFormComponent_div_4_app_meeting_step_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-meeting-step", 16);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "app-form-field", 11)(3, "app-meeting-select-class", 17);
    i0.ɵɵlistener("closed", function MeetingFormComponent_div_4_app_meeting_step_1_Template_app_meeting_select_class_closed_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClassroomViewed());
    })("changed", function MeetingFormComponent_div_4_app_meeting_step_1_Template_app_meeting_select_class_changed_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClassroomChanged());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("index", 0)("first", true)("title", i0.ɵɵpipeBind1(1, 8, "lingo2-forms.meetings.steps.classroom"))("completed", ctx_r2.isStepCompleted(0))("active", ctx_r2.isStepActive(0));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("me", ctx_r2.me)("classrooms", ctx_r2.classrooms)("readonly", ctx_r2.isReadonly("classroom_id") || ctx_r2.isEditFormAction);
  }
}
function MeetingFormComponent_div_4_app_meeting_step_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-meeting-step", 18);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "app-form-field", 11)(3, "app-meeting-select-author", 19);
    i0.ɵɵlistener("changed", function MeetingFormComponent_div_4_app_meeting_step_2_Template_app_meeting_select_author_changed_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onAuthorId($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("index", 0)("first", true)("title", i0.ɵɵpipeBind1(1, 8, "lingo2-forms.meetings.steps.tutor"))("completed", ctx_r2.isStepCompleted(0))("active", ctx_r2.isStepActive(0))("disabled", ctx_r2.form.controls.author_id.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("schoolParticipants", ctx_r2.schoolParticipants())("active", ctx_r2.isStepActive(0) && ctx_r2.form.controls.author_id.enabled);
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54)(1, "div", 55);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "lingo2-forms.meetings.form-error-choose-option"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54)(1, "div", 55);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "lingo2-forms.meetings.form-error-choose-option"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_label_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 35);
    i0.ɵɵelement(1, "input", 36)(2, "span", 37);
    i0.ɵɵelementStart(3, "span", 38);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("invalid", !ctx_r2.isValid("begin.immediate_time"))("disabled", ctx_r2.isEditFormAction);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r2.constants.immediate_time);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 6, "lingo2-forms.meetings.inputs-label.create-now"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵelement(1, "app-not-available-time-informer", 57);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("meeting", ctx_r2.anotherMeeting);
  }
}
function MeetingFormComponent_div_4_ng_container_12_span_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 58);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_32_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "app-form-field", 59)(2, "on-ui-date", 60);
    i0.ɵɵlistener("changed", function MeetingFormComponent_div_4_ng_container_12_div_32_Template_on_ui_date_changed_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.updateTimeLists());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "app-form-field", 61);
    i0.ɵɵelement(4, "on-ui-select", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "app-form-field", 63);
    i0.ɵɵelement(6, "on-ui-select", 64);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r2.form.controls.date);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r2.isEditFormAction);
    i0.ɵɵproperty("locale", ctx_r2.locale)("startView", ctx_r2.datePickerConfig.startView)("max", ctx_r2.datePickerConfig.max)("min", ctx_r2.datePickerConfig.min);
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r2.form.controls.begin_at);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r2.isEditFormAction);
    i0.ɵɵproperty("options", ctx_r2.timeBeginAtList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r2.form.controls.end_at);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r2.isEditFormAction);
    i0.ɵɵproperty("options", ctx_r2.timeEndAtList);
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_template_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵelement(1, "app-not-available-time-informer", 65);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("error", !ctx_r2.isTimeAvailable)("meeting", ctx_r2.anotherMeeting);
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_template_40_label_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 35);
    i0.ɵɵelement(1, "input", 66)(2, "span", 37);
    i0.ɵɵelementStart(3, "span", 38);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("disabled", ctx_r2.isEditFormAction)("invalid", !ctx_r2.isValid("charging.free"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r2.constants.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 6, "lingo2-forms.meetings.inputs-label.free"), " ");
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_template_40_label_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 58);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 67);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "lingo2-forms.meetings.form-balance-note"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", ctx_r2.formatCredits(ctx_r2.creditsAmount), " ", i0.ɵɵpipeBind1(5, 5, "lingo2-forms.meetings.form-credits"), " ");
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_template_40_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 35);
    i0.ɵɵelement(1, "input", 66)(2, "span", 37);
    i0.ɵɵelementStart(3, "span", 38);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, MeetingFormComponent_div_4_ng_container_12_ng_template_40_label_1_span_6_Template, 6, 7, "span", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("disabled", ctx_r2.isEditFormAction)("invalid", !ctx_r2.isValid("charging.credits"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r2.constants.credits);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("warn", !ctx_r2.isValid("charging"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 9, "lingo2-forms.meetings.inputs-label.credits"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.form.get("charging").value === ctx_r2.constants.credits);
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_template_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MeetingFormComponent_div_4_ng_container_12_ng_template_40_label_0_Template, 6, 8, "label", 41)(1, MeetingFormComponent_div_4_ng_container_12_ng_template_40_label_1_Template, 7, 11, "label", 41);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r2.isFreeChargingAllowed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isCreditsChargingAllowed);
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_container_41_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_container_41_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵtemplate(1, MeetingFormComponent_div_4_ng_container_12_ng_container_41_div_1_ng_container_1_Template, 1, 0, "ng-container", 70);
    i0.ɵɵelementStart(2, "div", 71)(3, "span", 72);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 73)(7, "span", 74);
    i0.ɵɵlistener("click", function MeetingFormComponent_div_4_ng_container_12_ng_container_41_div_1_Template_span_click_7_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onOpenPaywall());
    });
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 74);
    i0.ɵɵlistener("click", function MeetingFormComponent_div_4_ng_container_12_ng_container_41_div_1_Template_span_click_10_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onBuyCredits());
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const plan_r8 = i0.ɵɵreference(47);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", plan_r8);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, "lingo2-forms.meetings.hints.credit"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 6, "lingo2-forms.meetings.choose-plan-action"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 8, "lingo2-forms.meetings.buy-credits-action"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_container_41_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MeetingFormComponent_div_4_ng_container_12_ng_container_41_div_1_Template, 13, 10, "div", 68);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.activePlan);
  }
}
function MeetingFormComponent_div_4_ng_container_12_label_42_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 35);
    i0.ɵɵelement(1, "input", 66)(2, "span", 37);
    i0.ɵɵelementStart(3, "span", 38);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("disabled", ctx_r2.isEditFormAction)("invalid", !ctx_r2.isValid("charging.fee"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r2.constants.fee);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 6, "lingo2-forms.meetings.inputs-label.safe"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_container_43_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_container_43_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵtemplate(1, MeetingFormComponent_div_4_ng_container_12_ng_container_43_div_1_ng_container_1_Template, 1, 0, "ng-container", 70);
    i0.ɵɵelementStart(2, "div", 71)(3, "span", 72);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 74);
    i0.ɵɵlistener("click", function MeetingFormComponent_div_4_ng_container_12_ng_container_43_div_1_Template_span_click_6_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onOpenPaywall());
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const plan_r8 = i0.ɵɵreference(47);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", plan_r8);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(5, 3, "lingo2-forms.meetings.hints.secure", i0.ɵɵpureFunction2(8, _c26, ctx_r2.activePlanSafeTradeCommission(), 100 - ctx_r2.activePlanSafeTradeCommission())));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 6, "lingo2-forms.meetings.choose-plan-action"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_container_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MeetingFormComponent_div_4_ng_container_12_ng_container_43_div_1_Template, 9, 11, "div", 68);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.activePlan);
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_44_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 75)(1, "span", 76);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "a", 77);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "lingo2-forms.meetings.hints.verification-for-fee"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "lingo2-forms.meetings.hints.verification-link"), " ");
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_45_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 75)(1, "span", 76);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "a", 78);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "lingo2-forms.meetings.hints.verification-for-beneficiary"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "lingo2-forms.meetings.hints.beneficiary-link"), " ");
  }
}
function MeetingFormComponent_div_4_ng_container_12_ng_template_46_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵlistener("click", function MeetingFormComponent_div_4_ng_container_12_ng_template_46_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onOpenPaywall());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 80);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 81);
    i0.ɵɵlistener("click", function MeetingFormComponent_div_4_ng_container_12_ng_template_46_Template_div_click_3_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onOpenPaywall());
    });
    i0.ɵɵelementStart(4, "span", 82);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 83);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("fill", ctx_r2.activePlan == null ? null : ctx_r2.activePlan.plan == null ? null : ctx_r2.activePlan.plan.details == null ? null : ctx_r2.activePlan.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r2.svgSetIcon("finance-plan"), null, "xlink");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, "banner-plan.title"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 6, ctx_r2.activePlan == null ? null : ctx_r2.activePlan.plan == null ? null : ctx_r2.activePlan.plan.details == null ? null : ctx_r2.activePlan.plan.details.title));
  }
}
function MeetingFormComponent_div_4_ng_container_12_app_form_field_56_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-form-field", 84);
    i0.ɵɵelement(1, "on-ui-select", 85);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("field_error", !ctx_r2.isValid("participants_limit"));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r2.isEditFormAction);
    i0.ɵɵproperty("options", ctx_r2.groupLimitsList);
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_57_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 88);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 58);
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lingo2-forms.meetings.form-not-credits"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_57_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 89);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lingo2-forms.meetings.form-carrying-possible"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_57_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 86)(1, "span", 58);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 67);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, MeetingFormComponent_div_4_ng_container_12_div_57_ng_template_7_Template, 4, 3, "ng-template", 87)(8, MeetingFormComponent_div_4_ng_container_12_div_57_ng_template_8_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const creditsBalanceOk_r11 = i0.ɵɵreference(9);
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "lingo2-forms.meetings.form-required"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", ctx_r2.formatCredits(ctx_r2.calc ? ctx_r2.calc.maxCredits : null), " ", i0.ɵɵpipeBind1(6, 7, "lingo2-forms.meetings.form-credits"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.form.errors == null ? null : ctx_r2.form.errors.creditsBalanceLow)("ngIfElse", creditsBalanceOk_r11);
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_58_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54)(1, "div", 55);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "lingo2-forms.meetings.form-error-choose-option"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_58_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "span", 31);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 32)(5, "app-form-field", 90);
    i0.ɵɵelement(6, "on-ui-select", 91);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, MeetingFormComponent_div_4_ng_container_12_div_58_div_8_Template, 4, 3, "div", 25);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 10, "lingo2-forms.meetings.form-participation-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("field_error", !ctx_r2.isValid("price_tier"));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r2.isEditFormAction);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(7, 12, "lingo2-forms.meetings.form-price-placeholder"))("error", !ctx_r2.isValid("price_tier"))("options", ctx_r2.pricesList)("autosize", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isValid("price_tier"));
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_61_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 92)(1, "span", 93);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 94);
    i0.ɵɵlistener("click", function MeetingFormComponent_div_4_ng_container_12_div_61_Template_button_click_3_listener() {
      const idx_r13 = i0.ɵɵrestoreView(_r12).index;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.removeKeyword(idx_r13));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 95);
    i0.ɵɵelement(5, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const control_r14 = ctx.$implicit;
    const idx_r13 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroupName", idx_r13);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(control_r14.get("keyword").value);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r2.svgSetIcon("remove"), null, "xlink");
  }
}
function MeetingFormComponent_div_4_ng_container_12_div_64_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("[debug: on] ", i0.ɵɵpipeBind1(2, 1, ctx_r2.saveError), "");
  }
}
function MeetingFormComponent_div_4_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-meeting-step", 20);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "div", 21)(4, "app-form-field", 22);
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 23)(7, "div", 10)(8, "app-form-field", 11)(9, "app-subject-selector", 24);
    i0.ɵɵlistener("selectSubjectId", function MeetingFormComponent_div_4_ng_container_12_Template_app_subject_selector_selectSubjectId_9_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.selectSubjectId($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, MeetingFormComponent_div_4_ng_container_12_div_10_Template, 4, 3, "div", 25);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "app-form-field", 26);
    i0.ɵɵelement(12, "on-ui-input", 27);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵtemplate(14, MeetingFormComponent_div_4_ng_container_12_div_14_Template, 4, 3, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "app-form-field", 26);
    i0.ɵɵelement(16, "on-ui-textarea", 28);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(17, "div", 29)(18, "div", 30)(19, "span", 31);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 32);
    i0.ɵɵtemplate(23, MeetingFormComponent_div_4_ng_container_12_label_23_Template, 6, 8, "label", 33)(24, MeetingFormComponent_div_4_ng_container_12_ng_template_24_Template, 2, 1, "ng-template", 34);
    i0.ɵɵelementStart(25, "label", 35);
    i0.ɵɵelement(26, "input", 36)(27, "span", 37);
    i0.ɵɵelementStart(28, "span", 38);
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(31, MeetingFormComponent_div_4_ng_container_12_span_31_Template, 2, 0, "span", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, MeetingFormComponent_div_4_ng_container_12_div_32_Template, 7, 15, "div", 40)(33, MeetingFormComponent_div_4_ng_container_12_ng_template_33_Template, 2, 2, "ng-template", 34);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 29)(35, "div", 30)(36, "span", 31);
    i0.ɵɵtext(37);
    i0.ɵɵpipe(38, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 32);
    i0.ɵɵtemplate(40, MeetingFormComponent_div_4_ng_container_12_ng_template_40_Template, 2, 2, "ng-template", 34)(41, MeetingFormComponent_div_4_ng_container_12_ng_container_41_Template, 2, 1, "ng-container", 15)(42, MeetingFormComponent_div_4_ng_container_12_label_42_Template, 6, 8, "label", 41)(43, MeetingFormComponent_div_4_ng_container_12_ng_container_43_Template, 2, 1, "ng-container", 15)(44, MeetingFormComponent_div_4_ng_container_12_div_44_Template, 7, 6, "div", 42)(45, MeetingFormComponent_div_4_ng_container_12_div_45_Template, 7, 6, "div", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(46, MeetingFormComponent_div_4_ng_container_12_ng_template_46_Template, 10, 8, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "div", 30)(49, "span", 31);
    i0.ɵɵtext(50);
    i0.ɵɵpipe(51, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "div", 43)(53, "app-form-field", 44);
    i0.ɵɵelement(54, "on-ui-select", 45);
    i0.ɵɵpipe(55, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(56, MeetingFormComponent_div_4_ng_container_12_app_form_field_56_Template, 2, 5, "app-form-field", 46)(57, MeetingFormComponent_div_4_ng_container_12_div_57_Template, 10, 9, "div", 47);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(58, MeetingFormComponent_div_4_ng_container_12_div_58_Template, 9, 14, "div", 48);
    i0.ɵɵelementStart(59, "div", 49)(60, "div", 50);
    i0.ɵɵtemplate(61, MeetingFormComponent_div_4_ng_container_12_div_61_Template, 6, 3, "div", 51);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(62, "div", 52)(63, "on-ui-button", 53);
    i0.ɵɵlistener("onclick", function MeetingFormComponent_div_4_ng_container_12_Template_on_ui_button_onclick_63_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.save());
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(64, MeetingFormComponent_div_4_ng_container_12_div_64_Template, 3, 3, "div", 15);
    i0.ɵɵpipe(65, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 64, "lingo2-forms.meetings.steps.setup"));
    i0.ɵɵproperty("index", 3)("completed", ctx_r2.isStepCompleted(3))("active", ctx_r2.isStepActive(3))("last", true)("noContent", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", ctx_r2.form.controls.cover_id);
    i0.ɵɵadvance(4);
    i0.ɵɵclassProp("field_error", !ctx_r2.isValid("subject_id"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("subjects", ctx_r2.subjects)("subjectSelectedId", ctx_r2.subject == null ? null : ctx_r2.subject.value)("valid", ctx_r2.isValid("subject_id"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isValid("subject_id"));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("field_error", !ctx_r2.isValid("title"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("maxlength", 90)("hasCounter", true)("placeholder", i0.ɵɵpipeBind1(13, 66, "lingo2-forms.meetings.form-title-placeholder"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isValid("title"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("height", 25)("minHeight", 10)("rows", 1)("maxlength", 2000);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 68, "lingo2-forms.meetings.form-time-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.isSchoolMeeting);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isValid("begin.immediate_time") && ctx_r2.anotherMeeting);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("invalid", !ctx_r2.isValid("begin.specified_time"))("disabled", ctx_r2.isEditFormAction);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r2.constants.specified_time);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("warn", !ctx_r2.isValid("date"));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("warn", !ctx_r2.isValid("date"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(30, 70, "lingo2-forms.meetings.inputs-label.choose-time"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.form.get("begin").value === ctx_r2.constants.specified_time);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.form.get("begin").value === ctx_r2.constants.specified_time);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!ctx_r2.isValid("begin.specified_time") || ctx_r2.showTimeInformer) && ctx_r2.anotherMeeting);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("invalid", !ctx_r2.isValid("charging"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(38, 72, "lingo2-forms.meetings.form-type-calc-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.isSchoolMeeting);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.form.get("charging").value === ctx_r2.constants.credits);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isFeeChargingAllowed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.form.get("charging").value === ctx_r2.constants.fee);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.form.errors == null ? null : ctx_r2.form.errors.feeRequireVerification);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.form.errors == null ? null : ctx_r2.form.errors.feeBeneficiaryVerification);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("invalid", !ctx_r2.isValid("type") || !ctx_r2.isValid("participants_limit"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(51, 74, "lingo2-forms.meetings.form-number-participants-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("field_error", !ctx_r2.isValid("type"));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r2.isEditFormAction);
    i0.ɵɵproperty("options", ctx_r2.typesList)("placeholder", i0.ɵɵpipeBind1(55, 76, "lingo2-forms.meetings.participants-limit-placeholder"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.form.get("type").value === ctx_r2.constants.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.form.get("charging").value === ctx_r2.constants.credits);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.form.get("charging").value === ctx_r2.constants.fee);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.keywordsArray.controls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("state", ctx_r2.saveState)("label", ctx_r2.isNew ? "lingo2-forms.meetings.form-create-action" : "lingo2-forms.meetings.form-save-action");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(65, 78, ctx_r2.debug$));
  }
}
function MeetingFormComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, MeetingFormComponent_div_4_app_meeting_step_1_Template, 4, 10, "app-meeting-step", 7)(2, MeetingFormComponent_div_4_app_meeting_step_2_Template, 4, 10, "app-meeting-step", 8);
    i0.ɵɵelementStart(3, "app-meeting-step", 9);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementStart(5, "div", 10)(6, "app-form-field", 11)(7, "app-meeting-select", 12);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵlistener("changed", function MeetingFormComponent_div_4_Template_app_meeting_select_changed_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onTypeChanged($event));
    });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "app-meeting-step", 13);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementStart(11, "app-meeting-select-preset", 14);
    i0.ɵɵlistener("changed", function MeetingFormComponent_div_4_Template_app_meeting_select_preset_changed_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onPresetChanged($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, MeetingFormComponent_div_4_ng_container_12_Template, 66, 80, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r2.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isSchoolMeeting);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isSchoolMeeting);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(4, 19, "lingo2-forms.meetings.steps.type"));
    i0.ɵɵproperty("index", 1)("completed", ctx_r2.isStepCompleted(1))("active", ctx_r2.isStepActive(1))("disabled", ctx_r2.form.controls.type.disabled);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(8, 21, "lingo2-forms.meetings.placeholders.meeting-type"));
    i0.ɵɵproperty("options", ctx_r2.typesOptions)("active", ctx_r2.isStepActive(1))("disabled", ctx_r2.isEditFormAction);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(10, 23, "lingo2-forms.meetings.steps.template"));
    i0.ɵɵproperty("index", 2)("last", !ctx_r2.form.controls.preset.value)("completed", ctx_r2.isStepCompleted(2))("active", ctx_r2.isStepActive(2))("disabled", ctx_r2.form.controls.preset.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.form.controls.preset.value);
  }
}
function MeetingChargingPreviewComponent_div_0_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r0.formatAmount(ctx_r0.calc.price));
  }
}
function MeetingChargingPreviewComponent_div_0_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E");
  }
}
function MeetingChargingPreviewComponent_div_0_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate2(" \u043E\u0442 ", ctx_r0.calc.minParticipants, " \u0434\u043E ", ctx_r0.calc.maxParticipants, "");
  }
}
function MeetingChargingPreviewComponent_div_0_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r0.calc.maxParticipants);
  }
}
function MeetingChargingPreviewComponent_div_0_div_17_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate2(" \u043E\u0442 ", ctx_r0.formatAmount(ctx_r0.calc.minCredits), " \u0434\u043E ", ctx_r0.formatAmount(ctx_r0.calc.maxCredits), "");
  }
}
function MeetingChargingPreviewComponent_div_0_div_17_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r0.formatAmount(ctx_r0.calc.maxCredits));
  }
}
function MeetingChargingPreviewComponent_div_0_div_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "span", 10);
    i0.ɵɵtext(2, "\u0420\u0430\u0441\u0445\u043E\u0434 \u0432 \u0447\u0430\u0441: ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MeetingChargingPreviewComponent_div_0_div_17_ng_template_3_Template, 1, 2, "ng-template", 11)(4, MeetingChargingPreviewComponent_div_0_div_17_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const eqMinMaxCredits_r2 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.calc.minCredits !== ctx_r0.calc.maxCredits)("ngIfElse", eqMinMaxCredits_r2);
  }
}
function MeetingChargingPreviewComponent_div_0_div_18_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate2(" \u043E\u0442 ", ctx_r0.formatAmount(ctx_r0.calc.minIncome), " \u0434\u043E ", ctx_r0.formatAmount(ctx_r0.calc.maxIncome), "");
  }
}
function MeetingChargingPreviewComponent_div_0_div_18_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r0.formatAmount(ctx_r0.calc.maxIncome));
  }
}
function MeetingChargingPreviewComponent_div_0_div_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "span", 10);
    i0.ɵɵtext(2, "\u041F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0434\u043E\u0445\u043E\u0434: ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MeetingChargingPreviewComponent_div_0_div_18_ng_template_3_Template, 1, 2, "ng-template", 11)(4, MeetingChargingPreviewComponent_div_0_div_18_ng_template_4_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const eqMinMaxIncome_r3 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.calc.minIncome !== ctx_r0.calc.maxIncome)("ngIfElse", eqMinMaxIncome_r3);
  }
}
function MeetingChargingPreviewComponent_div_0_div_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "span", 10);
    i0.ɵɵtext(2, "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F onclass: ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" \u043E\u0442 ", ctx_r0.formatAmount(ctx_r0.calc.minFee), " \u0434\u043E ", ctx_r0.formatAmount(ctx_r0.calc.maxFee), "");
  }
}
function MeetingChargingPreviewComponent_div_0_span_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u0423\u0447\u0430\u0441\u0442\u0438\u0435 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E");
    i0.ɵɵelementEnd();
  }
}
function MeetingChargingPreviewComponent_div_0_span_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" \u041F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u0440\u0438\u0431\u044B\u043B\u044C: \u043E\u0442 ", ctx_r0.formatAmount(ctx_r0.calc.minProfit), " \u0434\u043E ", ctx_r0.formatAmount(ctx_r0.calc.maxProfit), " ");
  }
}
function MeetingChargingPreviewComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div", 7)(3, "div", 8);
    i0.ɵɵtext(4, "\u041F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0441\u0447\u0451\u0442");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9)(6, "span", 10);
    i0.ɵɵtext(7, "\u0423\u0447\u0430\u0441\u0442\u0438\u0435: ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, MeetingChargingPreviewComponent_div_0_ng_template_8_Template, 1, 1, "ng-template", 11)(9, MeetingChargingPreviewComponent_div_0_ng_template_9_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 9)(12, "span", 10);
    i0.ɵɵtext(13, "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438: ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, MeetingChargingPreviewComponent_div_0_ng_template_14_Template, 1, 2, "ng-template", 11)(15, MeetingChargingPreviewComponent_div_0_ng_template_15_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, MeetingChargingPreviewComponent_div_0_div_17_Template, 6, 2, "div", 12)(18, MeetingChargingPreviewComponent_div_0_div_18_Template, 6, 2, "div", 12)(19, MeetingChargingPreviewComponent_div_0_div_19_Template, 4, 2, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 13);
    i0.ɵɵelement(21, "span");
    i0.ɵɵtemplate(22, MeetingChargingPreviewComponent_div_0_span_22_Template, 2, 0, "span", 14)(23, MeetingChargingPreviewComponent_div_0_span_23_Template, 2, 2, "span", 14);
    i0.ɵɵelementStart(24, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(25, "svg", 15);
    i0.ɵɵelement(26, "rect", 16)(27, "path", 17);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const freeCharging_r4 = i0.ɵɵreference(10);
    const eqMinMaxParticipants_r5 = i0.ɵɵreference(16);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mobile", ctx_r0.isMobile);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", ctx_r0.calc.charging === ctx_r0.constants.fee)("ngIfElse", freeCharging_r4);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.calc.minParticipants !== ctx_r0.calc.maxParticipants)("ngIfElse", eqMinMaxParticipants_r5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.calc.maxCredits);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.calc.maxIncome);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.calc.maxFee);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.calc.charging === ctx_r0.constants.credits);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.calc.charging === ctx_r0.constants.fee);
  }
}
function SimpleTabsComponent_li_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", tab_r2.count, ")");
  }
}
function SimpleTabsComponent_li_2__svg_svg_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 8);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r2.svgsetIcon(tab_r2.icon), null, "xlink");
  }
}
function SimpleTabsComponent_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 3)(1, "div", 4)(2, "button", 5);
    i0.ɵɵlistener("click", function SimpleTabsComponent_li_2_Template_button_click_2_listener() {
      const tab_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onTabChange(tab_r2));
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, SimpleTabsComponent_li_2_span_5_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SimpleTabsComponent_li_2__svg_svg_6_Template, 2, 1, "svg", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("tab_active", tab_r2.id === (ctx_r2.activeTab == null ? null : ctx_r2.activeTab.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, tab_r2.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", tab_r2.count);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r2.icon);
  }
}
function PlanCard2Component_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background", ctx_r0.plan == null ? null : ctx_r0.plan.details == null ? null : ctx_r0.plan.details.color);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r0.plan == null ? null : ctx_r0.plan.details == null ? null : ctx_r0.plan.details.nameplate));
  }
}
function PlanCard2Component_ng_content_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngTemplateOutlet", "additional"]);
  }
}
function PlanCard2Component_ng_template_14_on_ui_button_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "on-ui-button", 17);
  }
}
function PlanCard2Component_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCard2Component_ng_template_14_on_ui_button_0_Template, 1, 0, "on-ui-button", 16);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.isCurrentPlan());
  }
}
function PlanCard2Component_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "on-ui-button", 18);
    i0.ɵɵlistener("click", function PlanCard2Component_ng_template_15_Template_on_ui_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onOpenActivatePlanModal());
    });
    i0.ɵɵelementEnd();
  }
}
function PlanCard2Component_div_18_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "span", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "\xA0 ");
    i0.ɵɵelementStart(4, "span", 27);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const term_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(term_r3 == null ? null : term_r3.side == null ? null : term_r3.side.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(term_r3 == null ? null : term_r3.side == null ? null : term_r3.side.text);
  }
}
function PlanCard2Component_div_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 21);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "div", 22);
    i0.ɵɵelement(5, "span", 23);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, PlanCard2Component_div_18_ng_template_7_Template, 6, 2, "ng-template", 24);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const term_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.svgsetIcon("finance-plan-property"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.replaceValues(i0.ɵɵpipeBind1(6, 3, term_r3 == null ? null : term_r3.label)), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", term_r3 == null ? null : term_r3.side);
  }
}
function PlanCard2Component_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "span", 29);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 30)(5, "span", 31);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "span", 32);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r0.plan == null ? null : ctx_r0.plan.details == null ? null : ctx_r0.plan.details.receive_credits_per_month, " ", i0.ɵɵpipeBind1(3, 4, "subscription-plans.lessons-per-month"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.price ? ctx_r0.price : i0.ɵɵpipeBind1(7, 6, "lingo2-forms.subscription-plans.plan-free.title"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "subscription-plans.period"));
  }
}
const _c27 = a0 => ({
  "price": a0
});
const _c28 = (a0, a1) => ({
  "date": a0,
  "price": a1
});
const _c29 = a0 => ({
  "credits": a0
});
function TrialCheckoutWizardDialogComponent_app_modal_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-modal", 7);
    i0.ɵɵlistener("closed", function TrialCheckoutWizardDialogComponent_app_modal_0_Template_app_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementStart(1, "app-modal-body");
    i0.ɵɵelementContainer(2, 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentRef_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("canClose", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", contentRef_r3);
  }
}
function TrialCheckoutWizardDialogComponent_app_mobile_modal_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-mobile-modal", 9);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("closed", function TrialCheckoutWizardDialogComponent_app_mobile_modal_1_Template_app_mobile_modal_closed_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementStart(2, "app-mobile-modal-body")(3, "div", 10);
    i0.ɵɵelementContainer(4, 8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentRef_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("titleVisible", false)("withCloseButton", true)("customTitle", i0.ɵɵpipeBind1(1, 4, "user-service-checkout-wizard.purchasing-tariff"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", contentRef_r3);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const trialInfo_r5 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", trialInfo_r5);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-payment-widget", 23);
    i0.ɵɵlistener("configured", function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_configured_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentConfigured($event));
    })("succeed", function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_succeed_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentSucceed());
    })("failed", function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_failed_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentFailed($event));
    })("processing", function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_processing_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPaymentProcessing($event));
    })("addAccount", function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template_app_payment_widget_addAccount_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onAddAccount($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("options", ctx_r1.paymentOptions)("payClicked", ctx_r1.payClicked)("needUpdate", ctx_r1.afterAddAccountNeedUpdate)("buyTrial", true);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_6_app_payment_widget_1_Template, 1, 4, "app-payment-widget", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.paymentOptions);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const successRef_r7 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", successRef_r7);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const failedRef_r8 = i0.ɵɵreference(9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", failedRef_r8);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_9_pre_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.paymentProcessingError);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_9_pre_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.errorMessage);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, "\u041A\u0430\u043A\u0430\u044F-\u0442\u043E \u043E\u0448\u0438\u0431\u043A\u0430");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4, "error");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_9_pre_5_Template, 2, 1, "pre", 24)(6, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_9_pre_6_Template, 2, 1, "pre", 24);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.paymentProcessingError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_div_10_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("paymentProcessingError = ", i0.ɵɵpipeBind1(2, 1, ctx_r1.paymentProcessingError), "");
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_div_10_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("errorMessage = ", i0.ɵɵpipeBind1(2, 1, ctx_r1.errorMessage), "");
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "pre");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, TrialCheckoutWizardDialogComponent_ng_template_2_div_10_div_10_Template, 3, 3, "div", 24)(11, TrialCheckoutWizardDialogComponent_ng_template_2_div_10_div_11_Template, 3, 3, "div", 24);
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "hr");
    i0.ɵɵelementStart(16, "pre");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "json");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("activeView = ", i0.ɵɵpipeBind1(3, 7, ctx_r1.activeView), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("paymentOptions = ", i0.ɵɵpipeBind1(6, 9, ctx_r1.paymentOptions), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("paymentConfigured = ", i0.ɵɵpipeBind1(9, 11, ctx_r1.paymentConfigured), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.paymentProcessingError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("canExecutePayment = ", i0.ɵɵpipeBind1(14, 13, ctx_r1.canExecutePayment()), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 15, ctx_r1.steps == null ? null : ctx_r1.steps.dump));
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "app-trial-footer-details", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("plan", ctx_r1.activePlan)("nextTrialPrice", ctx_r1.nextTrialPrice);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_on_ui_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "on-ui-button", 30);
    i0.ɵɵlistener("click", function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_on_ui_button_1_Template_on_ui_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.goNextStep());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("state", "default")("label", "meetings.wizard.next");
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_app_pay_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-pay-button", 31);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("start", function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_app_pay_button_2_Template_app_pay_button_start_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onStartPayment());
    })("retry", function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_app_pay_button_2_Template_app_pay_button_retry_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onRetryPayment());
    })("cancel", function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_app_pay_button_2_Template_app_pay_button_cancel_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onClose());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("state", ctx_r1.payButtonsState)("disabled", !ctx_r1.canExecutePayment())("startLabel", i0.ɵɵpipeBind1(1, 6, "plans.activate_30_days_free"))("closeLabel", i0.ɵɵpipeBind1(2, 8, "user-service-checkout-wizard.close"))("cancelLabel", i0.ɵɵpipeBind1(3, 10, "user-service-checkout-wizard.to-complete"))("retryLabel", i0.ɵɵpipeBind1(4, 12, "user-service-checkout-wizard.try-again"));
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 27);
    i0.ɵɵtemplate(1, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_on_ui_button_1_Template, 1, 2, "on-ui-button", 28)(2, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_app_pay_button_2_Template, 5, 14, "app-pay-button", 29);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_7_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (tmp_6_0 = ctx_r1.steps.get("trial")) == null ? null : tmp_6_0.active);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (tmp_7_0 = ctx_r1.steps.get("payment")) == null ? null : tmp_7_0.active);
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-step-by-step-wizard", 11);
    i0.ɵɵelementContainerStart(1, 12);
    i0.ɵɵelement(2, "app-trial-header-details", 13);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(3, 14)(4, 15);
    i0.ɵɵtemplate(5, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_5_Template, 2, 1, "ng-container", 16)(6, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_6_Template, 2, 1, "ng-container", 16)(7, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_7_Template, 2, 1, "ng-container", 16)(8, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_8_Template, 2, 1, "ng-container", 16)(9, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_9_Template, 7, 2, "ng-container", 16);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(10, TrialCheckoutWizardDialogComponent_ng_template_2_div_10_Template, 19, 17, "div", 17);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(12, 18);
    i0.ɵɵelementStart(13, "div", 19);
    i0.ɵɵtemplate(14, TrialCheckoutWizardDialogComponent_ng_template_2_div_14_Template, 2, 2, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(15, TrialCheckoutWizardDialogComponent_ng_template_2_ng_container_15_Template, 3, 2, "ng-container", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_18_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("steps", ctx_r1.steps)("showHeader", true)("showFooter", true)("showSteps", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", ctx_r1.activePlan)("nextTrialPrice", ctx_r1.nextTrialPrice);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r1.activeView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "trial");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "payment");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "success");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "fail");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "error");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 15, ctx_r1.debug$));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (tmp_18_0 = ctx_r1.steps.get("payment")) == null ? null : tmp_18_0.active);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.activeView !== "success" && ctx_r1.activeView !== "fail");
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "div", 33);
    i0.ɵɵelementStart(2, "div", 34)(3, "div", 35)(4, "div", 36);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 37)(8, "div", 38);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(9, "svg", 39);
    i0.ɵɵelement(10, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "span", 40);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(14, "div", 41)(15, "div", 42)(16, "div", 43);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵpipe(19, "dfnsFormat");
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 43);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 43);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.screenClasses());
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 8, "plans.30_days_for_free_Onclass"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("finance-plan-property"), null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 10, "plans.receive_credits_per_month", i0.ɵɵpureFunction1(25, _c29, ctx_r1.plan == null ? null : ctx_r1.plan.details == null ? null : ctx_r1.plan.details.currency_grants[0] == null ? null : ctx_r1.plan.details.currency_grants[0].amount)));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(18, 13, "plans.first_payment_date"), " ", i0.ɵɵpipeBind2(20, 18, "plans.text_per_month", i0.ɵɵpureFunction2(27, _c28, i0.ɵɵpipeBind2(19, 15, ctx_r1.trialEndAt, "dd MMMM yyyy"), ctx_r1.nextTrialPrice)), "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 21, "plans.payment_charged_automatically"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 23, "plans.can_cancel_any_time"));
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44)(1, "div", 36);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 45);
    i0.ɵɵelement(5, "path", 46)(6, "path", 47);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "meetings.wizard.pay-success"));
  }
}
function TrialCheckoutWizardDialogComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48)(1, "div", 36);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 45);
    i0.ɵɵelement(5, "path", 49)(6, "rect", 50)(7, "rect", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(8, "div", 52);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "meetings.wizard.pay-fail"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.errorMessage);
  }
}
function TrialCheckoutWizardDialogComponent_app_add_card_wizard_dialog_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-add-card-wizard-dialog", 53);
    i0.ɵɵlistener("closed", function TrialCheckoutWizardDialogComponent_app_add_card_wizard_dialog_10_Template_app_add_card_wizard_dialog_closed_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCloseAddAccount());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("providerId", ctx_r1.addAccountProviderId);
  }
}
const _c30 = ["dragScroll"];
function PaywallWrapperComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h2", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "subscription-plans.title-paywall"));
  }
}
function PaywallWrapperComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "app-plan-card-2", 13);
    i0.ɵɵlistener("updatePlan", function PaywallWrapperComponent_div_5_Template_app_plan_card_2_updatePlan_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.planUpdated());
    })("onChoose", function PaywallWrapperComponent_div_5_Template_app_plan_card_2_onChoose_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPlanChoose($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const plan_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("plan", plan_r3)("current_plan_id", ctx_r1.activePlanId)("isLimitedVersion", ctx_r1.isLimitedVersion);
  }
}
function PaywallWrapperComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵlistener("click", function PaywallWrapperComponent_div_6_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.moveLeft());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 16);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵlistener("click", function PaywallWrapperComponent_div_6_Template_div_click_4_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.moveRight());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 16);
    i0.ɵɵelement(6, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", "/assets/icons/arrow.svg#arrow", null, "xlink");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", "/assets/icons/arrow.svg#arrow", null, "xlink");
  }
}
function PaywallWrapperComponent_app_trial_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-trial", 18);
    i0.ɵɵlistener("onClickToTrial", function PaywallWrapperComponent_app_trial_7_Template_app_trial_onClickToTrial_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTrialClick());
    })("onChoose", function PaywallWrapperComponent_app_trial_7_Template_app_trial_onChoose_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTrialChoose());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("plan", ctx_r1.trialPlan)("plans", ctx_r1.plans);
  }
}
function PaywallWrapperComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr")(1, "p", 19);
    i0.ɵɵpipe(2, "translate");
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 1, "subscription-plans.text-paywall-wrapper"), i0.ɵɵsanitizeHtml);
  }
}
function PaywallWrapperComponent_app_hint_cards_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-hint-cards");
  }
}
function PaywallWrapperComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "app-trial-checkout-wizard-dialog", 20);
    i0.ɵɵlistener("succeed", function PaywallWrapperComponent_ng_container_10_Template_app_trial_checkout_wizard_dialog_succeed_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSuccessTrial());
    })("closed", function PaywallWrapperComponent_ng_container_10_Template_app_trial_checkout_wizard_dialog_closed_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeTrial());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("plan", ctx_r1.selectedPlan)("plans", ctx_r1.plans)("checkoutInfo", ctx_r1.switchOperation);
  }
}
let AbstractBillingService = /*#__PURE__*/(() => {
  class AbstractBillingService {
    static {
      this.ɵfac = function AbstractBillingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractBillingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractBillingService,
        factory: AbstractBillingService.ɵfac
      });
    }
  }
  return AbstractBillingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractBillingV2Service = /*#__PURE__*/(() => {
  class AbstractBillingV2Service {
    static {
      this.ɵfac = function AbstractBillingV2Service_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractBillingV2Service)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractBillingV2Service,
        factory: AbstractBillingV2Service.ɵfac
      });
    }
  }
  return AbstractBillingV2Service;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractCurrenciesService = /*#__PURE__*/(() => {
  class AbstractCurrenciesService {
    static {
      this.ɵfac = function AbstractCurrenciesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractCurrenciesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractCurrenciesService,
        factory: AbstractCurrenciesService.ɵfac
      });
    }
  }
  return AbstractCurrenciesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractClassroomsService = /*#__PURE__*/(() => {
  class AbstractClassroomsService {
    static {
      this.ɵfac = function AbstractClassroomsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractClassroomsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractClassroomsService,
        factory: AbstractClassroomsService.ɵfac
      });
    }
  }
  return AbstractClassroomsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractFeaturesService = /*#__PURE__*/(() => {
  class AbstractFeaturesService {
    static {
      this.ɵfac = function AbstractFeaturesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractFeaturesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractFeaturesService,
        factory: AbstractFeaturesService.ɵfac
      });
    }
  }
  return AbstractFeaturesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractFilesService = /*#__PURE__*/(() => {
  class AbstractFilesService {
    static {
      this.ɵfac = function AbstractFilesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractFilesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractFilesService,
        factory: AbstractFilesService.ɵfac
      });
    }
  }
  return AbstractFilesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractScreenService = /*#__PURE__*/(() => {
  class AbstractScreenService {
    static {
      this.ɵfac = function AbstractScreenService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractScreenService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractScreenService,
        factory: AbstractScreenService.ɵfac
      });
    }
  }
  return AbstractScreenService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const teachableStatues = [TeacherStatusEnum.limited_tutor, TeacherStatusEnum.tutor, TeacherStatusEnum.teacher, TeacherStatusEnum.limited_teacher];
// TODO: static isTeacher should be replaced with parent service method
let AbstractAccountService = /*#__PURE__*/(() => {
  class AbstractAccountService {
    static isTeacher(user) {
      return user ? teachableStatues.includes(user.teacher_status) : false;
    }
    static getUserFullName(user) {
      if (!user) {
        return '';
      }
      return [user.first_name, user.last_name].join(' ').replace(/\s+/g, ' ').trim();
    }
    static {
      this.ɵfac = function AbstractAccountService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractAccountService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractAccountService,
        factory: AbstractAccountService.ɵfac
      });
    }
  }
  return AbstractAccountService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractAuthService = /*#__PURE__*/(() => {
  class AbstractAuthService {
    static {
      this.ɵfac = function AbstractAuthService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractAuthService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractAuthService,
        factory: AbstractAuthService.ɵfac
      });
    }
  }
  return AbstractAuthService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractMeetingsService = /*#__PURE__*/(() => {
  class AbstractMeetingsService {
    static {
      this.ɵfac = function AbstractMeetingsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractMeetingsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractMeetingsService,
        factory: AbstractMeetingsService.ɵfac
      });
    }
  }
  return AbstractMeetingsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractDropzoneConfig = /*#__PURE__*/(() => {
  class AbstractDropzoneConfig {
    static {
      this.ɵfac = function AbstractDropzoneConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractDropzoneConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractDropzoneConfig,
        factory: AbstractDropzoneConfig.ɵfac
      });
    }
  }
  return AbstractDropzoneConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractProfileService = /*#__PURE__*/(() => {
  class AbstractProfileService {
    static {
      this.ɵfac = function AbstractProfileService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractProfileService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractProfileService,
        factory: AbstractProfileService.ɵfac
      });
    }
  }
  return AbstractProfileService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractConfigService = /*#__PURE__*/(() => {
  class AbstractConfigService {
    static {
      this.ɵfac = function AbstractConfigService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractConfigService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractConfigService,
        factory: AbstractConfigService.ɵfac
      });
    }
  }
  return AbstractConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractLanguageService = /*#__PURE__*/(() => {
  class AbstractLanguageService {
    static {
      this.ɵfac = function AbstractLanguageService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractLanguageService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractLanguageService,
        factory: AbstractLanguageService.ɵfac
      });
    }
  }
  return AbstractLanguageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractUserService = /*#__PURE__*/(() => {
  class AbstractUserService {
    static {
      this.ɵfac = function AbstractUserService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractUserService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractUserService,
        factory: AbstractUserService.ɵfac
      });
    }
  }
  return AbstractUserService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractWebsocketService = /*#__PURE__*/(() => {
  class AbstractWebsocketService {
    /** Изменение финансового профиля (подписки) */
    get onPlanUpdate() {
      return this.on('plan').pipe(debounceTime(1000));
    }
    /** Новое уведомление */
    get onNotice() {
      return this.on('notice');
    }
    static {
      this.ɵfac = function AbstractWebsocketService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractWebsocketService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AbstractWebsocketService,
        factory: AbstractWebsocketService.ɵfac
      });
    }
  }
  return AbstractWebsocketService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const moveFadeIn = animation([style({
  opacity: '0',
  transform: 'translateY({{slide}})'
}), animate('{{time}}', style({
  opacity: '1',
  transform: '*'
}))], {
  params: {
    time: '200ms',
    slide: '5px'
  }
});
const moveFadeOut = animation([style({
  opacity: '*'
}), animate('{{time}}', style({
  opacity: '0',
  transform: 'translateY({{slide}})'
}))], {
  params: {
    time: '200ms',
    slide: '5px'
  }
});
const fadeIn = animation([style({
  opacity: '0'
}), animate('{{time}}', style({
  opacity: '1'
}))], {
  params: {
    time: '200ms',
    slide: '5px'
  }
});
const fadeOut = animation([style({
  opacity: '*'
}), animate('{{time}}', style({
  opacity: '0'
}))], {
  params: {
    time: '200ms'
  }
});
const slideIn = animation([style({
  transform: 'translateX({{slide}})'
}), animate('{{time}}', style({
  transform: 'translateY(0)'
}))], {
  params: {
    time: '200ms',
    slide: '100vw'
  }
});
const slideOut = animation([style({
  transform: 'translateX(0)'
}), animate('{{time}}', style({
  transform: 'translateX({{slide}})'
}))], {
  params: {
    time: '200ms',
    slide: '100vw'
  }
});
const slideDown = animation([style({
  height: '0',
  opacity: '0'
}), animate('{{time}}', style({
  height: '*',
  opacity: '1'
}))], {
  params: {
    time: '200ms'
  }
});
const slideUp = animation([style({
  height: '*',
  opacity: '1'
}), animate('{{time}}', style({
  height: '0',
  opacity: '0'
}))], {
  params: {
    time: '200ms'
  }
});
let FormFieldComponent = /*#__PURE__*/(() => {
  class FormFieldComponent {
    constructor(deviceService) {
      this.deviceService = deviceService;
      this.isInline = true;
      this.hasDisplayErrorText = true;
    }
    ngOnInit() {}
    hasError() {
      return this.control && this.control.invalid && this.control.touched;
    }
    get errorKey() {
      return this.control && this.control.errors && Object.keys(this.control.errors)[0];
    }
    static {
      this.ɵfac = function FormFieldComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormFieldComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormFieldComponent,
        selectors: [["app-form-field"]],
        inputs: {
          label: "label",
          required: "required",
          isInline: "isInline",
          control: "control",
          patternError: "patternError",
          hasDisplayErrorText: "hasDisplayErrorText"
        },
        ngContentSelectors: _c0,
        decls: 6,
        vars: 8,
        consts: [[1, "field"], [1, "field__label"], [1, "field__content"], ["class", "field__text", 4, "ngIf"], [1, "field__text"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [4, "ngIf"]],
        template: function FormFieldComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵprojection(4);
            i0.ɵɵtemplate(5, FormFieldComponent_div_5_Template, 10, 9, "div", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("field_error", ctx.hasError() && ctx.errorKey)("field_compact", !ctx.isInline || ctx.deviceService.isMobile())("field_no-label", !ctx.label);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.hasError() && ctx.errorKey && ctx.hasDisplayErrorText);
          }
        },
        dependencies: [i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i2.NgSwitchDefault, i3.TranslatePipe],
        styles: [".field[_ngcontent-%COMP%]{display:flex}.field__label[_ngcontent-%COMP%]{color:#a4b0c3;font-size:14px;font-weight:400;line-height:20px;margin-right:30px;width:200px;-webkit-user-select:none;user-select:none;line-height:30px}.field__content[_ngcontent-%COMP%]{width:calc(100% - 220px)}.field__text[_ngcontent-%COMP%]{color:#e86f79;font-size:12px;font-weight:400;line-height:17px;transition:all .2s linear}.field_compact[_ngcontent-%COMP%]{flex-direction:column}.field_compact[_ngcontent-%COMP%]   .field__label[_ngcontent-%COMP%], .field_compact[_ngcontent-%COMP%]   .field__content[_ngcontent-%COMP%]{width:unset}.field_no-label[_ngcontent-%COMP%]   .field__label[_ngcontent-%COMP%]{display:none}.field_no-label[_ngcontent-%COMP%]   .field__content[_ngcontent-%COMP%]{width:100%}"],
        data: {
          animation: [trigger('error', [transition(':enter', useAnimation(slideDown)), transition(':leave', useAnimation(slideUp))])]
        }
      });
    }
  }
  return FormFieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormFieldModule = /*#__PURE__*/(() => {
  class FormFieldModule {
    static {
      this.ɵfac = function FormFieldModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormFieldModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FormFieldModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule]
      });
    }
  }
  return FormFieldModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Spinner1Component = /*#__PURE__*/(() => {
  class Spinner1Component {
    constructor() {
      this.active = false;
    }
    static {
      this.ɵfac = function Spinner1Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Spinner1Component)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Spinner1Component,
        selectors: [["spinner1"]],
        inputs: {
          active: "active"
        },
        decls: 3,
        vars: 0,
        consts: [[1, "spinner1"], [1, "dot1"], [1, "dot2"]],
        template: function Spinner1Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1)(2, "div", 2);
            i0.ɵɵelementEnd();
          }
        },
        styles: [".spinner1[_ngcontent-%COMP%]{width:40px;height:40px;position:relative;text-align:center;-webkit-animation:_ngcontent-%COMP%_sk-rotate 2s infinite linear;animation:_ngcontent-%COMP%_sk-rotate 2s infinite linear}.dot1[_ngcontent-%COMP%], .dot2[_ngcontent-%COMP%]{width:60%;height:60%;display:inline-block;position:absolute;top:0;background-color:#5ab3e4;border-radius:100%;-webkit-animation:_ngcontent-%COMP%_sk-bounce 2s infinite ease-in-out;animation:_ngcontent-%COMP%_sk-bounce 2s infinite ease-in-out}.dot2[_ngcontent-%COMP%]{top:auto;bottom:0;-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes _ngcontent-%COMP%_sk-rotate{to{-webkit-transform:rotate(360deg)}}@keyframes _ngcontent-%COMP%_sk-rotate{to{transform:rotate(360deg);-webkit-transform:rotate(360deg)}}@-webkit-keyframes _ngcontent-%COMP%_sk-bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}"]
      });
    }
  }
  return Spinner1Component;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Spinner2Component = /*#__PURE__*/(() => {
  class Spinner2Component {
    constructor() {
      this.active = false;
    }
    static {
      this.ɵfac = function Spinner2Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Spinner2Component)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Spinner2Component,
        selectors: [["spinner2"]],
        inputs: {
          active: "active"
        },
        decls: 2,
        vars: 0,
        consts: [[1, "spinner2"], [1, "dot-floating"]],
        template: function Spinner2Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementEnd();
          }
        },
        styles: [".spinner2[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;padding:2rem 0;margin:0 -5%;overflow:hidden}.dot-floating[_ngcontent-%COMP%]{position:relative;width:6px;height:6px;border-radius:3px;background-color:#5ab3e4;color:#5ab3e4;animation:_ngcontent-%COMP%_dotFloating 3s infinite cubic-bezier(.15,.6,.9,.1)}.dot-floating[_ngcontent-%COMP%]:before, .dot-floating[_ngcontent-%COMP%]:after{content:\"\";display:inline-block;position:absolute;top:0;width:6px;height:6px;border-radius:3px;background-color:#5ab3e4;color:#5ab3e4}.dot-floating[_ngcontent-%COMP%]:before{left:-12px;animation:_ngcontent-%COMP%_dotFloatingBefore 3s infinite ease-in-out}.dot-floating[_ngcontent-%COMP%]:after{left:-24px;animation:_ngcontent-%COMP%_dotFloatingAfter 3s infinite cubic-bezier(.4,0,1,1)}@keyframes _ngcontent-%COMP%_dotFloating{0%{left:calc(-50% - 5px)}75%{left:calc(50% + 105px)}to{left:calc(50% + 105px)}}@keyframes _ngcontent-%COMP%_dotFloatingBefore{0%{left:-50px}50%{left:-12px}75%{left:-50px}to{left:-50px}}@keyframes _ngcontent-%COMP%_dotFloatingAfter{0%{left:-100px}50%{left:-24px}75%{left:-100px}to{left:-100px}}"]
      });
    }
  }
  return Spinner2Component;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Spinner3Component = /*#__PURE__*/(() => {
  class Spinner3Component {
    constructor() {
      this.active = false;
    }
    static {
      this.ɵfac = function Spinner3Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Spinner3Component)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Spinner3Component,
        selectors: [["spinner3"]],
        inputs: {
          active: "active"
        },
        decls: 25,
        vars: 0,
        consts: [["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "30px", "height", "30px", "viewBox", "0 0 100 100", "preserveAspectRatio", "xMidYMid", 1, "spinner3"], ["transform", "rotate(0 50 50)"], ["x", "48.5", "y", "12", "rx", "1.5", "ry", "5.6000000000000005", "width", "3", "height", "28"], ["attributeName", "opacity", "values", "1;0", "keyTimes", "0;1", "dur", "1s", "begin", "-0.875s", "repeatCount", "indefinite"], ["transform", "rotate(45 50 50)"], ["attributeName", "opacity", "values", "1;0", "keyTimes", "0;1", "dur", "1s", "begin", "-0.75s", "repeatCount", "indefinite"], ["transform", "rotate(90 50 50)"], ["attributeName", "opacity", "values", "1;0", "keyTimes", "0;1", "dur", "1s", "begin", "-0.625s", "repeatCount", "indefinite"], ["transform", "rotate(135 50 50)"], ["attributeName", "opacity", "values", "1;0", "keyTimes", "0;1", "dur", "1s", "begin", "-0.5s", "repeatCount", "indefinite"], ["transform", "rotate(180 50 50)"], ["attributeName", "opacity", "values", "1;0", "keyTimes", "0;1", "dur", "1s", "begin", "-0.375s", "repeatCount", "indefinite"], ["transform", "rotate(225 50 50)"], ["attributeName", "opacity", "values", "1;0", "keyTimes", "0;1", "dur", "1s", "begin", "-0.25s", "repeatCount", "indefinite"], ["transform", "rotate(270 50 50)"], ["attributeName", "opacity", "values", "1;0", "keyTimes", "0;1", "dur", "1s", "begin", "-0.125s", "repeatCount", "indefinite"], ["transform", "rotate(315 50 50)"], ["attributeName", "opacity", "values", "1;0", "keyTimes", "0;1", "dur", "1s", "begin", "0s", "repeatCount", "indefinite"]],
        template: function Spinner3Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0)(1, "g", 1)(2, "rect", 2);
            i0.ɵɵelement(3, "animate", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "g", 4)(5, "rect", 2);
            i0.ɵɵelement(6, "animate", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "g", 6)(8, "rect", 2);
            i0.ɵɵelement(9, "animate", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "g", 8)(11, "rect", 2);
            i0.ɵɵelement(12, "animate", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "g", 10)(14, "rect", 2);
            i0.ɵɵelement(15, "animate", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "g", 12)(17, "rect", 2);
            i0.ɵɵelement(18, "animate", 13);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(19, "g", 14)(20, "rect", 2);
            i0.ɵɵelement(21, "animate", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(22, "g", 16)(23, "rect", 2);
            i0.ɵɵelement(24, "animate", 17);
            i0.ɵɵelementEnd()()();
          }
        },
        styles: [".spinner3[_ngcontent-%COMP%]{margin:auto;display:block;background:#f6f6f6;border-radius:50%}.spinner3[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:#acb6c7}"]
      });
    }
  }
  return Spinner3Component;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadingLineComponent = /*#__PURE__*/(() => {
  class LoadingLineComponent {
    static {
      this.ɵfac = function LoadingLineComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoadingLineComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoadingLineComponent,
        selectors: [["loading-line"]],
        inputs: {
          width: "width",
          height: "height"
        },
        decls: 13,
        vars: 2,
        consts: [["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "viewBox", "0 0 100 100", "preserveAspectRatio", "xMidYMid", 2, "margin", "auto", "shape-rendering", "auto"], ["transform", "translate(20 50)"], ["cx", "0", "cy", "0", "r", "6", "fill", "#109ad7"], ["attributeName", "transform", "type", "scale", "begin", "-0.375s", "calcMode", "spline", "keySplines", "0.3 0 0.7 1;0.3 0 0.7 1", "values", "0;1;0", "keyTimes", "0;0.5;1", "dur", "1s", "repeatCount", "indefinite"], ["transform", "translate(40 50)"], ["cx", "0", "cy", "0", "r", "6", "fill", "#fdfdfe"], ["attributeName", "transform", "type", "scale", "begin", "-0.25s", "calcMode", "spline", "keySplines", "0.3 0 0.7 1;0.3 0 0.7 1", "values", "0;1;0", "keyTimes", "0;0.5;1", "dur", "1s", "repeatCount", "indefinite"], ["transform", "translate(60 50)"], ["attributeName", "transform", "type", "scale", "begin", "-0.125s", "calcMode", "spline", "keySplines", "0.3 0 0.7 1;0.3 0 0.7 1", "values", "0;1;0", "keyTimes", "0;0.5;1", "dur", "1s", "repeatCount", "indefinite"], ["transform", "translate(80 50)"], ["attributeName", "transform", "type", "scale", "begin", "0s", "calcMode", "spline", "keySplines", "0.3 0 0.7 1;0.3 0 0.7 1", "values", "0;1;0", "keyTimes", "0;0.5;1", "dur", "1s", "repeatCount", "indefinite"]],
        template: function LoadingLineComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0)(1, "g", 1)(2, "circle", 2);
            i0.ɵɵelement(3, "animateTransform", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "g", 4)(5, "circle", 5);
            i0.ɵɵelement(6, "animateTransform", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "g", 7)(8, "circle", 2);
            i0.ɵɵelement(9, "animateTransform", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "g", 9)(11, "circle", 5);
            i0.ɵɵelement(12, "animateTransform", 10);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("width", ctx.width)("height", ctx.height);
          }
        },
        encapsulation: 2
      });
    }
  }
  return LoadingLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CircleToSquareSpinnerComponent = /*#__PURE__*/(() => {
  class CircleToSquareSpinnerComponent {
    static {
      this.ɵfac = function CircleToSquareSpinnerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CircleToSquareSpinnerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CircleToSquareSpinnerComponent,
        selectors: [["circle-to-square-spinner"]],
        decls: 1,
        vars: 0,
        consts: [[1, "circle-to-square-spinner"]],
        template: function CircleToSquareSpinnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
        },
        styles: [".circle-to-square-spinner[_ngcontent-%COMP%]{height:1em;width:1em;color:#fff;position:relative;display:inline-block;border:3px solid;border-radius:50%;animation:_ngcontent-%COMP%_circle-to-square 1.5s .66s ease-in-out infinite}.circle-to-square-spinner[_ngcontent-%COMP%]:before, .circle-to-square-spinner[_ngcontent-%COMP%]:after{content:\"\";height:inherit;width:inherit;border:2px solid;position:absolute;border-radius:50%;top:-2px;animation:_ngcontent-%COMP%_circle-to-square 1.5s ease-in-out infinite}.circle-to-square-spinner[_ngcontent-%COMP%]:before{left:-3em;animation-delay:.33s}.circle-to-square-spinner[_ngcontent-%COMP%]:after{right:-3em;animation-delay:.99s}@keyframes _ngcontent-%COMP%_circle-to-square{50%{border-radius:0;opacity:.6}}"]
      });
    }
  }
  return CircleToSquareSpinnerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ClockSpinnerComponent = /*#__PURE__*/(() => {
  class ClockSpinnerComponent {
    constructor() {
      this.type = 'default';
    }
    get classes() {
      return {
        [this.type]: true
      };
    }
    static {
      this.ɵfac = function ClockSpinnerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClockSpinnerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ClockSpinnerComponent,
        selectors: [["clock-spinner"]],
        inputs: {
          type: "type"
        },
        decls: 1,
        vars: 1,
        consts: [[1, "clock-spinner", 3, "ngClass"]],
        template: function ClockSpinnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.classes);
          }
        },
        dependencies: [i2.NgClass],
        styles: [".clock-spinner[_ngcontent-%COMP%]{border-radius:50%;border-width:1px;border-style:solid;padding:12px;position:relative}.clock-spinner.default[_ngcontent-%COMP%]{border-color:#fff}.clock-spinner.default[_ngcontent-%COMP%]:before{background-color:#5ab3e4}.clock-spinner.default[_ngcontent-%COMP%]:after{background-color:#5ab3e4}.clock-spinner.white[_ngcontent-%COMP%]{border-color:#fff}.clock-spinner.white[_ngcontent-%COMP%]:before{background-color:#fff}.clock-spinner.white[_ngcontent-%COMP%]:after{background-color:#fff}.clock-spinner.black[_ngcontent-%COMP%]{border-color:#000}.clock-spinner.black[_ngcontent-%COMP%]:before{background-color:#000}.clock-spinner.black[_ngcontent-%COMP%]:after{background-color:#000}.clock-spinner.info[_ngcontent-%COMP%]{border-color:#5ab3e4}.clock-spinner.info[_ngcontent-%COMP%]:before{background-color:#5ab3e4}.clock-spinner.info[_ngcontent-%COMP%]:after{background-color:#5ab3e4}.clock-spinner.success[_ngcontent-%COMP%]{border-color:#87d37c}.clock-spinner.success[_ngcontent-%COMP%]:before{background-color:#87d37c}.clock-spinner.success[_ngcontent-%COMP%]:after{background-color:#87d37c}.clock-spinner.danger[_ngcontent-%COMP%]{border-color:#e86f79}.clock-spinner.danger[_ngcontent-%COMP%]:before{background-color:#e86f79}.clock-spinner.danger[_ngcontent-%COMP%]:after{background-color:#e86f79}.clock-spinner.warning[_ngcontent-%COMP%]{border-color:#feed7d}.clock-spinner.warning[_ngcontent-%COMP%]:before{background-color:#feed7d}.clock-spinner.warning[_ngcontent-%COMP%]:after{background-color:#feed7d}.clock-spinner[_ngcontent-%COMP%]:before, .clock-spinner[_ngcontent-%COMP%]:after{border-radius:50%;animation:linear infinite _ngcontent-%COMP%_clock;background-clip:content-box;content:\"\";left:0;padding-bottom:11.4px;padding-left:11.28px;padding-right:11.28px;position:absolute;top:0;width:1.44px}.clock-spinner[_ngcontent-%COMP%]:before{animation-duration:12s;height:7.8px;padding-top:4.8px}.clock-spinner[_ngcontent-%COMP%]:after{animation-duration:1s;height:10.2px;padding-top:2.4px}@keyframes _ngcontent-%COMP%_clock{to{transform:rotate(360deg)}}"],
        changeDetection: 0
      });
    }
  }
  return ClockSpinnerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _interval = 150;
// @dynamic
let LoadingBarService = /*#__PURE__*/(() => {
  class LoadingBarService {
    constructor(platformId) {
      this.platformId = platformId;
      this.navigationVisibleSubject = new BehaviorSubject(false);
      this.navigationVisible$ = this.navigationVisibleSubject.asObservable();
      this.navigationPercentSubject = new BehaviorSubject(0);
      this.navigationPercent$ = this.navigationPercentSubject.asObservable();
      this._navigationPercent = 0;
      this.fetchingVisibleSubject = new BehaviorSubject(false);
      this.fetchingVisible$ = this.fetchingVisibleSubject.asObservable();
      this.fetchingPercentSubject = new BehaviorSubject(0);
      this.fetchingPercent$ = this.fetchingPercentSubject.asObservable();
      this._fetchingPercent = 0;
      // singleton
      if (LoadingBarService._instance) {
        return LoadingBarService._instance;
      }
      LoadingBarService._instance = this;
      console.log('LoadingBarService:constructor');
    }
    get isBrowser() {
      return isPlatformBrowser(this.platformId);
    }
    navigationStart(percent = 0) {
      if (!this.isBrowser) {
        return;
      }
      this._navigationPercent = 0;
      this.navigationVisibleSubject.next(true);
      this.navigationPercentSubject.next(this._navigationPercent);
      if (percent > 0) {
        this.navigationProgress(percent);
      }
    }
    navigationProgress(percent) {
      if (!this.isBrowser) {
        return;
      }
      const _percent = Math.min(100, Math.max(0, percent));
      if (_percent < this._navigationPercent) {
        return;
      }
      const _percent1 = (_percent + this._navigationPercent) / 2;
      const _percent2 = _percent;
      this._navigationPercent = _percent;
      setTimeout(() => {
        this.navigationPercentSubject.next(_percent1);
      }, _interval);
      setTimeout(() => {
        this.navigationPercentSubject.next(_percent2);
      }, _interval * 2);
    }
    navigationComplete() {
      if (!this.isBrowser) {
        return;
      }
      this.navigationProgress(100);
      setTimeout(() => {
        this._navigationPercent = 0;
        this.navigationVisibleSubject.next(false);
        this.navigationPercentSubject.next(this._navigationPercent);
      }, _interval * 3);
    }
    navigationStop() {
      if (!this.isBrowser) {
        return;
      }
      this.navigationVisibleSubject.next(false);
      setTimeout(() => {
        this._navigationPercent = 0;
        this.navigationPercentSubject.next(this._navigationPercent);
      }, _interval);
    }
    fetchingStart(percent = 0) {
      if (!this.isBrowser) {
        return;
      }
      this._fetchingPercent = 0;
      this.fetchingVisibleSubject.next(true);
      this.fetchingPercentSubject.next(this._fetchingPercent);
      if (percent > 0) {
        this.fetchingProgress(percent);
      }
    }
    fetchingProgress(percent) {
      if (!this.isBrowser) {
        return;
      }
      const _percent = Math.min(100, Math.max(0, percent));
      if (_percent < this._fetchingPercent) {
        return;
      }
      const _percent1 = (_percent + this._fetchingPercent) / 2;
      const _percent2 = _percent;
      this._fetchingPercent = _percent;
      setTimeout(() => {
        this.fetchingPercentSubject.next(_percent1);
      }, _interval);
      setTimeout(() => {
        this.fetchingPercentSubject.next(_percent2);
      }, _interval * 2);
    }
    fetchingComplete(percent = 100) {
      if (!this.isBrowser) {
        return;
      }
      this.fetchingProgress(percent);
      setTimeout(() => {
        this._fetchingPercent = 0;
        this.fetchingVisibleSubject.next(false);
        this.fetchingPercentSubject.next(this._fetchingPercent);
      }, _interval * 3);
    }
    fetchingStop() {
      if (!this.isBrowser) {
        return;
      }
      this.fetchingVisibleSubject.next(false);
      setTimeout(() => {
        this._fetchingPercent = 0;
        this.fetchingPercentSubject.next(this._fetchingPercent);
      }, _interval);
    }
    static {
      this.ɵfac = function LoadingBarService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoadingBarService)(i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LoadingBarService,
        factory: LoadingBarService.ɵfac
      });
    }
  }
  return LoadingBarService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadingBarComponent = /*#__PURE__*/(() => {
  class LoadingBarComponent {
    constructor(loadingBar) {
      this.loadingBar = loadingBar;
      this.navigationVisible$ = this.loadingBar.navigationVisible$;
      this.navigationPercent$ = this.loadingBar.navigationPercent$;
      this.fetchingVisible$ = this.loadingBar.fetchingVisible$;
      this.fetchingPercent$ = this.loadingBar.fetchingPercent$;
    }
    static {
      this.ɵfac = function LoadingBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoadingBarComponent)(i0.ɵɵdirectiveInject(LoadingBarService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoadingBarComponent,
        selectors: [["app-loading-bar"]],
        decls: 8,
        vars: 16,
        consts: [[1, "container", "navigation"], [1, "progress"], [1, "container", "fetching"]],
        template: function LoadingBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelement(2, "div", 1);
            i0.ɵɵpipe(3, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2);
            i0.ɵɵpipe(5, "async");
            i0.ɵɵelement(6, "div", 1);
            i0.ɵɵpipe(7, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("visible", i0.ɵɵpipeBind1(1, 8, ctx.navigationVisible$));
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", i0.ɵɵpipeBind1(3, 10, ctx.navigationPercent$) + "%");
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("visible", i0.ɵɵpipeBind1(5, 12, ctx.fetchingVisible$));
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", i0.ɵɵpipeBind1(7, 14, ctx.fetchingPercent$) + "%");
          }
        },
        dependencies: [i2.AsyncPipe],
        styles: [".container[_ngcontent-%COMP%]{display:block;position:fixed;left:0;right:0;opacity:0;background:#fff;transition:opacity .1s linear;will-change:opacity}.container[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{position:absolute;left:0;top:0;bottom:0;width:0;transition:width .5s ease-out;will-change:width}.container.visible[_ngcontent-%COMP%]{opacity:1;height:4px}.container.navigation[_ngcontent-%COMP%]{top:0;height:2px;z-index:10000}.container.navigation[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{background:#5ab3e4}.container.fetching[_ngcontent-%COMP%]{top:2px;height:2px;z-index:10001;background:#fff}.container.fetching[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{background:#feed7d}"]
      });
    }
  }
  return LoadingBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SpinnersModule = /*#__PURE__*/(() => {
  class SpinnersModule {
    static {
      this.ɵfac = function SpinnersModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SpinnersModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SpinnersModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [LoadingBarService],
        imports: [CommonModule]
      });
    }
  }
  return SpinnersModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IconsService = /*#__PURE__*/(() => {
  class IconsService {
    static svgsetIconUrl(icon) {
      return `./assets/icons/svgset.svg#${icon}`;
    }
    static {
      this.ɵfac = function IconsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IconsService,
        factory: IconsService.ɵfac
      });
    }
  }
  return IconsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DeviceService = /*#__PURE__*/(() => {
  class DeviceService {
    constructor(deviceService) {
      this.deviceService = deviceService;
    }
    static svgsetIconUrl(icon) {
      return `./assets/icons/svgset.svg#${icon}`;
    }
    isMobile() {
      return this.deviceService.isMobile();
    }
    isTablet() {
      return this.deviceService.isTablet();
    }
    isDesktop() {
      return this.deviceService.isDesktop();
    }
    static {
      this.ɵfac = function DeviceService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DeviceService)(i0.ɵɵinject(i1.DeviceDetectorService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DeviceService,
        factory: DeviceService.ɵfac
      });
    }
  }
  return DeviceService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// tslint:disable-next-line:directive-class-suffix
let DestroyableComponent = /*#__PURE__*/(() => {
  class DestroyableComponent {
    constructor(platform) {
      this.platform = platform;
      this.destroyed$ = new Subject();
      this.completable = [];
      if (platform) {
        this.isBrowser = platform.isBrowser;
        this.isServer = platform.isServer;
      } else {
        // По умолчанию считаем, что мы в браузере
        this.isServer = false;
        this.isBrowser = true;
      }
      this.isAutotestAgent = this.isBrowser ? navigator.userAgent?.includes('functional-test') : false;
    }
    ngOnDestroy() {
      this.destroyed$.next(true);
      this.destroyed$.complete();
      this.completable.map(s => s.complete());
      this.completable.splice(0);
    }
    register(instance) {
      this.completable.push(instance);
      return instance;
    }
    setTimeout(func, timeout) {
      if (this.isBrowser === null || this.isBrowser === undefined) {
        throw new Error(`RuntimeError: 'platform' not injected in ${this.constructor.name}`);
      }
      const dueTime = addMilliseconds(new Date(), timeout);
      if (this.isBrowser) {
        return timer(dueTime).pipe(first(), takeUntil(this.destroyed$)).subscribe(func);
      } else {
        func();
        return null;
      }
    }
    clearTimeout(timerLike) {
      if (!timerLike) {
        return;
      }
      if (typeof timerLike === 'number') {
        clearTimeout(timerLike);
      } else {
        if ('unsubscribe' in timerLike) {
          // instanceof Subscription
          timerLike.unsubscribe();
        }
      }
    }
    setInterval(func, period, count = 0) {
      if (this.isBrowser === null || this.isBrowser === undefined) {
        throw new Error(`RuntimeError: 'platform' not injected in ${this.constructor.name}`);
      }
      if (this.isBrowser) {
        let _interval = interval(period);
        if (count > 0) {
          _interval = _interval.pipe(take(count));
        }
        return _interval.pipe(takeUntil(this.destroyed$)).subscribe(func);
      } else {
        func();
        return null;
      }
    }
    clearInterval(intervalLike) {
      if (!intervalLike) {
        return;
      }
      if (typeof intervalLike === 'number') {
        clearInterval(intervalLike);
      } else {
        if ('unsubscribe' in intervalLike) {
          // instanceof Subscription
          intervalLike.unsubscribe();
        }
      }
    }
    onBrowserOnly(fn) {
      if (this.isBrowser === null || this.isBrowser === undefined) {
        throw new Error(`RuntimeError: 'platform' not injected in ${this.constructor.name}`);
      }
      if (this.isBrowser) {
        fn();
      }
    }
    onServerOnly(fn) {
      if (this.isBrowser === null || this.isBrowser === undefined) {
        throw new Error(`RuntimeError: 'platform' not injected in ${this.constructor.name}`);
      }
      if (this.isServer) {
        fn();
      }
    }
    static {
      this.ɵfac = function DestroyableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DestroyableComponent)(i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: DestroyableComponent
      });
    }
  }
  return DestroyableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// tslint:disable-next-line:directive-class-suffix
let ChangableComponent = /*#__PURE__*/(() => {
  class ChangableComponent extends DestroyableComponent {
    constructor(cdr) {
      super();
      this.cdr = cdr;
    }
    detectChanges() {
      if (this.cdr && !this.cdr.destroyed) {
        this.cdr.detectChanges();
      }
    }
    markForCheck() {
      if (this.cdr && !this.cdr.destroyed) {
        this.cdr.markForCheck();
      }
    }
    assetsUrl(url) {
      if (!url) {
        return null;
      }
      return url;
    }
    static {
      this.ɵfac = function ChangableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ChangableComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ChangableComponent,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return ChangableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlatformService = /*#__PURE__*/(() => {
  class PlatformService {
    constructor(platformId) {
      this.platformId = platformId;
      this.isBrowser = isPlatformBrowser(this.platformId);
      this.isServer = isPlatformServer(this.platformId);
    }
    static {
      this.ɵfac = function PlatformService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlatformService)(i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PlatformService,
        factory: PlatformService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PlatformService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var EIPhones = /*#__PURE__*/function (EIPhones) {
  EIPhones["XII"] = "XII";
  EIPhones["XI_Pro_Max_14"] = "XI_Pro_Max_14";
  EIPhones["XI_Pro_Max"] = "XI_Pro_Max";
  EIPhones["XI_Pro"] = "XI_Pro";
  EIPhones["XI"] = "XI";
  EIPhones["XI_14"] = "XI_14";
  EIPhones["XR"] = "XR";
  EIPhones["XS_Max"] = "XS_Max";
  EIPhones["XS"] = "XS";
  EIPhones["XS_13"] = "XS_13";
  EIPhones["X"] = "X";
  return EIPhones;
}(EIPhones || {});
const devices = {
  [EIPhones.XII]: {
    logicalWidth: 390,
    logicalHeight: 844,
    innerHeightP: 778,
    innerHeightL: 390,
    innerHeightPExpand: 664,
    innerHeightLExpand: 340,
    devicePixelRatio: 3,
    osVersion: 14
  },
  [EIPhones.XI_Pro_Max_14]: {
    logicalWidth: 414,
    logicalHeight: 896,
    innerHeightP: 833,
    innerHeightL: 414,
    innerHeightPExpand: 719,
    innerHeightLExpand: 364,
    devicePixelRatio: 3,
    osVersion: 14
  },
  [EIPhones.XI_Pro_Max]: {
    logicalWidth: 414,
    logicalHeight: 896,
    innerHeightP: 832,
    innerHeightL: 414,
    innerHeightPExpand: 719,
    innerHeightLExpand: 364,
    devicePixelRatio: 3,
    osVersion: 13
  },
  [EIPhones.XI_Pro]: {
    logicalWidth: 375,
    logicalHeight: 812,
    innerHeightP: 749,
    innerHeightL: 375,
    innerHeightPExpand: 635,
    innerHeightLExpand: 325,
    devicePixelRatio: 3,
    osVersion: 13
  },
  [EIPhones.XI]: {
    logicalWidth: 414,
    logicalHeight: 896,
    innerHeightP: 833,
    innerHeightL: 414,
    innerHeightPExpand: 719,
    innerHeightLExpand: 364,
    devicePixelRatio: 2,
    osVersion: 13
  },
  [EIPhones.XI_14]: {
    logicalWidth: 414,
    logicalHeight: 896,
    innerHeightP: 829,
    innerHeightL: 414,
    innerHeightPExpand: 715,
    innerHeightLExpand: 364,
    devicePixelRatio: 2,
    osVersion: 14
  },
  [EIPhones.XR]: {
    logicalWidth: 414,
    logicalHeight: 896,
    innerHeightP: 833,
    innerHeightL: 414,
    innerHeightPExpand: 719,
    innerHeightLExpand: 364,
    devicePixelRatio: 2,
    osVersion: 12
  },
  [EIPhones.XS_Max]: {
    logicalWidth: 414,
    logicalHeight: 896,
    innerHeightP: 832,
    innerHeightL: 414,
    innerHeightPExpand: 719,
    innerHeightLExpand: 364,
    devicePixelRatio: 3,
    osVersion: 12
  },
  [EIPhones.XS]: {
    logicalWidth: 375,
    logicalHeight: 812,
    innerHeightP: 748,
    innerHeightL: 375,
    innerHeightPExpand: 635,
    innerHeightLExpand: 325,
    devicePixelRatio: 3,
    osVersion: 12
  },
  [EIPhones.XS_13]: {
    logicalWidth: 375,
    logicalHeight: 812,
    innerHeightP: 749,
    innerHeightL: 375,
    innerHeightPExpand: 635,
    innerHeightLExpand: 325,
    devicePixelRatio: 3,
    osVersion: 13
  },
  [EIPhones.X]: {
    logicalWidth: 375,
    logicalHeight: 812,
    innerHeightP: 748,
    innerHeightL: 375,
    innerHeightPExpand: 635,
    innerHeightLExpand: 325,
    devicePixelRatio: 3,
    osVersion: 11
  }
};
var DeviceOrientationEnum = /*#__PURE__*/function (DeviceOrientationEnum) {
  DeviceOrientationEnum["portrait"] = "portrait";
  DeviceOrientationEnum["landscape"] = "landscape";
  return DeviceOrientationEnum;
}(DeviceOrientationEnum || {});
let ScreenService = /*#__PURE__*/(() => {
  class ScreenService extends DestroyableComponent {
    static screenOptions() {
      return {
        availWidth: window.screen.availWidth,
        availHeight: window.screen.availHeight,
        width: window.screen.width,
        height: window.screen.height,
        isPortrait: window.orientation ? window.orientation === 0 : true,
        isLandscape: window.orientation ? window.orientation === 90 : false
      };
    }
    constructor(deviceService, zone, platform) {
      super(platform);
      this.deviceService = deviceService;
      this.zone = zone;
      this.platform = platform;
      this.scrollTopSubject = this.register(new BehaviorSubject(0));
      this.scrollTop$ = this.scrollTopSubject.asObservable();
      this.widthSubject = this.register(new BehaviorSubject(375));
      this.width$ = this.widthSubject.asObservable();
      this.heightSubject = this.register(new BehaviorSubject(812));
      this.height$ = this.heightSubject.asObservable();
      this.isSmallScreen = true;
      this.isWideScreen = false;
      this.subject = this.register(new ReplaySubject(1));
      this.options = this.subject.asObservable();
      this._iPhoneScreenOptions = this.register(new ReplaySubject(1));
      this.iPhoneScreenOptions$ = this._iPhoneScreenOptions.asObservable();
      this.extraFontsEnabled = false;
      this.init();
    }
    init() {
      if (this.isBrowser) {
        this._scrollTop = fromEvent(window, 'scroll').pipe(map(() => {
          const supportPageOffset = window.pageXOffset !== undefined;
          const isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';
          // var x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
          return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
        }), debounceTime(10), distinctUntilChanged());
        this._width = fromEvent(window, 'resize').pipe(map(() => window.innerWidth), debounceTime(250), distinctUntilChanged());
        this._height = fromEvent(window, 'resize').pipe(map(() => window.innerHeight), debounceTime(250), distinctUntilChanged());
        this._scrollTop.pipe(takeUntil(this.destroyed$)).subscribe(scrollTop => {
          this.scrollTopSubject.next(scrollTop);
        });
        this._width.pipe(takeUntil(this.destroyed$)).subscribe(width => {
          this.onWidthChange(width);
        });
        this._height.pipe(takeUntil(this.destroyed$)).subscribe(height => {
          this.onHeightChange(height);
        });
        this.onWidthChange(window.innerWidth);
        this.onHeightChange(window.innerHeight);
        fromEvent(window, 'resize').pipe(debounceTime(500), distinctUntilChanged()).pipe(takeUntil(this.destroyed$)).subscribe(() => {
          this.subject.next(ScreenService.screenOptions());
        });
        this.subject.next(ScreenService.screenOptions());
      }
    }
    onWidthChange(width) {
      this.isSmallScreen = /* this.deviceService.isMobile() || this.deviceService.isTablet() ||*/width <= 990;
      this.isWideScreen = /* this.deviceService.isDesktop() &&*/width >= 1205;
      this.widthSubject.next(width);
    }
    onHeightChange(height) {
      this.heightSubject.next(height);
    }
    setBodyFixed(state) {
      this.setBodyClass('fixed', state);
      if (!this.deviceService.isDesktop()) {
        this.setBodyClass('mobile', state);
      }
    }
    setBodyClass(className, state) {
      if (this.isBrowser) {
        this.zone.runOutsideAngular(() => {
          const body = document.getElementsByTagName('body')[0];
          if (state) {
            body.classList.add(className);
          } else {
            body.classList.remove(className);
          }
        });
      }
    }
    enableExtraFonts() {
      if (this.isBrowser && !this.extraFontsEnabled) {
        this.extraFontsEnabled = true;
        this.zone.runOutsideAngular(() => {
          const link = document.createElement('link');
          link.href = 'https://fonts.googleapis.com/css?family=Londrina+Shadow&display=swap';
          link.rel = 'stylesheet';
          document.getElementsByTagName('head')[0].appendChild(link);
        });
      }
    }
    iPhoneModels() {
      if (this.deviceService.isMobile() && this.isIPhone) {
        const keys = Object.keys(devices);
        return keys.filter(key => devices[key].logicalWidth === window.screen.width && devices[key].logicalHeight === window.screen.height || devices[key].logicalWidth === window.screen.height && devices[key].logicalHeight === window.screen.width).filter(key => devices[key].osVersion === this.osVersion).filter(key => devices[key].devicePixelRatio === this.devicePixelRatio);
      }
      return [];
    }
    get isIPhone() {
      return !!navigator.userAgent.match(/iPhone/i);
    }
    get isSafari() {
      return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1;
    }
    get isIPhoneXAndYoung() {
      if (this.deviceService.isMobile() && this.isIPhone) {
        return !!this.iPhoneModels().length;
      }
      return false;
    }
    get osVersion() {
      if (!this.isIPhone) {
        return null;
      }
      const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
      return parseInt(v[1], 10);
    }
    get devicePixelRatio() {
      return window.devicePixelRatio;
    }
    get toolsExpanded() {
      const devicesList = this.iPhoneModels().map(key => ScreenService.screenOptions().isPortrait ? devices[key].innerHeightPExpand === window.innerHeight : devices[key].innerHeightLExpand === window.innerHeight);
      return devicesList.includes(true);
    }
    get deviceOrientation() {
      if (screen.availHeight > screen.availWidth) {
        return DeviceOrientationEnum.portrait;
      } else {
        return DeviceOrientationEnum.landscape;
      }
    }
    static {
      this.ɵfac = function ScreenService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScreenService)(i0.ɵɵinject(i1.DeviceDetectorService), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(PlatformService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ScreenService,
        factory: ScreenService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ScreenService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConfigService = /*#__PURE__*/(() => {
  class ConfigService extends DestroyableComponent {
    constructor() {
      super();
      this._updatePlan = this.register(new EventEmitter());
      this.updatePlan$ = this._updatePlan.asObservable();
    }
    updatePlan() {
      this._updatePlan.next(true);
    }
    static {
      this.ɵfac = function ConfigService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfigService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConfigService,
        factory: ConfigService.ɵfac
      });
    }
  }
  return ConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** TODO implements ControlValueAccessor */
/** @see @src/app/games/games-header/user-service-select/user-service-select.component.ts */
// @dynamic
let SubjectSelectorComponent = /*#__PURE__*/(() => {
  class SubjectSelectorComponent {
    set subjects(s) {
      this._subjects = s;
      this.prepare();
    }
    get subjects() {
      return {
        other: this._subjects ? this._subjects.other || [] : [],
        foreign: this._subjects ? this._foreignSubjects || [] : [],
        native: this._subjects ? this._nativeSubjects || [] : [],
        non_categorized: this._subjects ? this._subjects.non_categorized || [] : [],
        user: this._subjects ? this._subjects.user || [] : [],
        recent: this._subjects ? this._subjects.recent || [] : []
      };
    }
    set subjectSelectedId(id) {
      this._subjectSelectedId = id;
      this.prepare();
    }
    constructor(contextService,
    // private languageService: LanguageService,
    // private translate: TranslateService,
    cdr, platformId) {
      this.contextService = contextService;
      this.cdr = cdr;
      this.platformId = platformId;
      this.selectSubjectId = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.searchTerm = '';
      this.filteredSubjects = [];
      this.optionsLevel1 = [
      // { name: 'recent', label: 'recent'}, // последние
      // { name: 'user', label: 'user'},
      // { name: 'other', label: 'lingo2-forms.subject-selector.lvl1.other' },
      {
        name: 'foreign',
        label: 'lingo2-forms.subject-selector.lvl1.foreign'
      }, {
        name: 'native',
        label: 'lingo2-forms.subject-selector.lvl1.native'
      }, {
        name: 'non_categorized',
        label: 'lingo2-forms.subject-selector.lvl1.non_categorized'
      }];
      this._nativeSubjects = [];
      this._foreignSubjects = [];
      this.subscription = new Subscription();
    }
    ngOnInit() {
      this.subscription.add(this.contextService.me$.subscribe(me => {
        this._me = me;
        this.prepare();
      }));
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    get isBrowser() {
      return isPlatformBrowser(this.platformId);
    }
    /**
     * ID языков интерфейса
     */
    get uiLanguageIds() {
      const ids = [];
      // if (this.isBrowser) {
      //   /* список языков браузера */
      //   const langCode = this.languageService.findClosestLanguageCode((navigator.languages || []) as string[], false);
      //   const lang = LanguageService.getLanguageByCode(langCode);
      //   if (lang) {
      //     ids.push(lang.id);
      //   }
      // }
      //
      // /** язык текущей локали интерфейса */
      // const uiLang = LanguageService.getLanguageByCode(this.translate.currentLang);
      // if (uiLang) {
      //   ids.push(uiLang.id);
      // }
      return ids;
    }
    /**
     * Список ID языков, которым владеет текущий пользователь + язык интерфейса
     */
    get spokenLanguageIds() {
      const nativelanguageIds = (this._me ? this._me.spoken_languages : []).filter(lang => +lang.level_id === nativeSpokenLevel).map(lang => +lang.language_id);
      return [...nativelanguageIds, ...this.uiLanguageIds];
    }
    prepare() {
      if (this._subjects) {
        this.otherSubject = this._subjects.other[0];
        const spokenIds = this.spokenLanguageIds;
        this._nativeSubjects = this._subjects.native.filter(_s => spokenIds.find(_nId => _nId === +_s.language_id));
        // copist: фильтр дисциплин всегда показывать все иностранные - не понимаю, почему я не могу изучать русский, если он мой родной
        // this._foreignSubjects = this._subjects.foreign
        //   .filter((_s) => !spokenIds.find((_nId) => _nId === +_s.language_id));
        this._foreignSubjects = this._subjects.foreign;
      }
      this.selectedSubject = this.searchSubjectById(this._subjectSelectedId);
    }
    onSelectSubject(e, subject) {
      e.preventDefault();
      this.selectedSubject = subject;
      this.selectSubjectId.emit(subject.id);
      this.onCloseSelector();
    }
    onCloseSelector() {
      this.optionsExpandedLvl1 = false;
      this.searchTerm = null;
      this.cdr.markForCheck();
    }
    trackByFn(index, item) {
      return item.id;
    }
    // TODO: debounce
    // public onSearchSubjects = _debounce(() => {
    //   this.filterSubjectsByTerm();
    //   this.cdr.markForCheck();
    // }, 500);
    onSearchSubjects() {
      this.filterSubjectsByTerm();
      this.cdr.markForCheck();
    }
    filterSubjectsByTerm() {
      const term = this.searchTerm.toLowerCase();
      if (!term.length || !this._subjects) {
        return;
      }
      this.filteredSubjects = [...this.subjects.other, ...this.subjects.foreign, ...this.subjects.native, ...this.subjects.non_categorized, ...this.subjects.user].filter(s => s.title.toLowerCase().indexOf(term) >= 0);
    }
    searchSubjectById(id) {
      if (!id || !this._subjects) {
        return null;
      }
      const allSubjects = [...this.subjects.other, ...this.subjects.foreign, ...this.subjects.native, ...this.subjects.non_categorized, ...this.subjects.user];
      return allSubjects.find(s => s.id === id);
    }
    onCreateOther(e, subjectLvl1) {
      if (subjectLvl1.name === 'other') {
        this.onSelectSubject(e, this.otherSubject);
      }
    }
    langType(subject) {
      if (!subject) {
        return null;
      }
      if (subject.category_id === SubjectCategoryEnum.foreign_language) {
        return 'lingo2-forms.subject-selector.foreign';
      } else if (subject.category_id === SubjectCategoryEnum.native_language) {
        return 'lingo2-forms.subject-selector.native';
      } else {
        return null;
      }
    }
    onOptionsExpandedLvl1() {
      if (this.disabled) {
        return;
      }
      this.optionsExpandedLvl1 = true;
      this.cdr.markForCheck();
    }
    static {
      this.ɵfac = function SubjectSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SubjectSelectorComponent)(i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SubjectSelectorComponent,
        selectors: [["app-subject-selector"]],
        inputs: {
          subjects: "subjects",
          subjectSelectedId: "subjectSelectedId",
          valid: "valid",
          disabled: "disabled",
          warning: "warning"
        },
        outputs: {
          selectSubjectId: "selectSubjectId"
        },
        decls: 16,
        vars: 23,
        consts: [["selector", ""], ["newSubjects", ""], ["rest", ""], [1, "subject-selector", 3, "clickOutside"], [1, "select-lvl1", 3, "click"], [1, "select-wrap"], [1, "select-subject-text"], ["class", "lang-type", 4, "ngIf"], ["viewBox", "0 0 12 7", 1, "arrow"], [1, "options-lvl1"], [1, "search-wrap"], [1, "search", 3, "ngModelChange", "keyup", "ngModel", "placeholder"], [3, "ngIf", "ngIfElse"], [1, "lang-type"], [1, "search-options-wrap"], [1, "scroll"], [1, "search-list"], ["class", "search-option-item", 3, "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "search-option-item", 3, "click"], [1, "search-label"], [1, "new-subject"], [1, "new-subject-text"], [3, "ngIf"], [1, "options-list-lvl1"], ["ngFor", "", 3, "ngForOf"], [1, "recent-wrap"], [1, "recent-title"], [1, "recent-list"], ["class", "recent-item", 3, "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "separator"], [1, "recent-item", 3, "click"], [1, "recent-label"], [1, "option-item-lvl1", 3, "mouseover", "mouseout"], [1, "option-label-lvl1", 3, "click"], ["class", "subject-select-arrow", "viewBox", "0 0 16 16", 4, "ngIf"], ["viewBox", "0 0 16 16", 1, "subject-select-arrow"], [1, "options-lvl2"], [1, "option-list-lvl2"], [1, "back-wrap", 3, "click"], ["class", "option-item-lvl2", 3, "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "option-item-lvl2", 3, "click"], [1, "option-label-lvl2"]],
        template: function SubjectSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 3);
            i0.ɵɵlistener("clickOutside", function SubjectSelectorComponent_Template_div_clickOutside_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onCloseSelector());
            });
            i0.ɵɵelementStart(1, "div", 4);
            i0.ɵɵlistener("click", function SubjectSelectorComponent_Template_div_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOptionsExpandedLvl1());
            });
            i0.ɵɵelementStart(2, "div", 5)(3, "span", 6);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, SubjectSelectorComponent_span_6_Template, 3, 3, "span", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(7, "svg", 8);
            i0.ɵɵelement(8, "use");
            i0.ɵɵelementEnd()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(9, "div", 9)(10, "label", 10)(11, "input", 11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵtwoWayListener("ngModelChange", function SubjectSelectorComponent_Template_input_ngModelChange_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.searchTerm, $event) || (ctx.searchTerm = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("keyup", function SubjectSelectorComponent_Template_input_keyup_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSearchSubjects());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(13, SubjectSelectorComponent_ng_template_13_Template, 3, 2, "ng-template", 12)(14, SubjectSelectorComponent_ng_template_14_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const selector_r18 = i0.ɵɵreference(15);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("active", ctx.optionsExpandedLvl1)("invalid", !ctx.valid)("warning", ctx.warning)("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("placeholder", !ctx.selectedSubject);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 19, (ctx.selectedSubject == null ? null : ctx.selectedSubject.title) || "lingo2-forms.subject-selector.select-placeholder"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.langType(ctx.selectedSubject));
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("href", ctx.svgsetIcon("arrow-select-up"), null, "xlink");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("expand", ctx.optionsExpandedLvl1);
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.searchTerm);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(12, 21, "lingo2-forms.subject-selector.search-placeholder"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.searchTerm)("ngIfElse", selector_r18);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3$1.ClickOutsideDirective, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.subject-selector[_ngcontent-%COMP%]{position:relative;-webkit-user-select:none;user-select:none}.subject-selector[_ngcontent-%COMP%]   .select-lvl1[_ngcontent-%COMP%]{align-items:center;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;cursor:pointer;display:flex;height:34px;justify-content:space-between;padding:0 13px 0 10px;transition:all .2s;width:275px}.subject-selector[_ngcontent-%COMP%]   .select-lvl1[_ngcontent-%COMP%]:hover{border-color:#a4b0c3}.subject-selector[_ngcontent-%COMP%]   .select-lvl1.invalid[_ngcontent-%COMP%]{border-color:#e86f79}.subject-selector[_ngcontent-%COMP%]   .select-lvl1.warning[_ngcontent-%COMP%]{border-color:#fd0}.subject-selector[_ngcontent-%COMP%]   .select-lvl1[_ngcontent-%COMP%]   .select-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;margin-right:10px;width:0}.subject-selector[_ngcontent-%COMP%]   .select-lvl1[_ngcontent-%COMP%]   .select-wrap[_ngcontent-%COMP%]   .select-subject-text[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal}.subject-selector[_ngcontent-%COMP%]   .select-lvl1[_ngcontent-%COMP%]   .select-wrap[_ngcontent-%COMP%]   .select-subject-text.placeholder[_ngcontent-%COMP%]{color:#ccc}.subject-selector[_ngcontent-%COMP%]   .select-lvl1[_ngcontent-%COMP%]   .select-wrap[_ngcontent-%COMP%]   .lang-type[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px}.subject-selector[_ngcontent-%COMP%]   .select-lvl1[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{fill:#fff0;height:8px;stroke:#999;transition:all .2s;transform:rotate(180deg);min-width:14px;width:14px}.subject-selector[_ngcontent-%COMP%]   .select-lvl1.active[_ngcontent-%COMP%]{border-color:#5ab3e4}.subject-selector[_ngcontent-%COMP%]   .select-lvl1.active[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{stroke:#5ab3e4;transform:rotate(0)}.subject-selector[_ngcontent-%COMP%]   .select-lvl1.disabled[_ngcontent-%COMP%]{background:#f6f6f6;border:1px solid #EEEEEE}.subject-selector[_ngcontent-%COMP%]   .select-lvl1.disabled[_ngcontent-%COMP%]   .select-wrap[_ngcontent-%COMP%]   .select-subject-text[_ngcontent-%COMP%]{color:#ccc}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 10px #0000001a;border-radius:10px;box-sizing:border-box;opacity:0;position:absolute;transition:all .2s;visibility:hidden;display:flex;flex-direction:column;padding:10px 0 5px;top:0;transform:scaleY(0);left:-1px;width:275px;z-index:1}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]{margin:0 10px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;height:30px;outline:none;padding:0 10px;transition:all .2s;width:100%}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]::placeholder{color:#ccc}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]:focus{border-color:#5ab3e4}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]{padding-top:5px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]{overflow-y:auto;max-height:235px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:#eee}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:#f7f7f7}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]{scrollbar-face-color:#EEEEEE;scrollbar-track-color:#f7f7f7}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .search-list[_ngcontent-%COMP%]{margin:0;padding:0;cursor:pointer}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .search-list[_ngcontent-%COMP%]   .search-option-item[_ngcontent-%COMP%]{align-items:center;background:transparent;display:flex;height:26px;justify-content:space-between;padding:0 10px;position:relative;transition:all .2s}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .search-list[_ngcontent-%COMP%]   .search-option-item[_ngcontent-%COMP%]   .search-label[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 20px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;color:#1e252b}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .search-list[_ngcontent-%COMP%]   .search-option-item[_ngcontent-%COMP%]   .lang-type[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .search-list[_ngcontent-%COMP%]   .search-option-item[_ngcontent-%COMP%]:hover{background:#f5f8fa}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .search-options-wrap[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .search-list[_ngcontent-%COMP%]   .search-option-item[_ngcontent-%COMP%]:hover   .search-label[_ngcontent-%COMP%]{color:#41a1d9}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .new-subject[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;padding:20px 0 10px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .new-subject[_ngcontent-%COMP%]   .new-subject-text[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .new-subject[_ngcontent-%COMP%]   .new-subject-action[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:10px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;color:#41a1d9;cursor:pointer;line-height:30px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .recent-wrap[_ngcontent-%COMP%]{padding:10px 0 0}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .recent-wrap[_ngcontent-%COMP%]   .recent-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;color:#a4b0c3;font-size:14px;line-height:18px;line-height:20px;margin:0 10px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .recent-wrap[_ngcontent-%COMP%]   .recent-list[_ngcontent-%COMP%]{margin:0;padding:0;cursor:pointer}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .recent-wrap[_ngcontent-%COMP%]   .recent-list[_ngcontent-%COMP%]   .recent-item[_ngcontent-%COMP%]{align-items:center;background:transparent;display:flex;height:26px;justify-content:space-between;padding:0 10px;position:relative;transition:all .2s}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .recent-wrap[_ngcontent-%COMP%]   .recent-list[_ngcontent-%COMP%]   .recent-item[_ngcontent-%COMP%]   .recent-label[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 20px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;color:#1e252b}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .recent-wrap[_ngcontent-%COMP%]   .recent-list[_ngcontent-%COMP%]   .recent-item[_ngcontent-%COMP%]   .lang-type[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .recent-wrap[_ngcontent-%COMP%]   .recent-list[_ngcontent-%COMP%]   .recent-item[_ngcontent-%COMP%]:hover{background:#f5f8fa}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .recent-wrap[_ngcontent-%COMP%]   .recent-list[_ngcontent-%COMP%]   .recent-item[_ngcontent-%COMP%]:hover   .recent-label[_ngcontent-%COMP%]{color:#41a1d9}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .recent-wrap[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{background:#eee;border:none;height:1px;margin:5px 0 0;width:100%}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]{cursor:pointer;margin:0;padding:5px 0 0}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .option-item-lvl1[_ngcontent-%COMP%]{align-items:center;background:transparent;display:flex;height:26px;justify-content:space-between;padding:0 10px;position:relative;transition:all .2s}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .option-item-lvl1[_ngcontent-%COMP%]   .option-label-lvl1[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 20px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;color:#1e252b}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .option-item-lvl1[_ngcontent-%COMP%]   .subject-select-arrow[_ngcontent-%COMP%]{height:16px;stroke:#1e252b;min-width:16px;width:16px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .option-item-lvl1[_ngcontent-%COMP%]:hover{background:#f5f8fa}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .option-item-lvl1[_ngcontent-%COMP%]:hover   .option-label-lvl1[_ngcontent-%COMP%]{color:#41a1d9}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .option-item-lvl1[_ngcontent-%COMP%]:hover   .subject-select-arrow[_ngcontent-%COMP%]{stroke:#41a1d9}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 10px #0000001a;border-radius:10px;box-sizing:border-box;opacity:0;position:absolute;transition:all .2s;visibility:hidden;max-height:270px;overflow:hidden;padding:5px 0;right:-80%;top:0;transform:scaleX(0);width:260px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]{overflow-y:auto;max-height:260px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:#eee}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:#f7f7f7}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]{scrollbar-face-color:#EEEEEE;scrollbar-track-color:#f7f7f7}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .option-list-lvl2[_ngcontent-%COMP%]{margin:0;padding:0}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .option-list-lvl2[_ngcontent-%COMP%]   .option-item-lvl2[_ngcontent-%COMP%]{align-items:center;background:transparent;display:flex;height:26px;justify-content:space-between;padding:0 10px;position:relative;transition:all .2s}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .option-list-lvl2[_ngcontent-%COMP%]   .option-item-lvl2[_ngcontent-%COMP%]   .option-label-lvl2[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 20px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;color:#1e252b}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .option-list-lvl2[_ngcontent-%COMP%]   .option-item-lvl2[_ngcontent-%COMP%]:hover{background:#f5f8fa}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .scroll[_ngcontent-%COMP%]   .option-list-lvl2[_ngcontent-%COMP%]   .option-item-lvl2[_ngcontent-%COMP%]:hover   .option-label-lvl2[_ngcontent-%COMP%]{color:#41a1d9}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2.expand[_ngcontent-%COMP%]{transform-origin:0 0 0;opacity:1;visibility:visible;transform:scaleX(1);right:-100%}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .back-wrap[_ngcontent-%COMP%]{display:none}.subject-selector[_ngcontent-%COMP%]   .options-lvl1.expand[_ngcontent-%COMP%]{transform-origin:0 0 0;opacity:1;visibility:visible;transform:scaleY(1);top:35px}@media all and (max-width: 640px){.subject-selector[_ngcontent-%COMP%]   .select-lvl1[_ngcontent-%COMP%]{width:290px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .option-item-lvl1[_ngcontent-%COMP%]{position:initial}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .back-wrap[_ngcontent-%COMP%]{display:flex;align-items:center;color:#a4b0c3;margin-left:10px;gap:50px}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2[_ngcontent-%COMP%]   .back-wrap[_ngcontent-%COMP%]   .subject-select-arrow[_ngcontent-%COMP%]{transform:rotate(180deg);stroke:#a4b0c3}.subject-selector[_ngcontent-%COMP%]   .options-lvl1[_ngcontent-%COMP%]   .options-list-lvl1[_ngcontent-%COMP%]   .options-lvl2.expand[_ngcontent-%COMP%]{top:0;right:-15px;width:290px;min-height:270px;position:absolute;z-index:9}}"],
        changeDetection: 0
      });
    }
  }
  return SubjectSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubjectSelectorModule = /*#__PURE__*/(() => {
  class SubjectSelectorModule {
    static {
      this.ɵfac = function SubjectSelectorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SubjectSelectorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SubjectSelectorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ClickOutsideModule, FormsModule, TranslateModule]
      });
    }
  }
  return SubjectSelectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormErrorsComponent = /*#__PURE__*/(() => {
  class FormErrorsComponent {
    constructor(translateService) {
      this.translateService = translateService;
      this.errors = [];
      this.messages = [];
    }
    ngOnInit() {
      this.form.valueChanges.subscribe(() => {
        this.errors = [];
        this.calculateErrors(this.form);
      });
      this.calculateErrors(this.form);
    }
    get formState() {
      return {
        valid: this.form.valid,
        pristine: this.form.pristine,
        dirty: this.form.dirty,
        touched: this.form.touched
      };
    }
    calculateErrors(form) {
      Object.keys(form.controls).forEach(field => {
        const control = form.get(field);
        if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
          this.errors = this.errors.concat(this.calculateErrors(control));
          return;
        }
        const controlErrors = control.errors;
        if (controlErrors !== null) {
          Object.keys(controlErrors).forEach(keyError => {
            this.errors.push({
              controlName: field,
              errorName: keyError,
              errorValue: controlErrors[keyError]
            });
          });
        }
      });
      const formErrors = form.errors;
      if (formErrors !== null) {
        Object.keys(formErrors).forEach(keyError => {
          this.errors.push({
            controlName: 'form',
            errorName: keyError,
            errorValue: formErrors[keyError]
          });
        });
      }
      // This removes duplicates
      this.errors = this.errors.filter((error, index, self) => self.findIndex(t => t.controlName === error.controlName && t.errorName === error.errorName) === index);
      return this.errors;
    }
    getErrorMessage(error) {
      switch (error.errorName) {
        case 'required':
          return this.translateService.instant('mustFill') + ' ' + this.messages[error.controlName];
        default:
          return 'unknown error ' + error.errorName;
      }
    }
    static {
      this.ɵfac = function FormErrorsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormErrorsComponent)(i0.ɵɵdirectiveInject(i3.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormErrorsComponent,
        selectors: [["app-form-errors"]],
        inputs: {
          form: "form",
          formRef: "formRef",
          messages: "messages"
        },
        decls: 13,
        vars: 18,
        consts: [[1, "form-errors"], [1, "state"]],
        template: function FormErrorsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div");
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "pre");
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "json");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("valid", ctx.form.valid)("invalid", !ctx.form.valid);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.form.status);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("strong", ctx.form.dirty);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate2(" ", ctx.form.pristine ? "pristine" : "", " ", ctx.form.dirty ? "dirty" : "", " ");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("strong", ctx.form.touched);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.form.touched ? "touched" : "untouched", " ");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("strong", ctx.form.valid);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.form.valid ? "valid" : "invalid", " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 16, ctx.errors));
          }
        },
        dependencies: [i2.JsonPipe],
        styles: [".form-errors[_ngcontent-%COMP%]{border-radius:10px;border:1px solid #999}.form-errors.invalid[_ngcontent-%COMP%]{border-color:red}.form-errors.valid[_ngcontent-%COMP%]{border-color:green}.form-errors[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]{display:flex;height:40px;width:100%;justify-content:space-between;align-items:center;border-bottom:1px solid #999}"]
      });
    }
  }
  return FormErrorsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormErrorsModule = /*#__PURE__*/(() => {
  class FormErrorsModule {
    static {
      this.ɵfac = function FormErrorsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormErrorsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FormErrorsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return FormErrorsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IconComponent = /*#__PURE__*/(() => {
  class IconComponent {
    constructor() {
      this.width = 18;
      this.height = 18;
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    ngOnInit() {}
    static {
      this.ɵfac = function IconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IconComponent,
        selectors: [["app-icon"]],
        inputs: {
          icon: "icon",
          width: "width",
          height: "height"
        },
        decls: 2,
        vars: 5,
        consts: [[1, "icon", 3, "ngStyle"]],
        template: function IconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0);
            i0.ɵɵelement(1, "use");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(2, _c1, ctx.width + "px", ctx.height + "px"));
            i0.ɵɵadvance();
            i0.ɵɵattribute("href", ctx.svgsetIcon(ctx.icon), null, "xlink");
          }
        },
        dependencies: [i2.NgStyle],
        styles: ["[_nghost-%COMP%]{display:block}"],
        changeDetection: 0
      });
    }
  }
  return IconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IconModule = /*#__PURE__*/(() => {
  class IconModule {
    static {
      this.ɵfac = function IconModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IconModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return IconModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AgreementTermsFieldComponent = /*#__PURE__*/(() => {
  class AgreementTermsFieldComponent {
    constructor() {
      this.agreementText = '';
      this.valueChange = new EventEmitter();
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    onChanged(value) {
      this.value = value;
      this.propagateChange(value);
      this.valueChange.emit(value);
    }
    static {
      this.ɵfac = function AgreementTermsFieldComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AgreementTermsFieldComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AgreementTermsFieldComponent,
        selectors: [["app-agreement-terms-field"]],
        inputs: {
          invalid: "invalid",
          agreementText: "agreementText",
          value: "value"
        },
        outputs: {
          valueChange: "valueChange"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => AgreementTermsFieldComponent),
          multi: true
        }])],
        decls: 3,
        vars: 4,
        consts: [[1, "terms"], ["type", "checkbox", 1, "terms-checkbox", 3, "change", "checked"], [1, "terms-text", "normal", 3, "innerHTML"]],
        template: function AgreementTermsFieldComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0)(1, "input", 1);
            i0.ɵɵlistener("change", function AgreementTermsFieldComponent_Template_input_change_1_listener($event) {
              return ctx.onChanged($event.target["checked"]);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(2, "span", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("invalid", ctx.invalid);
            i0.ɵɵadvance();
            i0.ɵɵproperty("checked", ctx.value);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.agreementText, i0.ɵɵsanitizeHtml);
          }
        },
        styles: [".terms[_ngcontent-%COMP%]{border-radius:10px;background-color:#f5f8fa;border:1px solid #F5F8FA;padding:10px;display:flex;align-items:center}.terms[_ngcontent-%COMP%]:hover{cursor:pointer}.terms-text[_ngcontent-%COMP%]{margin-left:8px;color:#1e252b;font-size:13px;-webkit-user-select:none;user-select:none}.terms-text[_ngcontent-%COMP%]     a{color:#41a1d9;text-decoration:none}.terms-checkbox[_ngcontent-%COMP%]{width:25px;margin:0}.terms.invalid[_ngcontent-%COMP%]{border-radius:10px;border:1px solid #E86F79;background-color:#e86f7933}.terms.invalid[_ngcontent-%COMP%] > .terms-text[_ngcontent-%COMP%]{color:#e86f79}"]
      });
    }
  }
  return AgreementTermsFieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AgreementTermsFieldModule = /*#__PURE__*/(() => {
  class AgreementTermsFieldModule {
    static {
      this.ɵfac = function AgreementTermsFieldModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AgreementTermsFieldModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AgreementTermsFieldModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, FormsModule]
      });
    }
  }
  return AgreementTermsFieldModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var BankCardType = /*#__PURE__*/function (BankCardType) {
  BankCardType[BankCardType["mir"] = 2] = "mir";
  BankCardType[BankCardType["american_express"] = 3] = "american_express";
  BankCardType[BankCardType["visa"] = 4] = "visa";
  BankCardType[BankCardType["master_card"] = 5] = "master_card";
  BankCardType[BankCardType["maestro"] = 6] = "maestro";
  return BankCardType;
}(BankCardType || {});
let PaymentFormCardSelectorComponent = /*#__PURE__*/(() => {
  class PaymentFormCardSelectorComponent extends ChangableComponent {
    constructor(billingService, cdr) {
      super(cdr);
      this.billingService = billingService;
      this.cdr = cdr;
      this.cardListUpdated = new EventEmitter();
      this.cardSelected = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.selectedCard = null;
      this.bankCardType = BankCardType;
      this._billingCards = [];
    }
    ngOnInit() {
      this.loadCards();
    }
    get cards() {
      return this._billingCards;
    }
    selectCard(card) {
      this.selectedCard = card;
      this.cardSelected.emit(this.selectedCard);
      this.markForCheck();
    }
    trackByFn(index, item) {
      return item.id;
    }
    cardType(card) {
      const [firstNum] = card?.title;
      return +firstNum || null;
    }
    loadCards() {
      this.billingService.getCards().pipe(first(), takeUntil(this.destroyed$)).subscribe(billingCards => {
        this._billingCards = billingCards;
        this.cardListUpdated.emit(true);
        const defaultCard = this._billingCards.find(card => card.is_default);
        if (defaultCard) {
          this.selectCard(defaultCard);
        } else {
          this.selectCard(this._billingCards[0]);
        }
        this.detectChanges();
      });
    }
    static {
      this.ɵfac = function PaymentFormCardSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentFormCardSelectorComponent)(i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaymentFormCardSelectorComponent,
        selectors: [["app-payment-form-card-selector"]],
        outputs: {
          cardListUpdated: "cardListUpdated",
          cardSelected: "cardSelected"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "payment-form-card-selector"], [3, "ngIf"], [1, "cards-list"], ["class", "card", 3, "selected", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "card", 3, "click"], [1, "title", "normal"], [1, "icon-cards-wrap", 3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], ["width", "30", "height", "23", "viewBox", "0 0 59 46"], ["width", "31", "height", "12", "viewBox", "0 0 71 23"], ["width", "72", "height", "22", "viewBox", "-5 0 72 22"]],
        template: function PaymentFormCardSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, PaymentFormCardSelectorComponent_ng_template_1_Template, 2, 2, "ng-template", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.cards == null ? null : ctx.cards.length);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i2.NgSwitchDefault],
        styles: [".payment-form-card-selector[_ngcontent-%COMP%]{display:flex;flex-direction:column}.payment-form-card-selector[_ngcontent-%COMP%]   .no-cards[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;height:250px;justify-content:center}.payment-form-card-selector[_ngcontent-%COMP%]   .no-cards[_ngcontent-%COMP%]   .no-cards-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:18px;margin-bottom:30px}.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px}.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{align-items:center;border:1px solid #EEEEEE;border-radius:10px;cursor:pointer;display:flex;justify-content:space-between;height:50px;padding:0 20px;transition:border .2s linear;margin-bottom:10px;max-width:335px;box-sizing:content-box}@media screen and (max-width: 768px){.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{max-width:100%;width:100%}}.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]:hover, .payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card.selected[_ngcontent-%COMP%]{border:1px solid #5AB3E4}.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:1}"],
        changeDetection: 0
      });
    }
  }
  return PaymentFormCardSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentFormUniversalComponent = /*#__PURE__*/(() => {
  class PaymentFormUniversalComponent extends ChangableComponent {
    set transaction(value) {
      this._transaction = value;
      this.init();
    }
    get transaction() {
      return this._transaction;
    }
    constructor(deviceService, userService, billingService, cdr) {
      super(cdr);
      this.deviceService = deviceService;
      this.userService = userService;
      this.billingService = billingService;
      this.cdr = cdr;
      this.cardSelected = new EventEmitter();
      this.payment_currency_id = CurrencyEnum.rur;
      this.agreements = false;
      this.selectedCard = null;
    }
    ngOnInit() {
      this.userService.me$.pipe(takeUntil(this.destroyed$)).subscribe(me => {
        this.me = me;
        this.init();
      });
    }
    getCurrencyName(currency_id) {
      currency_id = currency_id || this.me?.currency_id;
      return currencies[currency_id].title;
    }
    onChangeAgreements() {
      this.tryEmit();
      this.detectChanges();
    }
    onCardSelected(card) {
      this.selectedCard = card;
      this.tryEmit();
      this.detectChanges();
    }
    init() {
      if (!this._transaction || !this.me) {
        return;
      }
      this.billingService.getExchangeRate(this.me.currency_id, this.payment_currency_id).pipe(first(), takeUntil(this.destroyed$)).subscribe(rate => {
        this.exchangeRate = rate;
        this.updateExchangeTable();
      });
    }
    tryEmit() {
      if (this.agreements) {
        if (this.selectedCard) {
          this.cardSelected.emit(this.selectedCard);
        }
      } else {
        this.cardSelected.emit(null);
      }
    }
    updateExchangeTable() {
      this.detectChanges();
    }
    static {
      this.ɵfac = function PaymentFormUniversalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentFormUniversalComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaymentFormUniversalComponent,
        selectors: [["app-payment-form-universal"]],
        inputs: {
          transaction: "transaction"
        },
        outputs: {
          cardSelected: "cardSelected"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 14,
        consts: [[1, "payment-form-universal"], [1, "panels"], [1, "card-selector-wrap"], [3, "cardSelected"], [1, "calculation"], [3, "valueChange", "value", "agreementText"]],
        template: function PaymentFormUniversalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0)(1, "div", 1)(2, "div", 2)(3, "app-payment-form-card-selector", 3);
            i0.ɵɵlistener("cardSelected", function PaymentFormUniversalComponent_Template_app_payment_form_card_selector_cardSelected_3_listener($event) {
              return ctx.onCardSelected($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(4, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "app-agreement-terms-field", 5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵtwoWayListener("valueChange", function PaymentFormUniversalComponent_Template_app_agreement_terms_field_valueChange_5_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.agreements, $event) || (ctx.agreements = $event);
              return $event;
            });
            i0.ɵɵlistener("valueChange", function PaymentFormUniversalComponent_Template_app_agreement_terms_field_valueChange_5_listener() {
              return ctx.onChangeAgreements();
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("mobile", ctx.deviceService.isMobile());
            i0.ɵɵadvance(5);
            i0.ɵɵtwoWayProperty("value", ctx.agreements);
            i0.ɵɵproperty("agreementText", i0.ɵɵpipeBind2(8, 8, "lingo2-forms.subscription-plans.forms.agreements", i0.ɵɵpureFunction2(11, _c2, "<a href=\"/terms\" class=\"link normal\" target=\"_blank\">" + i0.ɵɵpipeBind1(6, 4, "lingo2-forms.subscription-plans.forms.agreements-terms1") + "</a>", "<a href=\"/privacy\" class=\"link normal\" target=\"_blank\">" + i0.ɵɵpipeBind1(7, 6, "lingo2-forms.subscription-plans.forms.agreements-terms2") + "</a>")));
          }
        },
        dependencies: [PaymentFormCardSelectorComponent, AgreementTermsFieldComponent, i3.TranslatePipe],
        styles: [".payment-form-universal[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:30px}.payment-form-universal[_ngcontent-%COMP%]   .panels[_ngcontent-%COMP%]{display:flex;margin-bottom:20px}.payment-form-universal[_ngcontent-%COMP%]   .panels[_ngcontent-%COMP%]   .card-selector-wrap[_ngcontent-%COMP%]{flex:1 1 10px}.payment-form-universal[_ngcontent-%COMP%]   .panels[_ngcontent-%COMP%]   .calculation[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px;margin-left:15px}"],
        changeDetection: 0
      });
    }
  }
  return PaymentFormUniversalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FinancePlanActivateFormComponent = /*#__PURE__*/(() => {
  class FinancePlanActivateFormComponent extends ChangableComponent {
    set plan(plan) {
      this._plan = plan;
      this.formatCurrentPrice(this._plan.price_tier_id);
    }
    get plan() {
      return this._plan;
    }
    constructor(deviceService, billingService, billingV2Service, websocketService, userService, cdr) {
      super(cdr);
      this.deviceService = deviceService;
      this.billingService = billingService;
      this.billingV2Service = billingV2Service;
      this.websocketService = websocketService;
      this.userService = userService;
      this.cdr = cdr;
      this.displayMode = 'activate';
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.finished = new EventEmitter();
      this.closed = new EventEmitter();
      this.planPeriodEnum = PlanPeriodEnum;
      this.selectedCard = null;
      this.billingOperation = null;
      this.accountPlan = null;
      this.billingOperationStatusEnum = BillingOperationStatusEnum;
      this.finalStep = false;
    }
    ngOnInit() {
      this.init();
      /**
       * Реконнект к веб-сокетам
       */
      this.websocketService.status$.pipe(debounceTime$1(1000)).pipe(takeUntil$1(this.destroyed$)).subscribe(isOnline => {
        if (isOnline) {}
      });
      this.websocketService.on('operation').pipe(tap(operation => {
        this.billingOperation.status = operation.status;
        this.detectChanges();
      }), debounceTime$1(1000)).pipe(takeUntil$1(this.destroyed$)).subscribe();
    }
    get planExpired() {
      const plan = new BillingPlan(this._plan);
      return plan.getNextPaymentDate();
    }
    getPriceTier(price_tier_id) {
      return this.billingService.getPriceTier$(price_tier_id);
    }
    formatCurrencyAmount(amount) {
      return this.billingV2Service.formatCurrencyAmount(new CCurrencyAmount({
        amount: Number(amount),
        currency_id: this._plan?.currency_id || CurrencyEnum.usd
      }));
    }
    formatCurrentPrice(price_tier_id) {
      this.getPriceTier(price_tier_id).pipe(takeUntil$1(this.destroyed$)).subscribe(res => {
        this.currentPrice = this.billingV2Service.formatCurrencyAmount(new CCurrencyAmount({
          amount: res.amount,
          currency_id: res.currency_id
        }));
        this.detectChanges();
      });
    }
    onOpenPaymentTemplate() {
      if (!this.consentToPrivacyPolicy || this.openPaymentTemplate) {
        return;
      }
      this.billingService.switchToPlan(this.plan.id, '').pipe(takeUntil$1(this.destroyed$)).subscribe(transaction => {
        this.switchOperation = transaction;
        this.openPaymentTemplate = true;
        this.detectChanges();
      });
    }
    replaceValues(line) {
      const begin = '{{ ';
      const end = ' }}';
      if (!this._plan || !this._plan.details) {
        return line;
      }
      let bracedWord = Parser.getBracedWord(line, begin, end).word;
      const details = this._plan.details;
      while (bracedWord) {
        const replace =
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        details[bracedWord] === undefined ? bracedWord : `<span class="bold">${details[bracedWord].toString()}</span>`;
        line = Parser.replaceBracedWord(line, bracedWord, replace, begin, end);
        bracedWord = Parser.getBracedWord(line, begin, end).word;
      }
      return line;
    }
    onApplyPromo() {
      if (!this.promoCode) {
        return;
      }
      this.applyPromoFlag = true;
      this.detectChanges();
    }
    onCardSelected(card) {
      this.selectedCard = card;
      this.detectChanges();
    }
    onSubmitPlan() {
      this.loaded = false;
      this.billingService.completeOperation(this.switchOperation.id).pipe(first$1(), takeUntil$1(this.destroyed$)).subscribe(operation => {
        this.loaded = true;
        this.billingOperation = operation;
        this.finalStep = true;
        switch (operation.status) {
          case BillingOperationStatusEnum.succeed:
            // Успешное завершение операции
            this.finished.emit(true);
            break;
          case BillingOperationStatusEnum.failed:
            // Неуспешное завершение операции
            this.finished.emit(false);
            break;
          default:
            // Что-то ещё
            break;
        }
        this.detectChanges();
      });
    }
    onCancelPlan() {
      this.loaded = false;
      this.billingService.cancelPlan().pipe(takeUntil$1(this.destroyed$)).subscribe(accountPlan => {
        this.accountPlan = accountPlan;
        this.openPaymentTemplate = true;
        this.finalStep = true;
        this.loaded = true;
        this.finished.emit(true);
        this.detectChanges();
      });
    }
    getCreditsBySource(source) {
      switch (source) {
        case 'bonus':
          return this.creditBalances[AccountBalanceTypeEnum.gifts];
        case 'purchased':
          return this.creditBalances[AccountBalanceTypeEnum.paid];
        case 'subscription':
          return this.creditBalances[AccountBalanceTypeEnum.plan_grants];
        case 'total_left':
          return this.creditBalances[AccountBalanceTypeEnum.gifts];
        default:
          return 0;
      }
    }
    init() {
      if (this.displayMode === 'activate') {
        return;
      }
      this.userService.me$.pipe(takeUntil$1(this.destroyed$)).subscribe(me => {
        this.userName = me.first_name;
      });
      this.billingService.getUserBalancesForCurrency(CurrencyEnum.credits).pipe(takeUntil$1(this.destroyed$)).subscribe(creditBalances => {
        this.creditBalances = creditBalances;
        this.detectDataLoaded();
      });
      this.billingService.getDefaultPlan().pipe(takeUntil$1(this.destroyed$)).subscribe(defaultPlan => {
        this.defaultPlan = defaultPlan;
        this.detectDataLoaded();
      });
    }
    detectDataLoaded() {
      if (this.displayMode === 'activate') {
        return;
      }
      this.loaded = !!this.creditBalances && !!this.defaultPlan;
      if (this.loaded) {
        this.detectChanges();
      }
    }
    closeModal() {
      this.closed.emit(true);
    }
    static {
      this.ɵfac = function FinancePlanActivateFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FinancePlanActivateFormComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(AbstractWebsocketService), i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FinancePlanActivateFormComponent,
        selectors: [["app-finance-plan-activate-form"]],
        inputs: {
          plan: "plan",
          displayMode: "displayMode"
        },
        outputs: {
          finished: "finished",
          closed: "closed"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 15,
        vars: 5,
        consts: [["paymentTemplate", ""], ["header", ""], ["content", ""], ["payment", ""], ["actions", ""], ["paymentActions", ""], ["cancel", ""], ["billingOperationStatus", ""], [1, "finance-plan-activate-form"], [4, "ngTemplateOutlet"], [3, "ngIf", "ngIfElse"], [1, "header"], [1, "left"], ["width", "61", "height", "61", "viewBox", "0 0 61 61"], [1, "plan-info"], [1, "label", "normal"], [1, "title", "bold"], [1, "subtitle", "normal"], [1, "right", 3, "ngSwitch"], [1, "pay-info"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "activation-text", "normal"], [1, "price-wrap"], [1, "old-price", "normal"], [1, "price", "bold"], [1, "period"], [1, "content"], [3, "ngSwitch"], [1, "info-wrap"], [1, "form-wrap"], [1, "text", "normal"], [1, "comment-wrap"], ["maxlength", "120"], [1, "img"], ["height", "200px", "width", "100%"], [1, "cancel-top"], [1, "plan-after-cancellation"], [1, "cancellation-label", "bold"], [1, "plan-wrap"], ["width", "32", "height", "32", "viewBox", "0 0 61 61"], [1, "plan-title", "bold"], [1, "credits-after-canceling"], [1, "cancel-credits", "normal"], [1, "line-through"], [1, "cancel-credits", "bonus", "normal"], [1, "cancel-bottom"], [1, "alert-text", "normal"], [1, "total-credit", "bold"], [1, "info-header"], [1, "info-label", "bold"], [1, "properties-wrap"], ["class", "properties-item", 4, "ngFor", "ngForOf"], [1, "info-bottom"], [1, "properties-item"], [1, "icon-wrap"], ["width", "12", "height", "9", "viewBox", "0 0 12 9"], [1, "label-wrap"], [1, "label", "normal", 3, "innerHTML"], [3, "ngIf"], [1, "side-wrap"], [1, "side-value", "bold"], [1, "side-text", "normal"], [1, "finish-success"], ["width", "98", "height", "98", "viewBox", "0 0 98 98", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "icon"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#E86F79"], ["x", "29", "y", "35", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-45 29 35)", "fill", "white"], ["x", "35", "y", "70", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-135 35 70)", "fill", "white"], [1, "finish-fail"], [1, "payment"], [3, "cardSelected", "transaction"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#87D37C"], ["d", "M74.7524 38.2306L47.0937 65.7585C46.2639 66.5843 45.1747 67 44.0854 67C42.9962 67 41.9069 66.5843 41.0772 65.7585L27.2482 51.9945C25.5839 50.3389 25.5839 47.6619 27.2482 46.0063C28.9116 44.3498 31.6005 44.3498 33.2647 46.0063L44.0854 56.7761L68.7359 32.2423C70.3993 30.5859 73.0882 30.5859 74.7524 32.2423C76.4159 33.898 76.4159 36.5741 74.7524 38.2306Z", "fill", "#FAFAFA"], [1, "actions"], [3, "valueChange", "value", "agreementText"], [1, "action", "cancel", "normal", 3, "click", "hidden"], [1, "promo-wrap"], ["type", "text", 1, "input-promo", "normal", 3, "ngModelChange", "placeholder", "ngModel", "disabled"], [1, "action", "apply", "normal", 3, "click"], ["label", "meetings.wizard.next", 1, "primary", 3, "onclick", "disabled"], ["label", "lingo2-forms.subscription-plans.forms.pay", "class", "secondary", 3, "disabled", "onclick", 4, "ngIf"], [1, "action", "close", "normal", 3, "click", "hidden"], ["label", "lingo2-forms.subscription-plans.forms.pay", 1, "secondary", 3, "onclick", "disabled"]],
        template: function FinancePlanActivateFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 8);
            i0.ɵɵtemplate(1, FinancePlanActivateFormComponent_ng_container_1_Template, 1, 0, "ng-container", 9)(2, FinancePlanActivateFormComponent_ng_template_2_Template, 2, 2, "ng-template", 10)(3, FinancePlanActivateFormComponent_ng_template_3_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, FinancePlanActivateFormComponent_ng_template_5_Template, 18, 13, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(7, FinancePlanActivateFormComponent_ng_template_7_Template, 8, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(9, FinancePlanActivateFormComponent_ng_template_9_Template, 3, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(11, FinancePlanActivateFormComponent_ng_template_11_Template, 8, 14, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(13, FinancePlanActivateFormComponent_ng_template_13_Template, 5, 5, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const paymentTemplate_r15 = i0.ɵɵreference(4);
            const header_r16 = i0.ɵɵreference(6);
            i0.ɵɵclassProp("mobile", ctx.deviceService.isMobile());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", header_r16);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.openPaymentTemplate)("ngIfElse", paymentTemplate_r15);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, i2.NgSwitchDefault, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, PaymentFormUniversalComponent, Spinner2Component, LoadingLineComponent, i16.OnUiTextareaComponent, i16.OnUiButtonComponent, AgreementTermsFieldComponent, i3.TranslatePipe, i6.FormatPipe],
        styles: [".finance-plan-activate-form[_ngcontent-%COMP%]{margin:-30px}.finance-plan-activate-form[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{background:#fff;border:1px solid transparent;box-sizing:border-box;border-radius:10px;cursor:pointer;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;min-width:126px}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.apply[_ngcontent-%COMP%]{color:#41a1d9}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.apply.apply-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.payment[_ngcontent-%COMP%]{background:#87d37c;border:1px solid #87D37C;color:#fff}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.activate[_ngcontent-%COMP%]{border:1px solid #87D37C;color:#87d37c}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.cancel[_ngcontent-%COMP%]{background:#e86f79;border:1px solid #E86F79;color:#fff}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.close[_ngcontent-%COMP%]{background:#5ab3e4;border:1px solid #5AB3E4;color:#fff;margin-left:auto}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.disabled[_ngcontent-%COMP%]{opacity:.5;cursor:unset}.finance-plan-activate-form[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]   [hidden][_ngcontent-%COMP%]{display:none}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:0}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background:#fff;box-shadow:0 3px 5px #00000014;flex-direction:column;padding:15px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .activation-text[_ngcontent-%COMP%]{line-height:20px;margin:0}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{flex:1 1 10px;flex-direction:column;padding:15px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{height:231px;max-width:345px;margin:0 0 10px;width:100%}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{margin-bottom:45px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{height:40px;width:100%}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{align-items:flex-end;flex-direction:column}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]{margin-bottom:10px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]{margin:0}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%], .finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .comment-wrap[_ngcontent-%COMP%]{width:100%}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]{flex-direction:column}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%], .finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]{padding-top:20px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]{padding:0 0 5px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]   .alert-text[_ngcontent-%COMP%]{width:100%}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{background:#fff;flex-direction:column;padding:15px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{margin-bottom:15px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{height:40px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   [hidden][_ngcontent-%COMP%]{display:none}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]     on-ui-button .button{width:100%}.header[_ngcontent-%COMP%]{border-bottom:1px solid #EEEEEE;display:flex;justify-content:space-between;padding:30px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{display:flex}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-left:20px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:22px;line-height:26px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#a4b0c3;font-size:16px;line-height:19px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]{align-items:flex-end;display:flex;flex-direction:column}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .activation-text[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:24px;margin-bottom:4px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]{align-items:baseline;display:flex}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .old-price[_ngcontent-%COMP%]{color:#a4b0c3;font-size:15px;line-height:18px;text-decoration:line-through}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]{font-size:24px;line-height:29px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]   .period[_ngcontent-%COMP%]{font-size:14px;line-height:17px}.finish-success[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]{display:-webkit-box;display:flex;flex-direction:column;justify-content:center;align-items:center;flex:1;padding:30px 0}.finish-success[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:24px;color:#000;margin-top:20px;margin-bottom:10px;line-height:normal}.finish-success[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{font-size:16px;line-height:22px;width:350px;color:#6d7381;text-align:center}.finish-success[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:98px;height:98px}.content[_ngcontent-%COMP%]{display:flex;padding:20px 30px}.content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{background:url(/assets/images/plan-activate-form.jpg) no-repeat center;background-size:cover;border-radius:10px;height:242px;margin-right:30px;width:287px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .info-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:26px;margin:0 0 14px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;flex-direction:column;padding:0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]{display:flex;margin-bottom:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;height:12px;width:20px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]{display:flex;flex:1 1 10px;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;max-width:350px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]{align-items:center;background:#feed7d;border-radius:20px;display:flex;height:27px;margin:10px 0 0 -20px;padding:0 10px;width:fit-content}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-value[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;white-space:nowrap}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .plan-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .advantage-text[_ngcontent-%COMP%]{color:#6d7381;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]{padding-top:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#a4b0c3;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{color:#65c558}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]{display:flex}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancellation-label[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancellation-label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;margin:0 25px 15px 0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%]{align-items:center;display:flex}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%]   .plan-title[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%]   .plan-title[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px;margin:0 0 0 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%]{color:#e86f79;font-size:16px;line-height:19px;margin:0 0 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits.bonus[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits.bonus[_ngcontent-%COMP%]{color:#1e252b;text-decoration-line:none}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits.fire[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits.fire[_ngcontent-%COMP%]{text-decoration-line:none}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%]   .line-through[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%]   .line-through[_ngcontent-%COMP%]{text-decoration-line:line-through}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]{padding:0 0 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]   .alert-text[_ngcontent-%COMP%]{color:#e86f79;font-size:12px;line-height:14px;width:100%}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]   .total-credit[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:19px}.content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:0 20px 0 0}.content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:19px;margin:0 0 17px;width:375px}.content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .comment-wrap[_ngcontent-%COMP%]{width:366px}.actions[_ngcontent-%COMP%]{border-top:1px solid #EEEEEE;display:flex;padding:30px;justify-content:space-between;gap:10px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{display:flex}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]{border:1px solid #EEEEEE;background:#fff;box-sizing:border-box;border-radius:10px;color:#1e252b;cursor:pointer;outline:none;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;width:126px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]::placeholder, .actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo.disabled[_ngcontent-%COMP%]{color:#ccc}"],
        changeDetection: 0
      });
    }
  }
  return FinancePlanActivateFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SharedModule = /*#__PURE__*/(() => {
  class SharedModule {
    static {
      this.ɵfac = function SharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SharedModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SharedModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [FormErrorsModule, SpinnersModule, FormFieldModule, CommonModule, FormErrorsModule, SpinnersModule, FormFieldModule, CommonModule]
      });
    }
  }
  return SharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentFormCardSelectorModule = /*#__PURE__*/(() => {
  class PaymentFormCardSelectorModule {
    static {
      this.ɵfac = function PaymentFormCardSelectorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentFormCardSelectorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaymentFormCardSelectorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, FormsModule, SharedModule, RouterModule]
      });
    }
  }
  return PaymentFormCardSelectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentFormUniversalModule = /*#__PURE__*/(() => {
  class PaymentFormUniversalModule {
    static {
      this.ɵfac = function PaymentFormUniversalModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentFormUniversalModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaymentFormUniversalModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, FormsModule, PaymentFormCardSelectorModule, AgreementTermsFieldModule]
      });
    }
  }
  return PaymentFormUniversalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FinancePlanActivateFormModule = /*#__PURE__*/(() => {
  class FinancePlanActivateFormModule {
    static {
      this.ɵfac = function FinancePlanActivateFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FinancePlanActivateFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FinancePlanActivateFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, FormsModule, PaymentFormUniversalModule, SpinnersModule, RouterModule, DateFnsModule, OnUiTextareaModule, OnUiButtonModule, AgreementTermsFieldModule]
      });
    }
  }
  return FinancePlanActivateFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileModalAdComponent = /*#__PURE__*/(() => {
  class MobileModalAdComponent {
    static {
      this.ɵfac = function MobileModalAdComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileModalAdComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileModalAdComponent,
        selectors: [["app-mobile-modal-ad"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function MobileModalAdComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return MobileModalAdComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileModalTitleComponent = /*#__PURE__*/(() => {
  class MobileModalTitleComponent {
    static {
      this.ɵfac = function MobileModalTitleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileModalTitleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileModalTitleComponent,
        selectors: [["app-mobile-modal-title"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function MobileModalTitleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return MobileModalTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileModalBodyComponent = /*#__PURE__*/(() => {
  class MobileModalBodyComponent {
    static {
      this.ɵfac = function MobileModalBodyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileModalBodyComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileModalBodyComponent,
        selectors: [["app-mobile-modal-body"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function MobileModalBodyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return MobileModalBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileModalActionsComponent = /*#__PURE__*/(() => {
  class MobileModalActionsComponent {
    static {
      this.ɵfac = function MobileModalActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileModalActionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileModalActionsComponent,
        selectors: [["app-mobile-modal-actions"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function MobileModalActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return MobileModalActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileModalComponent = /*#__PURE__*/(() => {
  class MobileModalComponent extends ChangableComponent {
    constructor(el, screenService, cdr) {
      super(cdr);
      this.el = el;
      this.screenService = screenService;
      this.cdr = cdr;
      this.titleVisible = true;
      this.footerVisible = false;
      this.withCloseButton = false;
      this.closed = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this._open = false;
      this.element = el.nativeElement;
    }
    ngOnInit() {
      this.onBrowserOnly(() => {
        document.querySelector('.app').appendChild(this.element);
        /**  Это необходимо для того чтобы запомнить положение скролла до открытия модального окна.
         * При фиксированном позиционировании слетает положение скролла. Фиксированное позиционирование
         * необходимо для IPhone, без него под модалкой прокручивается контент. Все только ради IPhone
         * */
        this._scrollY = window.scrollY;
        this.screenService.setBodyFixed(true);
        this.setTimeout(() => {
          this._open = true;
          this.detectChanges();
        }, 100);
      });
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      this.onBrowserOnly(() => {
        this.element.remove();
        this.screenService.setBodyFixed(false);
        /** Восстанавливает положение скролла */
        window.scroll(0, this._scrollY);
      });
    }
    get open() {
      return this._open;
    }
    onClose() {
      this._open = false;
      this.setTimeout(() => {
        this.closed.emit(true);
        this.detectChanges();
      }, 200);
    }
    static {
      this.ɵfac = function MobileModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileModalComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileModalComponent,
        selectors: [["app-mobile-modal"]],
        inputs: {
          titleVisible: "titleVisible",
          footerVisible: "footerVisible",
          withCloseButton: "withCloseButton",
          customTitle: "customTitle"
        },
        outputs: {
          closed: "closed"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c6,
        decls: 1,
        vars: 1,
        consts: [["class", "mobile-modal", 3, "footer-visible", 4, "ngIf"], [1, "mobile-modal"], ["class", "mobile-title-block", 4, "ngIf"], ["class", "mobile-title-block title-wrap", 4, "ngIf"], [3, "ngIf"], [1, "mobile-title-block"], ["icon", "close-mobile-modal", 1, "close", 3, "click", "width", "height"], [1, "mobile-title"], ["icon", "menu", 1, "menu", 3, "width", "height"], [1, "mobile-title-block", "title-wrap"], [1, "title", "bold"], ["icon", "close-mobile-new", 1, "close-btn", 3, "click", "width", "height"], [1, "footer"]],
        template: function MobileModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵtemplate(0, MobileModalComponent_div_0_Template, 7, 6, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.open);
          }
        },
        dependencies: [i2.NgIf, IconComponent],
        styles: ["@charset \"UTF-8\";  app-mobile-modal-ad,   app-mobile-modal-title,   app-mobile-modal-body,   app-mobile-modal-actions{display:block}[_nghost-%COMP%]     app-mobile-modal-body{flex:1 1 10px;overflow-y:auto;overflow-x:hidden}[_nghost-%COMP%]     app-mobile-modal-body gamelib-slides-nav{position:fixed;width:calc(100% - 30px);z-index:2;top:0;background-color:#fff}[_nghost-%COMP%]     app-mobile-modal-body gamelib-slides-nav>.nav{margin-top:10px}[_nghost-%COMP%]     app-mobile-modal-body gamelib-slides-body{margin-top:45px}[_nghost-%COMP%]     app-mobile-modal-body gamelib-slides-body .slide-footer{position:fixed;width:calc(100% - 30px);bottom:0;z-index:1}.mobile-modal[_ngcontent-%COMP%]{background:#fff;bottom:0;display:flex;flex-direction:column;position:fixed;right:0;top:0;width:100vw;z-index:127}.mobile-modal.footer-visible[_ngcontent-%COMP%]{z-index:124}.mobile-modal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{height:70px}.mobile-title-block[_ngcontent-%COMP%]{align-items:center;background:#5ab3e4;height:60px;display:flex;justify-content:space-between}.mobile-title-block[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{fill:#5ab3e4;stroke:#fff;height:20px;width:11px;padding:12px 20px}.mobile-title-block[_ngcontent-%COMP%]   .mobile-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:18px;line-height:26px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;color:#fff;line-break:normal}.mobile-title-block[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%]{fill:#5ab3e4;height:19px;width:14px;padding:12px 15px}.mobile-title-block.title-wrap[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 9px #0000001a;box-sizing:border-box;padding:22px 20px}.mobile-title-block.title-wrap[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:20px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal}.mobile-title-block.title-wrap[_ngcontent-%COMP%]     .close-btn{background:#f6f6f6;border-radius:50%;width:30px;min-width:30px;height:30px;display:flex;align-items:center}.mobile-title-block.title-wrap[_ngcontent-%COMP%]     .close-btn svg{margin:0 auto}"],
        data: {
          animation: [trigger('modalAnimation', [transition(':enter', useAnimation(slideIn, {
            params: {
              time: '200ms',
              offset: '100vw'
            }
          })), transition(':leave', useAnimation(slideOut, {
            params: {
              time: '200ms',
              offset: '100vw'
            }
          }))])]
        }
      });
    }
  }
  return MobileModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const IS_SERVER_PLATFORM = new InjectionToken('Is server?', {
  factory() {
    return isPlatformServer(inject(PLATFORM_ID));
  }
});
let IfIsServerDirective = /*#__PURE__*/(() => {
  class IfIsServerDirective {
    constructor(isServer, templateRef, viewContainer) {
      if (isServer) {
        viewContainer.createEmbeddedView(templateRef);
      }
    }
    static {
      this.ɵfac = function IfIsServerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IfIsServerDirective)(i0.ɵɵdirectiveInject(IS_SERVER_PLATFORM), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IfIsServerDirective,
        selectors: [["", "ifIsServer", ""]]
      });
    }
  }
  return IfIsServerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IfIsBrowserDirective = /*#__PURE__*/(() => {
  class IfIsBrowserDirective {
    constructor(isServer, templateRef, viewContainer) {
      if (!isServer) {
        viewContainer.createEmbeddedView(templateRef);
      }
    }
    static {
      this.ɵfac = function IfIsBrowserDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IfIsBrowserDirective)(i0.ɵɵdirectiveInject(IS_SERVER_PLATFORM), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IfIsBrowserDirective,
        selectors: [["", "ifIsBrowser", ""]]
      });
    }
  }
  return IfIsBrowserDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalStackService = /*#__PURE__*/(() => {
  class ModalStackService extends DestroyableComponent {
    constructor() {
      super(...arguments);
      this.updated = this.register(new BehaviorSubject(false));
      this.updated$ = this.updated.asObservable();
      this.modalStack = [];
    }
    updateState() {
      const len = this.modalStack.length;
      if (len === 1) {
        // this.modalStack[0].no_show = false;
        this.modalStack[0].visible = true;
        return;
      }
      const lastModalIndex = this.modalStack.length - 1;
      this.modalStack.forEach((el, index) =>
      // return id === lastModalIndex ? el.no_show = false : el.no_show = true;
      index === lastModalIndex ? el.visible = true : el.visible = false);
    }
    get lastId() {
      const lastModalIndex = this.modalStack.length - 1;
      return lastModalIndex >= 0 ? this.modalStack[lastModalIndex].id : 0;
    }
    pushStack() {
      const modal = {
        id: this.lastId + 1,
        // no_show: false,
        visible: true
      };
      this.modalStack.push(modal);
      this.updateState();
      // this.setTimeout(() => {
      this.updated.next(true);
      // }, 10);
      return modal.id;
    }
    popStack() {
      this.modalStack.pop();
      this.updateState();
      this.updated.next(true);
    }
    isVisible(id) {
      // return this.modalStack.find(el => el.id === id).no_show;
      const element = this.modalStack.find(el => el.id === id);
      return element ? element.visible : false;
    }
    get visibleCount() {
      return this.modalStack.filter(el => el.visible).length;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵModalStackService_BaseFactory;
        return function ModalStackService_Factory(__ngFactoryType__) {
          return (ɵModalStackService_BaseFactory || (ɵModalStackService_BaseFactory = i0.ɵɵgetInheritedFactory(ModalStackService)))(__ngFactoryType__ || ModalStackService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ModalStackService,
        factory: ModalStackService.ɵfac
      });
    }
  }
  return ModalStackService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalAdComponent = /*#__PURE__*/(() => {
  class ModalAdComponent {
    static {
      this.ɵfac = function ModalAdComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalAdComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalAdComponent,
        selectors: [["app-modal-ad"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        consts: [[4, "ifIsBrowser"]],
        template: function ModalAdComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ModalAdComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
          }
        },
        dependencies: [IfIsBrowserDirective],
        encapsulation: 2
      });
    }
  }
  return ModalAdComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalBodyComponent = /*#__PURE__*/(() => {
  class ModalBodyComponent {
    static {
      this.ɵfac = function ModalBodyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalBodyComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalBodyComponent,
        selectors: [["app-modal-body"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        consts: [[4, "ifIsBrowser"]],
        template: function ModalBodyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ModalBodyComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
          }
        },
        dependencies: [IfIsBrowserDirective],
        encapsulation: 2
      });
    }
  }
  return ModalBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalTitleComponent = /*#__PURE__*/(() => {
  class ModalTitleComponent {
    static {
      this.ɵfac = function ModalTitleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalTitleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalTitleComponent,
        selectors: [["app-modal-title"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        consts: [[4, "ifIsBrowser"]],
        template: function ModalTitleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ModalTitleComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
          }
        },
        dependencies: [IfIsBrowserDirective],
        encapsulation: 2
      });
    }
  }
  return ModalTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalActionsComponent = /*#__PURE__*/(() => {
  class ModalActionsComponent {
    static {
      this.ɵfac = function ModalActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalActionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalActionsComponent,
        selectors: [["app-modal-actions"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        consts: [[4, "ifIsBrowser"]],
        template: function ModalActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ModalActionsComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
          }
        },
        dependencies: [IfIsBrowserDirective],
        encapsulation: 2
      });
    }
  }
  return ModalActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DEFAULT_MARGIN_BOTTOM = 150;
let ModalComponent = /*#__PURE__*/(() => {
  class ModalComponent extends ChangableComponent {
    constructor(screenService, modalStackService, el, platformId, cdr) {
      super(cdr);
      this.screenService = screenService;
      this.modalStackService = modalStackService;
      this.el = el;
      this.platformId = platformId;
      this.cdr = cdr;
      this.additionalHeight = 0;
      this.closed = new EventEmitter();
      this.togglePrev = new EventEmitter();
      this.toggleNext = new EventEmitter();
      this.isVisible = true;
      this.scrollTop = 0;
      this.hoverFlag = false;
      this.scaleNumber = 1;
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.heightCenter = 1;
      this.is_open = false;
      this.element = el.nativeElement;
      this.canClose = !!this.canClose;
    }
    set answerState(state) {
      this._answerState = state;
    }
    get answerState() {
      return this._answerState;
    }
    get scaleValue() {
      return Math.round(this.scaleNumber * 100);
    }
    get calcHeader() {
      if (this.scaleNumber > 1) {
        return Math.round((this.scaleNumber - 1) * 10 * (this.heightCenter / 20) + 100);
      }
      if (this.showToFooter) {
        return window.innerHeight * 0.6;
      }
      if (this.complain) {
        return 150;
      }
      return 100;
    }
    get isReachedPrev() {
      return this.reachedPrev || false;
    }
    get isReachedNext() {
      return this.reachedNext || false;
    }
    ngOnInit() {
      if (this.isBrowser) {
        document.querySelector('.app').appendChild(this.element);
        if (this.scale) {
          this.scaleNumber = +localStorage.getItem('scaleNumber') || 1;
        }
      }
      this.modalId = this.modalStackService.pushStack();
      this.modalStackService.updated$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
        this.isVisible = this.modalStackService.isVisible(this.modalId);
        this.detectChanges();
      });
      this.open();
    }
    ngAfterViewInit() {
      this.heightCenter = this.gridCenterRef?.nativeElement?.offsetHeight;
      this.markForCheck();
    }
    ngAfterViewChecked() {
      if (this.isBrowser) {
        setTimeout(() => {
          this.customHeight = this.modalBody?.nativeElement?.offsetHeight * this.scaleNumber + DEFAULT_MARGIN_BOTTOM + this.additionalHeight;
          this.detectChanges();
        }, 100);
      }
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      if (this.isBrowser) {
        this.element.remove();
      }
      this.modalStackService.popStack();
      this.close();
    }
    hover(event) {
      if (event.type === 'mouseover') {
        this.hoverFlag = true;
      } else if (event.type === 'mouseout') {
        this.hoverFlag = false;
      }
    }
    /**
     * open modal
     */
    open() {
      if (!this.is_open) {
        if (this.isBrowser) {
          if (this.scale) {
            this.scaleNumber = +localStorage.getItem('scaleNumber') || 1;
          }
          if (this.element?.style) {
            this.element.style.display = 'block';
          }
          const scrollAllContent = document.querySelector('.app-body-scroll>.ng-scrollbar-wrapper>scrollbar-control');
          if (scrollAllContent) {
            scrollAllContent.setAttribute('style', 'display: none');
          }
        }
        this.screenService.setBodyFixed(true);
        this.is_open = true;
      }
    }
    /**
     * close modal
     */
    close() {
      if (this.is_open) {
        if (this.isBrowser) {
          const scrollAllContent = document.querySelector('.app-body-scroll>.ng-scrollbar-wrapper>scrollbar-control');
          if (scrollAllContent) {
            scrollAllContent.setAttribute('style', 'display: flex');
          }
          if (this.scale) {
            localStorage.setItem('scaleNumber', String(this.scaleNumber));
          }
        }
        if (!this.modalStackService.visibleCount) {
          this.screenService.setBodyFixed(false);
        }
        this.is_open = false;
      }
    }
    onClose(event) {
      if (event) {
        event.preventDefault();
        // С event.cancelBubble = true не срабатывает clickOutside в дропдаунах зеленой панели
        // event.cancelBubble = true;
      }
      if (this.canClose) {
        this.closed.emit(true);
      }
    }
    onCloseBtn(event) {
      if (event) {
        event.preventDefault();
        event.cancelBubble = true;
      }
      this.closed.emit(true);
    }
    scalePlus() {
      if (this.scaleNumber < 1.5) {
        this.scaleNumber = Math.round((this.scaleNumber + 0.1) * 10) / 10;
      }
    }
    scaleMinus() {
      if (this.scaleNumber > 0.5) {
        this.scaleNumber = Math.round((this.scaleNumber - 0.1) * 10) / 10;
      }
    }
    onPrev() {
      this.togglePrev.emit(true);
    }
    onNext() {
      this.toggleNext.emit(true);
    }
    static {
      this.ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalComponent)(i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(ModalStackService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalComponent,
        selectors: [["app-modal"]],
        viewQuery: function ModalComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c7, 5, '');
            i0.ɵɵviewQuery(_c8, 7);
            i0.ɵɵviewQuery(_c9, 7);
            i0.ɵɵviewQuery(_c10, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.gridCenterRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollHolder = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.background = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalBody = _t.first);
          }
        },
        inputs: {
          canClose: "canClose",
          additionalHeight: "additionalHeight",
          short: "short",
          long: "long",
          wide: "wide",
          middle: "middle",
          schedule: "schedule",
          narrow: "narrow",
          narrow2: "narrow2",
          auth: "auth",
          wide2: "wide2",
          scale: "scale",
          prevNext: "prevNext",
          reachedPrev: "reachedPrev",
          reachedNext: "reachedNext",
          shadeDark: "shadeDark",
          shadeLight: "shadeLight",
          shadeGray: "shadeGray",
          complain: "complain",
          editor: "editor",
          canGoBack: "canGoBack",
          showToFooter: "showToFooter",
          answerState: "answerState"
        },
        outputs: {
          closed: "closed",
          togglePrev: "togglePrev",
          toggleNext: "toggleNext"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c12,
        decls: 2,
        vars: 2,
        consts: [["scrollHolder", ""], ["background", ""], ["gridCenter", ""], ["modalBody", ""], [3, "ngIf"], ["class", "modal", 3, "hide", 4, "ngIf"], [1, "modal"], [1, "modal-virtual-scroll"], [1, "shade"], [1, "window"], [1, "grid-wrap"], [1, "grid-header", 3, "click"], [1, "grid-center", 3, "ngStyle"], [1, "grid-left", 3, "click"], [1, "modal-body", 3, "ngClass"], ["class", "inner-close-btn", 3, "click", 4, "ngIf"], [1, "tools-block"], ["class", "close-btn", 3, "click", "mouseover", "mouseout", 4, "ngIf"], ["class", "scale-block", 4, "ngIf"], ["class", "prev-btn", 3, "ngStyle", "ngClass", "click", 4, "ngIf"], ["class", "prev-btn prev-btn--next", 3, "ngStyle", "ngClass", "click", 4, "ngIf"], [1, "grid-right", 3, "click"], [1, "grid-bottom", 3, "click", "ngStyle"], [1, "inner-close-btn", 3, "click"], ["viewBox", "0 0 15 16", 1, "inner-close-btn-icon"], [1, "close-btn", 3, "click", "mouseover", "mouseout"], ["viewBox", "0 0 38 38", 1, "close-btn-icon"], [1, "scale-block"], [1, "scale-btn", 3, "click"], [1, "scale-btn", "scale-btn--one-to-one", "bold", 3, "click"], [1, "prev-btn", 3, "click", "ngStyle", "ngClass"], [1, "prev-btn-icon"], [1, "prev-btn", "prev-btn--next", 3, "click", "ngStyle", "ngClass"]],
        template: function ModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c11);
            i0.ɵɵtemplate(0, ModalComponent_ng_template_0_Template, 1, 0, "ng-template", 4)(1, ModalComponent_div_1_Template, 22, 56, "div", 5);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.isVisible);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isBrowser);
          }
        },
        dependencies: [i2.NgClass, i2.NgIf, i2.NgStyle],
        styles: ["@charset \"UTF-8\";  app-modal-ad{display:block;position:fixed;top:0;left:0;right:0;z-index:111}  app-modal-body,   app-modal-title,   app-modal-actions{display:block}.modal[_ngcontent-%COMP%]{display:block;box-sizing:border-box}.modal.hide[_ngcontent-%COMP%]{display:none}.modal[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box}.modal[_ngcontent-%COMP%]   .shade[_ngcontent-%COMP%]{background:#00000040;position:absolute;left:0;top:0;min-height:100vh;transition:all .2s linear;width:100%;z-index:109}.modal[_ngcontent-%COMP%]   .shade.dark[_ngcontent-%COMP%]{background:#1e252b66}.modal[_ngcontent-%COMP%]   .shade.gray[_ngcontent-%COMP%]{background:#1e252b4d}.modal[_ngcontent-%COMP%]   .shade.none[_ngcontent-%COMP%]{background:transparent}.modal[_ngcontent-%COMP%]   .shade.light[_ngcontent-%COMP%]{background:#fff6}.modal[_ngcontent-%COMP%]   .window[_ngcontent-%COMP%]{width:100vw}.modal[_ngcontent-%COMP%]   .grid-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;min-height:100vh}.modal[_ngcontent-%COMP%]   .grid-header[_ngcontent-%COMP%]{height:100px;transition:all .2s linear}.modal[_ngcontent-%COMP%]   .grid-center[_ngcontent-%COMP%]{display:flex;justify-content:center;transition:all .2s linear}.modal[_ngcontent-%COMP%]   .grid-left[_ngcontent-%COMP%]{flex:1 1 auto}.modal[_ngcontent-%COMP%]   .grid-right[_ngcontent-%COMP%]{flex:1 1 auto;margin-right:15px}.modal[_ngcontent-%COMP%]   .grid-bottom[_ngcontent-%COMP%]{flex:1 1 auto;min-height:100px;transition:all .2s linear}.modal[_ngcontent-%COMP%]   .grid-bottom.hide-footer[_ngcontent-%COMP%]{min-height:auto!important}.modal[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{display:block;background:#fff;border-radius:10px;padding:30px;position:absolute;width:890px}.modal[_ngcontent-%COMP%]   .modal-body.shadow[_ngcontent-%COMP%]{box-shadow:0 10px 30px #00000080;border-radius:10px}.modal[_ngcontent-%COMP%]   .modal-body.complain[_ngcontent-%COMP%]{box-shadow:0 0 10px #0000001a}.modal[_ngcontent-%COMP%]   .modal-body.editor[_ngcontent-%COMP%]{box-shadow:0 0 15px #00000026;padding:10px}.modal[_ngcontent-%COMP%]   .modal-body.short[_ngcontent-%COMP%]{height:300px}.modal[_ngcontent-%COMP%]   .modal-body.long[_ngcontent-%COMP%]{height:90%}.modal[_ngcontent-%COMP%]   .modal-body.schedule[_ngcontent-%COMP%]{width:500px}.modal[_ngcontent-%COMP%]   .modal-body.auth[_ngcontent-%COMP%]{width:380px}.modal[_ngcontent-%COMP%]   .modal-body.middle[_ngcontent-%COMP%]{width:500px}.modal[_ngcontent-%COMP%]   .modal-body.narrow[_ngcontent-%COMP%]{width:300px}.modal[_ngcontent-%COMP%]   .modal-body.narrow2[_ngcontent-%COMP%]{width:330px}.modal[_ngcontent-%COMP%]   .modal-body.wide[_ngcontent-%COMP%]{width:890px}.modal[_ngcontent-%COMP%]   .modal-body.wide2[_ngcontent-%COMP%]{width:980px}.modal[_ngcontent-%COMP%]   .modal-body.canGoBack[_ngcontent-%COMP%]{margin-top:60px}.modal[_ngcontent-%COMP%]   .modal-body.canGoBack[_ngcontent-%COMP%]   .tools-block[_ngcontent-%COMP%]{top:-60px}.modal[_ngcontent-%COMP%]   .modal-body.correct[_ngcontent-%COMP%]:after{animation:_ngcontent-%COMP%_opacity 1.5s 1 ease-in-out;background:#87d37c;border-radius:10px;content:\"\";height:100%;left:0;opacity:0;position:absolute;top:0;width:100%;z-index:1}.modal[_ngcontent-%COMP%]   .modal-body.incorrect[_ngcontent-%COMP%]:after{animation:_ngcontent-%COMP%_opacity 1.5s 1 ease-in-out;background:#e86f79;border-radius:10px;content:\"\";height:100%;left:0;opacity:0;position:absolute;top:0;width:100%;z-index:1}@keyframes _ngcontent-%COMP%_opacity{0%{opacity:0}50%{opacity:1}to{opacity:0}}.modal[_ngcontent-%COMP%]   .inner-close-btn[_ngcontent-%COMP%]{align-items:center;background:#e86f79;border-radius:50%;cursor:pointer;display:flex;height:30px;justify-content:center;position:absolute;right:-10px;top:-10px;width:30px}.modal[_ngcontent-%COMP%]   .inner-close-btn[_ngcontent-%COMP%]   .inner-close-btn-icon[_ngcontent-%COMP%]{fill:#fff;height:16px;width:16px}.modal[_ngcontent-%COMP%]   .tools-block[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:196px;justify-content:space-between;position:absolute;right:-58px;top:0;transition:all .2s linear}.modal[_ngcontent-%COMP%]   .tools-block[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]{cursor:pointer;height:38px;transition:all .2s linear;width:38px}.modal[_ngcontent-%COMP%]   .tools-block[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]   .close-btn-icon[_ngcontent-%COMP%]{height:38px;stroke:#fff;width:38px}.modal[_ngcontent-%COMP%]   .tools-block[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]:hover > .close-btn-icon[_ngcontent-%COMP%]{stroke:#ebebec}.modal[_ngcontent-%COMP%]   .tools-block[_ngcontent-%COMP%]   .scale-block[_ngcontent-%COMP%]   .scale-btn[_ngcontent-%COMP%]{cursor:pointer;height:38px;margin:0;opacity:.5;stroke:#fff;transition:all .2s linear;-webkit-user-select:none;user-select:none;width:38px}.modal[_ngcontent-%COMP%]   .tools-block[_ngcontent-%COMP%]   .scale-block[_ngcontent-%COMP%]   .scale-btn[_ngcontent-%COMP%]:hover{color:#ebebec;stroke:#ebebec}.modal[_ngcontent-%COMP%]   .tools-block[_ngcontent-%COMP%]   .scale-block[_ngcontent-%COMP%]   .scale-btn--one-to-one[_ngcontent-%COMP%]{color:#fff;font-size:14px;height:34px;line-height:34px;text-align:center}.modal[_ngcontent-%COMP%]   .prev-btn[_ngcontent-%COMP%]{cursor:pointer;height:32px;left:-49px;position:absolute;top:234px;transform:rotate(0);visibility:visible;width:19px}.modal[_ngcontent-%COMP%]   .prev-btn--next[_ngcontent-%COMP%]{transform:rotate(180deg);left:unset;right:-49px}.modal[_ngcontent-%COMP%]   .prev-btn--disabled[_ngcontent-%COMP%]{opacity:0;visibility:hidden}.modal[_ngcontent-%COMP%]   .prev-btn[_ngcontent-%COMP%]   .prev-btn-icon[_ngcontent-%COMP%]{stroke:#fff;height:32px;transition:all .2s linear;width:19px}.modal[_ngcontent-%COMP%]   .prev-btn[_ngcontent-%COMP%]   .prev-btn-icon[_ngcontent-%COMP%]:hover{stroke:#ebebec}.modal[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:5px}.modal-virtual-scroll[_ngcontent-%COMP%]{position:fixed;left:0;top:0;height:100%;width:100%;z-index:410;overflow-x:hidden;overflow-y:auto}"],
        changeDetection: 0
      });
    }
  }
  return ModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PaymentFail {}
class PaymentOptions {}
class PaymentConfiguration {}
let PaymentWidgetService = /*#__PURE__*/(() => {
  class PaymentWidgetService extends DestroyableComponent {
    constructor() {
      super();
      this._pay = this.register(new EventEmitter());
      this._payAmount = this.register(new EventEmitter());
      this.pay$ = this._pay.asObservable();
      this.payAmount$ = this._payAmount.asObservable();
    }
    pay() {
      this._pay.next(true);
    }
    payAmount(value) {
      this._payAmount.next(value);
    }
    static {
      this.ɵfac = function PaymentWidgetService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PaymentWidgetService,
        factory: PaymentWidgetService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PaymentWidgetService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class StepByStepWizardStep {
  constructor(values) {
    this._complete = false;
    this._active = false;
    this._visible = false;
    if (values) {
      assign(this, values);
    }
  }
  setParent(value) {
    this._parent = value;
  }
  set complete(value) {
    this._complete = value;
    this._parent?.changed$.emit(true);
  }
  get complete() {
    return this._complete;
  }
  set active(value) {
    this._active = value;
    this._parent?.changed$.emit(true);
  }
  get active() {
    return this._active;
  }
  set visible(value) {
    this._visible = value;
    this._parent?.changed$.emit(true);
  }
  get visible() {
    return this._visible;
  }
  get done() {
    const checks = this.checks || [];
    if (checks.length === 0) {
      return true;
    }
    return checks.every(check => {
      if (check === true) {
        return true;
      }
      if (check === false) {
        return false;
      }
      return check(this.context);
    });
  }
}
class StepByStepWizardSteps {
  constructor(steps) {
    this.steps = steps;
    this.changed$ = new EventEmitter();
    this.activeStep$ = new EventEmitter();
    this.steps.map(step => step.setParent(this));
    const activeStep = this.steps.find(s => s.active);
    if (activeStep) {
      this.goStep(activeStep.id);
    }
  }
  addStep(step) {
    step.setParent(this);
    this.steps.push(step);
    if (step.active) {
      this.goStep(step.id);
    }
  }
  get dump() {
    return {
      activeStep: this.activeStep || null,
      steps: this.steps.map(s => pick(s, ['id', 'title', 'active', 'complete', 'visible']))
    };
  }
  get(id) {
    return this.steps.find(step => step.id === id);
  }
  goNextStep() {
    console.log('goNextStep from ' + this.activeStep);
    const activeIndex = this.steps.findIndex(step => step.visible && step.active);
    const nextStepIndex = this.steps.findIndex((step, index) => step.visible && index > activeIndex);
    if (nextStepIndex >= 0) {
      const nextStep = this.steps[nextStepIndex];
      console.log('goNextStep from ' + this.activeStep + ' to ' + nextStep.id);
      this.goStep(nextStep.id);
    } else {
      console.log('goNextStep from ' + this.activeStep + ' to ?');
    }
  }
  goStep(id) {
    console.log('goStep ' + id);
    const nextStep = this.get(id);
    if (nextStep && nextStep.visible) {
      this.deactivateAllSteps();
      console.log('goStep ' + id + ' -> activated');
      nextStep.active = true;
      this.activeStep = nextStep.id;
      this.activeStep$.next(this.activeStep);
    }
  }
  deactivateAllSteps() {
    this.steps.filter(step => step.active).map(step => step.active = false);
  }
}
let StepsComponent = /*#__PURE__*/(() => {
  class StepsComponent extends ChangableComponent {
    constructor(deviceService,
    // protected websocketService: WebsocketService,
    // public models: PaymentCheckoutWizardService,
    cdr) {
      super(cdr);
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.stepChanged = new EventEmitter();
      this.activeStep = new EventEmitter();
    }
    ngOnInit() {
      combineLatest([this.steps.activeStep$, this.steps.changed$]).pipe(takeUntil(this.destroyed$)).subscribe(([activeStep]) => {
        this.activeStep.emit(activeStep);
        this.detectChanges();
        this.detectChanges();
      });
    }
    get visibleSteps() {
      return this.steps.steps.filter(s => s.visible);
    }
    goStep(step) {
      this.steps.goStep(step.id);
      this.stepChanged.emit(step);
    }
    static {
      this.ɵfac = function StepsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StepsComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: StepsComponent,
        selectors: [["app-steps"]],
        inputs: {
          steps: "steps"
        },
        outputs: {
          stepChanged: "stepChanged",
          activeStep: "activeStep"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "steps"], ["class", "step", 3, "passed", "active", "click", 4, "ngFor", "ngForOf"], [1, "step", 3, "click"]],
        template: function StepsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, StepsComponent_div_1_Template, 5, 8, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.visibleSteps);
          }
        },
        dependencies: [i2.NgForOf, i3.TranslatePipe],
        styles: [".steps[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end;align-items:center}.steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{display:flex;align-items:center;white-space:nowrap;cursor:pointer;pointer-events:none;color:#a4b0c3}.steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;box-sizing:content-box;width:26px;height:26px;line-height:26px;text-align:center;border-radius:50%;border:1px solid #EEEEEE;color:#a4b0c3;margin-right:10px}.steps[_ngcontent-%COMP%]   .step.passed[_ngcontent-%COMP%]{color:#87d37c;cursor:pointer;pointer-events:all}.steps[_ngcontent-%COMP%]   .step.passed[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background-color:#87d37c;color:#fff;border-color:#87d37c}.steps[_ngcontent-%COMP%]   .step.active[_ngcontent-%COMP%]{color:#5ab3e4;pointer-events:all}.steps[_ngcontent-%COMP%]   .step.active[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background-color:#5ab3e4;color:#fff;border-color:#5ab3e4}.steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%] + .step[_ngcontent-%COMP%]:before{content:\"\";display:inline-block;border-top:1px solid #A4B0C3;border-right:1px solid #A4B0C3;transform:rotate(45deg);margin:0 10px;width:4px;height:4px}"],
        changeDetection: 0
      });
    }
  }
  return StepsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StepByStepWizardComponent = /*#__PURE__*/(() => {
  class StepByStepWizardComponent extends ChangableComponent {
    constructor(screenService, deviceService, cdr) {
      super(cdr);
      this.screenService = screenService;
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.showHeader = false;
      this.showFooter = false;
      this.showSteps = true;
      this.isSafari = this.screenService.isSafari;
    }
    ngOnInit() {
      this.steps.activeStep$.pipe(tap$1(() => {
        this.detectChanges();
      }), takeUntil(this.destroyed$)).subscribe();
    }
    onStepChanged(event) {
      this.activeStep = event;
    }
    get screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    static {
      this.ɵfac = function StepByStepWizardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StepByStepWizardComponent)(i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: StepByStepWizardComponent,
        selectors: [["app-step-by-step-wizard"]],
        inputs: {
          steps: "steps",
          showHeader: "showHeader",
          showFooter: "showFooter",
          showSteps: "showSteps"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c17,
        decls: 5,
        vars: 8,
        consts: [[1, "step-wizard-dialog", 3, "ngClass"], ["class", "header", 4, "ngIf"], [3, "class", 4, "ngIf"], [1, "header"], ["class", "steps", 4, "ngIf"], [1, "hr", "full-width"], [1, "steps"], [3, "steps", "activeStep", 4, "ngIf"], [3, "activeStep", "steps"], [1, "actions"]],
        template: function StepByStepWizardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c16);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, StepByStepWizardComponent_div_1_Template, 4, 1, "div", 1);
            i0.ɵɵelementStart(2, "div");
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, StepByStepWizardComponent_div_4_Template, 5, 3, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("safari", ctx.isSafari);
            i0.ɵɵproperty("ngClass", ctx.screenClasses);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showHeader);
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("content content-holder ", ctx.activeStep, "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showFooter);
          }
        },
        dependencies: [i2.NgClass, i2.NgIf, StepsComponent],
        styles: ["@charset \"UTF-8\";[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px}.step-wizard-dialog[_ngcontent-%COMP%]{min-height:430px;position:relative;display:flex;flex-direction:column;justify-content:stretch}.step-wizard-dialog[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{width:100%;height:auto;padding-bottom:31px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;position:relative}.step-wizard-dialog[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .hr[_ngcontent-%COMP%]{width:100%;height:0;border-bottom:1px solid #EEEEEE}.step-wizard-dialog[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .hr.full-width[_ngcontent-%COMP%]{position:absolute;left:-30px;right:-30px;bottom:0;width:calc(100% + 60px)}.step-wizard-dialog[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{display:flex;padding:20px 0;overflow-x:hidden;overflow-y:auto;min-height:240px;flex-direction:column}.step-wizard-dialog[_ngcontent-%COMP%]   .content.credits[_ngcontent-%COMP%]{padding:0}.step-wizard-dialog[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{width:100%;min-height:50px;padding-top:20px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;position:relative}.step-wizard-dialog[_ngcontent-%COMP%]   .footer.credits[_ngcontent-%COMP%]{padding-top:31px;min-height:auto}.step-wizard-dialog[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .hr[_ngcontent-%COMP%]{width:100%;height:0;border-bottom:1px solid #EEEEEE}.step-wizard-dialog[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .hr.full-width[_ngcontent-%COMP%]{position:absolute;left:-30px;right:-30px;top:0;width:calc(100% + 60px)}.step-wizard-dialog[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .margin-right[_ngcontent-%COMP%]{margin-right:15px}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{height:auto;flex-direction:column;padding:15px;box-sizing:border-box}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .steps[_ngcontent-%COMP%]{margin-top:15px;width:100%;overflow-y:hidden}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .steps[_ngcontent-%COMP%]     .steps{justify-content:flex-start}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .steps[_ngcontent-%COMP%]     .checkout-steps{justify-content:flex-start;align-items:center;padding:15px 0;width:100%}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{padding:20px 15px 190px;height:100%}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .course-block[_ngcontent-%COMP%]{padding:0}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]     .step-title{margin-bottom:0}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{box-sizing:border-box;padding:20px 15px;height:auto;flex-direction:column;justify-content:flex-start;position:fixed;bottom:0;background:#fff;z-index:3}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]     app-user-service-footer-details{width:100%}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{width:100%;justify-content:center;padding:0}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]     on-ui-button{width:100%;display:block;margin:30px auto 10px;text-align:center}.step-wizard-dialog.mobile[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]     on-ui-button   .button{width:100%}"],
        changeDetection: 0
      });
    }
  }
  return StepByStepWizardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StepByStepWizardModule = /*#__PURE__*/(() => {
  class StepByStepWizardModule {
    static {
      this.ɵfac = function StepByStepWizardModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StepByStepWizardModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: StepByStepWizardModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, SpinnersModule, TranslateModule, FormatPipeModule, OnUiReceiptModule, OnUiButtonModule, OnUiCoverModule, LazyLoadImageModule, OnUiCheckboxModule, IconModule]
      });
    }
  }
  return StepByStepWizardModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentOrderComponent = /*#__PURE__*/(() => {
  class PaymentOrderComponent extends ChangableComponent {
    set payment(payment) {
      this._payment = payment;
      this.prepareOrder();
    }
    get payment() {
      return this._payment;
    }
    set free(value) {
      this._free = value;
      this.prepareOrder();
    }
    get free() {
      return this._free;
    }
    constructor(screenService, deviceService, cdr) {
      super(cdr);
      this.screenService = screenService;
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.statsRating = 0;
      this.statsReviewsCount = 0;
      this.statsStudentsCount = 0;
      this._free = false;
    }
    ngOnInit() {}
    prepareOrder() {
      if (!this.payment) {
        return;
      }
      const order = this.payment.order;
      this.order = {
        id: order.id,
        currencyCode: this.payment.currencyCode,
        taxAmount: this.free ? '0' : this.payment.feeAmount,
        amount: this.free ? '0' : this.payment.amount,
        amountToPay: this.free ? '0' : this.payment.amountToPay,
        approximateAmountToPay: this.payment.approximateAmountToPay ? this.free ? '0' : this.payment.approximateAmountToPay : null,
        approximateCurrencyCode: this.payment.approximateCurrencyCode || null
      };
    }
    screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    get title() {
      return 'profile-form.card.title';
    }
    static {
      this.ɵfac = function PaymentOrderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentOrderComponent)(i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaymentOrderComponent,
        selectors: [["app-payment-order"]],
        inputs: {
          payment: "payment",
          free: "free"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 17,
        vars: 13,
        consts: [[1, "order-info"], [1, "info"], [1, "info-row"], [1, "name"], [1, "value"], ["class", "info-row", 4, "ngIf"], [1, "total"], ["class", "approximate", 4, "ngIf"], ["class", "additional-info", 4, "ngIf"], [1, "approximate"], [1, "additional-info"]],
        template: function PaymentOrderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, PaymentOrderComponent_div_8_Template, 6, 5, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 6)(10, "div", 3);
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "div", 4);
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(15, PaymentOrderComponent_div_15_Template, 3, 5, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(16, PaymentOrderComponent_div_16_Template, 8, 7, "div", 8);
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 9, "payment-form.order.price"), ":");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.order.amount, " ", ctx.order.currencyCode, "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.order.taxAmount);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(12, 11, "payment-form.order.total"), ":");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.order.amountToPay, " ", ctx.order.currencyCode, "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.order.approximateAmountToPay);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.order.approximateAmountToPay);
          }
        },
        dependencies: [i2.NgIf, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.order-info[_ngcontent-%COMP%]{display:flex;box-sizing:border-box;flex-direction:column;padding:20px;border:1px solid #EEEEEE;border-radius:10px;width:100%}.order-info[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;width:100%}.order-info[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .info-row[_ngcontent-%COMP%]{display:flex;justify-content:space-between;width:100%;margin-bottom:10px}.order-info[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .info-row[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;width:50%}.order-info[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .info-row[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;text-align:right;width:50%}.order-info[_ngcontent-%COMP%]   .total[_ngcontent-%COMP%]{border-top:1px solid #EEEEEE;display:flex;justify-content:space-between;width:100%;padding-top:10px}.order-info[_ngcontent-%COMP%]   .total[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;width:50%}.order-info[_ngcontent-%COMP%]   .total[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;text-align:right;width:50%}.order-info[_ngcontent-%COMP%]   .approximate[_ngcontent-%COMP%]{width:100%;color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;color:#6d7381;text-align:right}.additional-info[_ngcontent-%COMP%]{width:100%;padding-left:15px;margin-top:10px;box-sizing:border-box}.additional-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style-type:disc;margin:10px 0 0;padding-left:0}.additional-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 5px;color:#a4b0c3;font-size:12px;line-height:16px;color:#6d7381}.additional-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{margin-bottom:0}"]
      });
    }
  }
  return PaymentOrderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentOrderModule = /*#__PURE__*/(() => {
  class PaymentOrderModule {
    static {
      this.ɵfac = function PaymentOrderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentOrderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaymentOrderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, OnUiCoverModule, TranslateModule]
      });
    }
  }
  return PaymentOrderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// import { PaymentWidgetBillingService } from './payment-widget-billing.service';
// TODO Convert to DynamicModule with config
let PaymentWidgetBillingModule = /*#__PURE__*/(() => {
  class PaymentWidgetBillingModule {
    static {
      this.ɵfac = function PaymentWidgetBillingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetBillingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaymentWidgetBillingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [HttpClientModule, TranslateModule]
      });
    }
  }
  return PaymentWidgetBillingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentWidgetMerchantProcessingService = /*#__PURE__*/(() => {
  class PaymentWidgetMerchantProcessingService extends DestroyableComponent {
    constructor() {
      super();
      this._pay = this.register(new EventEmitter());
      this.pay$ = this._pay.asObservable();
    }
    pay() {
      this._pay.next(true);
    }
    static {
      this.ɵfac = function PaymentWidgetMerchantProcessingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetMerchantProcessingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PaymentWidgetMerchantProcessingService,
        factory: PaymentWidgetMerchantProcessingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PaymentWidgetMerchantProcessingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Компонент исполнения запроса на оплату и взаимодействия с UI мерчанта (если требуется).
 * Компоненту делегированы следующие функции:
 * - отправка запроса на оплату и отслеживание статуса платежа;
 * - ввод данных новой карты;
 * - обработка 3DSecure и других действий требующих внимания покупателя;
 * - прочие, требующие внимания покупателя действия (например, оплата по QR-коду).
 */
let PaymentWidgetMerchantProcessingComponent = /*#__PURE__*/(() => {
  class PaymentWidgetMerchantProcessingComponent extends ChangableComponent {
    set payment(payment) {
      if (payment['payment']) {
        this._payment = payment;
        this._isCharge = true;
      } else {
        this._payment = payment;
        this._isCharge = false;
      }
    }
    get payment() {
      return this._payment;
    }
    set isAccountPayment(value) {
      this._isAccountPayment = value;
    }
    get isAccountPayment() {
      return this._isAccountPayment;
    }
    constructor(billingV2Service, configService, merchantService, sanitizer, deviceService, cdr) {
      super(cdr);
      this.billingV2Service = billingV2Service;
      this.configService = configService;
      this.merchantService = merchantService;
      this.sanitizer = sanitizer;
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.succeed = new EventEmitter();
      this.canceled = new EventEmitter();
      this.failed = new EventEmitter();
      this.processing = new EventEmitter();
      this._isAccountPayment = true;
      this.loading = true;
      this.loaded = true;
      this._isCharge = true;
    }
    ngOnInit() {
      this.merchantService.pay$.pipe(tap$1(() => this.pay()), takeUntil(this.destroyed$)).subscribe();
    }
    get paymentAsCharge() {
      return this.payment;
    }
    get isCharge() {
      return this._isCharge;
    }
    get isPayment() {
      return this._isCharge;
    }
    get paymentAsPayment() {
      return this.payment;
    }
    get isAddCard() {
      return this.operation === 'add-card';
    }
    get isPay() {
      return this.operation === 'pay';
    }
    pay() {
      if (this.isCharge) {
        if (!this.paymentAsCharge || !this.paymentAsCharge.payment.paymentUrl) {
          if (!this.isAccountPayment) {
            this.failed.emit({
              message: 'No Payment url! Payment id: ' + this.paymentAsCharge.payment.id
            });
            return;
          }
        }
        this.safePaymentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.checkUrl(this.paymentAsCharge.payment.paymentUrl));
        this.detectChanges();
      } else {
        if (!this.paymentAsPayment || !this.paymentAsPayment.paymentUrl) {
          if (!this.isAccountPayment) {
            this.failed.emit({
              message: 'No Payment url! Payment id: ' + this.paymentAsCharge.payment.id
            });
            return;
          }
        }
        this.safePaymentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.checkUrl(this.paymentAsPayment.paymentUrl));
        this.detectChanges();
      }
      if (this.isCharge) {
        this.listenForFinish(this.paymentAsCharge.payment.id);
      } else {
        this.listenForFinish(this.paymentAsPayment.id);
      }
    }
    checkUrl(url) {
      if (!url) {
        return null;
      }
      const isAbsolute = url.indexOf('http://') === 0 || url.indexOf('https://') === 0 || url.indexOf('//') === 0;
      return isAbsolute ? url : url.indexOf('/') === 0 ? this.configService.getEnvBillingFrameHost() + url : this.configService.getEnvBillingFrameHost() + '/' + url;
    }
    listenForFinish(paymentId) {
      if (!paymentId) {
        return;
      }
      this.billingV2Service.getPayment(paymentId).pipe(takeUntil(this.destroyed$)).subscribe(data => {
        switch (data.status) {
          case BillingCorePaymentStatusEnum.SUCCEEDED:
            this.succeed.emit(true);
            break;
          default:
            this.setTimeout(() => {
              this.listenForFinish(paymentId);
            }, 2000);
            break;
        }
      }, error => {
        this.failed.emit({
          message: `${error}`
        });
      });
    }
    get isStripe() {
      return this.merchant && this.merchant.name.toLowerCase().indexOf('stripe') !== -1;
    }
    get isTinkoff() {
      return this.merchant && this.merchant.name.toLowerCase().indexOf('tinkoff') !== -1;
    }
    watchFrameLoad() {
      const frame = document.getElementById('payment-frame');
      if (this.isStripe) {
        frame.style.height = '550px';
      } else if (this.isTinkoff) {
        frame.style.height = '720px';
      } else {
        frame.style.height = '550px';
      }
    }
    static {
      this.ɵfac = function PaymentWidgetMerchantProcessingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetMerchantProcessingComponent)(i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(AbstractConfigService), i0.ɵɵdirectiveInject(PaymentWidgetMerchantProcessingService), i0.ɵɵdirectiveInject(i3$2.DomSanitizer), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaymentWidgetMerchantProcessingComponent,
        selectors: [["app-payment-widget-merchant-processing"]],
        inputs: {
          payment: "payment",
          isAccountPayment: "isAccountPayment",
          operation: "operation",
          merchant: "merchant"
        },
        outputs: {
          succeed: "succeed",
          canceled: "canceled",
          failed: "failed",
          processing: "processing"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 3,
        consts: [["class", "processing-wrapper", 4, "ngIf"], ["class", "error text-center", 4, "ngIf"], [3, "ngIf"], [1, "processing-wrapper"], [1, "processing"], [1, "error", "text-center"], ["frameborder", "0", "_allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", "_allowfullscreen", "", "class", "tinkoff-frame", "id", "payment-frame", 3, "mobile", "src", "load", 4, "ngIf"], ["frameborder", "0", "_allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", "_allowfullscreen", "", "id", "payment-frame", 1, "tinkoff-frame", 3, "load", "src"]],
        template: function PaymentWidgetMerchantProcessingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PaymentWidgetMerchantProcessingComponent_div_0_Template, 5, 3, "div", 0)(1, PaymentWidgetMerchantProcessingComponent_div_1_Template, 3, 3, "div", 1)(2, PaymentWidgetMerchantProcessingComponent_ng_template_2_Template, 1, 1, "ng-template", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.safePaymentUrl || ctx.isAccountPayment);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.error);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loaded && !ctx.isAccountPayment);
          }
        },
        dependencies: [i2.NgIf, Spinner2Component, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.top[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;margin-bottom:20px}.top[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:24px;line-height:30px}.top[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#e86f79}.top.mobile[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start}.tinkoff-frame[_ngcontent-%COMP%]{width:100%;border-radius:10px}.tinkoff-frame.mobile[_ngcontent-%COMP%]{width:100%}.processing-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;transform:translateY(50%);margin-top:50px;display:flex;justify-content:center;align-items:center;flex-direction:column}.processing-wrapper[_ngcontent-%COMP%]   spinner2[_ngcontent-%COMP%]{width:100%}.processing-wrapper[_ngcontent-%COMP%]   .processing[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;text-align:center;font-size:24px;line-height:24px;width:100%}"],
        changeDetection: 0
      });
    }
  }
  return PaymentWidgetMerchantProcessingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// import { PaymentWidgetMerchantProcessingService } from './payment-widget-merchant-processing.service';
// TODO Convert to DynamicModule with config
let PaymentWidgetMerchantProcessingModule = /*#__PURE__*/(() => {
  class PaymentWidgetMerchantProcessingModule {
    static {
      this.ɵfac = function PaymentWidgetMerchantProcessingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetMerchantProcessingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaymentWidgetMerchantProcessingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, SpinnersModule, TranslateModule, PaymentWidgetBillingModule]
      });
    }
  }
  return PaymentWidgetMerchantProcessingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DirectivesModule = /*#__PURE__*/(() => {
  class DirectivesModule {
    static {
      this.ɵfac = function DirectivesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DirectivesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DirectivesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return DirectivesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalModule = /*#__PURE__*/(() => {
  class ModalModule {
    static {
      this.ɵfac = function ModalModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ModalModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [ModalStackService],
        imports: [CommonModule, DirectivesModule]
      });
    }
  }
  return ModalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentCardComponent = /*#__PURE__*/(() => {
  class PaymentCardComponent extends ChangableComponent {
    set account(value) {
      if (value) {
        this._account = value;
      }
    }
    get account() {
      return this._account;
    }
    set view(value) {
      if (value) {
        this._view = value;
      } else {
        this._view = 'full';
      }
    }
    get view() {
      return this._view;
    }
    constructor(billingV2Service, cdr) {
      super(cdr);
      this.billingV2Service = billingV2Service;
      this.cdr = cdr;
      this.openHistory = new EventEmitter();
      this.getMoney = new EventEmitter();
      this.onChange = new EventEmitter();
      this.onSelect = new EventEmitter();
      this.onEdit = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    onOpenHistory() {
      this.openHistory.emit(this.account.providerId);
    }
    onGetMoney() {
      this.getMoney.emit(this.account.id);
    }
    deleteAccount() {
      this.billingV2Service.deleteAccount(this.account.id).pipe(takeUntil(this.destroyed$)).subscribe(() => {
        this.onChange.emit(String(new Date().getTime()));
      });
    }
    setDefault() {
      this.billingV2Service.setAccountDefault(this.account.id).pipe(takeUntil(this.destroyed$)).subscribe(() => {
        this.onChange.emit(String(new Date().getTime()));
      }, error => {
        console.log('SET DEFAULT ACCOUNT ID:' + this.account.id + ' ERROR', error);
      });
    }
    get accountLabel() {
      if (this.account.cardAccount) {
        return `**** **** **** ${this.account.cardAccount.label}`;
      } else if (this.account.bankAccount) {
        return `*********${this.account.bankAccount.label}`;
      }
    }
    get accountExpirationMY() {
      if (this.account.cardAccount) {
        const date = new Date(this.account.cardAccount.expiresAt.toString());
        return format(date, 'MM/yy');
      } else {
        return '---';
      }
    }
    get accountExpire() {
      if (this.account.cardAccount) {
        const currentYear = format(new Date(), 'yy');
        const currentMonth = format(new Date(), 'MM');
        const cardYear = format(new Date(this.account.cardAccount.expiresAt.toString()), 'yy');
        const cardMonth = format(new Date(this.account.cardAccount.expiresAt.toString()), 'MM');
        // return true;
        if (currentYear > cardYear) {
          return true;
        } else if (currentYear < cardYear) {
          return false;
        } else {
          return currentMonth > cardMonth;
        }
      } else {
        return false;
      }
    }
    get accountType() {
      if (this.account.cardAccount) {
        return this.account.cardAccount.brand.toLowerCase();
      } else {
        return '---';
      }
    }
    get isDefault() {
      return this.account.isDefault;
    }
    selectAcc() {
      this.onSelect.emit(true);
    }
    isTestCard() {
      return this.is_test;
    }
    static {
      this.ɵfac = function PaymentCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentCardComponent)(i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaymentCardComponent,
        selectors: [["app-payment-card"]],
        inputs: {
          account: "account",
          view: "view",
          selected: "selected",
          is_test: "is_test"
        },
        outputs: {
          openHistory: "openHistory",
          getMoney: "getMoney",
          onChange: "onChange",
          onSelect: "onSelect",
          onEdit: "onEdit"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 3,
        consts: [["simple", ""], ["full", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngTemplateOutlet"], [3, "click"], ["class", "account__expired", 4, "ngIf"], ["class", "test-card-label", 4, "ngIf"], [1, "data"], [1, "icon"], ["width", "32", "height", "32", "viewBox", "0 0 80 80", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], ["width", "32", "height", "32", "viewBox", "5 -20 40 60", "y", "0px", "x", "0px", 4, "ngIf"], ["width", "32", "height", "32", "viewBox", "0 0 25 20", "y", "0px", "x", "0px", 4, "ngIf"], [1, "account__expired"], [1, "test-card-label"], ["width", "32", "height", "32", "viewBox", "0 0 80 80", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M28.6279 56.6366C24.1923 56.6366 19.8563 55.3213 16.1683 52.857C12.4802 50.3927 9.60573 46.8901 7.90831 42.7922C6.21089 38.6943 5.76677 34.185 6.6321 29.8347C7.49744 25.4843 9.63338 21.4883 12.7698 18.3518C15.9062 15.2154 19.9023 13.0795 24.2526 12.2141C28.603 11.3488 33.1122 11.7929 37.2102 13.4903C41.3081 15.1878 44.8107 18.0622 47.2749 21.7503C49.7392 25.4383 51.0545 29.7743 51.0545 34.2099C51.0483 40.1559 48.6836 45.8566 44.4791 50.0611C40.2746 54.2656 34.5739 56.6304 28.6279 56.6366Z", "fill", "#EB001B"], ["opacity", "0.8", "d", "M50.4486 56.6366C46.013 56.6372 41.6768 55.3226 37.9884 52.8588C34.3 50.3951 31.425 46.893 29.727 42.7953C28.0289 38.6976 27.5841 34.1884 28.4488 29.8379C29.3135 25.4875 31.4489 21.4911 34.5848 18.3542C37.7208 15.2173 41.7165 13.0808 46.0667 12.2148C50.417 11.3488 54.9263 11.7923 59.0245 13.4891C63.1227 15.1859 66.6256 18.0598 69.0905 21.7475C71.5553 25.4352 72.8712 29.771 72.8719 34.2065V34.2099C72.8657 40.1553 70.5014 45.8555 66.2976 50.0599C62.0939 54.2643 56.394 56.6295 50.4486 56.6366Z", "fill", "#F79E1B"], ["d", "M8.97656 68.6276V62.2648H9.913C10.1114 62.2648 10.2417 62.3578 10.3037 62.5439L10.4029 63.0152C10.5145 62.8912 10.6303 62.7775 10.7502 62.6741C10.8742 62.5708 11.0045 62.4819 11.1409 62.4075C11.2815 62.333 11.4303 62.2752 11.5874 62.2338C11.7487 62.1883 11.9244 62.1656 12.1145 62.1656C12.5156 62.1656 12.8443 62.2752 13.1006 62.4943C13.3611 62.7093 13.5554 62.9966 13.6835 63.3563C13.7828 63.1454 13.9068 62.9656 14.0556 62.8168C14.2045 62.6638 14.3678 62.5398 14.5456 62.4447C14.7233 62.3496 14.9114 62.2793 15.1099 62.2338C15.3125 62.1883 15.5151 62.1656 15.7176 62.1656C16.0691 62.1656 16.3812 62.2193 16.6541 62.3268C16.927 62.4343 17.1564 62.5914 17.3425 62.7982C17.5285 63.0049 17.6691 63.2571 17.7642 63.5547C17.8634 63.8524 17.913 64.1935 17.913 64.578V68.6276H16.3812V64.578C16.3812 64.1728 16.2923 63.869 16.1145 63.6664C15.9368 63.4597 15.6763 63.3563 15.3332 63.3563C15.176 63.3563 15.0293 63.3832 14.8928 63.4369C14.7605 63.4907 14.6427 63.5692 14.5394 63.6726C14.4401 63.7718 14.3616 63.8979 14.3037 64.0509C14.2458 64.2038 14.2169 64.3796 14.2169 64.578V68.6276H12.6789V64.578C12.6789 64.1522 12.5921 63.8421 12.4184 63.6478C12.2489 63.4535 11.9988 63.3563 11.668 63.3563C11.4448 63.3563 11.236 63.4121 11.0417 63.5237C10.8515 63.6312 10.6737 63.7801 10.5083 63.9703V68.6276H8.97656Z", "fill", "#1E252B"], ["d", "M23.2264 65.9113C22.784 65.932 22.4119 65.9713 22.1101 66.0292C21.8083 66.0829 21.5664 66.1532 21.3845 66.24C21.2026 66.3268 21.0724 66.4281 20.9938 66.5439C20.9153 66.6597 20.876 66.7858 20.876 66.9222C20.876 67.1909 20.9545 67.3832 21.1116 67.4989C21.2729 67.6147 21.4817 67.6726 21.738 67.6726C22.0522 67.6726 22.323 67.6168 22.5504 67.5051C22.7819 67.3894 23.0072 67.2157 23.2264 66.9842V65.9113ZM19.7163 63.1516C20.4481 62.4819 21.3287 62.147 22.3582 62.147C22.7302 62.147 23.0631 62.209 23.3566 62.333C23.6501 62.4529 23.8982 62.6224 24.1008 62.8416C24.3034 63.0566 24.4563 63.315 24.5597 63.6168C24.6672 63.9186 24.7209 64.2493 24.7209 64.609V68.6276H24.0264C23.8817 68.6276 23.77 68.6069 23.6915 68.5656C23.6129 68.5201 23.5509 68.4312 23.5054 68.2989L23.369 67.84C23.2078 67.9847 23.0507 68.1129 22.8977 68.2245C22.7447 68.332 22.5855 68.423 22.4202 68.4974C22.2548 68.5718 22.077 68.6276 21.8868 68.6648C21.7008 68.7062 21.4941 68.7268 21.2667 68.7268C20.9979 68.7268 20.7499 68.6917 20.5225 68.6214C20.2951 68.547 20.0987 68.4374 19.9333 68.2927C19.768 68.148 19.6398 67.9682 19.5488 67.7532C19.4579 67.5382 19.4124 67.2881 19.4124 67.0028C19.4124 66.8416 19.4393 66.6824 19.493 66.5253C19.5468 66.3641 19.6336 66.2111 19.7535 66.0664C19.8775 65.9217 20.0367 65.7852 20.231 65.6571C20.4253 65.5289 20.6631 65.4173 20.9442 65.3222C21.2295 65.2271 21.5602 65.1506 21.9364 65.0927C22.3127 65.0307 22.7426 64.9935 23.2264 64.9811V64.609C23.2264 64.1832 23.1354 63.869 22.9535 63.6664C22.7716 63.4597 22.5091 63.3563 22.1659 63.3563C21.9178 63.3563 21.7111 63.3852 21.5457 63.4431C21.3845 63.501 21.2419 63.5672 21.1178 63.6416C20.9938 63.7119 20.8801 63.7759 20.7768 63.8338C20.6775 63.8917 20.5659 63.9206 20.4419 63.9206C20.3344 63.9206 20.2434 63.8938 20.169 63.84C20.0946 63.7821 20.0346 63.716 19.9892 63.6416L19.7163 63.1516Z", "fill", "#1E252B"], ["d", "M30.5419 63.5051C30.5005 63.5713 30.4571 63.6188 30.4116 63.6478C30.3662 63.6726 30.3083 63.685 30.238 63.685C30.1636 63.685 30.083 63.6643 29.9961 63.623C29.9134 63.5816 29.8163 63.5361 29.7047 63.4865C29.593 63.4328 29.4649 63.3852 29.3202 63.3439C29.1796 63.3026 29.0122 63.2819 28.8178 63.2819C28.516 63.2819 28.2783 63.346 28.1047 63.4741C27.9352 63.6023 27.8504 63.7697 27.8504 63.9765C27.8504 64.1129 27.8938 64.2287 27.9806 64.3237C28.0716 64.4147 28.1894 64.4953 28.3341 64.5656C28.483 64.6359 28.6504 64.7 28.8364 64.7578C29.0225 64.8116 29.2106 64.8715 29.4008 64.9377C29.5951 65.0038 29.7853 65.0803 29.9713 65.1672C30.1574 65.2498 30.3228 65.3573 30.4675 65.4896C30.6163 65.6178 30.7341 65.7728 30.8209 65.9547C30.9119 66.1367 30.9574 66.3558 30.9574 66.6121C30.9574 66.9181 30.9016 67.2013 30.7899 67.4617C30.6824 67.7181 30.5212 67.9413 30.3062 68.1315C30.0912 68.3175 29.8246 68.4643 29.5062 68.5718C29.192 68.6752 28.8282 68.7268 28.4147 68.7268C28.1956 68.7268 27.9806 68.7062 27.7698 68.6648C27.5631 68.6276 27.3625 68.5739 27.1682 68.5036C26.978 68.4333 26.8003 68.3506 26.6349 68.2555C26.4737 68.1604 26.331 68.0571 26.207 67.9454L26.5605 67.3625C26.606 67.2922 26.6597 67.2385 26.7217 67.2013C26.7837 67.1641 26.8623 67.1454 26.9574 67.1454C27.0525 67.1454 27.1414 67.1723 27.224 67.2261C27.3109 67.2798 27.4101 67.3377 27.5217 67.3997C27.6333 67.4617 27.7636 67.5196 27.9124 67.5734C28.0654 67.6271 28.2576 67.654 28.4892 67.654C28.6711 67.654 28.8261 67.6333 28.9543 67.592C29.0866 67.5465 29.1941 67.4886 29.2768 67.4183C29.3636 67.348 29.4256 67.2674 29.4628 67.1765C29.5041 67.0814 29.5248 66.9842 29.5248 66.885C29.5248 66.7361 29.4793 66.6142 29.3884 66.5191C29.3016 66.424 29.1837 66.3413 29.0349 66.271C28.8902 66.2007 28.7228 66.1387 28.5326 66.085C28.3465 66.0271 28.1543 65.9651 27.9558 65.8989C27.7615 65.8328 27.5693 65.7563 27.3791 65.6695C27.193 65.5785 27.0256 65.4648 26.8768 65.3284C26.7321 65.192 26.6142 65.0245 26.5233 64.8261C26.4364 64.6276 26.393 64.3878 26.393 64.1067C26.393 63.8462 26.4447 63.5982 26.5481 63.3625C26.6514 63.1268 26.8023 62.9222 27.0008 62.7485C27.2034 62.5708 27.4535 62.4302 27.7512 62.3268C28.053 62.2193 28.4003 62.1656 28.793 62.1656C29.2313 62.1656 29.6302 62.238 29.9899 62.3827C30.3496 62.5274 30.6494 62.7175 30.8892 62.9532L30.5419 63.5051Z", "fill", "#1E252B"], ["d", "M34.7273 68.7268C34.1733 68.7268 33.7475 68.5718 33.4498 68.2617C33.1563 67.9475 33.0095 67.5155 33.0095 66.9656V63.4121H32.3583C32.2757 63.4121 32.2054 63.3852 32.1475 63.3315C32.0896 63.2777 32.0607 63.1971 32.0607 63.0896V62.4819L33.0839 62.3144L33.4064 60.578C33.4271 60.4953 33.4664 60.4312 33.5242 60.3858C33.5821 60.3403 33.6565 60.3175 33.7475 60.3175H34.5413V62.3206H36.2405V63.4121H34.5413V66.8602C34.5413 67.0586 34.5888 67.2137 34.6839 67.3253C34.7832 67.4369 34.9175 67.4927 35.087 67.4927C35.1821 67.4927 35.2607 67.4824 35.3227 67.4617C35.3888 67.4369 35.4447 67.4121 35.4901 67.3873C35.5397 67.3625 35.5832 67.3398 35.6204 67.3191C35.6576 67.2943 35.6948 67.2819 35.732 67.2819C35.7775 67.2819 35.8147 67.2943 35.8436 67.3191C35.8726 67.3398 35.9036 67.3728 35.9366 67.4183L36.3956 68.1625C36.1723 68.3485 35.916 68.4891 35.6266 68.5842C35.3372 68.6793 35.0374 68.7268 34.7273 68.7268Z", "fill", "#1E252B"], ["d", "M41.7681 64.7144C41.7681 64.516 41.7392 64.3299 41.6813 64.1563C41.6276 63.9785 41.5449 63.8235 41.4333 63.6912C41.3216 63.5589 41.179 63.4555 41.0053 63.3811C40.8358 63.3026 40.6374 63.2633 40.41 63.2633C39.9676 63.2633 39.6183 63.3894 39.3619 63.6416C39.1097 63.8938 38.9485 64.2514 38.8782 64.7144H41.7681ZM38.8472 65.6385C38.872 65.9651 38.9299 66.2483 39.0208 66.4881C39.1118 66.7237 39.2317 66.9201 39.3805 67.0772C39.5294 67.2302 39.7051 67.346 39.9077 67.4245C40.1144 67.4989 40.3418 67.5361 40.5898 67.5361C40.8379 67.5361 41.0508 67.5072 41.2286 67.4493C41.4105 67.3914 41.5676 67.3274 41.6999 67.2571C41.8363 67.1868 41.9542 67.1227 42.0534 67.0648C42.1568 67.0069 42.256 66.978 42.3511 66.978C42.4792 66.978 42.5743 67.0256 42.6364 67.1206L43.0767 67.6788C42.9072 67.8772 42.717 68.0447 42.5061 68.1811C42.2953 68.3134 42.0741 68.4209 41.8426 68.5036C41.6152 68.5821 41.3816 68.638 41.1418 68.671C40.9061 68.7041 40.6767 68.7206 40.4534 68.7206C40.011 68.7206 39.5997 68.6483 39.2193 68.5036C38.8389 68.3548 38.5082 68.1377 38.227 67.8524C37.9459 67.563 37.7247 67.2075 37.5635 66.7858C37.4022 66.3599 37.3216 65.8679 37.3216 65.3098C37.3216 64.8757 37.3919 64.4684 37.5325 64.0881C37.673 63.7036 37.8736 63.3708 38.134 63.0896C38.3986 62.8044 38.719 62.579 39.0953 62.4137C39.4756 62.2483 39.9035 62.1656 40.379 62.1656C40.78 62.1656 41.15 62.2297 41.4891 62.3578C41.8281 62.486 42.1196 62.6741 42.3635 62.9222C42.6074 63.1661 42.7976 63.4679 42.934 63.8276C43.0746 64.1832 43.1449 64.5904 43.1449 65.0493C43.1449 65.2808 43.1201 65.438 43.0705 65.5206C43.0208 65.5992 42.9258 65.6385 42.7852 65.6385H38.8472Z", "fill", "#1E252B"], ["d", "M46.2355 63.3687C46.4339 62.9883 46.6696 62.6907 46.9425 62.4757C47.2153 62.2566 47.5378 62.147 47.9099 62.147C48.2034 62.147 48.4391 62.2111 48.6169 62.3392L48.5177 63.4865C48.497 63.5609 48.466 63.6147 48.4246 63.6478C48.3874 63.6767 48.3357 63.6912 48.2696 63.6912C48.2076 63.6912 48.1145 63.6808 47.9905 63.6602C47.8706 63.6395 47.7528 63.6292 47.637 63.6292C47.4675 63.6292 47.3166 63.654 47.1843 63.7036C47.052 63.7532 46.9321 63.8255 46.8246 63.9206C46.7213 64.0116 46.6282 64.1232 46.5456 64.2555C46.467 64.3878 46.3926 64.5387 46.3223 64.7082V68.6276H44.7905V62.2648H45.6897C45.8468 62.2648 45.9564 62.2938 46.0184 62.3516C46.0804 62.4054 46.1218 62.5046 46.1425 62.6493L46.2355 63.3687Z", "fill", "#1E252B"], ["d", "M54.29 63.6106C54.2446 63.6684 54.1991 63.7139 54.1536 63.747C54.1123 63.7801 54.0502 63.7966 53.9676 63.7966C53.889 63.7966 53.8125 63.7739 53.7381 63.7284C53.6637 63.6788 53.5748 63.625 53.4714 63.5672C53.3681 63.5051 53.244 63.4514 53.0993 63.4059C52.9588 63.3563 52.7831 63.3315 52.5722 63.3315C52.3035 63.3315 52.0678 63.3811 51.8652 63.4803C51.6626 63.5754 51.4931 63.7139 51.3567 63.8958C51.2244 64.0777 51.1252 64.2989 51.059 64.5594C50.9929 64.8157 50.9598 65.1072 50.9598 65.4338C50.9598 65.7728 50.9949 66.0746 51.0652 66.3392C51.1396 66.6038 51.2451 66.8271 51.3815 67.009C51.5179 67.1868 51.6833 67.3232 51.8776 67.4183C52.0719 67.5093 52.2911 67.5548 52.535 67.5548C52.7789 67.5548 52.9753 67.5258 53.1241 67.4679C53.2771 67.4059 53.4053 67.3398 53.5086 67.2695C53.612 67.1951 53.7009 67.1289 53.7753 67.071C53.8539 67.009 53.9407 66.978 54.0358 66.978C54.1598 66.978 54.2528 67.0256 54.3148 67.1206L54.7551 67.6788C54.5856 67.8772 54.4017 68.0447 54.2032 68.1811C54.0048 68.3134 53.798 68.4209 53.5831 68.5036C53.3722 68.5821 53.1531 68.638 52.9257 68.671C52.7024 68.7041 52.4792 68.7206 52.2559 68.7206C51.8632 68.7206 51.4931 68.6483 51.1458 68.5036C50.7986 68.3548 50.4947 68.1398 50.2342 67.8586C49.9738 67.5775 49.767 67.2343 49.6141 66.8292C49.4652 66.4199 49.3908 65.9547 49.3908 65.4338C49.3908 64.9666 49.457 64.5346 49.5893 64.1377C49.7257 63.7367 49.9241 63.3914 50.1846 63.102C50.4451 62.8085 50.7676 62.579 51.1521 62.4137C51.5365 62.2483 51.9789 62.1656 52.4792 62.1656C52.9546 62.1656 53.3701 62.2421 53.7257 62.3951C54.0854 62.548 54.4079 62.7672 54.6931 63.0524L54.29 63.6106Z", "fill", "#1E252B"], ["d", "M59.5728 65.9113C59.1304 65.932 58.7583 65.9713 58.4565 66.0292C58.1547 66.0829 57.9128 66.1532 57.7309 66.24C57.549 66.3268 57.4188 66.4281 57.3402 66.5439C57.2617 66.6597 57.2224 66.7858 57.2224 66.9222C57.2224 67.1909 57.3009 67.3832 57.4581 67.4989C57.6193 67.6147 57.8281 67.6726 58.0844 67.6726C58.3986 67.6726 58.6694 67.6168 58.8968 67.5051C59.1283 67.3894 59.3537 67.2157 59.5728 66.9842V65.9113ZM56.0627 63.1516C56.7945 62.4819 57.6751 62.147 58.7046 62.147C59.0767 62.147 59.4095 62.209 59.703 62.333C59.9966 62.4529 60.2446 62.6224 60.4472 62.8416C60.6498 63.0566 60.8028 63.315 60.9061 63.6168C61.0136 63.9186 61.0674 64.2493 61.0674 64.609V68.6276H60.3728C60.2281 68.6276 60.1165 68.6069 60.0379 68.5656C59.9593 68.5201 59.8973 68.4312 59.8519 68.2989L59.7154 67.84C59.5542 67.9847 59.3971 68.1129 59.2441 68.2245C59.0911 68.332 58.932 68.423 58.7666 68.4974C58.6012 68.5718 58.4234 68.6276 58.2332 68.6648C58.0472 68.7062 57.8405 68.7268 57.6131 68.7268C57.3444 68.7268 57.0963 68.6917 56.8689 68.6214C56.6415 68.547 56.4451 68.4374 56.2798 68.2927C56.1144 68.148 55.9862 67.9682 55.8953 67.7532C55.8043 67.5382 55.7588 67.2881 55.7588 67.0028C55.7588 66.8416 55.7857 66.6824 55.8395 66.5253C55.8932 66.3641 55.98 66.2111 56.0999 66.0664C56.2239 65.9217 56.3831 65.7852 56.5774 65.6571C56.7717 65.5289 57.0095 65.4173 57.2906 65.3222C57.5759 65.2271 57.9066 65.1506 58.2829 65.0927C58.6591 65.0307 59.0891 64.9935 59.5728 64.9811V64.609C59.5728 64.1832 59.4818 63.869 59.2999 63.6664C59.118 63.4597 58.8555 63.3563 58.5123 63.3563C58.2643 63.3563 58.0575 63.3852 57.8922 63.4431C57.7309 63.501 57.5883 63.5672 57.4643 63.6416C57.3402 63.7119 57.2265 63.7759 57.1232 63.8338C57.0239 63.8917 56.9123 63.9206 56.7883 63.9206C56.6808 63.9206 56.5898 63.8938 56.5154 63.84C56.441 63.7821 56.3811 63.716 56.3356 63.6416L56.0627 63.1516Z", "fill", "#1E252B"], ["d", "M64.4511 63.3687C64.6495 62.9883 64.8852 62.6907 65.1581 62.4757C65.4309 62.2566 65.7534 62.147 66.1255 62.147C66.419 62.147 66.6547 62.2111 66.8325 62.3392L66.7332 63.4865C66.7126 63.5609 66.6816 63.6147 66.6402 63.6478C66.603 63.6767 66.5513 63.6912 66.4852 63.6912C66.4232 63.6912 66.3302 63.6808 66.2061 63.6602C66.0862 63.6395 65.9684 63.6292 65.8526 63.6292C65.6831 63.6292 65.5322 63.654 65.3999 63.7036C65.2676 63.7532 65.1477 63.8255 65.0402 63.9206C64.9369 64.0116 64.8438 64.1232 64.7612 64.2555C64.6826 64.3878 64.6082 64.5387 64.5379 64.7082V68.6276H63.0061V62.2648H63.9053C64.0624 62.2648 64.172 62.2938 64.234 62.3516C64.296 62.4054 64.3374 62.5046 64.3581 62.6493L64.4511 63.3687Z", "fill", "#1E252B"], ["d", "M71.9534 63.8896C71.7798 63.6788 71.5896 63.5299 71.3829 63.4431C71.1803 63.3563 70.9612 63.3129 70.7255 63.3129C70.494 63.3129 70.2852 63.3563 70.0991 63.4431C69.9131 63.5299 69.7539 63.6622 69.6216 63.84C69.4893 64.0137 69.388 64.2369 69.3177 64.5098C69.2475 64.7785 69.2123 65.0969 69.2123 65.4648C69.2123 65.8369 69.2413 66.1532 69.2991 66.4137C69.3612 66.67 69.448 66.8808 69.5596 67.0462C69.6712 67.2075 69.8077 67.3253 69.9689 67.3997C70.1301 67.47 70.31 67.5051 70.5084 67.5051C70.8268 67.5051 71.0976 67.439 71.3208 67.3067C71.5441 67.1744 71.755 66.9863 71.9534 66.7423V63.8896ZM73.4852 59.4121V68.6276H72.5488C72.3462 68.6276 72.218 68.5346 72.1643 68.3485L72.034 67.7346C71.7777 68.0281 71.4821 68.2659 71.1472 68.4478C70.8165 68.6297 70.4299 68.7206 69.9875 68.7206C69.6402 68.7206 69.3219 68.6483 69.0325 68.5036C68.7431 68.3589 68.4929 68.1501 68.2821 67.8772C68.0754 67.6002 67.9141 67.2591 67.7984 66.854C67.6867 66.4488 67.6309 65.9858 67.6309 65.4648C67.6309 64.9935 67.695 64.5553 67.8232 64.1501C67.9513 63.7449 68.1353 63.3935 68.3751 63.0958C68.6149 62.7982 68.9022 62.5666 69.2371 62.4013C69.572 62.2317 69.9482 62.147 70.3658 62.147C70.7214 62.147 71.0252 62.2028 71.2774 62.3144C71.5296 62.4261 71.755 62.577 71.9534 62.7672V59.4121H73.4852Z", "fill", "#1E252B"], ["d", "M41.3741 35.5976C41.3284 39.3438 44.5813 41.4342 47.0316 42.6772C49.5491 43.9523 50.3947 44.7702 50.3847 45.9107C50.3659 47.6559 48.3766 48.4262 46.515 48.4561C43.2672 48.5085 41.3787 47.5433 39.8775 46.8134L38.7075 52.5123C40.2137 53.2348 43.0028 53.8649 45.895 53.8926C52.6841 53.8926 57.1256 50.404 57.1497 44.9953C57.1763 38.1308 48.0284 37.7508 48.0909 34.6826C48.1125 33.7522 48.9653 32.7594 50.8341 32.507C51.7591 32.3794 54.3125 32.2818 57.2075 33.6696L58.3438 28.1557C56.7869 27.5656 54.7859 27.0006 52.2947 27.0006C45.9047 27.0006 41.4103 30.5366 41.3741 35.5976ZM69.2619 27.4755C68.0222 27.4755 66.9775 28.2283 66.5112 29.3834L56.8134 53.4876H63.5975L64.9475 49.6038H73.2375L74.0206 53.4876H80L74.7822 27.4755H69.2619ZM70.2109 34.5023L72.1687 44.2702H66.8069L70.2109 34.5023ZM33.1488 27.4758L27.8012 53.4873H34.2659L39.6109 27.4752H33.1488V27.4758ZM23.5853 27.4752L16.8566 45.1804L14.1347 30.1264C13.8153 28.4459 12.5541 27.4755 11.1534 27.4755H0.154062L0 28.2309C2.25812 28.7409 4.82375 29.5636 6.37813 30.4439C7.32937 30.9816 7.60063 31.4517 7.91313 32.7295L13.0684 53.4876H19.9L30.3737 27.4755H23.5853", "fill", "url(#paint0_linear)"], ["id", "paint0_linear", "x1", "36.7792", "y1", "54.432", "x2", "37.5894", "y2", "26.8154", "gradientUnits", "userSpaceOnUse"], ["stop-color", "#222357"], ["offset", "1", "stop-color", "#254AA5"], ["width", "32", "height", "32", "viewBox", "5 -20 40 60", "y", "0px", "x", "0px"], ["id", "defs20"], ["id", "style3", "type", "text/css"], ["y2", "3", "x2", "48.5", "y1", "3", "x1", "34.1742", "gradientUnits", "userSpaceOnUse", "id", "SVGID_1_"], ["id", "stop6", "offset", "0", 2, "stop-color", "#00B4E6"], ["id", "stop8", "offset", "1", 2, "stop-color", "#088CCB"], ["id", "path10", "d", "M43.5,0h-9.3c0.5,3.1,3.5,6,6.8,6h7.4c0.1-0.3,0.1-0.7,0.1-1C48.5,2.2,46.3,0,43.5,0z", 1, "st0"], ["id", "path12", "d", "m 35,6.5 0,7.5 4.5,0 0,-4 4,0 c 2.2,0 4.1,-1.5 4.7,-3.5 z", 1, "st1", 2, "clip-rule", "evenodd", "fill", "#4db45f", "fill-rule", "evenodd"], ["id", "path14", "d", "M19,0v14h4c0,0,1,0,1.5-1C27.2,7.6,28,6,28,6h0.5v8H33V0h-4c0,0-1,0.1-1.5,1C25.2,5.6,24,8,24,8h-0.5V0H19z", 1, "st1"], ["id", "path16", "d", "M0,14V0h4.5c0,0,1.3,0,2,2c1.8,5.3,2,6,2,6s0.4-1.3,2-6c0.7-2,2-2,2-2H17v14h-4.5V6.5H12L9.5,14h-2L5,6.5H4.5  V14H0z", 1, "st1"], ["width", "32", "height", "32", "viewBox", "0 0 25 20", "y", "0px", "x", "0px"], ["d", "M25 7.5V16.25C25 17.2446 24.6049 18.1984 23.9017 18.9017C23.1984 19.6049 22.2446 20 21.25 20H3.75C2.75544 20 1.80161 19.6049 1.09835 18.9017C0.395088 18.1984 0 17.2446 0 16.25V7.5H25ZM20 12.5H16.25C15.9185 12.5 15.6005 12.6317 15.3661 12.8661C15.1317 13.1005 15 13.4185 15 13.75C15 14.0815 15.1317 14.3995 15.3661 14.6339C15.6005 14.8683 15.9185 15 16.25 15H20C20.3315 15 20.6495 14.8683 20.8839 14.6339C21.1183 14.3995 21.25 14.0815 21.25 13.75C21.25 13.4185 21.1183 13.1005 20.8839 12.8661C20.6495 12.6317 20.3315 12.5 20 12.5ZM21.25 0C22.2446 0 23.1984 0.395088 23.9017 1.09835C24.6049 1.80161 25 2.75544 25 3.75V5H0V3.75C0 2.75544 0.395088 1.80161 1.09835 1.09835C1.80161 0.395088 2.75544 0 3.75 0H21.25Z", "fill", "#41A1D9"], [1, "account__details"], [1, "card-type-icon"], ["width", "80", "height", "80", "viewBox", "0 0 80 80", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], ["width", "80", "height", "80", "viewBox", "5 -20 40 60", "y", "0px", "x", "0px", 4, "ngIf"], ["width", "80", "height", "80", "viewBox", "0 0 25 20", "y", "0px", "x", "0px", 4, "ngIf"], [1, "info"], [1, "info__type", "bold"], [1, "info__expiration"], [1, "account__actions"], ["class", "link card-not-default", 3, "disabled", "click", 4, "ngIf"], ["class", "link card-default", 3, "disabled", 4, "ngIf"], [1, "link", "link-delete", 3, "click"], ["width", "80", "height", "80", "viewBox", "0 0 80 80", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["width", "80", "height", "80", "viewBox", "5 -20 40 60", "y", "0px", "x", "0px"], ["width", "80", "height", "80", "viewBox", "0 0 25 20", "y", "0px", "x", "0px"], [1, "link", "card-not-default", 3, "click"], [1, "link", "card-default"]],
        template: function PaymentCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainerStart(0, 2);
            i0.ɵɵtemplate(1, PaymentCardComponent_ng_container_1_Template, 2, 1, "ng-container", 3)(2, PaymentCardComponent_ng_container_2_Template, 2, 1, "ng-container", 3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(3, PaymentCardComponent_ng_template_3_Template, 11, 17, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(5, PaymentCardComponent_ng_template_5_Template, 23, 22, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngSwitch", ctx.view);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "simple");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "full");
          }
        },
        dependencies: [i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.account.simple[_ngcontent-%COMP%]{border:1px solid #EEEEEE;border-radius:10px;cursor:pointer;display:flex;align-items:center;justify-content:space-between;height:50px;padding:0 20px;transition:border .2s linear;margin-bottom:10px;max-width:335px;position:relative}.account.simple[_ngcontent-%COMP%]:hover{border:1px solid #41A1D9}.account.simple[_ngcontent-%COMP%]:hover   .icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#41a1d9}.account.simple.test[_ngcontent-%COMP%]{border:1px solid #FEED7D}.account.simple.selected[_ngcontent-%COMP%]{border:1px solid #5AB3E4;background:#e6f6ff}.account.simple.expired[_ngcontent-%COMP%]{border:1px solid #E86F79;opacity:.4;pointer-events:none}.account.simple[_ngcontent-%COMP%]   .test-card-label[_ngcontent-%COMP%]{position:absolute;top:0;right:50%;transform:translate(50%);border-bottom-left-radius:5px;border-bottom-right-radius:5px;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;color:#1e252b;line-height:12px;background:#feed7d;padding:2px 5px}.account.simple[_ngcontent-%COMP%]   .account__expired[_ngcontent-%COMP%]{padding:2px 5px;background:#e86f79;color:#fff;text-align:center;font-size:10px;font-style:normal;line-height:12px;position:absolute;top:0;left:50%;transform:translate(-50%);border-radius:0 0 5px 5px}.account.simple[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:32px;height:32px;justify-content:center;display:flex;flex-shrink:0;align-items:center}.account.simple[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#a4b0c3}.account.simple[_ngcontent-%COMP%]   .data[_ngcontent-%COMP%]{width:100%;display:flex;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b}.account.full[_ngcontent-%COMP%]{border-radius:10px;border:1px solid #eee;width:100%;height:180px;position:relative;box-sizing:border-box;display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start}.account.full.expired[_ngcontent-%COMP%]{border:1px solid #E86F79}.account.full.selected[_ngcontent-%COMP%]{border:1px solid #5AB3E4;background:#e6f6ff}.account.full[_ngcontent-%COMP%]   .account__expired[_ngcontent-%COMP%]{padding:2px 5px;background:#e86f79;color:#fff;text-align:center;font-size:10px;font-style:normal;line-height:12px;position:absolute;top:10px;right:10px;border-radius:5px}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;padding:20px}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .card-type-icon[_ngcontent-%COMP%]{display:block;width:80px;height:80px;flex-shrink:0}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{display:block;margin-left:20px}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info__type[_ngcontent-%COMP%]{font-size:24px;line-height:24px;color:#1e252b;margin-bottom:6px;text-transform:capitalize}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info__expiration[_ngcontent-%COMP%]{font-size:14px;line-height:16px;color:#a4b0c3}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info__expiration.status[_ngcontent-%COMP%]{margin-top:10px}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info__expiration[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:16px}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info__expiration[_ngcontent-%COMP%]   span.pending[_ngcontent-%COMP%]{color:#eed76d}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info__expiration[_ngcontent-%COMP%]   span.active[_ngcontent-%COMP%]{color:#65c558}.account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info__expiration[_ngcontent-%COMP%]   span.canceled[_ngcontent-%COMP%], .account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info__expiration[_ngcontent-%COMP%]   span.deleting[_ngcontent-%COMP%], .account.full[_ngcontent-%COMP%]   .account__details[_ngcontent-%COMP%]   .info__expiration[_ngcontent-%COMP%]   span.expired[_ngcontent-%COMP%]{color:#e86f79}.account.full[_ngcontent-%COMP%]   .account__actions[_ngcontent-%COMP%]{background:#f5f8fa;border-bottom-left-radius:10px;border-bottom-right-radius:10px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;height:56px;position:absolute;width:100%;bottom:0}.account.full[_ngcontent-%COMP%]   .account__actions[_ngcontent-%COMP%]   .link[_ngcontent-%COMP%]{color:#41a1d9;margin:0 20px}.account.full[_ngcontent-%COMP%]   .account__actions[_ngcontent-%COMP%]   .card-not-default[_ngcontent-%COMP%]{color:#41a1d9;cursor:pointer}.account.full[_ngcontent-%COMP%]   .account__actions[_ngcontent-%COMP%]   .card-default[_ngcontent-%COMP%]{color:#a4b0c3;cursor:default}.disabled[_ngcontent-%COMP%]{opacity:.3;pointer-events:none;cursor:unset}"],
        changeDetection: 0
      });
    }
  }
  return PaymentCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentCardModule = /*#__PURE__*/(() => {
  class PaymentCardModule {
    static {
      this.ɵfac = function PaymentCardModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentCardModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaymentCardModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, ModalModule, OnUiButtonModule, OnUiCardMenuModule, OnUiPopoverModule]
      });
    }
  }
  return PaymentCardModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentWidgetPaymentMethodSelectorComponent = /*#__PURE__*/(() => {
  class PaymentWidgetPaymentMethodSelectorComponent extends ChangableComponent {
    set paymentMethods(value) {
      if (value?.length && !isEqual(value, this._paymentMethods)) {
        this._paymentMethods = value;
        if (this._paymentMethods.length && this.defaultAccount) {
          this.onSelect(this.defaultAccount, 'account');
        }
      }
    }
    get paymentMethods() {
      return this._paymentMethods;
    }
    set paymentProviders(data) {
      if (data?.length && !isEqual(data, this._paymentProviders)) {
        this._paymentProviders = data;
      }
    }
    get paymentProviders() {
      return this._paymentProviders;
    }
    set initAdd(value) {
      if (value) {
        this.selected = null;
        this.paymentMethodSelected.emit(null);
      } else {
        if (this._paymentMethods.length && this.defaultAccount) {
          this.onSelect(this.defaultAccount, 'account');
        }
      }
    }
    set selectedAccountId(accountId) {
      if (this._paymentMethods.length) {
        this.defaultAccount = this._paymentMethods.find(account => account.id === accountId);
        if (this.defaultAccount) {
          this.onSelect(this.defaultAccount, 'account');
        }
      }
    }
    constructor(cdr) {
      super(cdr);
      this.cdr = cdr;
      this.paymentMethodSelected = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.selected = null;
      this.defaultAccount = null;
    }
    ngOnInit() {}
    /** Если выбран провайдер для нового способа оплаты или уже имеющийся счет */
    onSelect(method, type) {
      if (type === 'account') {
        this.selected = {
          paymentMethod: method,
          provider: null
        };
      } else if (type === 'provider') {
        this.selected = {
          paymentMethod: null,
          provider: method
        };
      }
      this.paymentMethodSelected.emit(this.selected);
      this.markForCheck();
    }
    isForNotRussia(merchant) {
      if (merchant.unSupportCountries) {
        return merchant.unSupportCountries.includes('RU');
      } else {
        if (merchant.supportedCountries) {
          return !merchant.supportedCountries.includes('RU');
        } else {
          return true;
        }
      }
    }
    trackByFn(index, item) {
      return item.id;
    }
    isTestCard(account) {
      return this.paymentProviders.find(provider => provider.id === account.providerId).testMode;
    }
    static {
      this.ɵfac = function PaymentWidgetPaymentMethodSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetPaymentMethodSelectorComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaymentWidgetPaymentMethodSelectorComponent,
        selectors: [["app-payment-widget-payment-method-selector"]],
        inputs: {
          paymentMethods: "paymentMethods",
          paymentProviders: "paymentProviders",
          initAdd: "initAdd",
          selectedAccountId: "selectedAccountId"
        },
        outputs: {
          paymentMethodSelected: "paymentMethodSelected"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "payment-form-card-selector"], [3, "ngIf"], [1, "cards-list"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "onSelect", "selected", "is_test", "account", "view"]],
        template: function PaymentWidgetPaymentMethodSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, PaymentWidgetPaymentMethodSelectorComponent_ng_template_1_Template, 2, 2, "ng-template", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.paymentMethods == null ? null : ctx.paymentMethods.length);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, PaymentCardComponent],
        styles: [".payment-form-card-selector[_ngcontent-%COMP%]{display:flex;flex-direction:column}.payment-form-card-selector[_ngcontent-%COMP%]   .no-cards[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;height:250px;justify-content:center}.payment-form-card-selector[_ngcontent-%COMP%]   .no-cards[_ngcontent-%COMP%]   .no-cards-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:18px;margin-bottom:30px}.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px}.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{align-items:center;border:1px solid #EEEEEE;border-radius:10px;cursor:pointer;display:flex;justify-content:space-between;height:50px;padding:0 20px;transition:border .2s linear;margin-bottom:10px;max-width:335px}@media screen and (max-width: 768px){.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{max-width:100%;width:100%}}.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]:hover, .payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card.selected[_ngcontent-%COMP%]{border:1px solid #5AB3E4}.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:1}.payment-form-card-selector[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;gap:10px}"],
        changeDetection: 0
      });
    }
  }
  return PaymentWidgetPaymentMethodSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentWidgetPaymentMethodSelectorModule = /*#__PURE__*/(() => {
  class PaymentWidgetPaymentMethodSelectorModule {
    static {
      this.ɵfac = function PaymentWidgetPaymentMethodSelectorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetPaymentMethodSelectorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaymentWidgetPaymentMethodSelectorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, PaymentCardModule]
      });
    }
  }
  return PaymentWidgetPaymentMethodSelectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO Реализовать работу через @lingo2-billing-sdk/angular
// либо вообще заменить данный сервис на использование только сервисов
// @lingo2-billing-sdk/angular внутри платёжного компонента
let PaymentWidgetBillingService = /*#__PURE__*/(() => {
  class PaymentWidgetBillingService extends DestroyableComponent {
    constructor(http, translate, configService) {
      super();
      this.http = http;
      this.translate = translate;
      this.configService = configService;
      this.billing_v2_url = `${this.configService.getEnvAccountUrl()}/billing/v2`;
    }
    /**
     * Сохранённые способы оплаты
     */
    getPaymentMethods() {
      const url = `${this.billing_v2_url}/account?type=BANK&purpose=PAYMENT`;
      return this.http.get(url, {
        observe: 'response'
      }).pipe(map$1(response => this.handleBillingResponse(response)));
    }
    /**
     * Информация о платеже
     * (для отслеживания статуса оплаты)
     */
    getPayment(id) {
      const url = `${this.billing_v2_url}/payment/` + id;
      return this.http.get(url, {
        observe: 'response'
      }).pipe(map$1(response => this.handleBillingResponse(response)));
    }
    /**
     * Пакетная оплата начислений >=1
     */
    payBulk(charges, paymentMethod, customer) {
      const payload = charges.map(id => ({
        chargeId: id,
        firstName: customer.firstName,
        lastName: customer.lastName,
        countryCode: customer.countryCode,
        ...(customer.email ? {
          email: customer.email
        } : null),
        ...(paymentMethod?.provider?.id ? {
          providerId: paymentMethod.provider.id
        } : paymentMethod?.paymentMethod?.id ? {
          accountId: paymentMethod.paymentMethod.id
        } : null)
      }));
      const url = `${this.billing_v2_url}/charge/pay`;
      return this.http.post(url, payload, {
        observe: 'response'
      }).pipe(map$1(response => this.handleBillingResponse(response, data => {
        if (!data[0] || !data[0].payment) {
          throw new Error();
        }
        return {
          id: data[0].payment.id,
          status: data[0].payment.status,
          url: this.configService.getEnvBillingPublicUrl() + '/' + data[0].payment.paymentUrl
        };
      })));
    }
    /**
     * Загрузка информации о начислениях
     */
    getCharges(chargeId) {
      const url = `${this.billing_v2_url}/charge/`;
      return this.http.get(url, {
        observe: 'response',
        params: {
          'id[]': chargeId
        }
      }).pipe(map$1(response => this.handleBillingResponse(response)));
    }
    getPaymentProviders() {
      const url = `${this.billing_v2_url}/merchant/`;
      return this.http.get(url, {
        observe: 'response'
      }).pipe(map$1(response => this.handleBillingResponse(response)));
    }
    handleBillingResponse(response, transformer) {
      if (transformer) {
        return transformer(response.body);
      } else {
        return response.body;
      }
    }
    static {
      this.ɵfac = function PaymentWidgetBillingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetBillingService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(AbstractConfigService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PaymentWidgetBillingService,
        factory: PaymentWidgetBillingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PaymentWidgetBillingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaymentWidgetComponent = /*#__PURE__*/(() => {
  class PaymentWidgetComponent extends ChangableComponent {
    /** Информация о том, что надо обновить список счетов для оплаты */
    set needUpdate(value) {
      if (!value) {
        return;
      }
      this.showAddMethods = false;
      this.configuration = new PaymentConfiguration();
      this.prepare();
    }
    constructor(paymentWidgetService, screenService, deviceService, userService, cdr, billingService, billingV2Service, merchantService) {
      super(cdr);
      this.paymentWidgetService = paymentWidgetService;
      this.screenService = screenService;
      this.deviceService = deviceService;
      this.userService = userService;
      this.cdr = cdr;
      this.billingService = billingService;
      this.billingV2Service = billingV2Service;
      this.merchantService = merchantService;
      /** Информация о том, что нажали на кнопку оплатить */
      this.payClicked = false;
      /** Информация о том, что это покупка с бесплатным периодом */
      this.buyTrial = false;
      /** Текущее состояние формы и параметры, которые надо сохранить вне биллинга */
      this.configured = new EventEmitter();
      /** Вызывается когда в виджете 100% определено, что транзакция совершена */
      this.succeed = new EventEmitter();
      /** Вызывается когда пользователь отменил операцию по своему желанию */
      this.canceled = new EventEmitter();
      /** Вызывается когда пользователь операция была начата и закончилась ошибкой */
      this.failed = new EventEmitter();
      /** Вызывается когда в виджете начинается фоновое ожидание выполнения оплаты */
      this.processing = new EventEmitter();
      /** Вызвать окно добавления нового счета для оплаты (карты) */
      this.addAccount = new EventEmitter();
      this.screen = 'init';
      this.cardSelected = false;
      this._isAccountPayment = false;
      this.configuration = new PaymentConfiguration();
      this.paymentMethods = [];
      this.paymentProviders = [];
      this.currencyEnum = CurrencyEnum;
      this.errorDescription = '';
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.selected = null;
      this.showAddMethods = false;
      this.trueCharges = [];
      this.charges = [];
      this.approvedProviders = [];
    }
    ngOnInit() {
      /** Нажатие "Оплатить" снаружи виджета */
      this.paymentWidgetService.pay$.pipe(filter(value => !!value), tap$1(() => this.pay()), takeUntil(this.destroyed$)).subscribe();
      this.userService.me$.pipe(takeUntil(this.destroyed$)).subscribe(me => {
        this.me = me;
      });
      this.prepare();
    }
    screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    get formValid() {
      return this.cardSelected;
    }
    /**
     * Пользователь выбрал способ оплаты.
     * Это либо сохранённый способ оплаты (пока только карты)
     * либо доступный провайдер для оплаты новым способом.
     */
    onSelectPaymentMethod(paymentMethod) {
      if (this.configuration.paymentMethod && paymentMethod?.paymentMethod?.cardAccount.accountId === this.configuration.paymentMethod.paymentMethod?.cardAccount.accountId) {
        return;
      }
      if (!paymentMethod) {
        this.cardSelected = false;
        return;
      }
      this.cardSelected = true;
      this.configuration.paymentMethod = paymentMethod;
      this.configuration.provider_id = 'stripe';
      this.merchant = this.paymentProviders.find(merchant => {
        if (paymentMethod.paymentMethod) {
          return merchant.id === paymentMethod.paymentMethod.providerId;
        } else {
          return merchant.id === paymentMethod?.provider?.id;
        }
      });
      this._isAccountPayment = !!paymentMethod.paymentMethod;
      this.checkPayment(this.trueCharges, paymentMethod.paymentMethod?.cardAccount?.accountId);
      this.detectChanges();
      this.configuration.complete = this.formValid;
      this.configured.emit(this.configuration);
    }
    get isAccountPayment() {
      return this._isAccountPayment;
    }
    onSuccess() {
      this.screen = 'success';
      this.processing.emit(false);
      this.detectChanges();
      this.setTimeout(() => {
        this.succeed.emit(true);
        this.detectChanges();
      }, 5000);
    }
    onFail(err) {
      this.screen = 'fail';
      this.errorDescription = err?.message ? err?.message : JSON.stringify(err);
      this.detectChanges();
      this.failed.emit({
        message: err?.message || 'Fail'
      });
      this.processing.emit(false);
    }
    /**
     * ШАГ 1. Загрузка информации о начислениях,
     * сохранённых способах оплаты и доступных
     * платёжных провайдерах.
     */
    prepare() {
      zip([this.billingV2Service.getCharges(this.options.charge_id), this.billingV2Service.getMerchants()]).pipe(tap$1(([charges, paymentProviders]) => {
        if (this.options.charge_id.length !== charges.length) {
          this.errorDescription = 'Charge(s) not found';
          this.screen = 'fail';
          throw new Error('Charge(s) not found');
        }
        if (paymentProviders.length === 0) {
          this.errorDescription = 'No payment providers available';
          this.screen = 'fail';
          throw new Error('No payment providers available');
        }
        this.charges = charges;
        this.trueCharges = charges;
        this.paymentProviders = paymentProviders;
        this.checkPayment(this.trueCharges);
        this.detectChanges();
      }), catchError(error => {
        this.errorDescription = error.error ? error.error.message : JSON.stringify(error);
        this.screen = 'fail';
        this.failed.emit({
          message: this.errorDescription
        });
        this.detectChanges();
        return throwError(error);
      }), takeUntil(this.destroyed$)).subscribe();
    }
    checkPayment(charges, accountId) {
      if (!charges.length) {
        return;
      }
      const chargesId = [];
      charges.forEach(item => {
        chargesId.push(item.id);
      });
      let currencyCode = Object.keys(CurrencyEnum)[Object.values(CurrencyEnum).indexOf(this.me.currency_id)].toUpperCase();
      /**
       * @TODO: удалить из моделей код рубля RUR, оставить только RUB
       * У нас два кода для рубля RUR и RUB.
       * RUR - уже не используется но все равно есть в моделях с таким же ID как и RUB
       */
      if (currencyCode === 'RUR') {
        currencyCode = 'RUB';
      }
      this.billingV2Service.payCheck(chargesId, accountId ? accountId : null, currencyCode).pipe(takeUntil(this.destroyed$)).subscribe(res => {
        if (!res) {
          this.errorDescription = 'Check charges failed: ' + chargesId.toString();
          this.screen = 'fail';
          this.failed.emit({
            message: 'Check charges failed: ' + chargesId.toString()
          });
        } else {
          if (res.status === BillingCoreChargeStatusEnum.PAID) {
            this.screen = 'success';
            this.succeed.emit(true);
          } else if (res.status === BillingCoreChargeStatusEnum.REJECT) {
            this.errorDescription = 'Paid rejected';
            this.screen = 'fail';
            this.failed.emit({
              message: 'Paid rejected'
            });
          } else {
            this.screen = 'cards';
            this.checkData = res;
            this.approvedProviders = res.providers;
            this.paymentMethods = res.accounts;
            const amountToPay = new CCurrencyAmount();
            amountToPay.amount = Number(res.amountToPay);
            amountToPay.currency_id = this.currencyEnum[res.currencyCode.toLowerCase()];
            this.paymentWidgetService.payAmount(amountToPay);
            if (!this.paymentMethods.length) {
              this.showAddPaymentMethods();
            }
            this.detectChanges();
          }
        }
      }, err => {
        this.errorDescription = err.error ? err.error.message : JSON.stringify(err.message.error.message);
        this.screen = 'fail';
        this.failed.emit({
          message: this.errorDescription
        });
      });
    }
    /**
     * ШАГ 2. Создание платежа и активация компонента банковского процессинга в котором
     * осуществляется непосредственная оплата платежа по ID.
     *
     * Переход осущевляется при условиях, что у правила приняты, а
     * также выбран способ оплаты или провайдер для оплаты новым способом.
     */
    pay() {
      if (!this.formValid) {
        return;
      }
      if (!this.configuration.paymentMethod) {
        return;
      }
      this.processing.emit(true);
      this.screen = 'processing';
      // Создание платежа.
      // Платёж будет иметь либо сведения для оплаты, если платёж
      // требует участия пользователя (новый способ, 3DSecure и т.п.),
      // либо вернётся со статусом SUCCESS/FAIL при оплате сохраннённым способом.
      this.billingV2Service.payBulk(this.charges.map(charge => charge.id), this.configuration.paymentMethod, {
        accountId: this.configuration.paymentMethod.paymentMethod.accountId,
        firstName: this.options.first_name,
        lastName: this.options.last_name,
        email: this.options.email,
        phone: this.getFormattedPhone(this.options.phone),
        countryCode: this.options.country
      }).pipe(map(payment => {
        if (payment.status === BillingCoreChargeStatusEnum.REJECT) {
          this.errorDescription = 'Charge rejected';
          this.screen = 'fail';
          throw new Error('Charge rejected');
        }
        return payment;
      }), takeUntil(this.destroyed$)).subscribe(payment => {
        switch (payment.payment.status) {
          case BillingCorePaymentStatusEnum.INTENT:
            // Ручная оплата у мерчанта
            this.payment = payment;
            this.setTimeout(() => this.merchantService.pay(), 500);
            break;
          case BillingCorePaymentStatusEnum.SUCCEEDED:
            // Сразу оплачен
            this.onSuccess();
            break;
        }
        this.detectChanges();
      }, error => {
        this.errorDescription = error.error ? error.error.message : JSON.stringify(error);
        this.screen = 'fail';
        this.failed.emit({
          message: this.errorDescription
        });
      });
    }
    getFormattedPhone(phone) {
      const formattedPhone = phone.replace(/\D/g, '');
      if (formattedPhone.indexOf('+') !== -1) {
        return formattedPhone;
      } else {
        return `+${formattedPhone}`;
      }
    }
    addNewAccount(method) {
      this.addAccount.emit(method.id);
    }
    /** Если выбран провайдер для нового способа оплаты или уже имеющийся счет */
    onSelect(method, type) {
      if (type === 'account') {
        this.selected = {
          paymentMethod: method,
          provider: null
        };
      } else if (type === 'provider') {
        this.selected = {
          paymentMethod: null,
          provider: method
        };
      }
      this.onSelectPaymentMethod(this.selected);
      this.screen = 'processing';
      this.pay();
      this.markForCheck();
    }
    isForNotRussia(merchant) {
      if (merchant.unSupportCountries) {
        return merchant.unSupportCountries.includes('RU');
      } else {
        if (merchant.supportedCountries) {
          return !merchant.supportedCountries.includes('RU');
        } else {
          return true;
        }
      }
    }
    showAddPaymentMethods() {
      this.showAddMethods = true;
      this.detectChanges();
    }
    closeAddPaymentMethods() {
      if (!this.paymentMethods.length) {
        return;
      }
      this.showAddMethods = false;
      this.detectChanges();
    }
    isTestProvider(provider) {
      return provider.note && provider.note.toLowerCase().indexOf('test') !== -1;
    }
    isApprovedProviders(provider) {
      return this.approvedProviders.find(approvedProvider => approvedProvider.id === provider.id);
    }
    static {
      this.ɵfac = function PaymentWidgetComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetComponent)(i0.ɵɵdirectiveInject(PaymentWidgetService), i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PaymentWidgetBillingService), i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(PaymentWidgetMerchantProcessingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaymentWidgetComponent,
        selectors: [["app-payment-widget"]],
        inputs: {
          options: "options",
          payClicked: "payClicked",
          buyTrial: "buyTrial",
          needUpdate: "needUpdate"
        },
        outputs: {
          configured: "configured",
          succeed: "succeed",
          canceled: "canceled",
          failed: "failed",
          processing: "processing",
          addAccount: "addAccount"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 19,
        vars: 7,
        consts: [["initRef", ""], ["cardsRef", ""], ["processingRef", ""], ["successRef", ""], ["failedRef", ""], ["addPaymentMethodsRef", ""], [1, "payment-widget", 3, "ngClass"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "ngTemplateOutlet"], [1, "payment-form"], [1, "payment-top"], [1, "step-title"], [1, "title-block"], [1, "title"], ["class", "add-payment-method-link", 3, "clickOutside", "click", 4, "ngIf"], [1, "payment-systems"], [1, "icon", "pci-grey"], [1, "icon", "mastercard-grey"], [1, "icon", "visa-grey"], [1, "icon", "mir-grey"], [1, "top-wrapper"], [3, "paymentMethodSelected", "paymentMethods", "selectedAccountId", "paymentProviders", "initAdd"], [3, "payment", "free"], ["class", "not-selected-payment-method", 4, "ngIf"], [1, "add-payment-method-link", 3, "clickOutside", "click"], [1, "link"], [3, "ngIf", "ngIfThen"], [1, "not-selected-payment-method"], ["class", "processing-wrapper", 4, "ngIf"], [3, "payment", "isAccountPayment", "merchant", "succeed", "failed", 4, "ngIf"], [1, "processing-wrapper"], [1, "processing"], [3, "succeed", "failed", "payment", "isAccountPayment", "merchant"], [1, "finish-success"], ["width", "98", "height", "98", "viewBox", "0 0 98 98", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "icon"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#87D37C"], ["d", "M74.7524 38.2306L47.0937 65.7585C46.2639 66.5843 45.1747 67 44.0854 67C42.9962 67 41.9069 66.5843 41.0772 65.7585L27.2482 51.9945C25.5839 50.3389 25.5839 47.6619 27.2482 46.0063C28.9116 44.3498 31.6005 44.3498 33.2647 46.0063L44.0854 56.7761L68.7359 32.2423C70.3993 30.5859 73.0882 30.5859 74.7524 32.2423C76.4159 33.898 76.4159 36.5741 74.7524 38.2306Z", "fill", "#FAFAFA"], [1, "finish-fail"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#E86F79"], ["x", "29", "y", "35", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-45 29 35)", "fill", "white"], ["x", "35", "y", "70", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-135 35 70)", "fill", "white"], [1, "description"], [1, "add-card-list-wrapper", 3, "ngClass"], [3, "ngIf"], [1, "cards-list"], [4, "ngFor", "ngForOf"], ["class", "card", 3, "test", "selected", "click", 4, "ngIf"], [1, "card", 3, "click"], ["class", "test-card-label", 4, "ngIf"], [1, "icons"], [1, "test-card-label"], [1, "title", "normal"], ["width", "35", "height", "28", "viewBox", "0 0 59 46"], ["width", "41", "height", "22", "viewBox", "0 0 71 23"], ["width", "65", "height", "25", "viewBox", "0 0 65 15"]],
        template: function PaymentWidgetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 6);
            i0.ɵɵelementContainerStart(1, 7);
            i0.ɵɵtemplate(2, PaymentWidgetComponent_ng_container_2_Template, 2, 1, "ng-container", 8)(3, PaymentWidgetComponent_ng_container_3_Template, 2, 1, "ng-container", 8)(4, PaymentWidgetComponent_ng_container_4_Template, 2, 1, "ng-container", 8)(5, PaymentWidgetComponent_ng_container_5_Template, 2, 1, "ng-container", 8)(6, PaymentWidgetComponent_ng_container_6_Template, 2, 1, "ng-container", 8);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, PaymentWidgetComponent_ng_template_7_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(9, PaymentWidgetComponent_ng_template_9_Template, 21, 15, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(11, PaymentWidgetComponent_ng_template_11_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(13, PaymentWidgetComponent_ng_template_13_Template, 7, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(15, PaymentWidgetComponent_ng_template_15_Template, 10, 4, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(17, PaymentWidgetComponent_ng_template_17_Template, 2, 4, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.screenClasses());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitch", ctx.screen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "init");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "cards");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "processing");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "success");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "fail");
          }
        },
        dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, Spinner2Component, PaymentWidgetPaymentMethodSelectorComponent, PaymentWidgetMerchantProcessingComponent, PaymentOrderComponent, i3$1.ClickOutsideDirective, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";  .clock-spinner{text-align:center;width:0;margin:50px auto}.payment-form[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;width:100%;min-height:300px}.payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 20px;font-size:18px;line-height:24px;display:flex;justify-content:space-between;align-items:center}.payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:baseline;gap:20px}.payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]   .add-payment-method-link[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;cursor:pointer;color:#41a1d9;position:relative}.payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .payment-systems[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center}.payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .payment-systems[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;margin-right:20px}.payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .payment-systems[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]:last-child{margin-right:0}.payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .payment-systems[_ngcontent-%COMP%]   .icon.pci-grey[_ngcontent-%COMP%]{width:43px;height:17px}.payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .payment-systems[_ngcontent-%COMP%]   .icon.visa-grey[_ngcontent-%COMP%], .payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .payment-systems[_ngcontent-%COMP%]   .icon.mastercard-grey[_ngcontent-%COMP%]{width:30px;height:30px}.payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .payment-systems[_ngcontent-%COMP%]   .icon.mir-grey[_ngcontent-%COMP%]{width:42px;height:19px}.payment-form[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.payment-form[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]   .no-payment-methods[_ngcontent-%COMP%]{border-radius:10px;width:50%;height:60px;display:block;box-sizing:border-box;padding:20px;text-align:center;justify-content:center;align-items:center;background:#ffcacf;color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#c84550}.payment-form[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]   app-payment-widget-payment-method-selector[_ngcontent-%COMP%]{width:45%}.payment-form[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]   app-payment-order[_ngcontent-%COMP%]{width:45%}.payment-form[_ngcontent-%COMP%]   .select-card[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:flex-start;gap:80px}.payment-form[_ngcontent-%COMP%]   .select-card[_ngcontent-%COMP%]   .card-selector[_ngcontent-%COMP%], .payment-form[_ngcontent-%COMP%]   .select-card[_ngcontent-%COMP%]   .receipt[_ngcontent-%COMP%]{width:50%;max-width:375px}.agreement[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:20px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;padding:10px;background:#f5f8fa;color:#1e252b;border-radius:10px}.agreement.error[_ngcontent-%COMP%]{background:#ff00001f}.agreement[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin:0 4px;color:#41a1d9;text-decoration:none;cursor:pointer}.user-cards[_ngcontent-%COMP%]{display:flex;justify-content:space-around}.user-cards[_ngcontent-%COMP%]   .user-card-wrap[_ngcontent-%COMP%]{cursor:pointer;display:flex;border-radius:10px;border:1px solid transparent}.user-cards[_ngcontent-%COMP%]   .user-card-wrap.active[_ngcontent-%COMP%]{border:1px solid #5AB3E4}.finish-success[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;flex:1;min-height:300px;width:100%}.finish-success[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 30px;font-size:24px;line-height:30px}.finish-success[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:98px;height:98px}.finish-success[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:20px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;text-align:center}.processing[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;text-align:center;font-size:24px;line-height:24px;width:100%}spinner2[_ngcontent-%COMP%]{width:100%}.processing-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;transform:translateY(50%);margin-top:50px;display:flex;justify-content:center;align-items:center;flex-direction:column}.debug-cards[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:20px}.debug-card[_ngcontent-%COMP%]{justify-content:center;align-items:center;min-height:100px;border-color:#6d7381!important}.payment-widget[_ngcontent-%COMP%]{min-height:240px}.payment-widget.mobile[_ngcontent-%COMP%]   .payment-form[_ngcontent-%COMP%]{flex-direction:column}.payment-widget.mobile[_ngcontent-%COMP%]   .payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{margin-bottom:20px;align-items:flex-start}.payment-widget.mobile[_ngcontent-%COMP%]   .payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]{flex-direction:column;gap:20px;position:relative}.payment-widget.mobile[_ngcontent-%COMP%]   .payment-form[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]   .add-payment-method-link[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;cursor:pointer;color:#41a1d9}.payment-widget.mobile[_ngcontent-%COMP%]   .payment-form[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]{flex-direction:column}.payment-widget.mobile[_ngcontent-%COMP%]   .payment-form[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]   .no-payment-methods[_ngcontent-%COMP%]{width:100%}.payment-widget.mobile[_ngcontent-%COMP%]   .payment-form[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]   app-payment-widget-payment-method-selector[_ngcontent-%COMP%]{width:100%}.payment-widget.mobile[_ngcontent-%COMP%]   .payment-form[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]   app-payment-widget-payment-method-selector[_ngcontent-%COMP%]     .cards-list .card{box-sizing:border-box}.payment-widget.mobile[_ngcontent-%COMP%]   .payment-form[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]   app-payment-order[_ngcontent-%COMP%]{margin-top:20px;width:100%}.payment-widget.mobile[_ngcontent-%COMP%]   .agreement[_ngcontent-%COMP%]   on-ui-checkbox[_ngcontent-%COMP%]     .input-checkbox-item{flex-shrink:0}.add-card-list-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;position:absolute;z-index:2;top:30px;left:-60%;padding:10px;border-radius:10px;background:#fff;box-shadow:0 0 15px #0000001a;border:1px solid transparent}.add-card-list-wrapper.error[_ngcontent-%COMP%]{border:1px solid #E86F79}.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px}.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{align-items:center;border:1px solid #EEEEEE;border-radius:10px;cursor:pointer;display:flex;justify-content:space-between;height:50px;padding:0 20px;transition:border .2s linear;margin-bottom:10px;width:335px;position:relative}@media screen and (max-width: 768px){.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{max-width:100%;width:100%}}.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]:hover{border:1px solid #5AB3E4}.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card.test[_ngcontent-%COMP%]{border:1px solid #FEED7D}.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card.selected[_ngcontent-%COMP%]{border:1px solid #5AB3E4}.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]:last-child{margin:0}.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]   .test-card-label[_ngcontent-%COMP%]{position:absolute;top:0;right:50%;transform:translate(50%);border-bottom-left-radius:5px;border-bottom-right-radius:5px;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;color:#1e252b;line-height:12px;background:#feed7d;padding:2px 5px}.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px}.add-card-list-wrapper[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;gap:10px}.add-card-list-wrapper.mobile[_ngcontent-%COMP%]{top:40px;left:-7px;width:340px}.add-card-list-wrapper.mobile[_ngcontent-%COMP%]   .cards-list[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{box-sizing:border-box;width:100%}.not-selected-payment-method[_ngcontent-%COMP%]{background:#fef4ae;width:100%;padding:10px 15px;border-radius:10px;text-align:left;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:15px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;box-sizing:border-box}"],
        changeDetection: 0
      });
    }
  }
  return PaymentWidgetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO Convert to DynamicModule with config
let PaymentWidgetModule = /*#__PURE__*/(() => {
  class PaymentWidgetModule {
    static {
      this.ɵfac = function PaymentWidgetModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentWidgetModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaymentWidgetModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [PaymentWidgetService],
        imports: [CommonModule, OnUiButtonModule, TranslateModule, SpinnersModule, OnUiCheckboxModule, StepByStepWizardModule, PaymentWidgetPaymentMethodSelectorModule, PaymentWidgetMerchantProcessingModule, PaymentOrderModule, ClickOutsideModule]
      });
    }
  }
  return PaymentWidgetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbstractCheckoutWizard = /*#__PURE__*/(() => {
  class AbstractCheckoutWizard extends ChangableComponent {
    // protected context: ContextService;
    constructor(injector, cdr) {
      super(cdr);
      this.injector = injector;
      this.cdr = cdr;
      this.steps = new StepByStepWizardSteps([]);
      this.paymentConfigured = false;
      this.paymentProcessing = false;
      this.payButtonsState = 'default';
      this.showAgreementError = false;
      this.amount = new CCurrencyAmount({
        currency_id: CurrencyEnum.usd,
        amount: 0
      });
      this.totalAmount = new CCurrencyAmount({
        currency_id: CurrencyEnum.usd,
        amount: 0
      });
      this.paymentWidgetService = injector.get(PaymentWidgetService);
      // this.context = injector.get(ContextService);
      // this.debug$ = this.context.debug$;
    }
    ngOnInit() {
      this.initWizardSteps();
      this.watchStepChanged$.pipe(takeUntil$1(this.destroyed$)).subscribe();
      of(...[this.watchMe$, this.watchPayAmountChanged$]).pipe(mergeAll(), tap$1(() => this.detectChanges()), takeUntil$1(this.destroyed$)).subscribe();
      this.setupWizardSteps();
    }
    get me() {
      return this._me;
    }
    /** Можно ли начать исполнение платежа */
    canExecutePayment() {
      return this.payButtonsState !== 'progress' && this.paymentConfigured && !this.paymentProcessingError && !this.errorMessage;
    }
    /** Исполнение платежа */
    onStartPayment() {
      if (!this.canExecutePayment()) {
        this.showAgreementError = true;
        const agreement = document.getElementsByClassName('agreement')[0];
        if (agreement) {
          agreement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
        document.querySelector('app-payment-widget').scrollTop = 0;
        return;
      }
      this.paymentWidgetService.pay();
      // if (!this.paymentFormValid || this.payButtonsState !== 'default') {
      //       return;
      //     }
      //     if (!this._billingOperation) {
      //       return;
      //     }
      //     if (this.isAgreementError) {
      //       this.showAgreementError = true;
      //       return;
      //     }
      //
      //     this.paymentProcessing = true;
      //     this.payButtonsState = 'progress';
      //     this.paymentProcessingError = '';
      //     this.billingService
      //       .completeOperation(this._billingOperation.id, this.models.billingCard?.id)
      //       .pipe(first(), takeUntil(this.destroyed$))
      //       .subscribe(
      //         (res) => {
      //           switch (res?.status) {
      //             case BillingOperationStatusEnum.succeed:
      //             case BillingOperationStatusEnum.pending:
      //               this.operationChecker(this._billingOperation.id);
      //               break;
      //             default:
      //               this.onPaymentFailed(res);
      //               break;
      //           }
      //         },
      //         (error) => {
      //           this.onPaymentFailed(error);
      //         },
      //       );
      //
      //     /**
      //      * Начинать слушать можно сразу же, не обязательно ждать ответа от сервера.
      //      * Сэкономим пару секунд, может быть.
      //      */
      //     // Возможно для пендинга надо сделать отдельное состояние
      //     this.listenForFinish(this._billingOperation.id);
      //     this.detectChanges();
      //     this.responseTimer = new Date();
    }
    onRetryPayment() {
      this.payButtonsState = 'default';
      this.detectChanges();
      this.onStartPayment();
    }
    onPaymentProcessing(value) {
      this.paymentProcessing = value;
      if (this.paymentProcessing) {
        this.payButtonsState = 'progress';
      }
      this.detectChanges();
    }
    /** Обработчик на изменение настроек платёжной формы и параметров проведения платежей */
    onPaymentConfigured(configuration) {
      this.paymentConfigured = configuration.complete;
      this.detectChanges();
    }
    /** Обработчик на исполнение платежа */
    onPaymentSucceed() {
      this.payButtonsState = 'done';
      this.detectChanges();
      // this.setTimeout(() => {
      //   this.payButtonsState = 'default';
      //   this.detectChanges();
      // }, 2500);
    }
    /** Обработчик на прекращение платежа по желанию пользователя */
    onPaymentCanceled() {}
    /** Обработчик на прекращение платежа по техническим причинам */
    onPaymentFailed(err) {
      this.paymentProcessingError = err.message;
      this.payButtonsState = 'fail';
      this.detectChanges();
      // this.setTimeout(() => {
      //   this.payButtonsState = 'default';
      //   this.detectChanges();
      // }, 2500);
    }
    activateView(view) {
      this.activeView = view;
      this.detectChanges();
    }
    get watchMe$() {
      return null; // this.context.me$.pipe(tap((me) => (this._me = me)));
    }
    get watchStepChanged$() {
      return this.steps.activeStep$.pipe(distinctUntilChanged(), tap$1(step => {
        this.onStepActivated(step);
        this.activateView(step);
      }));
    }
    get watchPayAmountChanged$() {
      return this.paymentWidgetService.payAmount$.pipe(tap$1(totalAmount => this.totalAmount = totalAmount));
    }
    static {
      this.ɵfac = function AbstractCheckoutWizard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AbstractCheckoutWizard)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AbstractCheckoutWizard,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return AbstractCheckoutWizard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PayButtonComponent = /*#__PURE__*/(() => {
  class PayButtonComponent {
    constructor(deviceService) {
      this.deviceService = deviceService;
      this.startLabel = 'Pay';
      this.closeLabel = 'Close';
      this.cancelLabel = 'Cancel';
      this.retryLabel = 'Retry';
      this.start = new EventEmitter();
      this.retry = new EventEmitter();
      this.cancel = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    onStart() {
      this.start.emit(true);
    }
    onRetry() {
      this.retry.emit(true);
    }
    onCancel() {
      this.cancel.emit(true);
    }
    static {
      this.ɵfac = function PayButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PayButtonComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PayButtonComponent,
        selectors: [["app-pay-button"]],
        inputs: {
          state: "state",
          disabled: "disabled",
          startLabel: "startLabel",
          closeLabel: "closeLabel",
          cancelLabel: "cancelLabel",
          retryLabel: "retryLabel"
        },
        outputs: {
          start: "start",
          retry: "retry",
          cancel: "cancel"
        },
        decls: 5,
        vars: 3,
        consts: [["protected", ""], [3, "ngIf"], [1, "secondary", 3, "click", "state", "disabled", "label"], [4, "ngTemplateOutlet"], ["state", "default", 1, "secondary", 3, "onclick", "label"], [1, "protected-label"], [1, "icon"], [1, "label"]],
        template: function PayButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PayButtonComponent_ng_template_0_Template, 2, 4, "ng-template", 1)(1, PayButtonComponent_ng_template_1_Template, 2, 2, "ng-template", 1)(2, PayButtonComponent_ng_template_2_Template, 1, 1, "ng-template", 1)(3, PayButtonComponent_ng_template_3_Template, 6, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.state === "progress" || ctx.state === "default");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.state === "done");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.state === "fail");
          }
        },
        dependencies: [i2.NgIf, i2.NgTemplateOutlet, i16.OnUiButtonComponent, i3.TranslatePipe],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;position:relative}on-ui-button[_ngcontent-%COMP%] + on-ui-button[_ngcontent-%COMP%]{margin-left:20px}.protected-label[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;gap:5px;margin-top:5px}.protected-label[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:26px;height:23px}.protected-label[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#65c558;font-size:12px;font-style:normal;line-height:16px}.protected-label.web[_ngcontent-%COMP%]{position:absolute;bottom:-25px;width:100%;min-width:180px;right:50%;transform:translate(50%)}"],
        changeDetection: 0
      });
    }
  }
  return PayButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PayButtonModule = /*#__PURE__*/(() => {
  class PayButtonModule {
    static {
      this.ɵfac = function PayButtonModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PayButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PayButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, OnUiButtonModule, TranslateModule]
      });
    }
  }
  return PayButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlansHeaderDetailsComponent = /*#__PURE__*/(() => {
  class PlansHeaderDetailsComponent extends ChangableComponent {
    set plan(plan) {
      this._plan = plan;
    }
    get plan() {
      return this._plan;
    }
    constructor(screenService, deviceService, cdr) {
      super(cdr);
      this.screenService = screenService;
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    ngOnInit() {}
    screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    static {
      this.ɵfac = function PlansHeaderDetailsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlansHeaderDetailsComponent)(i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PlansHeaderDetailsComponent,
        selectors: [["app-plans-header-details"]],
        inputs: {
          plan: "plan"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 14,
        vars: 12,
        consts: [[1, "headers-details", 3, "ngClass"], [1, "avatar"], ["width", "61", "height", "61", "viewBox", "0 0 61 61"], [1, "info", "credit"], [1, "label", "normal"], [1, "title", "bold"], [1, "subtitle", "normal"]],
        template: function PlansHeaderDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(2, "svg", 2);
            i0.ɵɵelement(3, "use");
            i0.ɵɵelementEnd()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(4, "div", 3)(5, "span", 4);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "span", 5);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "span", 6);
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.screenClasses());
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("fill", ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.color);
            i0.ɵɵadvance();
            i0.ɵɵattribute("href", ctx.svgsetIcon("finance-plan"), null, "xlink");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "lingo2-forms.subscription-plans.forms.header-label"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "lingo2-forms." + (ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.title)));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 10, "lingo2-forms." + (ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.subtitle)));
          }
        },
        dependencies: [i2.NgClass, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";[_nghost-%COMP%]{width:100%}.headers-details[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center}.headers-details[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{width:61px;height:61px;text-align:center;object-fit:cover;margin-right:20px;border-radius:50%;overflow:hidden}.headers-details[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;height:100%}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{max-width:100%;margin-top:5px;display:flex;flex-direction:column;justify-content:center;align-items:flex-start}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:18px;line-height:24px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;width:100%}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]{display:flex;flex-direction:column}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars.norating[_ngcontent-%COMP%]   .rating-icon[_ngcontent-%COMP%]{fill:#a4b0c3}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars.norating[_ngcontent-%COMP%]   .rating-count[_ngcontent-%COMP%]{color:#a4b0c3}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars[_ngcontent-%COMP%]   .rating-icon[_ngcontent-%COMP%]{width:16px;height:15px;margin-right:5px;fill:#fd0}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .stars[_ngcontent-%COMP%]   .rating-count[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 5px 0 0;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;color:#fd0}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .rating[_ngcontent-%COMP%]   .review-count[_ngcontent-%COMP%]{color:#41a1d9;font-family:LatoWeb,sans-serif;font-weight:inherit;text-decoration:none;-webkit-user-select:none;user-select:none;margin:0;font-size:14px;line-height:18px}.headers-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .school-participants[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px}.headers-details[_ngcontent-%COMP%]   .info.credit[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:flex-start;margin:0}.headers-details[_ngcontent-%COMP%]   .info.credit[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.headers-details[_ngcontent-%COMP%]   .info.credit[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:22px;line-height:26px}.headers-details[_ngcontent-%COMP%]   .info.credit[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#a4b0c3;font-size:16px;line-height:19px}.headers-details[_ngcontent-%COMP%]   .info.trial[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:flex-start;gap:5px}.headers-details[_ngcontent-%COMP%]   .info.trial[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.headers-details[_ngcontent-%COMP%]   .info.trial[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:22px;line-height:26px}.headers-details[_ngcontent-%COMP%]   .info.trial[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#a4b0c3;font-size:16px;line-height:19px}.headers-details.mobile[_ngcontent-%COMP%]{width:100%;justify-content:flex-start}.headers-details.mobile[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{margin-top:0}.headers-details.mobile[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{margin-bottom:5px}.headers-details.no-steps[_ngcontent-%COMP%]{align-items:center;justify-content:space-between}.headers-details.no-steps[_ngcontent-%COMP%]   .left-info[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center}.headers-details.no-steps[_ngcontent-%COMP%]   .right-info[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:16px;line-height:20px;text-align:right;margin-bottom:5px}.headers-details.no-steps[_ngcontent-%COMP%]   .right-info[_ngcontent-%COMP%]   .amount-holder[_ngcontent-%COMP%]{text-align:right;color:#41a1d9}.headers-details.no-steps[_ngcontent-%COMP%]   .right-info[_ngcontent-%COMP%]   .amount-holder[_ngcontent-%COMP%]   .amount[_ngcontent-%COMP%]{font-size:24px;line-height:29px}.headers-details.no-steps[_ngcontent-%COMP%]   .right-info[_ngcontent-%COMP%]   .amount-holder[_ngcontent-%COMP%]   .sup-amount[_ngcontent-%COMP%]{font-size:14px;line-height:17px}"]
      });
    }
  }
  return PlansHeaderDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlansHeaderDetailsModule = /*#__PURE__*/(() => {
  class PlansHeaderDetailsModule {
    static {
      this.ɵfac = function PlansHeaderDetailsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlansHeaderDetailsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PlansHeaderDetailsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, OnUiCoverModule, TranslateModule]
      });
    }
  }
  return PlansHeaderDetailsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AddCardHeaderDetailsComponent = /*#__PURE__*/(() => {
  class AddCardHeaderDetailsComponent extends ChangableComponent {
    constructor(screenService, deviceService, cdr) {
      super(cdr);
      this.screenService = screenService;
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.statsRating = 0;
      this.statsReviewsCount = 0;
      this.statsStudentsCount = 0;
    }
    ngOnInit() {}
    screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    get title() {
      return 'profile-form.card.title';
    }
    static {
      this.ɵfac = function AddCardHeaderDetailsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddCardHeaderDetailsComponent)(i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddCardHeaderDetailsComponent,
        selectors: [["app-add-card-header-details"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 4,
        consts: [[1, "headers-details", 3, "ngClass"], [1, "info"], [1, "name"]],
        template: function AddCardHeaderDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.screenClasses());
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, ctx.title));
          }
        },
        dependencies: [i2.NgClass, i3.TranslatePipe],
        styles: [_c18]
      });
    }
  }
  return AddCardHeaderDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AddCardHeaderDetailsModule = /*#__PURE__*/(() => {
  class AddCardHeaderDetailsModule {
    static {
      this.ɵfac = function AddCardHeaderDetailsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddCardHeaderDetailsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AddCardHeaderDetailsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, OnUiCoverModule, TranslateModule]
      });
    }
  }
  return AddCardHeaderDetailsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Мастер для добавления карты */
let AddCardWizardDialogComponent = /*#__PURE__*/(() => {
  class AddCardWizardDialogComponent extends AbstractCheckoutWizard {
    constructor(profileService, contextService, deviceService, injector, cdr, platform, billingV2Service, merchantService) {
      super(injector, cdr);
      this.profileService = profileService;
      this.contextService = contextService;
      this.deviceService = deviceService;
      this.injector = injector;
      this.cdr = cdr;
      this.platform = platform;
      this.billingV2Service = billingV2Service;
      this.merchantService = merchantService;
      this.closed = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.errorDescription = '';
      this.screen = 'frame';
    }
    ngOnInit() {
      super.ngOnInit();
      this.contextService.me$.pipe(filter$1(me => !!me), map$1(me => {
        this._me = me;
        this.getMerchants();
        return me;
      }), mergeMap(me => forkJoin([this.profileService.getSettings(me?.id)])), takeUntil$1(this.destroyed$)).subscribe(([settings]) => {
        this._settings = settings;
        this.setupPaymentWidget();
        this.detectChanges();
      });
    }
    onClose() {
      this.closed.emit(true);
    }
    /** Инициализация шагов мастера */
    initWizardSteps() {
      this.steps.addStep(new StepByStepWizardStep({
        id: 'payment',
        title: 'payment-checkout-wizard.steps.user-service.payment',
        context: this,
        checks: [],
        visible: true,
        active: false
      }));
      this.cdr.detectChanges();
    }
    /** Настройка шагов мастера под набор входных параметров */
    setupWizardSteps() {
      this.steps.goStep('payment');
      this.activateView('payment');
      this.screen = 'frame';
      /** @see onLoadMeetingDone */
    }
    /** Выполнить обработку по активации шага мастера */
    onStepActivated() {
      /* не требуется */
    }
    onLoadMeetingDone() {
      /* не требуется */
    }
    getMerchants() {
      this.billingV2Service.getMerchants().pipe(takeUntil$1(this.destroyed$)).subscribe(merchants => {
        this.merchant = merchants.find(merchant => merchant.id === this.providerId);
        this.detectChanges();
      });
    }
    /** Настройка данных для проведения платежа */
    setupPaymentWidget() {
      this.sendData = {
        email: this._settings?.email,
        phone: null,
        contractorId: null,
        providerId: this.providerId,
        countryCode: this._me?.country.alpha2Code,
        firstName: this._me?.first_name,
        lastName: this._me?.last_name
      };
      this.billingV2Service.addCard(this.sendData).pipe(takeUntil$1(this.destroyed$)).subscribe(payment => {
        switch (payment.status) {
          case BillingCorePaymentStatusEnum.INTENT:
            // Ручная оплата у мерчанта
            this.payment = payment;
            this.setTimeout(() => this.merchantService.pay(), 500);
            break;
          case BillingCorePaymentStatusEnum.SUCCEEDED:
            // Сразу оплачен
            this.onSuccess();
            break;
        }
        this.detectChanges();
      }, error => {
        this.errorDescription = error.error ? error.error.message : JSON.stringify(error);
        this.screen = 'fail';
        this.detectChanges();
      });
    }
    onSuccess() {
      this.screen = 'success';
      this.detectChanges();
      this.setTimeout(() => {
        this.onClose();
      }, 5000);
    }
    onFail(err) {
      this.screen = 'fail';
      this.errorDescription = err.message;
      this.detectChanges();
    }
    static {
      this.ɵfac = function AddCardWizardDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddCardWizardDialogComponent)(i0.ɵɵdirectiveInject(AbstractProfileService), i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService), i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(PaymentWidgetMerchantProcessingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddCardWizardDialogComponent,
        selectors: [["app-add-card-wizard-dialog"]],
        inputs: {
          providerId: "providerId"
        },
        outputs: {
          closed: "closed"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 2,
        consts: [["contentRef", ""], ["successRef", ""], ["failedRef", ""], [3, "canClose", "closed", 4, "ngIf"], [3, "titleVisible", "withCloseButton", "customTitle", "closed", 4, "ngIf"], [3, "closed", "canClose"], [3, "ngTemplateOutlet"], [3, "closed", "titleVisible", "withCloseButton", "customTitle"], [1, "checkout-wizard-wrap"], [3, "steps", "showHeader", "showFooter"], ["header-details", ""], ["content", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "ngIf"], [1, "hint-title"], [1, "hint-description"], ["class", "processing-wrapper", 4, "ngIf"], [3, "payment", "isAccountPayment", "merchant", "succeed", "failed", 4, "ngIf"], [1, "processing-wrapper"], [1, "processing"], [3, "succeed", "failed", "payment", "isAccountPayment", "merchant"], [1, "finish-success"], [1, "title"], ["width", "98", "height", "98", "viewBox", "0 0 98 98", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "icon"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#87D37C"], ["d", "M74.7524 38.2306L47.0937 65.7585C46.2639 66.5843 45.1747 67 44.0854 67C42.9962 67 41.9069 66.5843 41.0772 65.7585L27.2482 51.9945C25.5839 50.3389 25.5839 47.6619 27.2482 46.0063C28.9116 44.3498 31.6005 44.3498 33.2647 46.0063L44.0854 56.7761L68.7359 32.2423C70.3993 30.5859 73.0882 30.5859 74.7524 32.2423C76.4159 33.898 76.4159 36.5741 74.7524 38.2306Z", "fill", "#FAFAFA"], [1, "finish-fail"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#E86F79"], ["x", "29", "y", "35", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-45 29 35)", "fill", "white"], ["x", "35", "y", "70", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-135 35 70)", "fill", "white"], [1, "description"]],
        template: function AddCardWizardDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, AddCardWizardDialogComponent_app_modal_0_Template, 3, 2, "app-modal", 3)(1, AddCardWizardDialogComponent_app_mobile_modal_1_Template, 5, 6, "app-mobile-modal", 4)(2, AddCardWizardDialogComponent_ng_template_2_Template, 8, 7, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, AddCardWizardDialogComponent_ng_template_4_Template, 7, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, AddCardWizardDialogComponent_ng_template_6_Template, 10, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.deviceService.isDesktop());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.deviceService.isDesktop());
          }
        },
        dependencies: [i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, ModalComponent, ModalBodyComponent, MobileModalComponent, MobileModalBodyComponent, StepByStepWizardComponent, AddCardHeaderDetailsComponent, PaymentWidgetMerchantProcessingComponent, Spinner2Component, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.step-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 20px;font-size:18px;line-height:24px;display:flex;justify-content:space-between;align-items:center}.tinkoff-frame[_ngcontent-%COMP%]{width:100%;min-height:550px;border-radius:10px}.tinkoff-frame.mobile[_ngcontent-%COMP%]{width:100%}.finish-success[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;flex:1;min-height:300px;width:100%}.finish-success[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 30px;font-size:24px;line-height:30px}.finish-success[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:98px;height:98px}.finish-success[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:20px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;text-align:center}.processing-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;transform:translateY(50%);margin-top:50px;display:flex;justify-content:center;align-items:center;flex-direction:column}.processing-wrapper[_ngcontent-%COMP%]   spinner2[_ngcontent-%COMP%]{width:100%}.processing-wrapper[_ngcontent-%COMP%]   .processing[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;text-align:center;font-size:24px;line-height:24px;width:100%}.hint-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 10px;font-size:22px;line-height:26px;text-align:center}.hint-description[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;font-size:16px;line-height:24px;text-align:center;max-width:500px;margin:0 auto}.hint-description.mobile[_ngcontent-%COMP%]{margin:0 auto 20px}"],
        changeDetection: 0
      });
    }
  }
  return AddCardWizardDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Мастер покупки тарифных планов */
let PlansCheckoutWizardDialogComponent = /*#__PURE__*/(() => {
  class PlansCheckoutWizardDialogComponent extends AbstractCheckoutWizard {
    set plan(plan) {
      this._plan = plan;
      this.activePlan = plan;
    }
    get plan() {
      return this._plan;
    }
    set checkoutInfo(value) {
      this._checkoutInfo = value;
    }
    get checkoutInfo() {
      return this._checkoutInfo;
    }
    constructor(userService, billingV2Service, profileService, injector, cdr, store, billingService, deviceService) {
      super(injector, cdr);
      this.userService = userService;
      this.billingV2Service = billingV2Service;
      this.profileService = profileService;
      this.injector = injector;
      this.cdr = cdr;
      this.store = store;
      this.billingService = billingService;
      this.deviceService = deviceService;
      this.closed = new EventEmitter();
      this.succeed = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.creditsAmountValue = null;
      this.userHavePaymentMethods = null;
      this.payClicked = false;
      this.openAddAccountModal = false;
      this.ngDestroyed = new Subject();
      this.currency_id = CurrencyEnum.usd;
      this._isCheckout = false;
    }
    ngOnInit() {
      super.ngOnInit();
      this.userService.me$.pipe(takeUntil$1(this.destroyed$)).subscribe(me => {
        this.currency_id = me.currency_id;
        this._me = me;
        this.getExchangeRate();
        this.prepareCheckoutInfo();
      });
      this.billingService.getRecommendedPlan().pipe(takeUntil$1(this.ngDestroyed)).subscribe(recommended => {
        this.recommendedPlan = recommended;
        this.detectChanges();
      });
      this.getUserPaymentMethods();
    }
    onClose() {
      this.closed.emit(true);
    }
    /** Инициализация шагов мастера */
    initWizardSteps() {
      this.steps.addStep(new StepByStepWizardStep({
        id: 'payment',
        title: 'payment-checkout-wizard.steps.user-service.payment',
        context: this,
        checks: [],
        visible: true,
        active: false
      }));
      this.cdr.detectChanges();
    }
    /** Настройка шагов мастера под набор входных параметров */
    setupWizardSteps() {
      this.setupPaymentWidget();
      this.steps.goStep('payment');
    }
    /** Настройка данных для проведения платежа */
    setupPaymentWidget() {
      if (this._isCheckout) {
        return;
      }
      this.paymentWidgetService.payAmount$.pipe(tap$1(totalAmount => {
        this.totalAmount = totalAmount;
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    /** Выполнить обработку по активации шага мастера */
    onStepActivated() {}
    onPaymentSucceed() {
      super.onPaymentSucceed();
      this.succeed.emit(true);
      this.onClose();
    }
    getExchangeRate() {
      this.billingService.getExchangeRate(CurrencyEnum.credits, this.currency_id).pipe(takeUntil$1(this.ngDestroyed)).subscribe(exchangeRate => {
        this.exchangeRate = exchangeRate;
        this.onAmountChange();
      });
    }
    onAmountChange() {
      this.currencyAmountValue = 0;
      if (this.exchangeRate) {
        this.currencyAmountValue = this.exchangeRate.rate * this.creditsAmountValue || null;
      }
      this.detectChanges();
    }
    formatCurrencyAmount(amount) {
      if (amount <= 0) {
        return '?';
      }
      return this.billingService.formatCurrencyAmount({
        amount,
        currency_id: this.currency_id
      });
    }
    ngAfterViewInit() {}
    prepareCheckoutInfo() {
      this.profileService.getSettings(this._me.id).pipe(tap$1(userSettings => {
        this._isCheckout = true;
        this.paymentOptions = {
          first_name: this._me.first_name,
          last_name: this._me.last_name,
          email: userSettings.email,
          phone: userSettings.mobile_phone,
          country: this._me.country?.alpha2Code,
          order_id: String(this.checkoutInfo.model.billing_order_id),
          charge_id: [String(this.checkoutInfo.model.billing_charge_id)]
        };
        this.detectChanges();
      }), catchError$1(err => {
        this.errorMessage = err.message;
        this.activateView('error');
        console.error(err);
        return throwError(err);
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    getUserPaymentMethods() {
      this.billingV2Service.getAccounts().pipe(tap$1(accounts => {
        this.userHavePaymentMethods = accounts.length > 0;
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    onStartPayment() {
      this.payClicked = true;
      super.onStartPayment();
      this.detectChanges();
    }
    onAddAccount(providerId) {
      this.openAddAccountModal = true;
      this.addAccountProviderId = providerId;
    }
    onCloseAddAccount() {
      this.openAddAccountModal = false;
      this.afterAddAccountNeedUpdate = Date.now();
      this.detectChanges();
    }
    static {
      this.ɵfac = function PlansCheckoutWizardDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlansCheckoutWizardDialogComponent)(i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(AbstractProfileService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$1.Store), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PlansCheckoutWizardDialogComponent,
        selectors: [["app-plans-checkout-wizard-dialog"]],
        inputs: {
          plan: "plan",
          checkoutInfo: "checkoutInfo"
        },
        outputs: {
          closed: "closed",
          succeed: "succeed"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 3,
        consts: [["contentRef", ""], [3, "canClose", "closed", 4, "ngIf"], [3, "titleVisible", "withCloseButton", "customTitle", "closed", 4, "ngIf"], [3, "providerId", "closed", 4, "ngIf"], [3, "closed", "canClose"], [3, "ngTemplateOutlet"], [3, "closed", "titleVisible", "withCloseButton", "customTitle"], [1, "checkout-wizard-wrap"], [3, "steps", "showHeader", "showFooter"], ["header-details", ""], [3, "plan"], ["content", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], ["style", "font-size: 8px;", 4, "ngIf"], ["footer-details", ""], [1, "plan-footer"], ["footer-actions", ""], [3, "state", "disabled", "startLabel", "closeLabel", "cancelLabel", "retryLabel", "start", "retry", "cancel", 4, "ngIf"], [3, "options", "payClicked", "needUpdate", "configured", "succeed", "failed", "processing", "addAccount", 4, "ngIf"], [3, "configured", "succeed", "failed", "processing", "addAccount", "options", "payClicked", "needUpdate"], [4, "ngIf"], [2, "font-size", "8px"], [3, "start", "retry", "cancel", "state", "disabled", "startLabel", "closeLabel", "cancelLabel", "retryLabel"], [3, "closed", "providerId"]],
        template: function PlansCheckoutWizardDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PlansCheckoutWizardDialogComponent_app_modal_0_Template, 3, 2, "app-modal", 1)(1, PlansCheckoutWizardDialogComponent_app_mobile_modal_1_Template, 5, 6, "app-mobile-modal", 2)(2, PlansCheckoutWizardDialogComponent_ng_template_2_Template, 13, 11, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, PlansCheckoutWizardDialogComponent_app_add_card_wizard_dialog_4_Template, 1, 1, "app-add-card-wizard-dialog", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.deviceService.isDesktop());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.deviceService.isDesktop());
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.openAddAccountModal);
          }
        },
        dependencies: [i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, ModalComponent, ModalBodyComponent, MobileModalComponent, MobileModalBodyComponent, StepByStepWizardComponent, PaymentWidgetComponent, PayButtonComponent, PlansHeaderDetailsComponent, AddCardWizardDialogComponent, i2.AsyncPipe, i2.JsonPipe, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.step-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 20px;font-size:18px;line-height:24px;display:flex;justify-content:space-between;align-items:center}.content[_ngcontent-%COMP%]{display:flex;padding:20px 30px}.content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{background:url(/assets/images/plan-activate-form.jpg) no-repeat center;background-size:cover;border-radius:10px;height:242px;margin-right:30px;width:287px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .info-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:26px;margin:0 0 14px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;flex-direction:column;padding:0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]{display:flex;margin-bottom:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;height:12px;width:20px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]{display:flex;flex:1 1 10px;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;max-width:350px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]{align-items:center;background:#feed7d;border-radius:20px;display:flex;height:27px;margin:10px 0 0 -20px;padding:0 10px;width:fit-content}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-value[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;white-space:nowrap}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .plan-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .advantage-text[_ngcontent-%COMP%]{color:#6d7381;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]{padding-top:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#a4b0c3;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{color:#65c558}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]{display:flex}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancellation-label[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancellation-label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;margin:0 25px 15px 0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%]{align-items:center;display:flex}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%]   .plan-title[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%]   .plan-title[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px;margin:0 0 0 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%]{color:#e86f79;font-size:16px;line-height:19px;margin:0 0 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits.bonus[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits.bonus[_ngcontent-%COMP%]{color:#1e252b;text-decoration-line:none}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits.fire[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits.fire[_ngcontent-%COMP%]{text-decoration-line:none}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%]   .line-through[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%]   .line-through[_ngcontent-%COMP%]{text-decoration-line:line-through}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]{padding:0 0 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]   .alert-text[_ngcontent-%COMP%]{color:#e86f79;font-size:12px;line-height:14px;width:100%}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]   .total-credit[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:19px}.content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:0 20px 0 0}.content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:19px;margin:0 0 17px;width:375px}.content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .comment-wrap[_ngcontent-%COMP%]{width:366px}.actions[_ngcontent-%COMP%]{border-top:1px solid #EEEEEE;display:flex;padding:30px;justify-content:space-between;gap:10px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{display:flex}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]{border:1px solid #EEEEEE;background:#fff;box-sizing:border-box;border-radius:10px;color:#1e252b;cursor:pointer;outline:none;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;width:126px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]::placeholder{color:#ccc}"],
        changeDetection: 0
      });
    }
  }
  return PlansCheckoutWizardDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FinancePlanActivateFormV2Component = /*#__PURE__*/(() => {
  class FinancePlanActivateFormV2Component extends ChangableComponent {
    set plan(plan) {
      this._plan = plan;
      if (plan.details.id === 'monthly-free' || plan.details.price === 0) {
        this.isFreePlan = true;
        this.detectChanges();
      }
      this.formatCurrentPrice(this._plan.price_tier_id);
      this.getActivePlan();
    }
    get plan() {
      return this._plan;
    }
    constructor(deviceService, billingService, billingV2Service, websocketService, userService, cdr) {
      super(cdr);
      this.deviceService = deviceService;
      this.billingService = billingService;
      this.billingV2Service = billingV2Service;
      this.websocketService = websocketService;
      this.userService = userService;
      this.cdr = cdr;
      this.displayMode = 'activate';
      this.finished = new EventEmitter();
      this.closed = new EventEmitter();
      this.svgSetIcon = IconsService.svgsetIconUrl;
      this.planPeriodEnum = PlanPeriodEnum;
      this.billingOperation = null;
      this.accountPlan = null;
      this.finalStep = false;
      this.isFreePlan = false;
      this._activePlan = null;
    }
    ngOnInit() {
      this.init();
      this.userService.me$.pipe(takeUntil$1(this.destroyed$)).subscribe(me => {
        this.me = me;
        this.myCurrencyCode = Object.keys(CurrencyEnum)[Object.values(CurrencyEnum).indexOf(me.currency_id)].toUpperCase();
        if (this.myCurrencyCode === 'RUR') {
          this.myCurrencyCode = 'RUB';
        }
        this.formatCurrentPrice(this.plan.price_tier_id);
        this.init();
      });
      /**
       * Реконнект к веб-сокетам
       */
      this.websocketService.status$.pipe(debounceTime$1(1000)).pipe(takeUntil$1(this.destroyed$)).subscribe(isOnline => {
        if (isOnline) {
          console.log('FinancePlanActivateFormComponent -> websocketService.status$ = online');
        }
      });
      this.websocketService.on('operation').pipe(tap(operation => {
        console.log('FinancePlanActivateFormComponent::operation', operation);
        this.billingOperation.status = operation.status;
        this.detectChanges();
      }), debounceTime$1(1000)).pipe(takeUntil$1(this.destroyed$)).subscribe();
      this.getPriceTier(this._plan.price_tier_id).pipe(takeUntil$1(this.destroyed$)).subscribe(res => {
        this.billingV2Service.getCurrencyRate(res.currency_id).pipe(takeUntil$1(this.destroyed$)).subscribe(rate => {
          this.currencyRate = rate;
          this.formatCurrentPrice(this.plan.price_tier_id);
        });
      });
    }
    getActivePlan() {
      this.billingService.getActivePlan().pipe(takeUntil$1(this.destroyed$)).subscribe(plan => {
        this._activePlan = plan;
        this.detectChanges();
      });
    }
    get activePlan() {
      return this._activePlan;
    }
    get planExpired() {
      const plan = new BillingPlan(this._plan);
      return plan.getNextPaymentDate();
    }
    get isLimitedVersion() {
      return this.tenant === TenantEnum.onclass_me;
    }
    getPriceTier(price_tier_id) {
      return this.billingService.getPriceTier$(price_tier_id);
    }
    formatCurrencyAmount(amount) {
      if (!this.me || !this.currencyRate) {
        return;
      }
      let currencyRate = 1;
      if (this.currencyRate.find(r => r.currency.toUpperCase() === this.myCurrencyCode.toUpperCase())) {
        currencyRate = Number(this.currencyRate.find(r => r.currency.toUpperCase() === this.myCurrencyCode.toUpperCase())?.rate);
      }
      return this.billingService.formatCurrencyAmount({
        amount: Number(amount) * Number(currencyRate),
        currency_id: this.me.currency_id
      });
    }
    formatCurrentPrice(price_tier_id) {
      if (!this.me || !this.currencyRate) {
        return;
      }
      if (this.plan.is_trial) {
        this.currentPrice = this.formatCurrencyAmount(0);
        this.detectChanges();
      } else {
        this.getPriceTier(price_tier_id).pipe(takeUntil$1(this.destroyed$)).subscribe(res => {
          let currencyRate = 1;
          if (this.currencyRate.find(r => r.currency.toUpperCase() === this.myCurrencyCode.toUpperCase())) {
            currencyRate = Number(this.currencyRate.find(r => r.currency.toUpperCase() === this.myCurrencyCode.toUpperCase())?.rate);
          }
          this.currentPrice = this.billingService.formatCurrencyAmount({
            amount: Number(res.amount) * Number(currencyRate),
            currency_id: this.me.currency_id
          });
          this.detectChanges();
        });
      }
    }
    onOpenPaymentTemplate() {
      if (this.openPaymentTemplate) {
        return;
      }
      this.billingService.switchToPlanV2({
        plan_id: this.plan.id
      }).pipe(takeUntil$1(this.destroyed$)).subscribe(response => {
        this.switchOperation = response;
        this.openPaymentTemplate = true;
        this.detectChanges();
      });
    }
    replaceValues(line) {
      const begin = '{{ ';
      const end = ' }}';
      if (!this._plan || !this._plan.details) {
        return line;
      }
      let bracedWord = Parser.getBracedWord(line, begin, end).word;
      const details = this._plan.details;
      while (bracedWord) {
        const replace =
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        details[bracedWord] === undefined ? bracedWord : `<span class="bold">${details[bracedWord].toString()}</span>`;
        line = Parser.replaceBracedWord(line, bracedWord, replace, begin, end);
        bracedWord = Parser.getBracedWord(line, begin, end).word;
      }
      return line;
    }
    onCancelPlan() {
      this.loaded = false;
      this.billingService.cancelPlanV2().pipe(takeUntil$1(this.destroyed$)).subscribe(response => {
        this.accountPlan = response.model;
        this.openPaymentTemplate = true;
        this.finalStep = true;
        this.loaded = true;
        this.finished.emit(true);
        this.detectChanges();
      });
    }
    getTotalCredits() {
      return this.creditBalances[AccountBalanceTypeEnum.gifts] + this.creditBalances[AccountBalanceTypeEnum.paid] + this.creditBalances[AccountBalanceTypeEnum.plan_grants];
    }
    getCreditsBySource(source) {
      switch (source) {
        case 'bonus':
          return this.creditBalances[AccountBalanceTypeEnum.gifts];
        case 'purchased':
          return this.creditBalances[AccountBalanceTypeEnum.paid];
        case 'subscription':
          return this.creditBalances[AccountBalanceTypeEnum.plan_grants];
        case 'total_left':
          return this.creditBalances[AccountBalanceTypeEnum.gifts];
        default:
          return 0;
      }
    }
    init() {
      if (this.displayMode === 'activate') {
        return;
      }
      this.userService.me$.pipe(takeUntil$1(this.destroyed$)).subscribe(me => {
        this.userName = me.first_name;
      });
      this.billingService.getUserBalancesForCurrency(CurrencyEnum.credits).pipe(takeUntil$1(this.destroyed$)).subscribe(creditBalances => {
        this.creditBalances = creditBalances;
        this.detectDataLoaded();
      });
      this.billingService.getDefaultPlan().pipe(takeUntil$1(this.destroyed$)).subscribe(defaultPlan => {
        this.defaultPlan = defaultPlan;
        this.detectDataLoaded();
      });
    }
    detectDataLoaded() {
      if (this.displayMode === 'activate') {
        return;
      }
      this.loaded = !!this.creditBalances && (!!this.defaultPlan || this.isLimitedVersion);
      if (this.loaded) {
        this.detectChanges();
      }
    }
    closeModal() {
      this.closed.emit(true);
    }
    onSuccess() {
      this.finished.emit(true);
    }
    static {
      this.ɵfac = function FinancePlanActivateFormV2Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FinancePlanActivateFormV2Component)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(AbstractWebsocketService), i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FinancePlanActivateFormV2Component,
        selectors: [["app-finance-plan-activate-form-v2"]],
        inputs: {
          plan: "plan",
          displayMode: "displayMode",
          tenant: "tenant"
        },
        outputs: {
          finished: "finished",
          closed: "closed"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 12,
        vars: 2,
        consts: [["header", ""], ["content", ""], ["payment", ""], ["actions", ""], ["paymentActions", ""], ["paymentTemplate", ""], ["cancel", ""], [3, "canClose", "closed", 4, "ngIf"], [3, "titleVisible", "withCloseButton", "customTitle", "closed", 4, "ngIf"], [3, "closed", "canClose"], [1, "finance-plan-activate-form"], [4, "ngTemplateOutlet"], [3, "ngIf", "ngIfElse"], [3, "closed", "titleVisible", "withCloseButton", "customTitle"], [1, "header"], [1, "left", 3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "right", 3, "ngSwitch"], [1, "pay-info"], ["width", "61", "height", "61", "viewBox", "0 0 61 61"], [1, "plan-info", "cancel"], [1, "title", "bold"], [1, "subtitle", "normal"], [1, "plan-info"], [1, "label", "normal"], [1, "activation-text", "bold"], ["class", "price-wrap", 4, "ngIf"], [1, "price-wrap"], ["class", "old-price normal", 4, "ngIf"], [1, "price", "bold"], [1, "period"], [1, "old-price", "normal"], [3, "ngSwitch"], [1, "info-wrap"], ["class", "form-wrap cancel", 4, "ngIf"], [1, "form-wrap", "cancel"], [1, "subtitle"], [1, "update-value"], [1, "text", "normal"], [1, "img"], ["height", "200px", "width", "100%"], [1, "cancel-top"], [1, "credits-after-canceling"], [1, "cancellation-label", "bold"], [1, "cancel-credits", "fire"], [1, "cancel-credits", "normal"], [1, "info-header"], [1, "info-label", "bold"], [1, "properties-wrap"], ["class", "properties-item", 4, "ngFor", "ngForOf"], [1, "info-bottom"], [1, "properties-item"], [1, "icon-wrap"], ["width", "12", "height", "9", "viewBox", "0 0 12 9"], [1, "label-wrap"], [1, "label", "normal", 3, "innerHTML"], [3, "ngIf"], [1, "side-wrap"], [1, "side-value", "bold"], [1, "side-text", "normal"], [1, "finish-success"], ["width", "98", "height", "98", "viewBox", "0 0 98 98", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "icon"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#87D37C"], ["d", "M74.7524 38.2306L47.0937 65.7585C46.2639 66.5843 45.1747 67 44.0854 67C42.9962 67 41.9069 66.5843 41.0772 65.7585L27.2482 51.9945C25.5839 50.3389 25.5839 47.6619 27.2482 46.0063C28.9116 44.3498 31.6005 44.3498 33.2647 46.0063L44.0854 56.7761L68.7359 32.2423C70.3993 30.5859 73.0882 30.5859 74.7524 32.2423C76.4159 33.898 76.4159 36.5741 74.7524 38.2306Z", "fill", "#FAFAFA"], [1, "finish-fail"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#E86F79"], ["x", "29", "y", "35", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-45 29 35)", "fill", "white"], ["x", "35", "y", "70", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-135 35 70)", "fill", "white"], [1, "payment"], [3, "succeed", "closed", "plan", "checkoutInfo"], [1, "actions"], ["class", "cancel-plan-footer", 4, "ngIf"], ["label", "lingo2-forms.subscription-plans.forms.cancel-subscription", 1, "danger", 3, "onclick", "disabled"], [1, "cancel-plan-footer"], [1, "plan-after-cancellation"], [1, "plan-title", "bold"], [1, "activate-time"], [1, "activate-plan-footer"], ["label", "meetings.wizard.next", "class", "primary", 3, "onclick", 4, "ngIf"], ["label", "meetings.wizard.next", "class", "primary", 3, "disabled", "onclick", 4, "ngIf"], ["label", "meetings.wizard.next", 1, "primary", 3, "onclick"], ["label", "meetings.wizard.next", 1, "primary", 3, "onclick", "disabled"], ["label", "lingo2-forms.subscription-plans.forms.close", 1, "secondary", 3, "onclick", "hidden"]],
        template: function FinancePlanActivateFormV2Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FinancePlanActivateFormV2Component_app_modal_0_Template, 7, 6, "app-modal", 7)(1, FinancePlanActivateFormV2Component_app_mobile_modal_1_Template, 8, 10, "app-mobile-modal", 8)(2, FinancePlanActivateFormV2Component_ng_template_2_Template, 8, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, FinancePlanActivateFormV2Component_ng_template_4_Template, 8, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, FinancePlanActivateFormV2Component_ng_template_6_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, FinancePlanActivateFormV2Component_ng_template_8_Template, 4, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(10, FinancePlanActivateFormV2Component_ng_template_10_Template, 3, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.deviceService.isDesktop());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.deviceService.isDesktop());
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, i2.NgSwitchDefault, LoadingLineComponent, i16.OnUiButtonComponent, MobileModalComponent, MobileModalBodyComponent, ModalComponent, ModalBodyComponent, PlansCheckoutWizardDialogComponent, i2.DatePipe, i3.TranslatePipe, i6.FormatPipe],
        styles: ["@charset \"UTF-8\";.finance-plan-activate-form[_ngcontent-%COMP%]{margin:-30px}.finance-plan-activate-form[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{background:#fff;border:1px solid transparent;box-sizing:border-box;border-radius:10px;cursor:pointer;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;min-width:126px}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.apply[_ngcontent-%COMP%]{color:#41a1d9}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.apply.apply-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.payment[_ngcontent-%COMP%]{background:#87d37c;border:1px solid #87D37C;color:#fff}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.activate[_ngcontent-%COMP%]{border:1px solid #87D37C;color:#87d37c}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.cancel[_ngcontent-%COMP%]{background:#e86f79;border:1px solid #E86F79;color:#fff}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.close[_ngcontent-%COMP%]{background:#5ab3e4;border:1px solid #5AB3E4;color:#fff;margin-left:auto}.finance-plan-activate-form[_ngcontent-%COMP%]   .action.disabled[_ngcontent-%COMP%]{opacity:.5;cursor:unset}.finance-plan-activate-form[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]   [hidden][_ngcontent-%COMP%]{display:none}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:0}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background:#fff;box-shadow:0 3px 5px #00000014;flex-direction:column;padding:15px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .activation-text[_ngcontent-%COMP%]{line-height:20px;margin:0}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{flex:1 1 10px;flex-direction:column;padding:15px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{height:231px;max-width:345px;margin:0 0 10px;width:100%}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{margin-bottom:45px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{height:40px;width:100%}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{align-items:flex-end;flex-direction:column}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]{margin-bottom:10px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]{margin:0}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%], .finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .comment-wrap[_ngcontent-%COMP%]{width:100%}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]{flex-direction:column}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%], .finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]{padding-top:20px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]{padding:0 0 5px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]   .alert-text[_ngcontent-%COMP%]{width:100%}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{background:#fff;flex-direction:column;padding:15px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{margin-bottom:15px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{height:40px}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   [hidden][_ngcontent-%COMP%]{display:none}.finance-plan-activate-form.mobile[_ngcontent-%COMP%]     on-ui-button .button{width:100%}.header[_ngcontent-%COMP%]{border-bottom:1px solid #EEEEEE;display:flex;justify-content:space-between;padding:30px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{display:flex}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-left:20px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:22px;line-height:26px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#a4b0c3;font-size:16px;line-height:19px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info.cancel[_ngcontent-%COMP%]{justify-content:center}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info.cancel[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info.cancel[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:24px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info.cancel[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#6d7381;font-size:14px;line-height:20px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{display:flex;align-items:center}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]{align-items:flex-end;display:flex;flex-direction:column}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .activation-text[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:24px;margin-bottom:4px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]{align-items:baseline;display:flex}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .old-price[_ngcontent-%COMP%]{color:#a4b0c3;font-size:15px;line-height:18px;text-decoration:line-through}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]{font-size:24px;line-height:29px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]   .period[_ngcontent-%COMP%]{font-size:14px;line-height:17px}.finish-success[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]{display:-webkit-box;display:flex;flex-direction:column;justify-content:center;align-items:center;flex:1;padding:30px 0}.finish-success[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:24px;color:#000;margin-top:20px;margin-bottom:10px;line-height:normal}.finish-success[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{font-size:16px;line-height:22px;margin-top:10px;width:350px;color:#6d7381;text-align:center}.finish-success[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:98px;height:98px}.content[_ngcontent-%COMP%]{display:flex;padding:20px 30px}.content.cancel[_ngcontent-%COMP%]{min-height:230px}.content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{background:url(/assets/images/plan-activate-form.jpg) no-repeat center;background-size:cover;border-radius:10px;height:242px;margin-right:30px;width:287px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .info-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:26px;margin:0 0 14px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;flex-direction:column;padding:0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]{display:flex;margin-bottom:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;height:12px;width:20px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]{display:flex;flex:1 1 10px;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;max-width:350px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]{align-items:center;background:#feed7d;border-radius:20px;display:flex;height:27px;margin:10px 0 0 -20px;padding:0 10px;width:fit-content}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-value[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;white-space:nowrap}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .plan-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .advantage-text[_ngcontent-%COMP%]{color:#6d7381;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]{padding-top:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#a4b0c3;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{color:#65c558}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]{display:flex;width:100%;min-width:250px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancellation-label[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancellation-label[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 10px;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%]{align-items:center;display:flex}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%]   .plan-title[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .plan-wrap[_ngcontent-%COMP%]   .plan-title[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px;margin:0 0 0 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 5px;color:#a4b0c3;font-size:14px;line-height:18px;color:#6d7381;line-height:20px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits.fire[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits.fire[_ngcontent-%COMP%]{color:#e86f79}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%]   .line-through[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-top[_ngcontent-%COMP%]   .credits-after-canceling[_ngcontent-%COMP%]   .cancel-credits[_ngcontent-%COMP%]   .line-through[_ngcontent-%COMP%]{text-decoration-line:line-through}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]{padding:0 0 10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]   .alert-text[_ngcontent-%COMP%]{color:#e86f79;font-size:12px;line-height:14px;width:100%}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .cancel-bottom[_ngcontent-%COMP%]   .total-credit[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:19px}.content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:0 20px 0 0}.content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:19px;margin:0 0 17px;width:375px}.content[_ngcontent-%COMP%]   .form-wrap[_ngcontent-%COMP%]   .comment-wrap[_ngcontent-%COMP%]{width:366px}.content[_ngcontent-%COMP%]   .form-wrap.cancel[_ngcontent-%COMP%]{width:100%}.content[_ngcontent-%COMP%]   .form-wrap.cancel[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 10px;font-size:18px;line-height:24px}.content[_ngcontent-%COMP%]   .form-wrap.cancel[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#6d7381;line-height:20px}.actions[_ngcontent-%COMP%]{border-top:1px solid #EEEEEE;display:flex;padding:30px;justify-content:space-between;gap:10px}.actions.limited[_ngcontent-%COMP%]{justify-content:flex-end}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{display:flex}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]{border:1px solid #EEEEEE;background:#fff;box-sizing:border-box;border-radius:10px;color:#1e252b;cursor:pointer;outline:none;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;width:126px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]::placeholder, .actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo.disabled[_ngcontent-%COMP%]{color:#ccc}.cancel-plan-footer[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:flex-start;flex-direction:column;gap:5px}.cancel-plan-footer[_ngcontent-%COMP%]   on-ui-button[_ngcontent-%COMP%]{display:flex;align-items:center}.cancel-plan-footer[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:flex-start;gap:5px}.cancel-plan-footer[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .cancellation-label[_ngcontent-%COMP%], .cancel-plan-footer[_ngcontent-%COMP%]   .plan-after-cancellation[_ngcontent-%COMP%]   .plan-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:18px;line-height:24px}.cancel-plan-footer[_ngcontent-%COMP%]   .activate-time[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#6d7381;line-height:20px}"],
        changeDetection: 0
      });
    }
  }
  return FinancePlanActivateFormV2Component;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileModalModule = /*#__PURE__*/(() => {
  class MobileModalModule {
    static {
      this.ɵfac = function MobileModalModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileModalModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MobileModalModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, IconModule]
      });
    }
  }
  return MobileModalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable max-len */
let AddCardWizardDialogModule = /*#__PURE__*/(() => {
  class AddCardWizardDialogModule {
    static {
      this.ɵfac = function AddCardWizardDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddCardWizardDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AddCardWizardDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CommonModule, TranslateModule, ModalModule, MobileModalModule, StepByStepWizardModule, OnUiButtonModule, PaymentWidgetModule, PayButtonModule, AddCardHeaderDetailsModule, PaymentWidgetMerchantProcessingModule, SpinnersModule, ModalModule, MobileModalModule, StepByStepWizardModule, SpinnersModule, PaymentWidgetMerchantProcessingModule, AddCardHeaderDetailsModule]
      });
    }
  }
  return AddCardWizardDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable max-len */
let PlansCheckoutWizardDialogModule = /*#__PURE__*/(() => {
  class PlansCheckoutWizardDialogModule {
    static {
      this.ɵfac = function PlansCheckoutWizardDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlansCheckoutWizardDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PlansCheckoutWizardDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CommonModule, TranslateModule, ModalModule, MobileModalModule, StepByStepWizardModule, OnUiButtonModule, PaymentWidgetModule, PayButtonModule, ReactiveFormsModule, FormsModule, PlansHeaderDetailsModule, OnUiTextareaModule, SpinnersModule, AddCardWizardDialogModule]
      });
    }
  }
  return PlansCheckoutWizardDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FinancePlanActivateFormV2Module = /*#__PURE__*/(() => {
  class FinancePlanActivateFormV2Module {
    static {
      this.ɵfac = function FinancePlanActivateFormV2Module_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FinancePlanActivateFormV2Module)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FinancePlanActivateFormV2Module
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, FormsModule, PaymentFormUniversalModule, SpinnersModule, RouterModule, DateFnsModule, OnUiTextareaModule, OnUiButtonModule, AgreementTermsFieldModule, MobileModalModule, ModalModule, PlansCheckoutWizardDialogModule]
      });
    }
  }
  return FinancePlanActivateFormV2Module;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FinancePlanBuyCreditsFormComponent = /*#__PURE__*/(() => {
  class FinancePlanBuyCreditsFormComponent extends ChangableComponent {
    set plan(plan) {
      this._plan = plan;
    }
    get plan() {
      return this._plan;
    }
    set creditsAmount(creditsAmount) {
      this.creditsAmountValue = creditsAmount;
      if (creditsAmount) {
        this.inputCreditsDisabled = true;
      }
    }
    constructor(deviceService, cdr, billingService, billingV2Service, userService) {
      super(cdr);
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.billingService = billingService;
      this.billingV2Service = billingV2Service;
      this.userService = userService;
      this.activatePlan = new EventEmitter();
      this.buyCreditsSuccess = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.creditsAmountValue = null;
      this.selectedCard = null;
      this.billingOperation = null;
      this.billingOperationStatusEnum = BillingOperationStatusEnum;
      this.ngDestroyed = new Subject();
      this.currency_id = CurrencyEnum.usd;
    }
    ngOnInit() {
      this.billingService.getRecommendedPlan().pipe(takeUntil(this.ngDestroyed)).subscribe(recommended => {
        this.recommendedPlan = recommended;
        this.detectChanges();
      });
      this.userService.me$.pipe(takeUntil(this.destroyed$), switchMap(me => {
        this.currency_id = me.currency_id;
        this.myCurrencyCode = Object.keys(CurrencyEnum)[Object.values(CurrencyEnum).indexOf(me.currency_id)].toUpperCase();
        if (this.myCurrencyCode === 'RUR') {
          this.myCurrencyCode = 'RUB';
        }
        return this.billingV2Service.getCurrencyRate(this.currency_id);
      })).subscribe(rate => {
        this.exchangeRate = rate.find(r => r.currency.toUpperCase() === this.myCurrencyCode.toUpperCase());
        this.onAmountChange();
      });
    }
    ngAfterViewInit() {
      this.inputCredits.nativeElement.focus();
    }
    onCardSelected(card) {
      this.selectedCard = card;
      this.detectChanges();
    }
    getPriceTier(price_tier_id) {
      return this.billingService.getPriceTier$(price_tier_id);
    }
    formatCurrencyAmount(amount) {
      if (amount <= 0) {
        return '?';
      }
      return this.billingService.formatCurrencyAmount({
        amount,
        currency_id: this.currency_id
      });
    }
    onOpenPaymentTemplate() {
      this.billingService.switchToPlan(this.plan.id, '').pipe(takeUntil(this.ngDestroyed)).subscribe(transaction => {
        this.buyCreditsOperation = transaction;
        this.openPaymentTemplate = true;
        this.detectChanges();
      });
    }
    replaceValues(line) {
      const begin = '{{ ';
      const end = ' }}';
      if (!this._plan || !this._plan.details) {
        return line;
      }
      let bracedWord = Parser.getBracedWord(line, begin, end).word;
      const details = this._plan.details;
      while (bracedWord) {
        const replace =
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        details[bracedWord] === undefined ? bracedWord : `<span class="bold">${details[bracedWord].toString()}</span>`;
        line = Parser.replaceBracedWord(line, bracedWord, replace, begin, end);
        bracedWord = Parser.getBracedWord(line, begin, end).word;
      }
      return line;
    }
    buyCredits() {
      if (!this.creditsAmountValue || !this.consentToPrivacyPolicy || this.openPaymentTemplate) {
        return;
      }
      this.billingService.buyCredits(this.creditsAmountValue).pipe(takeUntil(this.ngDestroyed)).subscribe(transaction => {
        this.buyCreditsOperation = transaction;
        this.openPaymentTemplate = true;
        const success = transaction?.status === BillingOperationStatusEnum.succeed;
        this.buyCreditsSuccess.emit(success);
        this.detectChanges();
      });
    }
    onAmountChange() {
      this.currencyAmountValue = 0;
      let rate = 1;
      if (this.exchangeRate?.rate) {
        rate = Number(this.exchangeRate.rate);
      }
      this.currencyAmountValue = Number(rate) * Number(this.creditsAmountValue) || null;
      this.detectChanges();
    }
    onKeydown(event) {
      return event?.keyCode !== 69 || event?.code !== 'KeyE';
    }
    onActivatePlan() {
      this.activatePlan.emit(true);
      this.detectChanges();
    }
    onBuyCredits() {
      this.billingService.completeOperation(this.buyCreditsOperation.id).pipe(takeUntil(this.destroyed$)).subscribe(operation => {
        this.billingOperation = operation;
        switch (operation.status) {
          case BillingOperationStatusEnum.succeed:
            // Успешное завершение операции
            this.buyCreditsSuccess.emit(true);
            break;
          case BillingOperationStatusEnum.failed:
            // Неуспешное завершение операции
            this.buyCreditsSuccess.emit(false);
            break;
          default:
            // Что-то ещё
            break;
        }
        this.detectChanges();
      });
    }
    diffCredits() {
      return +this.recommendedPlan?.details?.receive_credits_per_month - +this.plan?.details?.receive_credits_per_month;
    }
    diffDiscount() {
      return +this.recommendedPlan?.details?.discount_on_purchase_of_additional_credits - +this.plan?.details?.discount_on_purchase_of_additional_credits;
    }
    static {
      this.ɵfac = function FinancePlanBuyCreditsFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FinancePlanBuyCreditsFormComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(AbstractUserService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FinancePlanBuyCreditsFormComponent,
        selectors: [["app-finance-plan-buy-credits-form"]],
        viewQuery: function FinancePlanBuyCreditsFormComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c20, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputCredits = _t.first);
          }
        },
        inputs: {
          plan: "plan",
          creditsAmount: "creditsAmount"
        },
        outputs: {
          activatePlan: "activatePlan",
          buyCreditsSuccess: "buyCreditsSuccess"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 15,
        vars: 5,
        consts: [["paymentTemplate", ""], ["header", ""], ["content", ""], ["payment", ""], ["actions", ""], ["paymentActions", ""], ["input_credits", ""], ["billingOperationStatus", ""], [1, "finance-plan-buy-credits-form"], [4, "ngTemplateOutlet"], [3, "ngIf", "ngIfElse"], [1, "header"], [1, "left"], ["width", "61", "height", "61", "viewBox", "0 0 61 61"], [1, "plan-info"], [1, "label", "normal"], [1, "title", "bold"], [1, "subtitle", "normal"], [1, "right"], [1, "pay-info"], [1, "activation-text", "normal"], [1, "content"], [1, "img"], [1, "info-wrap"], [1, "info-header"], [3, "ngIf"], [1, "info-bottom"], [1, "pay-info-wrap"], [1, "credit-label", "normal"], ["type", "number", "min", "0", 1, "input-credits", "normal", 3, "ngModelChange", "change", "keydown", "ngModel", "disabled"], [1, "total-pay", "bold"], [1, "value"], [1, "plan-text", "normal"], [1, "bold"], [1, "advantage-text", "normal"], [1, "activate-wrap"], ["label", "lingo2-forms.subscription-plans.forms.action-activate-plan", 1, "secondary", "outline", 3, "onclick"], [1, "payment"], [3, "cardSelected", "transaction"], [1, "finish-success"], ["width", "98", "height", "98", "viewBox", "0 0 98 98", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "icon"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#87D37C"], ["d", "M74.7524 38.2306L47.0937 65.7585C46.2639 66.5843 45.1747 67 44.0854 67C42.9962 67 41.9069 66.5843 41.0772 65.7585L27.2482 51.9945C25.5839 50.3389 25.5839 47.6619 27.2482 46.0063C28.9116 44.3498 31.6005 44.3498 33.2647 46.0063L44.0854 56.7761L68.7359 32.2423C70.3993 30.5859 73.0882 30.5859 74.7524 32.2423C76.4159 33.898 76.4159 36.5741 74.7524 38.2306Z", "fill", "#FAFAFA"], [1, "finish-fail"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#E86F79"], ["x", "29", "y", "35", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-45 29 35)", "fill", "white"], ["x", "35", "y", "70", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-135 35 70)", "fill", "white"], [1, "actions"], [1, "action", "payment", "hidden", "normal"], [3, "valueChange", "value", "agreementText"], ["label", "lingo2-forms.subscription-plans.forms.action-buy-credits", 1, "secondary", 3, "onclick", "disabled"], ["label", "lingo2-forms.subscription-plans.forms.pay", 1, "secondary", 3, "onclick", "disabled"]],
        template: function FinancePlanBuyCreditsFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 8);
            i0.ɵɵtemplate(1, FinancePlanBuyCreditsFormComponent_ng_container_1_Template, 1, 0, "ng-container", 9)(2, FinancePlanBuyCreditsFormComponent_ng_template_2_Template, 2, 2, "ng-template", 10)(3, FinancePlanBuyCreditsFormComponent_ng_template_3_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, FinancePlanBuyCreditsFormComponent_ng_template_5_Template, 19, 14, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(7, FinancePlanBuyCreditsFormComponent_ng_template_7_Template, 17, 10, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(9, FinancePlanBuyCreditsFormComponent_ng_template_9_Template, 3, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(11, FinancePlanBuyCreditsFormComponent_ng_template_11_Template, 9, 16, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(13, FinancePlanBuyCreditsFormComponent_ng_template_13_Template, 2, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const paymentTemplate_r12 = i0.ɵɵreference(4);
            const header_r13 = i0.ɵɵreference(6);
            i0.ɵɵclassProp("mobile", ctx.deviceService.isMobile());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", header_r13);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.openPaymentTemplate)("ngIfElse", paymentTemplate_r12);
          }
        },
        dependencies: [i2.NgIf, i2.NgTemplateOutlet, i4.DefaultValueAccessor, i4.NumberValueAccessor, i4.NgControlStatus, i4.MinValidator, i4.NgModel, PaymentFormUniversalComponent, i16.OnUiButtonComponent, AgreementTermsFieldComponent, i3.TranslatePipe],
        styles: [".finance-plan-buy-credits-form[_ngcontent-%COMP%]{margin:-30px}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{background:#fff;border:1px solid transparent;box-sizing:border-box;border-radius:10px;cursor:pointer;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;transition:all .2s;min-width:126px}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.apply[_ngcontent-%COMP%]{color:#41a1d9}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.payment[_ngcontent-%COMP%]{background:#87d37c;border:1px solid #87D37C;color:#fff}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.activate[_ngcontent-%COMP%]{border:1px solid #87D37C;color:#87d37c}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.cancel[_ngcontent-%COMP%]{background:#e86f79;border:1px solid #E86F79;color:#fff}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.disabled[_ngcontent-%COMP%]{opacity:.5;cursor:unset}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.hidden[_ngcontent-%COMP%]{display:none}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:0}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background:#fff;box-shadow:0 3px 5px #00000014;flex-direction:column;padding:15px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .activation-text[_ngcontent-%COMP%]{line-height:20px;margin:0}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{flex:1 1 10px;flex-direction:column;padding:15px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{height:231px;max-width:345px;margin:0 0 10px;width:100%}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{margin-bottom:45px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{height:40px;width:100%}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{align-items:flex-end;flex-direction:column}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]{margin-bottom:10px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{background:#fff;flex-direction:column;padding:15px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{margin-bottom:15px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{height:40px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]     on-ui-button .button{width:100%}.header[_ngcontent-%COMP%]{border-bottom:1px solid #EEEEEE;display:flex;justify-content:space-between;padding:30px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{display:flex}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-left:20px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:22px;line-height:26px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#a4b0c3;font-size:16px;line-height:19px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]{align-items:flex-end;display:flex;flex-direction:column}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .activation-text[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:24px;margin-bottom:4px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]{align-items:baseline;display:flex}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .old-price[_ngcontent-%COMP%]{color:#a4b0c3;font-size:15px;line-height:18px;text-decoration:line-through}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]{font-size:24px;line-height:29px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]   .period[_ngcontent-%COMP%]{font-size:14px;line-height:17px}.finish-success[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]{display:-webkit-box;display:flex;flex-direction:column;justify-content:center;align-items:center;flex:1;padding:30px 0}.finish-success[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:24px;color:#000;margin-bottom:30px}.finish-success[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:98px;height:98px}.content[_ngcontent-%COMP%]{display:flex;padding:20px 30px}.content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{background:url(/assets/images/plan-activate-form.jpg) no-repeat center;background-size:cover;border-radius:10px;height:242px;margin-right:30px;width:287px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .info-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:26px;margin:0 0 14px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;flex-direction:column;padding:0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]{display:flex;margin-bottom:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;height:12px;width:20px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]{display:flex;flex:1 1 10px;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;max-width:350px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]{align-items:center;background:#feed7d;border-radius:20px;display:flex;height:27px;margin:10px 0 0 -20px;padding:0 10px;width:fit-content}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-value[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;white-space:nowrap}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .plan-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .advantage-text[_ngcontent-%COMP%]{color:#6d7381;font-size:14px;line-height:17px;margin-top:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]{padding-top:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#a4b0c3;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]   .input-credits[_ngcontent-%COMP%]{border:1px solid #5AB3E4;box-sizing:border-box;border-radius:10px;color:#000;display:inline;font-size:18px;height:32px;line-height:22px;outline:none;padding:0 8px;width:53px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]   .input-credits[_ngcontent-%COMP%]::-webkit-outer-spin-button, .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]   .input-credits[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{color:#65c558}.actions[_ngcontent-%COMP%]{border-top:1px solid #EEEEEE;display:flex;padding:30px;justify-content:space-between;gap:10px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{display:flex}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]{border:1px solid #EEEEEE;background:#fff;box-sizing:border-box;border-radius:10px;color:#1e252b;cursor:pointer;outline:none;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;width:126px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]::placeholder{color:#ccc}"],
        changeDetection: 0
      });
    }
  }
  return FinancePlanBuyCreditsFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FinancePlanBuyCreditsFormModule = /*#__PURE__*/(() => {
  class FinancePlanBuyCreditsFormModule {
    static {
      this.ɵfac = function FinancePlanBuyCreditsFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FinancePlanBuyCreditsFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FinancePlanBuyCreditsFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, FormsModule, PaymentFormUniversalModule, RouterModule, OnUiButtonModule, AgreementTermsFieldModule]
      });
    }
  }
  return FinancePlanBuyCreditsFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CreditHeaderDetailsComponent = /*#__PURE__*/(() => {
  class CreditHeaderDetailsComponent extends ChangableComponent {
    set plan(plan) {
      this._plan = plan;
    }
    get plan() {
      return this._plan;
    }
    constructor(screenService, deviceService, cdr) {
      super(cdr);
      this.screenService = screenService;
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    ngOnInit() {}
    screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    static {
      this.ɵfac = function CreditHeaderDetailsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CreditHeaderDetailsComponent)(i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CreditHeaderDetailsComponent,
        selectors: [["app-credit-header-details"]],
        inputs: {
          plan: "plan"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 14,
        vars: 12,
        consts: [[1, "headers-details", 3, "ngClass"], [1, "avatar"], ["width", "61", "height", "61", "viewBox", "0 0 61 61"], [1, "info", "credit"], [1, "label", "normal"], [1, "title", "bold"], [1, "subtitle", "normal"]],
        template: function CreditHeaderDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(2, "svg", 2);
            i0.ɵɵelement(3, "use");
            i0.ɵɵelementEnd()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(4, "div", 3)(5, "span", 4);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "span", 5);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "span", 6);
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.screenClasses());
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("fill", ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.color);
            i0.ɵɵadvance();
            i0.ɵɵattribute("href", ctx.svgsetIcon("finance-plan"), null, "xlink");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "lingo2-forms.subscription-plans.forms.header-label"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "lingo2-forms." + (ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.title)));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 10, "lingo2-forms." + (ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.subtitle)));
          }
        },
        dependencies: [i2.NgClass, i3.TranslatePipe],
        styles: [_c18]
      });
    }
  }
  return CreditHeaderDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CreditHeaderDetailsModule = /*#__PURE__*/(() => {
  class CreditHeaderDetailsModule {
    static {
      this.ɵfac = function CreditHeaderDetailsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CreditHeaderDetailsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CreditHeaderDetailsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, OnUiCoverModule, TranslateModule]
      });
    }
  }
  return CreditHeaderDetailsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Мастер покупки кредитов */
let CreditCheckoutWizardDialogComponent = /*#__PURE__*/(() => {
  class CreditCheckoutWizardDialogComponent extends AbstractCheckoutWizard {
    set plan(plan) {
      this._plan = plan;
      this.activePlan = plan;
    }
    get plan() {
      return this._plan;
    }
    set creditsAmount(creditsAmount) {
      this.creditsAmountValue = creditsAmount;
      if (creditsAmount) {
        this.inputCreditsDisabled = true;
      }
    }
    constructor(userService, profileService, billingV2Service, injector, cdr, store, billingService, screenService, deviceService) {
      super(injector, cdr);
      this.userService = userService;
      this.profileService = profileService;
      this.billingV2Service = billingV2Service;
      this.injector = injector;
      this.cdr = cdr;
      this.store = store;
      this.billingService = billingService;
      this.screenService = screenService;
      this.deviceService = deviceService;
      this.activatePlan = new EventEmitter();
      this.closed = new EventEmitter();
      this.succeed = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.creditsAmountValue = null;
      this.userHavePaymentMethods = null;
      this.payClicked = false;
      this.openAddAccountModal = false;
      this.ngDestroyed = new Subject();
      this.currency_id = CurrencyEnum.usd;
      this._isCheckout = false;
    }
    ngOnInit() {
      super.ngOnInit();
      this.userService.me$.pipe(takeUntil$1(this.destroyed$)).subscribe(me => {
        this.currency_id = me.currency_id;
        this.myCurrencyCode = Object.keys(CurrencyEnum)[Object.values(CurrencyEnum).indexOf(me.currency_id)].toUpperCase();
        if (this.myCurrencyCode === 'RUR') {
          this.myCurrencyCode = 'RUB';
        }
        this._me = me;
        this.getExchangeRate();
      });
      this.billingService.getRecommendedPlan().pipe(takeUntil$1(this.ngDestroyed)).subscribe(recommended => {
        this.recommendedPlan = recommended;
        this.detectChanges();
      });
      this.getUserPaymentMethods();
    }
    onClose() {
      this.closed.emit(true);
    }
    /** Получаем сумму из price tier */
    getPriceFromTier(amount) {
      return new CCurrencyAmount({
        currency_id: this.currencyId,
        amount: Number(Number(amount.getAmountByCurrency(this.currencyId)).toFixed())
      });
    }
    /** Инициализация шагов мастера */
    initWizardSteps() {
      this.steps.addStep(new StepByStepWizardStep({
        id: 'credits',
        title: 'subscription-plans.forms.buying-credits',
        context: this,
        checks: [],
        visible: true,
        active: false
      }));
      this.steps.addStep(new StepByStepWizardStep({
        id: 'payment',
        title: 'payment-checkout-wizard.steps.user-service.payment',
        context: this,
        checks: [],
        visible: true,
        active: false
      }));
      this.cdr.detectChanges();
    }
    /** Настройка шагов мастера под набор входных параметров */
    setupWizardSteps() {
      this.setupPaymentWidget();
      this.steps.goStep('credits');
    }
    /** Настройка данных для проведения платежа */
    setupPaymentWidget() {
      if (this._isCheckout) {
        return;
      }
      this.paymentWidgetService.payAmount$.pipe(tap$1(totalAmount => {
        this.totalAmount = totalAmount;
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    /** Выполнить обработку по активации шага мастера */
    onStepActivated() {}
    onPaymentSucceed() {
      super.onPaymentSucceed();
      this.succeed.emit(true);
      this.onClose();
    }
    getExchangeRate() {
      this.billingV2Service.getCurrencyRate(this.currency_id).pipe(takeUntil$1(this.destroyed$)).subscribe(rate => {
        this.exchangeRate = rate.find(r => r.currency.toUpperCase() === this.myCurrencyCode.toUpperCase());
        this.onAmountChange();
      });
    }
    onAmountChange() {
      this.currencyAmountValue = 0;
      let rate = 1;
      if (this.exchangeRate?.rate) {
        rate = Number(this.exchangeRate.rate);
      }
      this.currencyAmountValue = Number(rate) * Number(this.creditsAmountValue) || null;
      this.detectChanges();
    }
    buyCredits() {
      if (!this.creditsAmountValue) {
        this.inputCredits.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        return;
      }
      const credits_amount = this.creditsAmountValue;
      this.billingV2Service.buyCredits({
        credits_amount
      }).pipe(tap$1(response => {
        this.profileService.getSettings(this._me.id).pipe(tap$1(userSettings => {
          this._userSettings = userSettings;
          this._isCheckout = true;
          this.paymentOptions = {
            first_name: this._me.first_name,
            last_name: this._me.last_name,
            email: this._userSettings.email,
            phone: this._userSettings.mobile_phone,
            country: this._me.country?.alpha2Code,
            order_id: String(response.data.billing_order_id),
            charge_id: [String(response.data.billing_charge_id)]
          };
          this.steps.get('credits').complete = true;
          this.steps.goStep('payment');
          this.detectChanges();
        }), catchError$1(err => {
          this.errorMessage = err.message;
          this.activateView('error');
          console.error(err);
          // TODO разобраться с Sentry : Sentry.captureException(err);
          return throwError(err);
        }), takeUntil$1(this.destroyed$)).subscribe();
      }), catchError$1(err => {
        // this.error = err;
        this.detectChanges();
        return throwError(() => err);
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    diffCredits() {
      return +this.recommendedPlan?.details?.receive_credits_per_month - +this.plan?.details?.receive_credits_per_month;
    }
    diffDiscount() {
      return +this.recommendedPlan?.details?.discount_on_purchase_of_additional_credits;
    }
    onActivatePlan() {
      this.activatePlan.emit(true);
      this.detectChanges();
    }
    onKeydown(event) {
      return event?.keyCode !== 69 || event?.code !== 'KeyE';
    }
    formatCurrencyAmount(amount) {
      if (amount <= 0) {
        return '?';
      }
      return this.billingService.formatCurrencyAmount({
        amount,
        currency_id: this.currency_id
      });
    }
    ngAfterViewInit() {
      this.inputCredits.nativeElement.focus();
      this.setTimeout(() => {
        this.inputCredits.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 1000);
    }
    screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    getUserPaymentMethods() {
      this.billingV2Service.getAccounts().pipe(tap$1(accounts => {
        this.userHavePaymentMethods = accounts.length > 0;
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    onStartPayment() {
      this.payClicked = true;
      super.onStartPayment();
      this.detectChanges();
    }
    onAddAccount(providerId) {
      this.openAddAccountModal = true;
      this.addAccountProviderId = providerId;
    }
    onCloseAddAccount() {
      this.openAddAccountModal = false;
      this.afterAddAccountNeedUpdate = Date.now();
      this.detectChanges();
    }
    static {
      this.ɵfac = function CreditCheckoutWizardDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CreditCheckoutWizardDialogComponent)(i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(AbstractProfileService), i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$1.Store), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CreditCheckoutWizardDialogComponent,
        selectors: [["app-credit-checkout-wizard-dialog"]],
        viewQuery: function CreditCheckoutWizardDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c20, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputCredits = _t.first);
          }
        },
        inputs: {
          plan: "plan",
          creditsAmount: "creditsAmount"
        },
        outputs: {
          activatePlan: "activatePlan",
          closed: "closed",
          succeed: "succeed"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 3,
        consts: [["contentRef", ""], ["credits", ""], ["input_credits", ""], [3, "canClose", "closed", 4, "ngIf"], [3, "titleVisible", "withCloseButton", "customTitle", "closed", 4, "ngIf"], [3, "providerId", "closed", 4, "ngIf"], [3, "closed", "canClose"], [3, "ngTemplateOutlet"], [3, "closed", "titleVisible", "withCloseButton", "customTitle"], [1, "checkout-wizard-wrap"], [3, "steps", "showHeader", "showFooter"], ["header-details", ""], [3, "plan"], ["content", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], ["style", "font-size: 8px;", 4, "ngIf"], ["footer-details", ""], [1, "credit-footer"], ["footer-actions", ""], ["class", "primary", 3, "state", "label", "click", 4, "ngIf"], [3, "state", "disabled", "startLabel", "closeLabel", "cancelLabel", "retryLabel", "start", "retry", "cancel", 4, "ngIf"], [4, "ngTemplateOutlet"], [3, "options", "payClicked", "needUpdate", "configured", "succeed", "failed", "processing", "addAccount", 4, "ngIf"], [3, "configured", "succeed", "failed", "processing", "addAccount", "options", "payClicked", "needUpdate"], [4, "ngIf"], [2, "font-size", "8px"], [1, "primary", 3, "click", "state", "label"], [3, "start", "retry", "cancel", "state", "disabled", "startLabel", "closeLabel", "cancelLabel", "retryLabel"], [1, "content", 3, "ngClass"], [1, "img"], [1, "info-wrap"], [1, "info-header"], [3, "ngIf"], [1, "info-bottom"], [1, "pay-info-wrap"], [1, "credit-label", "normal"], ["type", "number", "min", "0", 1, "input-credits", "normal", 3, "ngModelChange", "change", "input", "keydown", "ngModel", "disabled"], [1, "total-pay", "bold"], [1, "value"], [1, "plan-text", "normal"], [1, "bold"], [1, "advantage-text", "normal"], [1, "activate-wrap"], ["label", "lingo2-forms.subscription-plans.forms.action-activate-plan", 1, "secondary", "outline", 3, "onclick"], [3, "closed", "providerId"]],
        template: function CreditCheckoutWizardDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CreditCheckoutWizardDialogComponent_app_modal_0_Template, 3, 2, "app-modal", 3)(1, CreditCheckoutWizardDialogComponent_app_mobile_modal_1_Template, 5, 6, "app-mobile-modal", 4)(2, CreditCheckoutWizardDialogComponent_ng_template_2_Template, 15, 13, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, CreditCheckoutWizardDialogComponent_ng_template_4_Template, 17, 11, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, CreditCheckoutWizardDialogComponent_app_add_card_wizard_dialog_6_Template, 1, 1, "app-add-card-wizard-dialog", 5);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.deviceService.isDesktop());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.deviceService.isDesktop());
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.openAddAccountModal);
          }
        },
        dependencies: [i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, ModalComponent, ModalBodyComponent, MobileModalComponent, MobileModalBodyComponent, StepByStepWizardComponent, i16.OnUiButtonComponent, PaymentWidgetComponent, PayButtonComponent, CreditHeaderDetailsComponent, i4.DefaultValueAccessor, i4.NumberValueAccessor, i4.NgControlStatus, i4.MinValidator, i4.NgModel, AddCardWizardDialogComponent, i2.AsyncPipe, i2.JsonPipe, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.step-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 20px;font-size:18px;line-height:24px;display:flex;justify-content:space-between;align-items:center}.content[_ngcontent-%COMP%]{display:flex;padding:20px 0}.content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{background:url(/assets/images/plan-activate-form.jpg) no-repeat center;background-size:cover;border-radius:10px;height:242px;margin-right:30px;width:287px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .info-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:26px;margin:0 0 14px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;flex-direction:column;padding:0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]{display:flex;margin-bottom:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;height:12px;width:20px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]{display:flex;flex:1 1 10px;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;max-width:350px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]{align-items:center;background:#feed7d;border-radius:20px;display:flex;height:27px;margin:10px 0 0 -20px;padding:0 10px;width:fit-content}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-value[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;white-space:nowrap}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .plan-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .advantage-text[_ngcontent-%COMP%]{color:#6d7381;font-size:14px;line-height:17px;margin-top:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]{padding-top:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#a4b0c3;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]   .input-credits[_ngcontent-%COMP%]{border:1px solid #5AB3E4;box-sizing:border-box;border-radius:10px;color:#000;display:inline;font-size:18px;height:32px;line-height:22px;outline:none;padding:0 8px;width:53px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]   .input-credits[_ngcontent-%COMP%]::-webkit-outer-spin-button, .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]   .input-credits[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{color:#65c558}.content.mobile[_ngcontent-%COMP%]{flex-direction:column;gap:30px;padding:0}.content.mobile[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{width:100%;margin-right:0}.content.mobile[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]{width:100%}.content.mobile[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]{margin-top:10px}.actions[_ngcontent-%COMP%]{border-top:1px solid #EEEEEE;display:flex;padding:30px;justify-content:space-between;gap:10px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{display:flex}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]{border:1px solid #EEEEEE;background:#fff;box-sizing:border-box;border-radius:10px;color:#1e252b;cursor:pointer;outline:none;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;width:126px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]::placeholder{color:#ccc}"],
        changeDetection: 0
      });
    }
  }
  return CreditCheckoutWizardDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FinancePlanBuyCreditsFormV2Component = /*#__PURE__*/(() => {
  class FinancePlanBuyCreditsFormV2Component extends ChangableComponent {
    set plan(plan) {
      this._plan = plan;
    }
    get plan() {
      return this._plan;
    }
    set creditsAmount(creditsAmount) {
      this.creditsAmountValue = creditsAmount;
    }
    constructor(deviceService, cdr) {
      super(cdr);
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.activatePlan = new EventEmitter();
      this.close = new EventEmitter();
      this.success = new EventEmitter();
      this.creditsAmountValue = null;
    }
    ngOnInit() {}
    onClose() {
      this.close.emit(true);
    }
    onSuccess() {
      this.success.emit(true);
    }
    onActivatePlan() {
      this.activatePlan.emit(true);
    }
    static {
      this.ɵfac = function FinancePlanBuyCreditsFormV2Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FinancePlanBuyCreditsFormV2Component)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FinancePlanBuyCreditsFormV2Component,
        selectors: [["app-finance-plan-buy-credits-form-v2"]],
        inputs: {
          plan: "plan",
          creditsAmount: "creditsAmount"
        },
        outputs: {
          activatePlan: "activatePlan",
          close: "close",
          success: "success"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 2,
        consts: [[3, "activatePlan", "closed", "succeed", "plan", "creditsAmount"]],
        template: function FinancePlanBuyCreditsFormV2Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "app-credit-checkout-wizard-dialog", 0);
            i0.ɵɵlistener("activatePlan", function FinancePlanBuyCreditsFormV2Component_Template_app_credit_checkout_wizard_dialog_activatePlan_0_listener() {
              return ctx.onActivatePlan();
            })("closed", function FinancePlanBuyCreditsFormV2Component_Template_app_credit_checkout_wizard_dialog_closed_0_listener() {
              return ctx.onClose();
            })("succeed", function FinancePlanBuyCreditsFormV2Component_Template_app_credit_checkout_wizard_dialog_succeed_0_listener() {
              return ctx.onSuccess();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("plan", ctx.plan)("creditsAmount", ctx.creditsAmountValue);
          }
        },
        dependencies: [CreditCheckoutWizardDialogComponent],
        styles: [".finance-plan-buy-credits-form[_ngcontent-%COMP%]{margin:-30px}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{background:#fff;border:1px solid transparent;box-sizing:border-box;border-radius:10px;cursor:pointer;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;transition:all .2s;min-width:126px}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.apply[_ngcontent-%COMP%]{color:#41a1d9}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.payment[_ngcontent-%COMP%]{background:#87d37c;border:1px solid #87D37C;color:#fff}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.activate[_ngcontent-%COMP%]{border:1px solid #87D37C;color:#87d37c}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.cancel[_ngcontent-%COMP%]{background:#e86f79;border:1px solid #E86F79;color:#fff}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.disabled[_ngcontent-%COMP%]{opacity:.5;cursor:unset}.finance-plan-buy-credits-form[_ngcontent-%COMP%]   .action.hidden[_ngcontent-%COMP%]{display:none}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:0}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background:#fff;box-shadow:0 3px 5px #00000014;flex-direction:column;padding:15px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .activation-text[_ngcontent-%COMP%]{line-height:20px;margin:0}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{flex:1 1 10px;flex-direction:column;padding:15px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{height:231px;max-width:345px;margin:0 0 10px;width:100%}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{margin-bottom:45px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{height:40px;width:100%}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{align-items:flex-end;flex-direction:column}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]{margin-bottom:10px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{background:#fff;flex-direction:column;padding:15px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{margin-bottom:15px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{height:40px}.finance-plan-buy-credits-form.mobile[_ngcontent-%COMP%]     on-ui-button .button{width:100%}.header[_ngcontent-%COMP%]{border-bottom:1px solid #EEEEEE;display:flex;justify-content:space-between;align-items:center;padding:30px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{display:flex}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-left:20px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-size:22px;line-height:26px}.header[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .plan-info[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#a4b0c3;font-size:16px;line-height:19px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]{align-items:flex-end;display:flex;flex-direction:column}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .activation-text[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:24px;margin-bottom:4px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]{align-items:baseline;display:flex}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .old-price[_ngcontent-%COMP%]{color:#a4b0c3;font-size:15px;line-height:18px;text-decoration:line-through}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]{font-size:24px;line-height:29px}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .pay-info[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]   .period[_ngcontent-%COMP%]{font-size:14px;line-height:17px}.finish-success[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]{display:-webkit-box;display:flex;flex-direction:column;justify-content:center;align-items:center;flex:1;padding:30px 0}.finish-success[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:24px;color:#000;margin-bottom:30px}.finish-success[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:98px;height:98px}.content[_ngcontent-%COMP%]{display:flex;padding:20px 30px}.content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{background:url(/assets/images/plan-activate-form.jpg) no-repeat center;background-size:cover;border-radius:10px;height:242px;margin-right:30px;width:287px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .info-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:26px;margin:0 0 14px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;flex-direction:column;padding:0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]{display:flex;margin-bottom:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;height:12px;width:20px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]{display:flex;flex:1 1 10px;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;max-width:350px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]{align-items:center;background:#feed7d;border-radius:20px;display:flex;height:27px;margin:10px 0 0 -20px;padding:0 10px;width:fit-content}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-value[_ngcontent-%COMP%], .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;white-space:nowrap}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .plan-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .advantage-text[_ngcontent-%COMP%]{color:#6d7381;font-size:14px;line-height:17px;margin-top:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-header[_ngcontent-%COMP%]   .activate-wrap[_ngcontent-%COMP%]{padding-top:10px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]{display:flex;flex-direction:column}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#a4b0c3;font-size:14px;line-height:17px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:space-between}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]   .input-credits[_ngcontent-%COMP%]{border:1px solid #5AB3E4;box-sizing:border-box;border-radius:10px;color:#000;display:inline;font-size:18px;height:32px;line-height:22px;outline:none;padding:0 8px;width:53px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]   .input-credits[_ngcontent-%COMP%]::-webkit-outer-spin-button, .content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .credit-label[_ngcontent-%COMP%]   .input-credits[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]{color:#1e252b;font-size:18px;line-height:22px}.content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .pay-info-wrap[_ngcontent-%COMP%]   .total-pay[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{color:#65c558}.actions[_ngcontent-%COMP%]{border-top:1px solid #EEEEEE;display:flex;padding:30px;justify-content:flex-end;gap:10px}.actions.only-btn[_ngcontent-%COMP%]{justify-content:flex-end}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{display:flex}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]{border:1px solid #EEEEEE;background:#fff;box-sizing:border-box;border-radius:10px;color:#1e252b;cursor:pointer;outline:none;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;width:126px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]::placeholder{color:#ccc}.payment[_ngcontent-%COMP%]{display:flex;width:calc(100% - 60px);padding:30px;gap:30px}.payment[_ngcontent-%COMP%]   app-payment-widget-payment-method-selector[_ngcontent-%COMP%]{width:50%}.payment[_ngcontent-%COMP%]   app-payment-order[_ngcontent-%COMP%]{width:50%}"],
        changeDetection: 0
      });
    }
  }
  return FinancePlanBuyCreditsFormV2Component;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable max-len */
let CreditCheckoutWizardDialogModule = /*#__PURE__*/(() => {
  class CreditCheckoutWizardDialogModule {
    static {
      this.ɵfac = function CreditCheckoutWizardDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CreditCheckoutWizardDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CreditCheckoutWizardDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CommonModule, TranslateModule, ModalModule, MobileModalModule, StepByStepWizardModule, OnUiButtonModule, PaymentWidgetModule, PayButtonModule, CreditHeaderDetailsModule, ReactiveFormsModule, FormsModule, AddCardWizardDialogModule]
      });
    }
  }
  return CreditCheckoutWizardDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FinancePlanBuyCreditsFormV2Module = /*#__PURE__*/(() => {
  class FinancePlanBuyCreditsFormV2Module {
    static {
      this.ɵfac = function FinancePlanBuyCreditsFormV2Module_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FinancePlanBuyCreditsFormV2Module)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FinancePlanBuyCreditsFormV2Module
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, FormsModule, RouterModule, OnUiButtonModule, CreditCheckoutWizardDialogModule]
      });
    }
  }
  return FinancePlanBuyCreditsFormV2Module;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
;
const versions = {
  version: '11.0.5',
  name: 'lingo2-forms',
  versionDate: '2025-06-04T17:02:49.150Z',
  gitCommitHash: 'g7bf5d8e',
  gitCommitDate: '2025-06-04T17:01:44.000Z',
  versionLong: '11.0.5-g7bf5d8e',
  gitTag: 'v11.0.3'
};

/**
 * https://learn.javascript.ru/task/throttle
 * Вызывать func не чаще чем 1 раз в ms миллисекунд, но запоминать, если был ещё один
 * вызов в это время
 */
function throttle(func, ms) {
  let isThrottled = false;
  let savedArgs;
  let savedThis;
  function wrapper(...args) {
    if (isThrottled) {
      savedArgs = args || [];
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      savedThis = this;
      return;
    }
    func.apply(this, args);
    isThrottled = true;
    setTimeout(() => {
      isThrottled = false;
      if (savedThis) {
        wrapper.apply(savedThis, savedArgs);
        savedArgs = savedThis = null;
      }
    }, ms);
  }
  return wrapper;
}
class MeetingCalcHelper {
  calc(values, price_tier) {
    // TODO :ChargingCalcType; не знаю, почему жалуется Property 'maxCredits' does not exist on type 'IChargingFeeCalc'
    try {
      return this.tryCalc(values, price_tier);
    } catch (e) {
      console.error(e);
    }
  }
  tryCalc(values, price_tier) {
    if (!values) {
      return null;
    }
    const {
      charging,
      begin,
      begin_at,
      end_at,
      participants_limit,
      type
    } = values;
    const minFeeAmount = 5; // комиссия не менее $5 с участника
    const minFeePercent = 20; // комиссия 20% с бывшего ученика или с нового ученика по реф ссылке
    const maxFeePercent = 40; // комиссия 40% с любого другого ученика
    const creditsHourRate = 1; // расход кредитов на ученика в час
    const minDurationHours = 1; // мин длительность урока в часах
    let durationHours = 1; // длительность урока в часах
    const maxParticipants = participants_limit; // макс количество участников
    let minParticipants = maxParticipants; // мин количество участников
    switch (begin) {
      case MeetingBeginEnum.immediate_time:
        durationHours = 1;
        break;
      case MeetingBeginEnum.specified_time:
        if (values.end_at && values.begin_at) {
          durationHours = Math.max(minDurationHours, differenceInHours(end_at, begin_at));
        }
        break;
    }
    switch (type) {
      case MeetingTypeEnum.single:
        minParticipants = 1;
        break;
      case MeetingTypeEnum.group:
        minParticipants = 2;
        break;
      case MeetingTypeEnum.webinar:
        minParticipants = 12;
        break;
      case MeetingTypeEnum.stream:
        minParticipants = 50;
        break;
    }
    switch (charging) {
      case BillingMeetingChargingEnum.credits:
        return {
          charging,
          currency_id: CurrencyEnum.credits,
          price: null,
          minParticipants,
          maxParticipants,
          minCredits: durationHours * creditsHourRate * minParticipants,
          maxCredits: durationHours * creditsHourRate * maxParticipants
        };
      case BillingMeetingChargingEnum.fee:
        if (!price_tier) {
          return null;
        }
        const price = price_tier.amount; // стоимость урока
        const minIncome = minParticipants * price;
        const maxIncome = maxParticipants * price;
        const minFee = Math.max(minParticipants * minFeeAmount, minParticipants * price * minFeePercent / 100);
        const maxFee = Math.max(minParticipants * minFeeAmount, maxParticipants * price * maxFeePercent / 100);
        const maxMinFee = Math.max(minParticipants * minFeeAmount, maxParticipants * price * minFeePercent / 100);
        const minProfit = minIncome - minFee;
        const maxProfit = maxIncome - maxMinFee;
        return {
          charging,
          currency_id: price_tier.currency_id,
          price,
          minParticipants,
          maxParticipants,
          minIncome,
          maxIncome,
          minFee,
          maxFee,
          minProfit,
          maxProfit
        };
    }
  }
}
const typesList = [{
  value: MeetingTypeEnum.single,
  title: 'lingo2-forms.meetings.meeting-type.single',
  disabled: false,
  limit: 1
}, {
  value: MeetingTypeEnum.group,
  title: 'lingo2-forms.meetings.meeting-type.group',
  disabled: false,
  limit: 11
}, {
  value: MeetingTypeEnum.webinar,
  title: 'lingo2-forms.meetings.meeting-type.webinar',
  disabled: true,
  limit: 50
}, {
  value: MeetingTypeEnum.talk,
  title: 'lingo2-forms.meetings.meeting-type.talk',
  disabled: true,
  limit: 6
}, {
  value: MeetingTypeEnum.stream,
  title: 'lingo2-forms.meetings.meeting-type.stream',
  disabled: true,
  limit: 1000
}];
const typesOptions = [{
  value: MeetingTypeEnum.single,
  icon: 'meeting-single',
  title: 'lingo2-forms.meetings.meeting-type-short.single',
  subtitle: '(1)'
}, {
  value: MeetingTypeEnum.group,
  icon: 'meeting-group',
  title: 'lingo2-forms.meetings.meeting-type-short.group',
  subtitle: '(2 - 24)'
},
// tslint:disable-next-line: max-line-length
{
  value: MeetingTypeEnum.webinar,
  icon: 'meeting-webinar',
  title: 'lingo2-forms.meetings.meeting-type-short.webinar',
  subtitle: '(25 - 50)'
}, {
  value: MeetingTypeEnum.talk,
  icon: 'meeting-talk',
  title: 'lingo2-forms.meetings.meeting-type-short.talk',
  subtitle: '(1 - 6)'
},
// tslint:disable-next-line: max-line-length
{
  value: MeetingTypeEnum.stream,
  icon: 'meeting-stream',
  title: 'lingo2-forms.meetings.meeting-type-short.stream',
  subtitle: '(50 - 1000)'
}];
// export const categoriesOptions: ISelectOption[] = [
//   { value: MeetingSubTypeEnum.all, title: 'Занятие для всех'},
//   { value: MeetingSubTypeEnum.exam_preparation, title: 'Подготовка к экзаменам и тестам'},
//   { value: MeetingSubTypeEnum.children, title: 'Занятия для детей'},
//   { value: MeetingSubTypeEnum.speaking, title: 'Разговорная практика'},
//   { value: MeetingSubTypeEnum.discussion, title: 'Дискуссия'},
//   { value: MeetingSubTypeEnum.literary_evening, title: 'Литературный вечер'}
// ];
const groupLimitsList = [{
  value: 2,
  title: '2',
  disabled: false
}, {
  value: 3,
  title: '3',
  disabled: false
}, {
  value: 4,
  title: '4',
  disabled: false
}, {
  value: 5,
  title: '5',
  disabled: false
}, {
  value: 6,
  title: '6',
  disabled: false
}, {
  value: 7,
  title: '7',
  disabled: false
}, {
  value: 8,
  title: '8',
  disabled: false
}, {
  value: 9,
  title: '9',
  disabled: false
}, {
  value: 10,
  title: '10',
  disabled: false
}, {
  value: 11,
  title: '11',
  disabled: false
}, {
  value: 12,
  title: '12',
  disabled: false
}, {
  value: 13,
  title: '13',
  disabled: false
}, {
  value: 14,
  title: '14',
  disabled: false
}, {
  value: 15,
  title: '15',
  disabled: false
}, {
  value: 16,
  title: '16',
  disabled: false
}, {
  value: 17,
  title: '17',
  disabled: false
}, {
  value: 18,
  title: '18',
  disabled: false
}, {
  value: 19,
  title: '19',
  disabled: false
}, {
  value: 20,
  title: '20',
  disabled: false
}, {
  value: 21,
  title: '21',
  disabled: false
}, {
  value: 22,
  title: '22',
  disabled: false
}, {
  value: 23,
  title: '23',
  disabled: false
}, {
  value: 24,
  title: '24',
  disabled: false
}];
const constants = {
  disabled: BillingMeetingChargingEnum.disabled,
  credits: BillingMeetingChargingEnum.credits,
  fee: BillingMeetingChargingEnum.fee,
  private: MeetingAccessEnum.private,
  public: MeetingAccessEnum.public,
  immediate_time: MeetingBeginEnum.immediate_time,
  specified_time: MeetingBeginEnum.specified_time,
  single: MeetingTypeEnum.single,
  group: MeetingTypeEnum.group
};
class ConditionalValidatorsInjector {
  constructor(donor) {
    this.donor = donor;
  }
  get account() {
    return this.donor.account;
  }
  get accountCheck() {
    return this.donor.accountCheck;
  }
  get featuresService() {
    return this.donor.featuresService;
  }
  get billingSettings() {
    return this.donor.billingSettings;
  }
  get creditsAmount() {
    return this.donor.creditsAmount;
  }
}
function creditsChargingConditionalValidator(injector) {
  const calcHelper = new MeetingCalcHelper();
  return form => {
    const {
      featuresService,
      billingSettings,
      creditsAmount,
      account
    } = injector;
    const isCreditsChargingAvailable = featuresService.isAvailable(FeatureEnum.credits_meetings, account);
    const hasPaidPlan = billingSettings?.plan ? billingSettings.plan?.plan?.price_tier_id !== null : false;
    const creditsBalance = creditsAmount || 0;
    const prices = billingSettings?.prices || [];
    const {
      charging,
      price_tier
    } = form.value;
    const selectedPriceTier = prices.find(pt => pt.id === price_tier);
    if (charging === BillingMeetingChargingEnum.credits) {
      if (!isCreditsChargingAvailable) {
        return {
          creditsNotAvailable: {
            message: 'Credits charging not available'
          }
        };
      }
      if (hasPaidPlan) {
        return null;
      }
      const calc = calcHelper.calc(form.value, selectedPriceTier);
      const calcCredits = calc?.maxCredits || 1;
      if (calcCredits > creditsBalance) {
        return {
          creditsBalanceLow: {
            message: 'Not enough credits'
          }
        };
      }
    }
    return null;
  };
}
function feeChargingConditionalValidator(injector) {
  return form => {
    const {
      featuresService,
      account,
      accountCheck
    } = injector;
    const isFeeChargingAvailable = featuresService.isAvailable(FeatureEnum.safe_deal_meetings, account);
    const haveBeneficiary = !accountCheck.no_payouts;
    const isTeacher = AbstractAccountService.isTeacher(account);
    const {
      charging,
      begin
    } = form.value;
    const isFeeChargingAllowed = (!begin || begin === MeetingBeginEnum.specified_time || begin === MeetingBeginEnum.immediate_time) && isFeeChargingAvailable;
    if (charging === BillingMeetingChargingEnum.fee) {
      if (!isFeeChargingAllowed) {
        return {
          feeNotAvailable: {
            message: 'Fee charging not available'
          }
        };
      }
      if (!isTeacher) {
        return {
          feeRequireVerification: {
            message: 'Teacher profile verification is required'
          }
        };
      }
      if (!haveBeneficiary) {
        return {
          feeBeneficiaryVerification: {
            message: 'Teacher profile beneficiary is required'
          }
        };
      }
    }
    return null;
  };
}
function publicAccessConditionalValidator(injector) {
  return form => {
    const {
      account
    } = injector;
    const isTeacher = AbstractAccountService.isTeacher(account);
    const {
      access
    } = form.value;
    if (access === MeetingAccessEnum.public && !isTeacher) {
      return {
        publicRequireVerification: {
          message: 'Teacher profile verification is required'
        }
      };
    }
    return null;
  };
}
/**
 * @see https://medium.com/ngx/3-ways-to-implement-conditional-validation-of-reactive-forms-c59ed6fc3325
 * @see https://stackblitz.com/edit/angular-conditional-validators-3rd-workaround-5-custom-msg
 *
 * A conditional validator generator. Assigns a validator to the form control if the predicate
 * function returns true on the moment of validation
 * @example
 * Here if the myCheckbox is set to true, the myEmailField will be required and also the text
 * will have to have the word 'mason' in the end.
 * If it doesn't satisfy these requirements, the errors will placed to the dedicated `illuminatiError` namespace.
 * Also the myEmailField will always have `maxLength`, `minLength` and `pattern` validators.
 * ngOnInit() {
 *   this.myForm = this.fb.group({
 *    myCheckbox: [''],
 *    myEmailField: ['', [
 *       Validators.maxLength(250),
 *       Validators.minLength(5),
 *       Validators.pattern(/.+@.+\..+/),
 *       conditionalValidator(() => this.myForm.get('myCheckbox').value,
 *                            Validators.compose([
 *                              Validators.required,
 *                              Validators.pattern(/.*mason/)
 *                            ]),
 *                           'illuminatiError')
 *        ]]
 *     })
 * }
 * @param predicate Add description please
 * @param validator Add description please
 * @param errorNamespace optional argument that creates own namespace for the validation error
 */
function conditionalValidator(predicate, validator, errorNamespace) {
  return formControl => {
    if (!formControl.parent) {
      return null;
    }
    let error = null;
    if (predicate()) {
      error = validator(formControl);
    }
    if (errorNamespace && error) {
      const customError = {};
      customError[errorNamespace] = error;
      error = customError;
    }
    return error;
  };
}
/**
 * makes the field required if the predicate function returns true
 */
function requiredIfValidator(predicate) {
  return conditionalValidator(predicate, Validators.required);
  // return (formControl => {
  //   if (!formControl.parent) {
  //     return null;
  //   }
  //   if (predicate()) {
  //     return Validators.required(formControl);
  //   }
  //   return null;
  // })
}
function validityDependsOn(formControl, dependsOnFields) {
  const form = formControl.parent;
  if (!form) {
    return null;
  }
  const observables = dependsOnFields.map(field => form.get(field).valueChanges);
  return combineLatest(observables).pipe(tap$1(() => formControl.updateValueAndValidity()));
}
var PresetTypeEnum = /*#__PURE__*/function (PresetTypeEnum) {
  PresetTypeEnum[PresetTypeEnum["quick"] = 1] = "quick";
  PresetTypeEnum[PresetTypeEnum["detailed"] = 2] = "detailed";
  return PresetTypeEnum;
}(PresetTypeEnum || {});
let MeetingSelectPresetComponent = /*#__PURE__*/(() => {
  class MeetingSelectPresetComponent {
    constructor(device) {
      this.device = device;
      this.changed = new EventEmitter();
      this.types = PresetTypeEnum;
      this.propagateChange = () => {};
    }
    ngOnInit() {}
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerOnTouched(fn) {}
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onChange(value) {
      if (this.isDisabled) {
        return;
      }
      this.value = value;
      this.propagateChange(value);
      this.changed.emit(value);
    }
    isActive(value) {
      return this.value === value;
    }
    static {
      this.ɵfac = function MeetingSelectPresetComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingSelectPresetComponent)(i0.ɵɵdirectiveInject(DeviceService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MeetingSelectPresetComponent,
        selectors: [["app-meeting-select-preset"]],
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => MeetingSelectPresetComponent),
          multi: true
        }])],
        decls: 19,
        vars: 26,
        consts: [[1, "select", "preset"], [1, "option", 3, "click"], ["icon", "meeting-rocket", 3, "width", "height"], ["icon", "meeting-schedule", 3, "width", "height"]],
        template: function MeetingSelectPresetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵlistener("click", function MeetingSelectPresetComponent_Template_div_click_1_listener() {
              return ctx.onChange(ctx.types.quick);
            });
            i0.ɵɵelement(2, "app-icon", 2);
            i0.ɵɵelementStart(3, "div")(4, "b");
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "p");
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(10, "div", 1);
            i0.ɵɵlistener("click", function MeetingSelectPresetComponent_Template_div_click_10_listener() {
              return ctx.onChange(ctx.types.detailed);
            });
            i0.ɵɵelement(11, "app-icon", 3);
            i0.ɵɵelementStart(12, "div")(13, "b");
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "p");
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("disabled", ctx.isDisabled)("mobile", ctx.device.isMobile())("tablet", ctx.device.isTablet());
            i0.ɵɵadvance();
            i0.ɵɵclassProp("active", ctx.isActive(ctx.types.quick));
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", 40)("height", 40);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 18, "lingo2-forms.meetings.placeholders.quick.title"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 20, "lingo2-forms.meetings.placeholders.quick.description"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("active", ctx.isActive(ctx.types.detailed));
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", 40)("height", 40);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 22, "lingo2-forms.meetings.placeholders.detailed.title"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 24, "lingo2-forms.meetings.placeholders.detailed.description"), " ");
          }
        },
        dependencies: [IconComponent, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.select[_ngcontent-%COMP%]{display:flex;flex-direction:row}.select.preset[_ngcontent-%COMP%]     .icon{position:relative!important;top:0;transform:none;right:auto;left:0;stroke:none}.select.disabled[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]{opacity:.5;cursor:default}.select.disabled[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]:hover{border-color:#eee}.select.mobile[_ngcontent-%COMP%]{flex-direction:column;margin-bottom:10px}.select.mobile[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]:first-child{margin-right:0;margin-bottom:10px}.select.tablet[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]{min-width:235px}.option[_ngcontent-%COMP%]{border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;padding:20px;transition:border-color .2s linear;display:inline-flex;flex-direction:row;min-width:274px;cursor:pointer;position:relative}.option[_ngcontent-%COMP%]:hover{border-color:#a4b0c3}.option[_ngcontent-%COMP%] > app-icon[_ngcontent-%COMP%]{margin-right:10px}.option[_ngcontent-%COMP%]   b[_ngcontent-%COMP%]{font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:20px;color:#1e252b}.option[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:3px 0 0;color:#a4b0c3;font-size:14px;line-height:18px}.option[_ngcontent-%COMP%]:first-child{margin-right:10px}.option.active[_ngcontent-%COMP%]{border:1px solid #5AB3E4}"]
      });
    }
  }
  return MeetingSelectPresetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DebugService = /*#__PURE__*/(() => {
  class DebugService {
    constructor(route) {
      this.route = route;
      this.debugSubject = new ReplaySubject(1);
      this.debug$ = this.debugSubject.asObservable();
      this.initDebugMode();
    }
    ngOnDestroy() {
      this.debugSubject.complete();
    }
    initDebugMode() {
      if (localStorage || false) {
        const debug = localStorage.getItem('APP_DBG') === '1';
        this.debugSubject.next(debug);
      }
      this.route.queryParamMap.subscribe(query => {
        if (query.has('debug')) {
          const debug = query.get('debug') === '1';
          this.debugSubject.next(debug);
          if (localStorage || false) {
            localStorage.setItem('APP_DBG', debug ? '1' : '');
          }
        }
      });
    }
    static {
      this.ɵfac = function DebugService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DebugService)(i0.ɵɵinject(i1$2.ActivatedRoute));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DebugService,
        factory: DebugService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DebugService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingSelectComponent = /*#__PURE__*/(() => {
  class MeetingSelectComponent {
    constructor(deviceService) {
      this.deviceService = deviceService;
      this.changed = new EventEmitter();
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    ngOnInit() {}
    ngOnDestroy() {}
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onChanged(option) {
      const value = option.value;
      this.value = value;
      this.propagateChange(value);
      this.changed.emit(value);
      this.onClosed();
    }
    onBlur() {
      this.propagateTouched();
    }
    onOpened() {
      if (!this.isDisabled) {
        this.isOpened = !this.isOpened;
      }
    }
    onClosed() {
      this.isOpened = false;
    }
    trackByFn(index, item) {
      return item.value;
    }
    get inputValue() {
      if (!this.value || !this.options.length) {
        return '';
      }
      return this.options.find(x => x.value === this.value).title;
    }
    get selectedOption() {
      if (!this.value || !this.options.length) {
        return null;
      }
      return this.options.find(x => x.value === this.value);
    }
    static {
      this.ɵfac = function MeetingSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingSelectComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MeetingSelectComponent,
        selectors: [["app-meeting-select"]],
        inputs: {
          options: "options",
          placeholder: "placeholder",
          active: "active",
          disabled: "disabled"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => MeetingSelectComponent),
          multi: true
        }])],
        decls: 8,
        vars: 12,
        consts: [["valueSelected", ""], [1, "meeting-select", 3, "clickOutside"], ["width", "12", "height", "7", 1, "meeting-select__chevron"], [1, "meeting-select__input", 3, "click"], [4, "ngIf", "ngIfElse"], ["class", "meeting-select__dropdown", 4, "ngIf"], [1, "selected-option"], ["class", "icon", 3, "icon", "width", "height", 4, "ngIf"], [1, "icon", 3, "icon", "width", "height"], [1, "meeting-select__dropdown"], ["class", "option", 3, "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "option", 3, "click"], [4, "ngIf"]],
        template: function MeetingSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("clickOutside", function MeetingSelectComponent_Template_div_clickOutside_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClosed());
            });
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 2);
            i0.ɵɵelement(2, "use");
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵlistener("click", function MeetingSelectComponent_Template_div_click_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOpened());
            });
            i0.ɵɵtemplate(4, MeetingSelectComponent_ng_container_4_Template, 3, 3, "ng-container", 4)(5, MeetingSelectComponent_ng_template_5_Template, 4, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, MeetingSelectComponent_div_7_Template, 2, 2, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const valueSelected_r5 = i0.ɵɵreference(6);
            i0.ɵɵclassProp("meeting-select_mobile", ctx.deviceService.isMobile())("meeting-select_disabled", ctx.isDisabled || ctx.disabled)("meeting-select_opened", ctx.isOpened)("meeting-select_active", ctx.active);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("href", "#chevron-up", null, "xlink");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.selectedOption)("ngIfElse", valueSelected_r5);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.isOpened);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3$1.ClickOutsideDirective, IconComponent, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.meeting-select[_ngcontent-%COMP%]{position:relative;line-height:30px}.meeting-select__input[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;height:60px;background:transparent;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;transition:border-color .2s linear;color:#ccc;display:flex;align-items:center;appearance:none;outline:none;padding:0 35px 0 20px;cursor:pointer}.meeting-select__input[_ngcontent-%COMP%]:hover{border-color:#a4b0c3}.meeting-select__chevron[_ngcontent-%COMP%]{stroke:#a4b0c3;position:absolute;right:20px;top:28px;transform:rotate(180deg);transition:all .2s linear}.meeting-select__dropdown[_ngcontent-%COMP%]{border-radius:10px;box-shadow:0 0 10px #0000001a;position:absolute;background:#fff;width:100%;right:0;color:#1e252b;margin-top:5px;max-height:280px;overflow-y:auto;z-index:1;padding:10px 0}.meeting-select_disabled[_ngcontent-%COMP%]{opacity:.5;pointer-events:none}.meeting-select_opened[_ngcontent-%COMP%]   .meeting-select__input[_ngcontent-%COMP%]{border-color:#5ab3e4}.meeting-select_opened[_ngcontent-%COMP%]   .meeting-select__chevron[_ngcontent-%COMP%]{transform:rotate(0);transition:all .2s linear}.meeting-select_mobile[_ngcontent-%COMP%]   .meeting-select__input[_ngcontent-%COMP%]{height:60px;line-height:60px}.meeting-select_mobile[_ngcontent-%COMP%]   .meeting-select__chevron[_ngcontent-%COMP%]{top:27px}.meeting-select_mobile[_ngcontent-%COMP%]   .meeting-select__dropdown[_ngcontent-%COMP%]{width:100%}.meeting-select_mobile.meeting-select_opened[_ngcontent-%COMP%]   .meeting-select__input[_ngcontent-%COMP%]{color:#1e252b;background:#fff;font-weight:400}.meeting-select_mobile.meeting-select_opened[_ngcontent-%COMP%]   .meeting-select__chevron[_ngcontent-%COMP%]{stroke:#1e252b}.meeting-select_active[_ngcontent-%COMP%]   .meeting-select__input[_ngcontent-%COMP%]{color:#1e252b}.icon[_ngcontent-%COMP%]{width:24px;height:24px;display:inline-flex;align-items:center;justify-content:space-around}.selected-option[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;color:#1e252b}.selected-option[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin:0 10px 0 0}.option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;display:flex;flex-direction:row;align-items:center;padding:0 20px;cursor:pointer;min-height:48px;box-sizing:border-box}.option[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin:0 10px 0 0}.option[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{color:#a4b0c3;margin-left:5px;display:block}.option[_ngcontent-%COMP%]   .grey[_ngcontent-%COMP%]{color:#a4b0c3}.option[_ngcontent-%COMP%]:hover{background:#f5f8fa;color:#41a1d9}"]
      });
    }
  }
  return MeetingSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const VISIBLE_AVATARS_COUNT = 3;
let ClassroomPanelComponent = /*#__PURE__*/(() => {
  class ClassroomPanelComponent {
    constructor(filesService) {
      this.filesService = filesService;
      this.hasHover = true;
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    ngOnInit() {}
    ngOnDestroy() {}
    get coverImg() {
      return {
        img: this.filesService.getFormFileUrlBySize(this.classroom.cover_id),
        form: 'base'
      };
    }
    get title() {
      const isNoTitle = !this.classroom.title || this.classroom.title === '---' || this.classroom.title === '';
      return isNoTitle ? 'classrooms.classroom.title' : this.classroom.title;
    }
    get participants() {
      if (!this.classroom || !this.classroom.participants) {
        return [];
      }
      return [...this.classroom.participants].splice(0, VISIBLE_AVATARS_COUNT);
    }
    get otherParticipantsCount() {
      const count = (this.classroom.stats || {}).accepted - VISIBLE_AVATARS_COUNT || 0;
      return count > 0 ? count : null;
    }
    trackByFn(index, participant) {
      return participant.id;
    }
    avatar(participant) {
      return {
        type: 'avatar',
        img: participant.user?.userpic?.sm?.url,
        title: AbstractAccountService.getUserFullName(participant.user),
        form: 'circle'
      };
    }
    static {
      this.ɵfac = function ClassroomPanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClassroomPanelComponent)(i0.ɵɵdirectiveInject(AbstractFilesService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ClassroomPanelComponent,
        selectors: [["app-classroom-panel"]],
        inputs: {
          classroom: "classroom",
          hasHover: "hasHover"
        },
        decls: 13,
        vars: 14,
        consts: [[1, "classroom-panel"], [1, "classroom-panel__left"], [1, "classroom-panel__img"], [1, "cover-wrap"], [3, "cover"], [1, "classroom-panel__meta"], [1, "classroom-panel__title"], [1, "classroom-panel__description"]],
        template: function ClassroomPanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵelement(4, "on-ui-cover", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "div", 7);
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("no-hover", !ctx.hasHover);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("cover", ctx.coverImg);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 8, ctx.title));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate4(" ", i0.ɵɵpipeBind1(11, 10, "lingo2-forms.meetings.classrooms.panel-classes"), " ", (ctx.classroom == null ? null : ctx.classroom.stats == null ? null : ctx.classroom.stats.meeting_finished) || 0, " \xB7 ", i0.ɵɵpipeBind1(12, 12, "lingo2-forms.meetings.classrooms.panel-students"), " ", (ctx.classroom == null ? null : ctx.classroom.stats == null ? null : ctx.classroom.stats.accepted) || 0, " ");
          }
        },
        dependencies: [i16.OnUiCoverComponent, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.cover-wrap[_ngcontent-%COMP%]{width:auto;height:40px;overflow:hidden;aspect-ratio:16/9}.classroom-panel[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;cursor:pointer;min-height:50px;justify-content:space-between}.classroom-panel__left[_ngcontent-%COMP%]{display:flex;align-items:center}.classroom-panel__img[_ngcontent-%COMP%]{margin-right:10px}.classroom-panel__meta[_ngcontent-%COMP%]{width:100%;line-height:112%}.classroom-panel__title[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 10px 5px 0;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;color:#1e252b}.classroom-panel__description[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 10px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;white-space:nowrap;color:#6d7381;display:flex}.classroom-panel__description[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{color:#41a1d9}.classroom-panel[_ngcontent-%COMP%]:hover{background:#f5f8fa}.classroom-panel.no-hover[_ngcontent-%COMP%]:hover{background:#fff}.avatars[_ngcontent-%COMP%]{display:flex;height:30px}.avatars[_ngcontent-%COMP%]   .avatar-wrap[_ngcontent-%COMP%]{height:30px;width:30px}.avatars[_ngcontent-%COMP%]   .avatar-wrap[_ngcontent-%COMP%]:not(:first-child){margin-left:-8px}.counter[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;color:#6d7381;padding:3px}"],
        changeDetection: 0
      });
    }
  }
  return ClassroomPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TabClassroomsComponent = /*#__PURE__*/(() => {
  class TabClassroomsComponent {
    constructor() {
      this.classrooms = [];
      this.changed = new EventEmitter();
    }
    ngOnInit() {}
    selectClassroom(classroom) {
      if (classroom) {
        this.changed.emit(classroom);
      } else {
        this.changed.emit(new Classroom({
          id: 'new'
        }));
      }
    }
    static {
      this.ɵfac = function TabClassroomsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TabClassroomsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TabClassroomsComponent,
        selectors: [["app-tab-classrooms"]],
        inputs: {
          classrooms: "classrooms",
          placeholder: "placeholder"
        },
        outputs: {
          changed: "changed"
        },
        decls: 7,
        vars: 5,
        consts: [["noClassrooms", ""], [1, "classes"], [1, "new-class", 3, "click"], [4, "ngIf", "ngIfElse"], [1, "title"], [1, "list"], [4, "ngFor", "ngForOf"], [1, "option", 3, "click", "classroom"], [1, "empty"], [1, "description", 3, "innerHTML"]],
        template: function TabClassroomsComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵlistener("click", function TabClassroomsComponent_Template_div_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectClassroom(null));
            });
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, TabClassroomsComponent_ng_container_4_Template, 6, 4, "ng-container", 3)(5, TabClassroomsComponent_ng_template_5_Template, 6, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const noClassrooms_r5 = i0.ɵɵreference(6);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx.placeholder), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.classrooms == null ? null : ctx.classrooms.length)("ngIfElse", noClassrooms_r5);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, ClassroomPanelComponent, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.classes[_ngcontent-%COMP%]{display:flex;flex-direction:column;box-sizing:border-box}.new-class[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 20px;font-size:16px;line-height:24px;height:60px;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;display:inline-flex;align-items:center;padding:20px}.new-class[_ngcontent-%COMP%]:hover{background:#f5f8fa;cursor:pointer}.title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 20px;font-size:16px;line-height:20px;font-size:20px;display:inline-flex;align-items:center}.empty[_ngcontent-%COMP%]{padding:20px;border-radius:10px;border:1px solid #EEEEEE}.empty[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 10px;font-size:16px;line-height:20px}.empty[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#6d7381}.list[_ngcontent-%COMP%]{overflow:auto;max-height:250px}.list[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}.list[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:#eee}.list[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:#f7f7f7}.list[_ngcontent-%COMP%]{scrollbar-face-color:#EEEEEE;scrollbar-track-color:#f7f7f7}.list[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]:hover{background:#f5f8fa}"],
        changeDetection: 0
      });
    }
  }
  return TabClassroomsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TabStudentsComponent = /*#__PURE__*/(() => {
  class TabStudentsComponent {
    constructor() {}
    ngOnInit() {}
    static {
      this.ɵfac = function TabStudentsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TabStudentsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TabStudentsComponent,
        selectors: [["app-tab-students"]],
        decls: 3,
        vars: 0,
        consts: [[1, "empty"]],
        template: function TabStudentsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtext(1, "Temporarily unavailable :(");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(2, ";\n");
          }
        },
        styles: [".empty[_ngcontent-%COMP%]{font-size:14px;line-height:100%;color:#a4b0c3;text-align:center;padding:20px}"]
      });
    }
  }
  return TabStudentsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TabGroupsComponent = /*#__PURE__*/(() => {
  class TabGroupsComponent {
    constructor() {}
    ngOnInit() {}
    static {
      this.ɵfac = function TabGroupsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TabGroupsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TabGroupsComponent,
        selectors: [["app-tab-groups"]],
        decls: 3,
        vars: 0,
        consts: [[1, "empty"]],
        template: function TabGroupsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtext(1, "Temporarily unavailable :(");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(2, ";\n");
          }
        },
        styles: [_c22]
      });
    }
  }
  return TabGroupsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var TabsEnum = /*#__PURE__*/function (TabsEnum) {
  TabsEnum["all"] = "all";
  TabsEnum["students"] = "students";
  TabsEnum["groups"] = "groups";
  return TabsEnum;
}(TabsEnum || {});
let MeetingSelectClassComponent = /*#__PURE__*/(() => {
  class MeetingSelectClassComponent {
    constructor(deviceService, classroomsService) {
      this.deviceService = deviceService;
      this.classroomsService = classroomsService;
      this.changed = new EventEmitter();
      this.closed = new EventEmitter();
      // TODO: убрать запрос me
      this.tabsEnum = TabsEnum;
      this.tabs = [{
        id: TabsEnum.all,
        label: 'All'
      }, {
        id: TabsEnum.students,
        label: 'Students'
      }, {
        id: TabsEnum.groups,
        label: 'Groups'
      }];
      this.activeTabId = TabsEnum.all;
      this.classroom_id = null;
      this.ngUnsubscribe = new Subject();
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    ngOnInit() {}
    ngOnDestroy() {
      this.ngUnsubscribe.complete();
    }
    writeValue(classroom_id) {
      this.classroom_id = classroom_id;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onClassroomChanged(classroom) {
      this.classroom_id = classroom ? classroom.id : null;
      this.propagateChange(this.classroom_id);
      this.changed.emit(this.classroom_id);
      this.onClosed();
    }
    onBlur() {
      this.propagateTouched();
    }
    onOpened() {
      if (!this.isDisabled && !this.readonly) {
        this.isOpened = !this.isOpened;
      }
    }
    onClosed() {
      if (this.isOpened) {
        this.closed.emit();
      }
      this.isOpened = false;
      this.activeTabId = TabsEnum.all;
    }
    trackByFn(index, item) {
      return item.value;
    }
    get selectedClassroom() {
      if (!this.classroom_id || !this.classrooms || !this.classrooms.length) {
        return null;
      }
      return this.classrooms.find(x => x.id === this.classroom_id);
    }
    onTabChanged(tab) {
      this.activeTabId = tab.id;
    }
    static {
      this.ɵfac = function MeetingSelectClassComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingSelectClassComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(AbstractClassroomsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MeetingSelectClassComponent,
        selectors: [["app-meeting-select-class"]],
        inputs: {
          placeholder: "placeholder",
          classrooms: "classrooms",
          me: "me",
          active: "active",
          readonly: "readonly"
        },
        outputs: {
          changed: "changed",
          closed: "closed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => MeetingSelectClassComponent),
          multi: true
        }])],
        decls: 8,
        vars: 12,
        consts: [["valueSelected", ""], [1, "meeting-select", 3, "clickOutside"], ["width", "12", "height", "7", 1, "meeting-select__chevron"], [1, "meeting-select__input", 3, "click"], [4, "ngIf", "ngIfElse"], ["class", "meeting-select__dropdown", 4, "ngIf"], [1, "placeholder"], [1, "classroom-panel", 3, "hasHover", "classroom"], [1, "meeting-select__dropdown"], [3, "ngSwitch"], [3, "classrooms", "placeholder", "changed", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [3, "changed", "classrooms", "placeholder"]],
        template: function MeetingSelectClassComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("clickOutside", function MeetingSelectClassComponent_Template_div_clickOutside_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClosed());
            });
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 2);
            i0.ɵɵelement(2, "use");
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵlistener("click", function MeetingSelectClassComponent_Template_div_click_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOpened());
            });
            i0.ɵɵtemplate(4, MeetingSelectClassComponent_ng_container_4_Template, 4, 3, "ng-container", 4)(5, MeetingSelectClassComponent_ng_template_5_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, MeetingSelectClassComponent_div_7_Template, 5, 4, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const valueSelected_r4 = i0.ɵɵreference(6);
            i0.ɵɵclassProp("meeting-select_mobile", ctx.deviceService.isMobile())("meeting-select_disabled", ctx.isDisabled || ctx.readonly)("meeting-select_opened", ctx.isOpened)("meeting-select_active", ctx.active);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("href", "#chevron-up", null, "xlink");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.selectedClassroom)("ngIfElse", valueSelected_r4);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.isOpened);
          }
        },
        dependencies: [i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i3$1.ClickOutsideDirective, ClassroomPanelComponent, TabClassroomsComponent, TabStudentsComponent, TabGroupsComponent, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.tabs[_ngcontent-%COMP%]{display:block;margin-bottom:20px}.meeting-select[_ngcontent-%COMP%]{position:relative;line-height:30px;display:block;width:100%}.meeting-select__input[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;height:60px;background:transparent;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;transition:border-color .2s linear;appearance:none;outline:none;padding:5px 35px 5px 10px;cursor:pointer}.meeting-select__input[_ngcontent-%COMP%]   .placeholder[_ngcontent-%COMP%]{height:50px;display:inline-flex;align-items:center;padding:0 0 0 10px}.meeting-select__input[_ngcontent-%COMP%]:hover{border-color:#a4b0c3}.meeting-select__chevron[_ngcontent-%COMP%]{stroke:#a4b0c3;position:absolute;right:20px;top:28px;transform:rotate(180deg);transition:all .2s linear}.meeting-select__dropdown[_ngcontent-%COMP%]{border-radius:10px;box-shadow:0 0 10px #0000001a;position:absolute;background:#fff;width:100%;right:0;color:#1e252b;margin-top:5px;max-height:500px;overflow-y:auto;z-index:1;padding:20px;box-sizing:border-box}.meeting-select_disabled[_ngcontent-%COMP%]{opacity:.5;pointer-events:none}.meeting-select_disabled[_ngcontent-%COMP%]   .placeholder[_ngcontent-%COMP%]{opacity:.3}.meeting-select_opened[_ngcontent-%COMP%]   .meeting-select__input[_ngcontent-%COMP%]{border-color:#41a1d9}.meeting-select_opened[_ngcontent-%COMP%]   .meeting-select__chevron[_ngcontent-%COMP%]{transform:rotate(0);transition:all .2s linear}.meeting-select_active[_ngcontent-%COMP%]   .meeting-select__input[_ngcontent-%COMP%]{border-color:#5ab3e4}.meeting-select_mobile[_ngcontent-%COMP%]   .meeting-select__input[_ngcontent-%COMP%]{height:60px;line-height:16px}.meeting-select_mobile[_ngcontent-%COMP%]   .meeting-select__chevron[_ngcontent-%COMP%]{top:25px}.meeting-select_mobile[_ngcontent-%COMP%]   .meeting-select__dropdown[_ngcontent-%COMP%]{width:100%}.meeting-select_mobile.meeting-select_opened[_ngcontent-%COMP%]   .meeting-select__input[_ngcontent-%COMP%]{color:#1e252b;background:#fff;font-weight:400}.meeting-select_mobile.meeting-select_opened[_ngcontent-%COMP%]   .meeting-select__chevron[_ngcontent-%COMP%]{stroke:#1e252b}.icon[_ngcontent-%COMP%]{width:24px;height:24px;display:inline-flex;align-items:center;justify-content:space-around}.selected-option[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;color:#1e252b}.selected-option[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin:0 10px 0 0}.option[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;display:flex;flex-direction:row;align-items:center;padding:0 20px;cursor:pointer;min-height:48px;box-sizing:border-box}.option[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin:0 10px 0 0}.option[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{color:#a4b0c3;margin-left:5px;display:block}.option[_ngcontent-%COMP%]   .grey[_ngcontent-%COMP%]{color:#a4b0c3}.option[_ngcontent-%COMP%]:hover{background:#f5f8fa;color:#41a1d9}"]
      });
    }
  }
  return MeetingSelectClassComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingStepComponent = /*#__PURE__*/(() => {
  class MeetingStepComponent {
    constructor(device) {
      this.device = device;
      this.index = 0;
      this.title = '';
    }
    ngOnInit() {}
    static {
      this.ɵfac = function MeetingStepComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingStepComponent)(i0.ɵɵdirectiveInject(DeviceService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MeetingStepComponent,
        selectors: [["app-meeting-step"]],
        inputs: {
          first: "first",
          last: "last",
          completed: "completed",
          active: "active",
          disabled: "disabled",
          noContent: "noContent",
          index: "index",
          title: "title"
        },
        ngContentSelectors: _c0,
        decls: 7,
        vars: 18,
        consts: [[1, "step"], [1, "step-circle"], [1, "step-title"], [1, "step-content"]],
        template: function MeetingStepComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("first", ctx.first)("last", ctx.last)("completed", ctx.completed)("active", ctx.active)("disabled", ctx.disabled)("mobile", ctx.device.isMobile())("tablet", ctx.device.isTablet())("no-content", ctx.noContent);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.index + 1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title);
          }
        },
        styles: ["@charset \"UTF-8\";.step[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;border-left:1px solid #EEEEEE;position:relative;margin-left:14px}.step.first[_ngcontent-%COMP%]:before{content:\"\";height:50%;width:28px;background:#fff;position:absolute;left:-14px;box-sizing:border-box;top:0}.step.last[_ngcontent-%COMP%]:before{content:\"\";height:50%;width:28px;background:#fff;position:absolute;left:-14px;box-sizing:border-box;bottom:0}.step.no-content[_ngcontent-%COMP%]{margin-bottom:10px}.step.no-content[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{width:100%}.step.no-content[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]{display:none}.step.completed[_ngcontent-%COMP%]:not(.active)   .step-circle[_ngcontent-%COMP%]{border:1px solid #87D37C;color:#fff;background:#87d37c}.step.active[_ngcontent-%COMP%]   .step-circle[_ngcontent-%COMP%]{border:1px solid #5AB3E4;color:#fff;background:#5ab3e4}.step.disabled[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{opacity:.5}.step.mobile[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;border-left:none;margin-left:0}.step.mobile[_ngcontent-%COMP%]   .step-circle[_ngcontent-%COMP%]{left:0}.step.mobile[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{padding:7px 10px;width:100%;margin-left:28px;margin-bottom:10px}.step.mobile[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]{padding:0;width:100%}.step[_ngcontent-%COMP%]   .step-circle[_ngcontent-%COMP%]{position:absolute;height:28px;width:28px;box-sizing:border-box;border:1px solid #EEEEEE;color:#a4b0c3;background:#fff;border-radius:50%;left:-14px;display:inline-flex;flex-direction:column;justify-content:center;align-items:center;flex-shrink:0;transition:all .2s linear}.step[_ngcontent-%COMP%]   .step-circle[_ngcontent-%COMP%]:before{content:\"\";height:5px;width:28px;background:#fff;position:absolute;top:-6px}.step[_ngcontent-%COMP%]   .step-circle[_ngcontent-%COMP%]:after{content:\"\";height:5px;width:28px;background:#fff;position:absolute;bottom:-6px}.step[_ngcontent-%COMP%]   .step-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;font-size:16px;line-height:20px;margin:0 0 0 14px;padding:15px;width:182px;box-sizing:border-box;flex-shrink:0}.step[_ngcontent-%COMP%]   .step-content[_ngcontent-%COMP%]{padding:5px 0;box-sizing:border-box;flex-grow:1}"],
        changeDetection: 0
      });
    }
  }
  return MeetingStepComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthorItemComponent = /*#__PURE__*/(() => {
  class AuthorItemComponent extends ChangableComponent {
    set author(author) {
      this._author = author;
      this.prepare();
    }
    constructor(cdr, accountService, filesService) {
      super(cdr);
      this.cdr = cdr;
      this.accountService = accountService;
      this.filesService = filesService;
      this.svgSetIcon = IconsService.svgsetIconUrl;
      this.cover = {
        type: 'avatar',
        form: 'circle'
      };
    }
    ngOnInit() {}
    prepare() {
      this.accountService.getUserById(this._author.account_id).pipe(takeUntil(this.destroyed$)).subscribe(res => {
        this.fullName = AbstractAccountService.getUserFullName(res);
        this.cover = {
          type: 'avatar',
          form: 'circle',
          img: this.filesService.getFormFileUrlBySize(res.userpic_id)
        };
        this.stats = res.stats;
        this.detectChanges();
      });
    }
    get changeRateFormat() {
      return Math.round((this.stats?.reviews_rating + Number.EPSILON) * 10) / 10;
    }
    static {
      this.ɵfac = function AuthorItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AuthorItemComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AbstractAccountService), i0.ɵɵdirectiveInject(AbstractFilesService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AuthorItemComponent,
        selectors: [["app-author-item"]],
        inputs: {
          author: "author"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [["class", "author-item", 4, "ngIf"], [1, "author-item"], [1, "avatar-wrap"], [3, "cover"], [1, "full-name"], ["class", "stats", 4, "ngIf"], [1, "stats"], ["width", "16", "height", "16", "viewBox", "0 0 16 16", "fill", "#FFDD00"], [1, "reviews-rating"], [1, "reviews-count"]],
        template: function AuthorItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, AuthorItemComponent_div_0_Template, 6, 3, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.fullName);
          }
        },
        dependencies: [i2.NgIf, i16.OnUiCoverComponent, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.author-item[_ngcontent-%COMP%]{align-items:center;display:flex;padding:10px 0}.author-item[_ngcontent-%COMP%]   .avatar-wrap[_ngcontent-%COMP%]{height:40px;margin-right:10px;width:40px;flex-shrink:0}.author-item[_ngcontent-%COMP%]   .full-name[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 10px 0 0;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;color:#1e252b;max-width:200px}.author-item[_ngcontent-%COMP%]   .stats[_ngcontent-%COMP%]{align-items:center;display:flex}.author-item[_ngcontent-%COMP%]   .stats[_ngcontent-%COMP%]   .reviews-rating[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;color:#a4b0c3;font-size:14px;line-height:18px;color:#fd0;margin:2px 5px 0}.author-item[_ngcontent-%COMP%]   .stats[_ngcontent-%COMP%]   .reviews-count[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;color:#a4b0c3;font-size:14px;line-height:18px;color:#41a1d9;margin:2px 0 0}"],
        changeDetection: 0
      });
    }
  }
  return AuthorItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingSelectAuthorComponent = /*#__PURE__*/(() => {
  class MeetingSelectAuthorComponent {
    constructor(deviceService) {
      this.deviceService = deviceService;
      this.changed = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    ngOnInit() {}
    ngOnDestroy() {}
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    onChanged(option) {
      const value = option.account_id;
      this.value = value;
      this.propagateChange(value);
      this.changed.emit(value);
      this.onClosed();
    }
    onBlur() {
      this.propagateTouched();
    }
    onOpened() {
      if (!this.isDisabled) {
        this.isOpened = !this.isOpened;
      }
    }
    onClosed() {
      this.isOpened = false;
    }
    trackByFn(index, item) {
      return item.account_id;
    }
    get selectedOption() {
      if (!this.value || !this.schoolParticipants.length) {
        return null;
      }
      return this.schoolParticipants.find(x => x.account_id === this.value);
    }
    static {
      this.ɵfac = function MeetingSelectAuthorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingSelectAuthorComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MeetingSelectAuthorComponent,
        selectors: [["app-meeting-select-author"]],
        inputs: {
          schoolParticipants: "schoolParticipants",
          active: "active"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => MeetingSelectAuthorComponent),
          multi: true
        }])],
        decls: 8,
        vars: 12,
        consts: [["empty", ""], ["emptyDropdown", ""], [1, "meeting-select-author", 3, "clickOutside"], ["width", "12", "height", "7", 1, "meeting-select-author__chevron"], [1, "meeting-select-author__input", 3, "click"], [4, "ngIf", "ngIfElse"], ["class", "meeting-select-author__dropdown", 4, "ngIf"], [3, "author"], [1, "meeting-select-author__dropdown"], [1, "meeting-select-author__dropdown-scroll"], ["class", "option", 3, "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "option", 3, "click"], [1, "empty-message"]],
        template: function MeetingSelectAuthorComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵlistener("clickOutside", function MeetingSelectAuthorComponent_Template_div_clickOutside_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClosed());
            });
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 3);
            i0.ɵɵelement(2, "use");
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(3, "div", 4);
            i0.ɵɵlistener("click", function MeetingSelectAuthorComponent_Template_div_click_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOpened());
            });
            i0.ɵɵtemplate(4, MeetingSelectAuthorComponent_ng_container_4_Template, 2, 1, "ng-container", 5)(5, MeetingSelectAuthorComponent_ng_template_5_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, MeetingSelectAuthorComponent_div_7_Template, 5, 2, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const empty_r6 = i0.ɵɵreference(6);
            i0.ɵɵclassProp("meeting-select-author_mobile", ctx.deviceService.isMobile())("meeting-select-author_disabled", ctx.isDisabled)("meeting-select-author_opened", ctx.isOpened)("meeting-select-author_active", ctx.active);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("href", "#chevron-up", null, "xlink");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.selectedOption)("ngIfElse", empty_r6);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.isOpened);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3$1.ClickOutsideDirective, AuthorItemComponent, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.meeting-select-author[_ngcontent-%COMP%]{position:relative;line-height:30px}.meeting-select-author__input[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;height:60px;background:transparent;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;transition:border-color .2s linear;color:#ccc;display:flex;align-items:center;appearance:none;outline:none;padding:0 35px 0 20px;cursor:text}.meeting-select-author__chevron[_ngcontent-%COMP%]{stroke:#a4b0c3;position:absolute;right:20px;top:28px;transform:rotate(180deg);transition:all .2s linear}.meeting-select-author__dropdown[_ngcontent-%COMP%]{border-radius:10px;box-shadow:0 0 10px #0000001a;position:absolute;background:#fff;width:100%;right:0;color:#1e252b;margin-top:5px;max-height:280px;z-index:1;padding:10px 0}.meeting-select-author__dropdown-scroll[_ngcontent-%COMP%]{overflow-y:auto;max-height:280px}.meeting-select-author__dropdown-scroll[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}.meeting-select-author__dropdown-scroll[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:#eee}.meeting-select-author__dropdown-scroll[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:#f7f7f7}.meeting-select-author__dropdown-scroll[_ngcontent-%COMP%]{scrollbar-face-color:#EEEEEE;scrollbar-track-color:#f7f7f7}.meeting-select-author__dropdown[_ngcontent-%COMP%]   .empty-message[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#a4b0c3;display:flex;justify-content:center;padding:20px}.meeting-select-author_disabled[_ngcontent-%COMP%]{opacity:.5}.meeting-select-author_opened[_ngcontent-%COMP%]   .meeting-select__chevron[_ngcontent-%COMP%]{transform:rotate(0);transition:all .2s linear}.meeting-select-author_mobile[_ngcontent-%COMP%]   .meeting-select-author__input[_ngcontent-%COMP%]{height:37px;line-height:37px}.meeting-select-author_mobile[_ngcontent-%COMP%]   .meeting-select-author__chevron[_ngcontent-%COMP%]{top:15px}.meeting-select-author_mobile[_ngcontent-%COMP%]   .meeting-select-author__dropdown[_ngcontent-%COMP%]{width:100%}.meeting-select-author_mobile.meeting-select-author_opened[_ngcontent-%COMP%]   .meeting-select-author__input[_ngcontent-%COMP%]{color:#1e252b;background:#fff}.meeting-select-author_mobile.meeting-select-author_opened[_ngcontent-%COMP%]   .meeting-select-author__chevron[_ngcontent-%COMP%]{stroke:#1e252b}.meeting-select-author_active[_ngcontent-%COMP%]   .meeting-select-author__input[_ngcontent-%COMP%]{border-color:#5ab3e4}.option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;display:flex;flex-direction:row;align-items:center;padding:0 10px;cursor:pointer;min-height:48px;box-sizing:border-box}.option[_ngcontent-%COMP%]:hover{background:#f5f8fa;color:#41a1d9}"]
      });
    }
  }
  return MeetingSelectAuthorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotAvailableTimeInformerComponent = /*#__PURE__*/(() => {
  class NotAvailableTimeInformerComponent {
    constructor(filesService) {
      this.filesService = filesService;
      this.meetingTitle = '';
      this.subject = '';
    }
    set meeting(meeting) {
      this._meeting = meeting;
      this.prepareMeeting();
    }
    prepareMeeting() {
      this.user_id = '';
      this.coverImg = {
        img: this.filesService.getFormFileUrlBySize(this._meeting.cover_id),
        form: 'base'
      };
      this.meetingTitle = this._meeting.title;
      this.subject = this._meeting.subject.title;
      this.begin_at = new Date(this._meeting.begin_at);
      this.end_at = new Date(this._meeting.end_at);
    }
    writeUser() {
      // TODO: невозможно написать пользователю
      // повесить событие на output?
      // this.store.dispatch(openPrivateChat({ user_id: this.user_id }));
    }
    onCancel() {}
    onReschedule() {}
    static {
      this.ɵfac = function NotAvailableTimeInformerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotAvailableTimeInformerComponent)(i0.ɵɵdirectiveInject(AbstractFilesService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NotAvailableTimeInformerComponent,
        selectors: [["app-not-available-time-informer"]],
        inputs: {
          error: "error",
          meeting: "meeting"
        },
        decls: 21,
        vars: 26,
        consts: [[1, "not-available-time-informer", 3, "ngClass"], [1, "title"], [1, "meeting-wrap"], [1, "cover-wrap"], [3, "cover"], [1, "meeting-info"], [1, "subject"], [1, "meeting-title"], ["class", "participant", 4, "ngIf"], ["class", "send-message", 3, "click", 4, "ngIf"], [1, "info-text"], ["class", "actions-wrap", 4, "ngIf"], [1, "participant"], [1, "participant-label"], [1, "participant-label", "name"], [1, "send-message", 3, "click"], [1, "actions-wrap"], [1, "button-wrap"], ["state", "default", "label", "lingo2-forms.meetings.not-available-time-informer.cancel-class", 1, "danger", 3, "onclick"], ["state", "default", "label", "lingo2-forms.meetings.not-available-time-informer.postpone-class", 1, "primary", 3, "onclick"]],
        template: function NotAvailableTimeInformerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0)(1, "h2", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵpipe(4, "dfnsFormat");
            i0.ɵɵpipe(5, "dfnsFormat");
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 2)(8, "div", 3);
            i0.ɵɵelement(9, "on-ui-cover", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 5)(11, "span", 6);
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "h3", 7);
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(15, NotAvailableTimeInformerComponent_div_15_Template, 7, 3, "div", 8)(16, NotAvailableTimeInformerComponent_span_16_Template, 3, 3, "span", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "p", 10);
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(20, NotAvailableTimeInformerComponent_div_20_Template, 5, 0, "div", 11);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c23, ctx.error));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate4(" ", i0.ɵɵpipeBind1(3, 12, "lingo2-forms.meetings.not-available-time-informer.title-part1"), " ", i0.ɵɵpipeBind2(4, 14, ctx.begin_at, "HH:mm"), " - ", i0.ɵɵpipeBind2(5, 17, ctx.end_at, "HH:mm"), " ", i0.ɵɵpipeBind1(6, 20, "lingo2-forms.meetings.not-available-time-informer.title-part2"), " ");
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("cover", ctx.coverImg);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.subject);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.meetingTitle);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.user_id);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 22, "lingo2-forms.meetings.not-available-time-informer.info-text"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", false);
          }
        },
        dependencies: [i2.NgClass, i2.NgIf, i16.OnUiButtonComponent, i16.OnUiCoverComponent, i3.TranslatePipe, i6.FormatPipe],
        styles: ["@charset \"UTF-8\";.not-available-time-informer[_ngcontent-%COMP%]{background:#f5f8fa;border-radius:10px;box-sizing:border-box;padding:20px;width:440px;border:1px solid #41A1D9}.not-available-time-informer.teacher-error[_ngcontent-%COMP%]{border:1px solid #E86F79}.not-available-time-informer[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 17px;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b}.not-available-time-informer[_ngcontent-%COMP%]   .meeting-wrap[_ngcontent-%COMP%]{display:flex;margin-bottom:20px}.not-available-time-informer[_ngcontent-%COMP%]   .meeting-wrap[_ngcontent-%COMP%]   .cover-wrap[_ngcontent-%COMP%]{height:80px;margin-right:20px;width:80px}.not-available-time-informer[_ngcontent-%COMP%]   .meeting-wrap[_ngcontent-%COMP%]   .meeting-info[_ngcontent-%COMP%]{flex:1 1 10px;width:10px}.not-available-time-informer[_ngcontent-%COMP%]   .meeting-wrap[_ngcontent-%COMP%]   .meeting-info[_ngcontent-%COMP%]   .subject[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;color:#41a1d9;margin:5px 0 0;display:block}.not-available-time-informer[_ngcontent-%COMP%]   .meeting-wrap[_ngcontent-%COMP%]   .meeting-info[_ngcontent-%COMP%]   .meeting-title[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;color:#1e252b}.not-available-time-informer[_ngcontent-%COMP%]   .meeting-wrap[_ngcontent-%COMP%]   .meeting-info[_ngcontent-%COMP%]   .participant[_ngcontent-%COMP%]{display:flex}.not-available-time-informer[_ngcontent-%COMP%]   .meeting-wrap[_ngcontent-%COMP%]   .meeting-info[_ngcontent-%COMP%]   .participant[_ngcontent-%COMP%]   .participant-label[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px}.not-available-time-informer[_ngcontent-%COMP%]   .meeting-wrap[_ngcontent-%COMP%]   .meeting-info[_ngcontent-%COMP%]   .participant[_ngcontent-%COMP%]   .participant-label.name[_ngcontent-%COMP%]{color:#1e252b;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal}.not-available-time-informer[_ngcontent-%COMP%]   .meeting-wrap[_ngcontent-%COMP%]   .meeting-info[_ngcontent-%COMP%]   .send-message[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;color:#a4b0c3;font-size:14px;line-height:18px;color:#41a1d9;cursor:pointer;display:block;padding:10px;margin:-10px;width:fit-content}.not-available-time-informer[_ngcontent-%COMP%]   .info-text[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;margin:0}.not-available-time-informer[_ngcontent-%COMP%]   .actions-wrap[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.not-available-time-informer[_ngcontent-%COMP%]   .actions-wrap[_ngcontent-%COMP%]   .button-wrap[_ngcontent-%COMP%]{margin-left:10px}@media all and (max-width: 640px){.not-available-time-informer[_ngcontent-%COMP%]{width:100%}}"],
        changeDetection: 0
      });
    }
  }
  return NotAvailableTimeInformerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingHeaderComponent = /*#__PURE__*/(() => {
  class MeetingHeaderComponent {
    constructor(route) {
      this.route = route;
      this.buyCredits = new EventEmitter();
    }
    ngOnInit() {}
    ngOnDestroy() {}
    onBuyCredits() {
      this.buyCredits.emit();
    }
    static {
      this.ɵfac = function MeetingHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingHeaderComponent)(i0.ɵɵdirectiveInject(i1$2.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MeetingHeaderComponent,
        selectors: [["app-meeting-header"]],
        inputs: {
          isNew: "isNew",
          isModal: "isModal",
          isActivePlan: "isActivePlan",
          creditsAmount: "creditsAmount"
        },
        outputs: {
          buyCredits: "buyCredits"
        },
        decls: 5,
        vars: 6,
        consts: [[1, "header"], [1, "title"], ["class", "credits", 4, "ngIf"], [1, "credits"], [1, "amount"], [1, "link", 3, "click"]],
        template: function MeetingHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h2", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, MeetingHeaderComponent_div_4_Template, 7, 7, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("header_modal", ctx.isModal);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx.isNew ? "lingo2-forms.meetings.form-title" : "lingo2-forms.meetings.form-change-title"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isActivePlan);
          }
        },
        dependencies: [i2.NgIf, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.header[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:20px 30px;border-bottom:1px solid #EEEEEE;margin-bottom:30px}.header[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:22px;line-height:26px}.header[_ngcontent-%COMP%]   .credits[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;display:inline-flex;flex-direction:column;justify-content:space-between}.header[_ngcontent-%COMP%]   .credits[_ngcontent-%COMP%]   .amount[_ngcontent-%COMP%]{margin-bottom:7px}.header[_ngcontent-%COMP%]   .credits[_ngcontent-%COMP%]   .link[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#41a1d9}.header_modal[_ngcontent-%COMP%]{padding:0 0 20px}"],
        changeDetection: 0
      });
    }
  }
  return MeetingHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// 'Другой уровень' TODO нужно добавить в модели по аналогии с дисциплинами
const otherLevelId = -1;
let MeetingFormComponent = /*#__PURE__*/(() => {
  class MeetingFormComponent {
    set meeting(meeting) {
      this._meeting = meeting instanceof Meeting ? meeting : new Meeting(meeting);
      if (this.form) {
        this.patchFormValues();
      }
    }
    get meeting() {
      return this._meeting;
    }
    set cover(cover) {
      if (cover && cover.id) {
        this.form.controls.cover_id.setValue(cover.id);
      }
    }
    set references(references) {
      this._references = references;
      this.mapReferencesToParameters(references);
    }
    get references() {
      return this._references;
    }
    /** References */
    get subjects() {
      return this.references.subjects;
    }
    get me() {
      return this.references.me;
    }
    constructor(debugService, fb, meetingsService, billingService, currencyService, configService, featuresService, router, dateConfig, elementRef, screenService, websocket, device, cdr, dateAdapter) {
      this.debugService = debugService;
      this.fb = fb;
      this.meetingsService = meetingsService;
      this.billingService = billingService;
      this.currencyService = currencyService;
      this.configService = configService;
      this.featuresService = featuresService;
      this.router = router;
      this.dateConfig = dateConfig;
      this.elementRef = elementRef;
      this.screenService = screenService;
      this.websocket = websocket;
      this.device = device;
      this.cdr = cdr;
      this.dateAdapter = dateAdapter;
      /**
       * Подходит для случаев, когда нужно создать новый митинг с
       * предустановленными полями
       * TODO: в шаблоне параметр readonly установлен только у classroom_id,
       * нужно расширить на остальные поля
       */
      this.readonlyFields = [];
      this.buyCredits = new EventEmitter();
      this.activatePlan = new EventEmitter();
      this.saved = new EventEmitter();
      this.openGallery = new EventEmitter();
      this.changeCover = new EventEmitter();
      this.openPaywall = new EventEmitter();
      this.otherLevelId = otherLevelId;
      this.versions = versions;
      /** Controls options lists */
      this.subjectLevelOptions = [];
      this.languagesOptions = [];
      this.pricesList = [];
      this.typesList = typesList;
      this.typesOptions = typesOptions;
      this.groupLimitsList = groupLimitsList;
      this.keyword = '';
      this.saveState = 'default';
      this.constants = constants;
      this.timeBeginAtList = [];
      this.timeEndAtList = [];
      this.dateFormat = new FormatPipe(this.dateConfig, null);
      this.isTimeAvailable = false;
      this.showTimeInformer = false;
      this.isTimeValidating = false;
      /** // Billing */
      this.classrooms = [];
      this.svgSetIcon = IconsService.svgsetIconUrl;
      this.isLandscape = false;
      this.isPortrait = true;
      this.planFormOpened = false;
      this.creditsBuyFormOpened = false;
      this.couponFormOpened = false;
      this.validationVisible = false;
      this.isClassroomsViewedByUser = false;
      this.debug$ = this.debugService.debug$;
      this.onTimeChange = throttle(() => {
        this._onTimeChange();
      }, 100);
      this.calcHelper = new MeetingCalcHelper();
      this.validatorInjector = new ConditionalValidatorsInjector(this);
      this.subscription = new Subscription();
      this.destroyed$ = new Subject();
      const minDate = startOfDay(new Date());
      const maxDate = addMonths(new Date(), 1);
      this.datePickerConfig = {
        min: minDate,
        max: maxDate,
        startView: 'month'
      };
      this.suggestKeywords = [
        // '200 new words',
        // 'How to ask a question',
        // 'Infinitive',
        // 'Formulas',
        // 'Present Simple',
      ];
      this.el = this.elementRef.nativeElement;
      this.configService.updatePlan$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
        this.getActivePlan();
      });
    }
    set locale(value) {
      if (value) {
        this.dateAdapter.setLocale(value);
      }
      this._locale = value;
    }
    get locale() {
      return this._locale;
    }
    ngOnInit() {
      this.activeStepIndex = this.isNew || this.displayAsNew ? 0 : null;
      this.currencyService.getCurrenciesRate().pipe(tap$1(currencies => {
        this.currencies = currencies;
        this.mapReferencesToParameters(this.references);
      }), takeUntil(this.destroyed$)).subscribe();
      /** Map data and set options */
      this.createForm();
      this.patchFormValues();
      this.listenFormChanges();
      this.getActivePlan();
      this.watchScreenOptions$.pipe(takeUntil(this.destroyed$)).subscribe();
      this.websocket.onPlanUpdate.pipe(takeUntil(this.destroyed$)).subscribe(() => this.getActivePlan());
      // interval(60 * 1000) // раз в минуту
      // this._timeChangeInterval = setInterval(() => {
      //   this.updateTimeArrays();
      //   }, 60 * 1000); // раз в минуту
    }
    ngOnChanges(changes) {
      if (changes.creditsAmount && !changes.creditsAmount.firstChange) {
        this.form.updateValueAndValidity();
      }
    }
    ngAfterContentInit() {
      this.formGroup?.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(res => {
        this.form.controls['cover_id'].setValue(res.cover_id);
        this.cdr.detectChanges();
      });
    }
    ngOnDestroy() {
      this.destroyed$.next(true);
      this.destroyed$.complete();
      this.subscription.unsubscribe();
      if (this.timeChangeInterval) {
        clearInterval(this.timeChangeInterval);
      }
      if (this.resetSaveStateTimeout) {
        clearTimeout(this.resetSaveStateTimeout);
      }
    }
    get isSchoolMeeting() {
      return this.meeting.school_id || this.meeting.school?.id;
    }
    isStepCompleted(id) {
      switch (id) {
        case 0:
          return this.isSchoolMeeting ? this.form.controls.author_id.value : this.form.controls.classroom_id.value;
        case 1:
          return this.form.controls.type.value && this.form.controls.type.valid;
        case 2:
          return this.form.controls.preset.value;
        case 3:
          return this.form.valid;
      }
    }
    isStepActive(id) {
      return this.activeStepIndex === id;
    }
    schoolParticipants() {
      return this._meeting?.school?.participants?.filter(_p => _p.role === ESchoolParticipantRole.teacher);
    }
    mapReferencesToParameters(refs) {
      /** Classrooms */
      this.classrooms = refs.classrooms;
      /** Billing */
      const settings = refs.billingSettings;
      this.billingSettings = settings;
      this.accountCheck = refs.accountCheck;
      this.hasPaidPlan = settings.plan && settings.plan?.plan?.price_tier_id !== null;
      this.typesList.forEach(value => {
        value.disabled = value.value > settings.features.meetings_max_participants;
      });
      if (this.currencies) {
        let selectedCurrency = Object.keys(CurrencyEnum)[Object.values(CurrencyEnum).indexOf(this.me.currency_id)].toUpperCase();
        if (selectedCurrency === 'RUR') {
          selectedCurrency = 'RUB';
        }
        const rate = this.getRateForCurrency(this.currencies, selectedCurrency);
        if (rate) {
          this.pricesList = settings.prices.map(price_tier => ({
            value: price_tier.id,
            sub_title: '<span class="sub_value">(≈' + (price_tier.amount * rate.rate).toFixed(rate.fraction) + ' ' + rate.currency + ')</span>',
            title: this.billingService.formatPriceTier(price_tier),
            price_tier
          }));
        } else {
          this.pricesList = settings.prices.map(price_tier => ({
            value: price_tier.id,
            title: this.billingService.formatPriceTier(price_tier),
            price_tier
          }));
        }
      } else {
        this.pricesList = settings.prices.map(price_tier => ({
          value: price_tier.id,
          title: this.billingService.formatPriceTier(price_tier),
          price_tier
        }));
      }
      /** Languages */
      this.languagesOptions = this.references.languages.map(x => ({
        value: x.id,
        title: x.title
      }));
    }
    /**
     * Для совместимости с интерфейсом IConditionalValidatorsInjector
     *
     * @see IConditionalValidatorsInjector
     */
    get account() {
      return this.references?.me;
    }
    get watchScreenOptions$() {
      return this.screenService.options.pipe(tap$1(options => {
        this.isLandscape = options.isLandscape;
        this.isPortrait = options.isPortrait;
      }));
    }
    get selectedPriceTier() {
      const {
        charging,
        price_tier
      } = this.form.value;
      if (charging === this.constants.fee) {
        const _p = this.pricesList.find(p => p.value === price_tier);
        return _p ? _p.price_tier : null;
      }
      return null;
    }
    get meetingDate() {
      return this.form.get('date').value;
    }
    get minBeginTime() {
      const meetingDate = this.meetingDate;
      const nearestTime = addMinutes(startOfHour(this.newZonedDate()), 30);
      return meetingDate < nearestTime ? nearestTime : meetingDate;
    }
    get minEndTime() {
      const meeting_begin_at = this.form.get('begin_at').value;
      const minBeginTime = addMinutes(this.minBeginTime, 30);
      const nearestTime = addMinutes(meeting_begin_at, 30);
      return minBeginTime < nearestTime ? nearestTime : minBeginTime;
    }
    // Корректируем погрешность времени окончания.
    prepareEndAt(time) {
      return time.getTime();
    }
    fixDateBeginEndTime() {
      // TODO !! fix meeting.date
      const dateString = this.dateFormat.transform(this.meetingDate, 'yyyy-MM-dd');
      const dateEndOfDay = parseISO(dateString + 'T23:59:59');
      const begin_at = new Date(this.form.get('begin_at').value);
      const minBeginTime = this.minBeginTime;
      if (begin_at < minBeginTime || begin_at > dateEndOfDay) {
        this.form.get('begin_at').patchValue(minBeginTime.getTime(), {
          emitEvent: false
        });
      }
      const end_at = new Date(this.form.get('end_at').value);
      const minEndTime = this.minEndTime;
      if (end_at < minEndTime) {
        this.form.get('end_at').patchValue(this.prepareEndAt(minEndTime), {
          emitEvent: false
        });
      }
    }
    updateTimeLists() {
      this.fixDateBeginEndTime();
      const {
        meetingDate,
        minBeginTime,
        minEndTime
      } = this;
      const dateString = this.dateFormat.transform(meetingDate, 'yyyy-MM-dd');
      const dateStartOfDay = parseISO(dateString + 'T00:00:00');
      const dateEndOfDay = parseISO(dateString + 'T23:59:59');
      const timeBeginAtList = [];
      const timeEndAtList = [];
      let _time = dateStartOfDay;
      let i = 48; // защита от зацикливания = 48 интервалов по 30 минут
      while (_time < dateEndOfDay) {
        const _beginAt = _time;
        const _beginAtString = this.dateFormat.transform(_beginAt, 'HH:mm');
        // debug const _timeBeginString = this.dateFormat.transform(_timeBegin, 'yyyy-MM-dd HH:mm:ss z');
        const _endAt = addMinutes(_beginAt, 30);
        const _endAtString = this.dateFormat.transform(_endAt, 'HH:mm');
        // debug const _timeEndString = this.dateFormat.transform(_timeEnd, 'yyyy-MM-dd HH:mm:ss z');
        if (!(_beginAt < minBeginTime)) {
          timeBeginAtList.push({
            value: _beginAt.getTime(),
            title: _beginAtString
            // disabled: _beginAt < minBeginTime,
          });
        }
        if (!(_endAt < minEndTime)) {
          timeEndAtList.push({
            value: this.prepareEndAt(_endAt),
            title: _endAtString === '00:00' ? '00:00' : _endAtString
            // disabled: _endAt < minEndTime,
          });
        }
        _time = addMinutes(_time, 30);
        if (i-- < 0) {
          break; // защита от зацикливания
        }
      }
      this.timeBeginAtList = timeBeginAtList;
      const timeEndAtListNextDay = this.addTimeOfTheNextDay();
      this.timeEndAtList = [...timeEndAtList, ...timeEndAtListNextDay.splice(0, timeEndAtListNextDay.length - timeEndAtList.length)];
      this.onTimeChange();
    }
    addTimeOfTheNextDay() {
      const {
        meetingDate,
        minEndTime
      } = this;
      const dateString = this.dateFormat.transform(meetingDate, 'yyyy-MM-dd');
      const dateStartOfNextDay = addHours(parseISO(dateString + 'T00:00:00'), 24);
      const nextDateString = this.dateFormat.transform(dateStartOfNextDay, 'yyyy-MM-dd');
      const dateEndOfNextDay = parseISO(nextDateString + 'T23:59:59');
      let _time = dateStartOfNextDay;
      /** @todo strong typings */
      const timeEndAtList = [];
      let i = 48;
      while (_time < dateEndOfNextDay) {
        const _beginAt = _time;
        const _endAt = addMinutes(_beginAt, 30);
        const _endAtString = this.dateFormat.transform(_endAt, 'HH:mm');
        const _endAtDateString = this.dateFormat.transform(_endAt, 'dd MMM');
        const _endAtTimeString = _endAtString === '00:00' ? '00:00' : _endAtString;
        if (!(_endAt < minEndTime)) {
          timeEndAtList.push({
            value: this.prepareEndAt(_endAt),
            title: `${_endAtTimeString} - ${_endAtDateString}`
            // mode: 'light'
          });
        }
        _time = addMinutes(_time, 30);
        if (i-- < 0) {
          break; // защита от зацикливания
        }
      }
      return timeEndAtList;
    }
    _onTimeChange() {
      const {
        begin
      } = this.form.value;
      const {
        me
      } = this.references;
      let {
        begin_at,
        end_at
      } = this.form.value;
      begin_at = new Date(begin_at);
      end_at = new Date(end_at);
      const meetingId = this.meeting ? this.meeting.id : null;
      if (begin === this.constants.immediate_time) {
        begin_at = new Date();
        end_at = addMinutes(begin_at, 30);
      }
      if (!me) {
        return;
      }
      if (this.lastTimeValidated && this.lastTimeValidated.begin_at === begin_at.getTime() && this.lastTimeValidated.end_at === end_at.getTime()) {
        return;
      }
      if (this._onTimeChange$$) {
        this._onTimeChange$$.unsubscribe();
      }
      this.lastTimeValidated = {
        begin_at: begin_at.getTime(),
        end_at: end_at.getTime()
      };
      this.isTimeValidating = true;
      const details = ['begin_at', 'end_at', 'cover:sm', 'author_id', 'title', 'subject', 'type', 'participant:some'];
      this._onTimeChange$$ = this.meetingsService.checkThatTimeIsAvailableForMeeting(addSeconds(begin_at, 2), addSeconds(end_at, 0), me.id, meetingId, details).subscribe({
        next: response => {
          this._onTimeChange$$.unsubscribe();
          this.isTimeValidating = false;
          this.anotherMeeting = response.meeting;
          this.isTimeAvailable = true;
          this.showTimeInformer = true;
        },
        error: () => {
          this._onTimeChange$$.unsubscribe();
        }
      });
      this.form.markAsDirty();
    }
    updateCalc() {
      this.calc = this.calcHelper.calc(this.form.value, this.selectedPriceTier);
    }
    get isFreeChargingAllowed() {
      return this.featuresService.isAvailable(FeatureEnum.free_meetings, this.me) && (this.me?.roles?.includes(UserRoleEnum.tester) || this.me?.roles?.includes(UserRoleEnum.developer));
    }
    get isCreditsChargingAllowed() {
      return this.featuresService.isAvailable(FeatureEnum.credits_meetings, this.me);
    }
    get isFeeChargingAllowed() {
      return this.featuresService.isAvailable(FeatureEnum.safe_deal_meetings, this.me);
    }
    patchFormValues() {
      const meeting = this._meeting || new Meeting();
      const beginAt = meeting.begin_at ? new Date(meeting.begin_at) : null;
      const endAt = meeting.end_at ? new Date(meeting.end_at) : null;
      const participantsLimit = this.fixParticipantsLimit(meeting.participants_limit);
      const now = this.newZonedDate();
      const nearestTime = addHours(startOfHour(now), 1);
      const nextHour = addHours(nearestTime, 1);
      const author_id = this.schoolParticipants()?.length ? this.schoolParticipants()[0]?.account_id : null;
      const school_id = this._meeting?.school_id;
      const school = this._meeting?.school;
      const classroom_id = this._meeting?.classroom_id;
      const classroom = this._meeting?.classroom;
      const formValue = {
        ...meeting,
        author_id,
        school_id,
        school,
        subject_id: meeting.subject ? meeting.subject.id : null,
        level_other_name: meeting.level_other_name ? meeting.level_other_name : null,
        type_repeat: meeting.type,
        date: beginAt || nearestTime,
        begin_at: (beginAt || nearestTime).getTime(),
        end_at: this.prepareEndAt(endAt || nextHour),
        participants_limit: participantsLimit,
        preset: meeting.id && !this.displayAsNew ? PresetTypeEnum.detailed : null
      };
      Object.keys(formValue).forEach(key => {
        if (formValue[key] === null) {
          delete formValue[key];
        }
      });
      this.form.patchValue(formValue);
      this.clearKeywords();
      (meeting.keywords || []).map(keyword => {
        this.keywordsArray.push(this.createKeyword(keyword));
      });
      if (meeting.id && !this.displayAsNew) {
        this.form.controls.preset.enable();
      }
      if (this.isSchoolMeeting) {
        this.onAuthorId(author_id);
        this.form.controls.begin.setValue(this.constants.specified_time);
        this.form.controls.charging.setValue(this.constants.fee);
        this.activeStepIndex = 0;
      }
      if (!!classroom_id || !!classroom) {
        this.form.controls.type.enable();
        this.activeStepIndex = 1;
      }
      // this.loadCover();
      this.updateTimeLists();
      this.calcDescriptionHeight();
      this.form.markAsPristine();
      this.onSubjectIdChange(+formValue.subject_id);
      this.onTimeChange();
    }
    listenFormChanges() {
      // запуск валидации полей формы, которые зависят от других полей формы
      of(validityDependsOn(this.form.get('date'), ['begin']), validityDependsOn(this.form.get('begin_at'), ['begin']), validityDependsOn(this.form.get('end_at'), ['begin']), validityDependsOn(this.form.get('price_tier'), ['charging']), validityDependsOn(this.form.get('participants_limit'), ['type'])).pipe(mergeAll(), takeUntil(this.destroyed$)).subscribe();
      of(this.form.get('subject_id').valueChanges.pipe(tap$1(subject_id => this.onSubjectIdChange(+subject_id))), this.form.get('begin').valueChanges.pipe(tap$1(begin => this.onBeginChange(begin))), this.form.get('type').valueChanges.pipe(tap$1(type => this.onTypeChange(type)))).pipe(mergeAll(), takeUntil(this.destroyed$)).subscribe();
      of(this.form.get('begin').valueChanges, this.form.get('begin_at').valueChanges, this.form.get('end_at').valueChanges).pipe(mergeAll(), takeUntil(this.destroyed$), tap$1(() => {
        this.updateTimeLists();
        this.onTimeChange();
      })).subscribe();
      this.form.valueChanges.pipe(takeUntil(this.destroyed$), tap$1(value => this.updateActiveStepIndex(value)), tap$1(() => this.updateCalc())).subscribe();
    }
    createForm() {
      this.form = this.fb.group({
        author_id: [''],
        school_id: [''],
        school: [null],
        title: ['', [Validators.required, Validators.maxLength(90)]],
        classroom_id: [''],
        preset: [{
          value: null,
          disabled: true
        }],
        subject_id: [null,
        // TODO из настроек пользователя
        [Validators.required]],
        level_other_name: [null, [Validators.maxLength(30)]],
        description: ['', [Validators.maxLength(2000)]],
        type: [{
          value: null,
          disabled: true
        }, [Validators.required]],
        // Bullshit
        type_repeat: [{
          value: null,
          disabled: true
        }],
        charging: [constants.credits, [Validators.required]],
        begin: [null, [Validators.required]],
        date: [null, [
        // required зависит от begin
        requiredIfValidator(() => this.form.get('begin').value === MeetingBeginEnum.specified_time)]],
        begin_at: [null, [
        // required зависит от begin
        requiredIfValidator(() => this.form.get('begin').value === MeetingBeginEnum.specified_time)]],
        end_at: [null, [
        // required зависит от begin
        requiredIfValidator(() => this.form.get('begin').value === MeetingBeginEnum.specified_time)]],
        participants_limit: [null, [
        // TODO не меньше 1, не больше 10
        // required зависит от type
        requiredIfValidator(() => this.form.get('type').value === MeetingTypeEnum.group)]],
        price_tier: [null, [
        // TODO входит в список допустимых
        // required зависит от charging
        requiredIfValidator(() => this.form.get('charging').value === BillingMeetingChargingEnum.fee)]],
        cover_id: [null],
        keywords: this.fb.array([])
      }, {
        validators: [
        // этим валидаторам нужна вся форма и немного других данных
        creditsChargingConditionalValidator(this.validatorInjector), feeChargingConditionalValidator(this.validatorInjector)]
      });
    }
    onSubjectIdChange(subject_id) {
      this.setSubjectLevelsBySubject(subject_id);
    }
    onBeginChange(begin) {
      // if (this._meeting.)
      if (begin === this.constants.immediate_time) {
        if (this.isCreditsChargingAllowed) {
          this.form.controls.charging.patchValue(this.constants.credits);
        } else {
          this.form.controls.charging.patchValue(null);
        }
      }
    }
    onTypeChange(type) {
      const typeListOptions = typesList.find(item => item.value === type);
      if (!typeListOptions) {
        return;
      }
      const limit = typeListOptions.limit;
      this.form.controls.participants_limit.patchValue(limit);
    }
    get keywordsArray() {
      return this.form.get('keywords');
    }
    createKeyword(value) {
      return this.fb.group({
        keyword: [value || '']
      });
    }
    removeKeyword(idx) {
      this.keywordsArray.removeAt(idx);
      this.form.markAsDirty();
    }
    clearKeywords() {
      const keywords = this.fb.array([]);
      this.form.setControl('keywords', keywords);
      this.form.markAsDirty();
    }
    get isNew() {
      return this._meeting ? !this._meeting.id : true;
    }
    get subject() {
      return this.form.get('subject_id');
    }
    get readyForSave() {
      return this.form.valid && this.saveState === 'default' && this.isTimeAvailable && !this.isTimeValidating;
    }
    getMeetingFromForm() {
      if (!this.readyForSave) {
        return;
      }
      const meeting = this.form.value;
      const {
        begin
      } = meeting;
      let {
        begin_at,
        end_at
      } = meeting;
      begin_at = this.normalizeDateTimezone(new Date(begin_at)).toISOString();
      end_at = this.normalizeDateTimezone(new Date(end_at)).toISOString();
      let duration = null;
      if (begin === this.constants.immediate_time) {
        begin_at = new Date();
        end_at = new Date(this.prepareEndAt(addHours(begin_at, 1)));
        duration = 60;
      }
      return {
        ...meeting,
        classroom_id: this.form?.get('classroom_id').value === 'new' ? null : this.form?.get('classroom_id').value,
        begin,
        begin_at,
        end_at,
        duration,
        id: this._meeting ? this._meeting.id : null,
        keywords: meeting.keywords.map(k => k.keyword).filter(v => v.length),
        published_at: new Date()
      };
    }
    resetSaveState(timeout = 1500) {
      if (this.resetSaveStateTimeout) {
        clearTimeout(this.resetSaveStateTimeout);
      }
      this.resetSaveStateTimeout = setTimeout(() => {
        this.saveState = 'default';
      }, timeout);
    }
    isValid(field) {
      const touched = false;
      switch (field) {
        case 'begin':
        case 'date':
        case 'begin_at':
        case 'end_at':
          return this.validationVisible || touched ? this.isTimeAvailable && this.form.get(field).valid : true;
        case 'begin.immediate_time':
          {
            const {
              begin
            } = this.form.value;
            return !begin || begin === MeetingBeginEnum.immediate_time ? this.isValid('begin') : true;
          }
        case 'begin.specified_time':
          {
            const {
              begin
            } = this.form.value;
            // const isSpecifiedTime = this.form.get('begin').value === MeetingBeginEnum.specified_time;
            return !begin || begin === MeetingBeginEnum.specified_time ? this.isValid('begin') && this.isValid('date') && this.isValid('begin_at') && this.isValid('end_at') : true;
          }
        case 'subject':
          return this.isValid('subject_id');
        case 'access.private':
          return true;
        case 'access.public':
          return !this.form.errors?.publicRequireVerification;
        /** @see publicAccessConditionalValidator */
        case 'charging.free':
          return true;
        // ??
        case 'charging.credits':
          return !this.form.errors?.creditsNotAvailable /** @see creditsChargingConditionalValidator */ && !this.form.errors?.creditsBalanceLow /** @see creditsChargingConditionalValidator */;
        case 'charging.fee':
          return !this.form.errors?.feeNotAvailable /** @see feeChargingConditionalValidator */ && !this.form.errors?.feeRequireVerification /** @see feeChargingConditionalValidator */ && !this.form.errors?.feeBeneficiaryVerification /** @see feeChargingConditionalValidator */;
        default:
          // touched = this.form.get(field).touched;
          return this.validationVisible || touched ? this.form.get(field).valid : true;
      }
    }
    save() {
      this.validationVisible = true;
      const values = this.getMeetingFromForm();
      if (!(values?.charging !== constants.fee || !this._references.accountCheck.no_payouts)) {
        return;
      }
      if (this.isInvalidForm) {
        return;
      }
      this.saveState = 'progress';
      const observable = this.isNew ? this.meetingsService.createMeeting(values) : this.meetingsService.updateMeeting(values.id, values);
      const s = observable.subscribe({
        next: meeting => {
          this.saveState = 'done';
          this.resetSaveState();
          this._meeting = meeting;
          this.saved.emit(meeting);
        },
        error: err => {
          this.saveState = 'fail';
          this.saveError = err.error;
          this.resetSaveState();
        }
      });
      this.subscription.add(s);
    }
    get isInvalidForm() {
      return this.form.invalid || this.form.get('charging').value === constants.fee && this._references.accountCheck.no_payouts || this.form.errors?.creditsBalanceLow;
    }
    /** Без понятия зачем это, но изменил: добавил для групповых занятий - установка лимита тот который укзали в форме **/
    fixParticipantsLimit(limit) {
      if (MeetingTypeEnum.group) {
        return limit;
      }
      if (MeetingTypeEnum.webinar) {
        return 50;
      }
      if (MeetingTypeEnum.stream) {
        return 5000;
      }
      if (MeetingTypeEnum.talk) {
        return 6;
      }
      return null;
    }
    formatCredits(amount) {
      return this.billingService.formatAmount(amount, CurrencyEnum.credits);
    }
    calcDescriptionHeight() {
      const pre = this.el.querySelector('pre');
      this.descriptionHeight = pre ? pre.offsetHeight : '';
    }
    selectSubjectId(subject_id) {
      this.form.controls.subject_id.setValue(subject_id);
      const subjectCoverId = this.findSubjectById(subject_id).cover?.md?.id || null;
      this.changeCover.emit(subjectCoverId);
    }
    findSubjectById(subject_id) {
      const {
        subjects
      } = this.references;
      if (!subjects) {
        return null;
      }
      return [...subjects.native, ...subjects.foreign, ...subjects.other, ...subjects.non_categorized, ...subjects.user].find(_s => _s.id === subject_id) || null;
    }
    /** настройка формы по выбранной дисциплине */
    setSubjectLevelsBySubject(subject_id) {
      const subject = this.findSubjectById(subject_id);
      const {
        subjectLevels
      } = this.references;
      const _subjectLevels = subject && subject.levels_category_id ? subjectLevels[subject.levels_category_id] || [] : [];
      const otherSubjectLevel = new SubjectLevel({
        id: otherSubjectLevelId,
        code: '',
        title: 'Other...' // TODO this.translate.instant('????'),
      });
      this.subjectLevelOptions = [otherSubjectLevel, ..._subjectLevels].map(x => ({
        value: x.id,
        title: x.title
      }));
      // патч на "Другой уровень сложности"
      // const levelOtherName = this.levelOtherName.value;
      // if (levelOtherName && levelOtherName.length) {
      //   this.level.patchValue(otherSubjectLevelId);
      // }
    }
    onTypeChanged(value) {
      this.form.patchValue({
        type_repeat: value
      });
      this.onCategoryIdChanged();
    }
    onAuthorId(value) {
      this.form.patchValue({
        author_id: value
      });
      this.form.controls.author_id.enable();
      this.form.controls.type.enable();
      if (this.form.controls.type.value) {
        this.onTypeChanged(this.form.controls.type.value);
      }
      this.updateActiveStepIndex(this.form.value);
    }
    onCategoryIdChanged() {
      // if (!this._meeting?.id) {
      this.form.controls.classroom_id.enable();
      // }
      if (this.preset) {
        this.form.controls.preset.setValue(this.preset);
        this.onPresetChanged(this.preset);
      }
      this.form.controls.preset.enable();
    }
    onPresetChanged(value) {
      if (value === PresetTypeEnum.quick) {
        const {
          me,
          profile
        } = this.references;
        const subjects = profile.teaching_subjects || [];
        const subject_id = subjects && subjects.length ? subjects[0].subject_id : null;
        const subject = subject_id ? this.findSubjectById(subject_id) : null;
        const cover_id = subject?.cover?.md?.id || null;
        if (cover_id) {
          this.changeCover.emit(cover_id);
        }
        const title = AbstractAccountService.getUserFullName(me) + ' - ' + (subject ? subject.title : '');
        const {
          type,
          participants_limit,
          author_id,
          school_id
        } = this.form.value;
        const quickMeeting = new Meeting({
          title,
          author_id,
          school_id,
          description: '',
          begin: this.specifiedDate ? MeetingBeginEnum.specified_time : MeetingBeginEnum.immediate_time,
          subject_id,
          charging: constants.credits
        });
        this.form.patchValue({
          ...quickMeeting,
          type_repeat: type,
          participants_limit
        });
      } else if (value === PresetTypeEnum.detailed) {
        const {
          type,
          classroom_id,
          participants_limit,
          author_id
        } = this.form.value;
        const now = new Date();
        const nearestTime = addHours(startOfHour(now), 1);
        const nextHour = addHours(nearestTime, 1);
        this.changeCover.emit(null);
        this.form.reset({
          date: nearestTime,
          begin_at: nearestTime.getTime(),
          end_at: this.prepareEndAt(nextHour),
          type,
          classroom_id,
          author_id,
          type_repeat: type,
          participants_limit,
          preset: PresetTypeEnum.detailed
        }, {
          emitEvent: false
        });
      }
    }
    // TODO: Isolate
    onBuyCredits() {
      this.buyCredits.emit(this.references.billingSettings.plan.plan);
    }
    /** Active steps highlighting */
    onClassroomViewed() {}
    onClassroomChanged() {
      this.form.controls.type.enable();
      this.isClassroomsViewedByUser = true;
      this.updateActiveStepIndex(this.form.value);
    }
    updateActiveStepIndex(formValue) {
      if (!this.isNew && !this.displayAsNew) {
        return;
      }
      if (!formValue.preset && !this.isClassroomsViewedByUser && !this.isReadonly('classroom_id')) {
        this.activeStepIndex = 0;
      } else if (!formValue.type) {
        this.activeStepIndex = 1;
      } else if (!formValue.preset) {
        this.activeStepIndex = 2;
      } else {
        this.activeStepIndex = 3;
      }
    }
    isReadonly(name) {
      if (!name || !this.readonlyFields) {
        return false;
      }
      return this.readonlyFields.includes(name);
    }
    onOpenPaywall() {
      this.openPaywall.emit(true);
    }
    getActivePlan() {
      this.billingService.getActivePlan().pipe(takeUntil(this.destroyed$)).subscribe(activePlan => {
        this.activePlan = activePlan;
        this.cdr.detectChanges();
      });
    }
    activePlanSafeTradeCommission() {
      return +this.activePlan?.details?.safe_trade_commission || 35;
    }
    get isEditFormAction() {
      const participants_count = this.meeting?.participants_count || 0;
      const reservations_count = this.meeting?.reservations_count || 0;
      return participants_count + reservations_count > 0;
    }
    newZonedDate() {
      return utcToZonedTime(new Date(), this.references.me.timezone);
    }
    normalizeDateTimezone(date) {
      const zoneOffset = getTimezoneOffset(this.references.me.timezone, date) / 1000 / 60;
      const myTimezoneOffset = -1 * date.getTimezoneOffset();
      return addMinutes(date, myTimezoneOffset - zoneOffset);
    }
    getRateForCurrency(currencies, currencyCode) {
      if (!currencies.length) {
        return;
      }
      return currencies.find(currency => currency.currency === currencyCode.toUpperCase());
    }
    static {
      this.ɵfac = function MeetingFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingFormComponent)(i0.ɵɵdirectiveInject(DebugService), i0.ɵɵdirectiveInject(i4.UntypedFormBuilder), i0.ɵɵdirectiveInject(AbstractMeetingsService), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(AbstractCurrenciesService), i0.ɵɵdirectiveInject(ConfigService), i0.ɵɵdirectiveInject(AbstractFeaturesService), i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(i6.DateFnsConfigurationService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(AbstractScreenService), i0.ɵɵdirectiveInject(AbstractWebsocketService), i0.ɵɵdirectiveInject(DeviceService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i7.DateAdapter));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MeetingFormComponent,
        selectors: [["app-meeting-form"]],
        contentQueries: function MeetingFormComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ControlContainer, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formGroup = _t.first);
          }
        },
        inputs: {
          meeting: "meeting",
          cover: "cover",
          references: "references",
          creditsAmount: "creditsAmount",
          preset: "preset",
          specifiedDate: "specifiedDate",
          readonlyFields: "readonlyFields",
          modalDisplayMode: "modalDisplayMode",
          displayAsNew: "displayAsNew",
          disableGallery: "disableGallery",
          locale: "locale"
        },
        outputs: {
          buyCredits: "buyCredits",
          activatePlan: "activatePlan",
          saved: "saved",
          openGallery: "openGallery",
          changeCover: "changeCover",
          openPaywall: "openPaywall"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c25,
        decls: 5,
        vars: 16,
        consts: [["plan", ""], ["creditsBalanceOk", ""], [1, "meeting-form"], [1, "version"], [1, "meeting-header", 3, "buyCredits", "isNew", "isActivePlan", "isModal", "creditsAmount"], ["class", "form", 3, "formGroup", 4, "ngIf"], [1, "form", 3, "formGroup"], [3, "index", "first", "title", "completed", "active", 4, "ngIf"], [3, "index", "first", "title", "completed", "active", "disabled", 4, "ngIf"], [3, "index", "title", "completed", "active", "disabled"], [1, "sh-row"], [1, "sh-field", "sh-col"], ["formControlName", "type", 3, "changed", "options", "active", "disabled", "placeholder"], [3, "index", "title", "last", "completed", "active", "disabled"], ["formControlName", "preset", 3, "changed"], [4, "ngIf"], [3, "index", "first", "title", "completed", "active"], ["formControlName", "classroom_id", "placeholder", "lingo2-forms.meetings.placeholders.classroom", 3, "closed", "changed", "me", "classrooms", "readonly"], [3, "index", "first", "title", "completed", "active", "disabled"], ["formControlName", "author_id", 3, "changed", "schoolParticipants", "active"], [3, "index", "title", "completed", "active", "last", "noContent"], [1, "header"], [1, "image-uploader", 3, "control"], [1, "meta"], [3, "selectSubjectId", "subjects", "subjectSelectedId", "valid"], ["class", "warn-wrap", 4, "ngIf"], [1, "sh-field"], ["formControlName", "title", 3, "maxlength", "hasCounter", "placeholder"], ["formControlName", "description", 3, "height", "minHeight", "rows", "maxlength"], [1, "inputs"], [1, "input-wrap"], [1, "label", "normal"], [1, "input-content"], ["class", "input-radio-wrap", 3, "invalid", "disabled", 4, "ngIf"], [3, "ngIf"], [1, "input-radio-wrap"], ["type", "radio", "formControlName", "begin", 1, "input-radio", 3, "value"], [1, "input-radio-item"], [1, "label-input-radio"], ["class", "sub-label", 4, "ngIf"], ["class", "sh-row", 4, "ngIf"], ["class", "input-radio-wrap", 3, "disabled", "invalid", 4, "ngIf"], ["class", "hint-wrap invalid", 4, "ngIf"], [1, "input-content", "row"], [1, "sh-field", "type"], ["formControlName", "type_repeat", 3, "options", "placeholder"], ["class", "sh-field participants-limit", 3, "field_error", 4, "ngIf"], ["class", "advance-payment", 4, "ngIf"], ["class", "input-wrap", 4, "ngIf"], [1, "bottom-block"], ["formArrayName", "keywords", 1, "keywords"], ["class", "keyword", 3, "formGroupName", 4, "ngFor", "ngForOf"], [1, "button-wrap"], [1, "primary", 3, "onclick", "state", "label"], [1, "warn-wrap"], [1, "warn-message"], [1, "informer-wrap"], [3, "meeting"], [1, "sub-label"], [1, "sh-field", "sh-col", "sh-col_date", 3, "control"], ["formControlName", "date", 3, "changed", "locale", "startView", "max", "min"], [1, "sh-field", "sh-col", "sh-col_begin-at", 3, "control"], ["formControlName", "begin_at", "placeholder", "Begin at", 3, "options"], [1, "sh-field", "sh-col", "sh-col_end-at", 3, "control"], ["formControlName", "end_at", "placeholder", "End at", 3, "options"], [3, "error", "meeting"], ["type", "radio", "formControlName", "charging", 1, "input-radio", 3, "value"], [1, "sub-label", "value"], ["class", "banner-plan", 4, "ngIf"], [1, "banner-plan"], [4, "ngTemplateOutlet"], [1, "hint"], [1, "text"], [1, "actions"], [1, "action", 3, "click"], [1, "hint-wrap", "invalid"], [1, "hint", "normal"], ["routerLink", "/profile/about", 1, "hint", "link", "normal"], ["routerLink", "/profile/payout", 1, "hint", "link", "normal"], [1, "icon-wrap", 3, "click"], ["width", "38", "height", "38", "viewBox", "0 0 61 61"], [1, "meta", 3, "click"], [1, "my-plan"], [1, "plan-title"], [1, "sh-field", "participants-limit"], ["formControlName", "participants_limit", 3, "options"], [1, "advance-payment"], [3, "ngIf", "ngIfElse"], [1, "sub-label", "alert"], [1, "sub-label", "info"], [1, "sh-field", "price-tier"], ["formControlName", "price_tier", 3, "placeholder", "error", "options", "autosize"], [1, "keyword", 3, "formGroupName"], [1, "keyword-text"], ["type", "button", 1, "keyword-remove-btn", 3, "click"], [1, "keyword-remove-btn-icon"]],
        template: function MeetingFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c24);
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "app-meeting-header", 4);
            i0.ɵɵlistener("buyCredits", function MeetingFormComponent_Template_app_meeting_header_buyCredits_3_listener() {
              return ctx.onBuyCredits();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, MeetingFormComponent_div_4_Template, 13, 25, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("tablet-portrait", ctx.device.isTablet() && ctx.isPortrait)("tablet-landscape", ctx.device.isTablet() && !ctx.isPortrait)("mobile-portrait", ctx.device.isMobile() && ctx.isPortrait)("mobile-landscape", ctx.device.isMobile() && !ctx.isPortrait)("meeting-form_modal", ctx.modalDisplayMode);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("forms v.", ctx.versions.version, "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("isNew", ctx.isNew)("isActivePlan", !!ctx.activePlan)("isModal", ctx.modalDisplayMode)("creditsAmount", ctx.creditsAmount);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i4.DefaultValueAccessor, i4.RadioControlValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, i4.FormGroupName, i4.FormArrayName, SubjectSelectorComponent, FormFieldComponent, MeetingSelectComponent, MeetingSelectClassComponent, MeetingStepComponent, MeetingSelectPresetComponent, MeetingSelectAuthorComponent, i1$2.RouterLink, i16.OnUiButtonComponent, i16.OnUiSelectComponent, i16.OnUiInputComponent, i16.OnUiDateComponent, i16.OnUiTextareaComponent, NotAvailableTimeInformerComponent, MeetingHeaderComponent, i2.AsyncPipe, i2.JsonPipe, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";*[_ngcontent-%COMP%]{box-sizing:border-box}.version[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;color:#f5f8fa;position:fixed;top:10px}.meeting-form[_ngcontent-%COMP%]{background:#fff;border-radius:10px;box-shadow:0 0 10px #0000001a;margin-bottom:150px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{padding:0 30px 30px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{display:flex;margin-bottom:20px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]{display:flex;flex:1 auto;flex-direction:column;max-width:560px;margin-left:20px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]   .form-field[_ngcontent-%COMP%]{align-items:center;display:flex;flex-wrap:wrap;margin-bottom:10px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]   .form-field[_ngcontent-%COMP%]:last-child{margin-bottom:0}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]   .form-field[_ngcontent-%COMP%]   .title-text-wrap[_ngcontent-%COMP%]{border:1px solid #EEEEEE;border-radius:10px;display:flex;flex:1 1 auto}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]   .form-field[_ngcontent-%COMP%]   .title-text-wrap.warn[_ngcontent-%COMP%]{border-color:#e86f79}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_hint-animation .4s;background:#e6f6ff;border-radius:10px;box-sizing:border-box;display:flex;margin-bottom:10px;padding:15px;position:relative;-webkit-user-select:none;user-select:none}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{cursor:pointer;margin-right:12px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-right:30px;min-width:70px;cursor:pointer}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]   .my-plan[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 5px;color:#a4b0c3;font-size:12px;line-height:16px;color:#1e252b}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]   .plan-title[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]{display:flex;flex-direction:column}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 7px;color:#a4b0c3;font-size:12px;line-height:16px;color:#1e252b}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 20px 0 0;color:#a4b0c3;font-size:12px;line-height:16px;color:#41a1d9;cursor:pointer;transition:all .2s linear}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]:hover{text-decoration:underline}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]{display:flex;flex-direction:column}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]{display:flex;margin-bottom:10px;width:100%}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 20px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;line-height:30px;min-width:190px;max-width:190px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]{display:flex;flex-direction:column}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content.row[_ngcontent-%COMP%]{align-items:center;flex-direction:row}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .hint-wrap[_ngcontent-%COMP%]{align-items:center;animation:_ngcontent-%COMP%_hint-animation .4s;background:#f5f8fa;border-radius:10px;display:flex;margin:10px 0;padding:10px 15px;width:439px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .hint-wrap[_ngcontent-%COMP%]   .hint-icon-wrap[_ngcontent-%COMP%]{height:30px;margin-right:20px;width:30px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .hint-wrap.invalid[_ngcontent-%COMP%]{border:1px solid #E86F79}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .hint-wrap[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;flex:1 1 10px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .hint-wrap[_ngcontent-%COMP%]   .hint.link[_ngcontent-%COMP%]{color:#41a1d9;cursor:pointer;-webkit-user-select:none;user-select:none;text-decoration:none;padding:10px;margin:-10px}@keyframes _ngcontent-%COMP%_hint-animation{0%{opacity:0;transform:scale(0)}to{opacity:1;transform:scale(1)}}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .warn-message[_ngcontent-%COMP%]{margin-top:-5px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .advance-payment[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-left:10px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .bank-cards[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;color:#e86f79;text-decoration:none}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .bank-cards[_ngcontent-%COMP%]     .link{color:#41a1d9}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap.invalid[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%], .meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap.invalid[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .label-input-radio[_ngcontent-%COMP%]{color:#e86f79!important}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]{align-items:flex-end;display:flex;justify-content:space-between}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]   .keywords[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;justify-content:left;width:450px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]   .keywords[_ngcontent-%COMP%]   .keyword[_ngcontent-%COMP%]{align-items:center;border:1px solid #5AB3E4;border-radius:10px;display:flex;height:24px;margin:5px 10px 5px 0;padding:0 6px;transition:background-color .2s linear;-webkit-user-select:none;user-select:none}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]   .keywords[_ngcontent-%COMP%]   .keyword[_ngcontent-%COMP%]   .keyword-text[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;color:#5ab3e4}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]   .keywords[_ngcontent-%COMP%]   .keyword[_ngcontent-%COMP%]   .keyword-remove-btn[_ngcontent-%COMP%]{background:#fff;border:none;cursor:pointer;height:22px;outline:none;transition:background-color .2s linear;width:24px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]   .keywords[_ngcontent-%COMP%]   .keyword[_ngcontent-%COMP%]   .keyword-remove-btn[_ngcontent-%COMP%]   .keyword-remove-btn-icon[_ngcontent-%COMP%]{fill:#5ab3e4;height:9px;transition:fill .2s linear;width:7px}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]   .keywords[_ngcontent-%COMP%]   .keyword[_ngcontent-%COMP%]:hover{background-color:#5ab3e4}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]   .keywords[_ngcontent-%COMP%]   .keyword[_ngcontent-%COMP%]:hover > .keyword-text[_ngcontent-%COMP%]{color:#fff}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]   .keywords[_ngcontent-%COMP%]   .keyword[_ngcontent-%COMP%]:hover > .keyword-remove-btn[_ngcontent-%COMP%]{background-color:#5ab3e4}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .bottom-block[_ngcontent-%COMP%]   .keywords[_ngcontent-%COMP%]   .keyword[_ngcontent-%COMP%]:hover > .keyword-remove-btn[_ngcontent-%COMP%] > .keyword-remove-btn-icon[_ngcontent-%COMP%]{fill:#fff}.meeting-form[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .button-wrap[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;margin:20px 0}.meeting-form_modal[_ngcontent-%COMP%]{box-shadow:none;margin:0}.meeting-form_modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{padding:0}.input-radio-wrap[_ngcontent-%COMP%]{display:flex;cursor:pointer;margin-bottom:10px;-webkit-user-select:none;user-select:none;transition:all .2s linear}.input-radio-wrap[_ngcontent-%COMP%]   .input-radio-item[_ngcontent-%COMP%]{border:2px solid #EEEEEE;border-radius:50%;height:25px;margin-right:10px;position:relative;transition:all .2s linear;width:25px}.input-radio-wrap[_ngcontent-%COMP%]   .input-radio-item[_ngcontent-%COMP%]:after{background:transparent;border-radius:50%;content:\"\";position:absolute;height:11px;margin:5px;width:11px}.input-radio-wrap[_ngcontent-%COMP%]:hover   .input-radio-item[_ngcontent-%COMP%]{border-color:#a4b0c3}.input-radio-wrap[_ngcontent-%COMP%]   .label-input-radio[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 10px 0 0;font-size:16px;line-height:24px;color:#1e252b;flex:1 1 10px;transition:all .2s linear}.input-radio-wrap[_ngcontent-%COMP%]   .input-radio[_ngcontent-%COMP%]{display:none}.input-radio-wrap[_ngcontent-%COMP%]   .input-radio[_ngcontent-%COMP%]:checked ~ .input-radio-item[_ngcontent-%COMP%]{border-color:#5ab3e4}.input-radio-wrap[_ngcontent-%COMP%]   .input-radio[_ngcontent-%COMP%]:checked ~ .input-radio-item[_ngcontent-%COMP%]:after{background:#5ab3e4}.input-radio-wrap[_ngcontent-%COMP%]   .input-radio[_ngcontent-%COMP%]:checked ~ .label-input-radio[_ngcontent-%COMP%]{color:#1e252b}.input-radio-wrap.invalid[_ngcontent-%COMP%]   .label-input-radio[_ngcontent-%COMP%]{color:#e86f79}.input-radio-wrap.invalid[_ngcontent-%COMP%]   .input-radio[_ngcontent-%COMP%]:checked ~ .input-radio-item[_ngcontent-%COMP%]{border-color:#e86f79}.input-radio-wrap.invalid[_ngcontent-%COMP%]   .input-radio[_ngcontent-%COMP%]:checked ~ .input-radio-item[_ngcontent-%COMP%]:after{background:#e86f79}.input-radio-wrap.invalid[_ngcontent-%COMP%]   .input-radio[_ngcontent-%COMP%] ~ .label-input-radio[_ngcontent-%COMP%]{color:#e86f79}.informer-wrap[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_hint-animation .2s ease-in-out;margin:10px 0 20px}.informer-wrap.invalid[_ngcontent-%COMP%]{border:1px solid #E86F79}.sub-label[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;display:inline-flex;align-items:center}.sub-label.value[_ngcontent-%COMP%]{color:#1e252b;margin-left:5px}.sub-label.alert[_ngcontent-%COMP%]{color:#e86f79}.sub-label.info[_ngcontent-%COMP%]{color:#87d37c}.sub-label[_ngcontent-%COMP%]   .link[_ngcontent-%COMP%]{color:#41a1d9;text-decoration:none;padding:10px;margin:-10px;-webkit-user-select:none;user-select:none}.sub-label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]{padding-left:20px}.sh-field[_ngcontent-%COMP%]{display:block;margin-bottom:10px;min-width:180px}.sh-field.level-other-name[_ngcontent-%COMP%]{min-width:60px;margin-left:10px}.sh-field.participants-limit[_ngcontent-%COMP%]{min-width:75px;margin-left:10px}.sh-field.language-id[_ngcontent-%COMP%]{width:180px}.sh-field.price-tier[_ngcontent-%COMP%]{min-width:200px}.sh-row[_ngcontent-%COMP%]{display:flex;flex-direction:row}.sh-row[_ngcontent-%COMP%]   .sh-col[_ngcontent-%COMP%]:not(:last-child){margin-right:10px}.sh-col[_ngcontent-%COMP%]{width:100%;display:block}.sh-col_xs[_ngcontent-%COMP%]{width:30px;flex-shrink:0}.sh-col_sm[_ngcontent-%COMP%]{width:60px;flex-shrink:0}.sh-col_md[_ngcontent-%COMP%]{width:180px;flex-shrink:0}.sh-col_lg[_ngcontent-%COMP%]{width:350px;flex-shrink:0}.sh-col_type[_ngcontent-%COMP%]{width:330px;flex-shrink:0}.sh-col_category[_ngcontent-%COMP%]{width:220px;flex-shrink:0}.sh-col_date[_ngcontent-%COMP%]{width:180px}.sh-col_begin-at[_ngcontent-%COMP%], .sh-col_end-at[_ngcontent-%COMP%]{min-width:120px}.warn-message[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:5px 0 0;color:#a4b0c3;font-size:12px;line-height:16px;color:#e86f79}.tablet-portrait[_ngcontent-%COMP%], .tablet-landscape[_ngcontent-%COMP%]{border-radius:0;box-shadow:unset;margin-top:80px}.tablet-portrait[_ngcontent-%COMP%]   .meeting-header[_ngcontent-%COMP%], .tablet-landscape[_ngcontent-%COMP%]   .meeting-header[_ngcontent-%COMP%], .tablet-portrait[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%], .tablet-landscape[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{display:none}.tablet-portrait[_ngcontent-%COMP%]   .sh-col_type[_ngcontent-%COMP%], .tablet-landscape[_ngcontent-%COMP%]   .sh-col_type[_ngcontent-%COMP%]{width:270px}.mobile-portrait[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]{border-radius:0;box-shadow:unset;margin-top:80px}.mobile-portrait[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{display:none}.mobile-portrait[_ngcontent-%COMP%]   .sh-row[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .sh-row[_ngcontent-%COMP%]{flex-direction:column}.mobile-portrait[_ngcontent-%COMP%]   .sh-col[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .sh-col[_ngcontent-%COMP%]{width:100%}.mobile-portrait[_ngcontent-%COMP%]   .image-uploader[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .image-uploader[_ngcontent-%COMP%]{margin-bottom:10px}.mobile-portrait[_ngcontent-%COMP%]   .meeting-header[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .meeting-header[_ngcontent-%COMP%]{display:none}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{padding:0 15px 15px}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{align-items:center;flex-direction:column}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%]{margin:0 0 20px}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]{width:100%;margin-left:0}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]   .form-field[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]   .form-field[_ngcontent-%COMP%]{width:100%}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]{flex-direction:column}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content.row[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content.row[_ngcontent-%COMP%]{flex-wrap:wrap}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .input-radio-wrap[_ngcontent-%COMP%]   .sub-label[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .input-radio-wrap[_ngcontent-%COMP%]   .sub-label[_ngcontent-%COMP%]{margin-top:0}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .hint-wrap[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .hint-wrap[_ngcontent-%COMP%]{height:unset;width:100%}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .advance-payment[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .advance-payment[_ngcontent-%COMP%]{margin:10px 0 0}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;flex-direction:column}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%] + .action[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .banner-plan[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%] + .action[_ngcontent-%COMP%]{margin-top:5px}.mobile-portrait[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .button-wrap[_ngcontent-%COMP%], .mobile-landscape[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .button-wrap[_ngcontent-%COMP%]{justify-content:center}.grid-row[_ngcontent-%COMP%]{flex-direction:column}  app-textarea .textarea__input{height:82px!important}@media all and (min-width: 768px) and (max-width: 1024px){.meeting-form-modal[_ngcontent-%COMP%]{border-radius:0;box-shadow:unset;margin-top:80px}.meeting-form-modal[_ngcontent-%COMP%]   .meeting-header[_ngcontent-%COMP%], .meeting-form-modal[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{display:none}.meeting-form-modal[_ngcontent-%COMP%]   .sh-col_type[_ngcontent-%COMP%]{width:270px}}@media all and (max-width: 768px){.meeting-form-modal[_ngcontent-%COMP%]{border-radius:0;box-shadow:unset;margin-top:80px}.meeting-form-modal[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{display:none}.meeting-form-modal[_ngcontent-%COMP%]   .sh-row[_ngcontent-%COMP%]{flex-direction:column}.meeting-form-modal[_ngcontent-%COMP%]   .sh-col[_ngcontent-%COMP%]{width:100%}.meeting-form-modal[_ngcontent-%COMP%]   .image-uploader[_ngcontent-%COMP%]{margin-bottom:10px}.meeting-form-modal[_ngcontent-%COMP%]   .meeting-header[_ngcontent-%COMP%]{display:none}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{padding:0 15px 15px}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{align-items:center;flex-direction:column}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%]{margin:0 0 20px}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]{width:100%;margin-left:0}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .meta[_ngcontent-%COMP%]   .form-field[_ngcontent-%COMP%]{width:100%}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]{flex-direction:column}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content.row[_ngcontent-%COMP%]{flex-wrap:wrap}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .input-radio-wrap[_ngcontent-%COMP%]   .sub-label[_ngcontent-%COMP%]{margin-top:0}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .hint-wrap[_ngcontent-%COMP%]{height:unset;width:100%}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .input-wrap[_ngcontent-%COMP%]   .input-content[_ngcontent-%COMP%]   .advance-payment[_ngcontent-%COMP%]{margin:10px 0 0}.meeting-form-modal[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .inputs[_ngcontent-%COMP%]   .button-wrap[_ngcontent-%COMP%]{justify-content:center}}.disabled[_ngcontent-%COMP%]{opacity:.5;pointer-events:none}"],
        changeDetection: 0
      });
    }
  }
  return MeetingFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingChargingPreviewComponent = /*#__PURE__*/(() => {
  class MeetingChargingPreviewComponent {
    set price_tier(price_tier) {
      this._price_tier = price_tier;
      this.calc = this.calcHelper.calc(this._meeting, this._price_tier);
      this.cdr.markForCheck();
    }
    set meeting(meeting) {
      this._meeting = meeting;
      this.calc = this.calcHelper.calc(this._meeting, this._price_tier);
      this.cdr.markForCheck();
    }
    constructor(billingService, cdr) {
      this.billingService = billingService;
      this.cdr = cdr;
      this.isMobile = false;
      this.constants = {
        credits: BillingMeetingChargingEnum.credits,
        fee: BillingMeetingChargingEnum.fee
      };
      this.calcHelper = new MeetingCalcHelper();
    }
    formatAmount(amount) {
      return this.billingService.formatAmount(amount, this.calc.currency_id);
    }
    static {
      this.ɵfac = function MeetingChargingPreviewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingChargingPreviewComponent)(i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MeetingChargingPreviewComponent,
        selectors: [["app-meeting-charging-preview"]],
        inputs: {
          price_tier: "price_tier",
          meeting: "meeting",
          isMobile: "isMobile"
        },
        decls: 1,
        vars: 1,
        consts: [["freeCharging", ""], ["eqMinMaxParticipants", ""], ["eqMinMaxCredits", ""], ["eqMinMaxIncome", ""], ["class", "charging-notes-block", 3, "mobile", 4, "ngIf"], [1, "charging-notes-block"], [1, "charging-notes"], [1, "charging-notes-body"], [1, "charging-notes-title", "strong"], [1, "line"], [1, "text-muted"], [3, "ngIf", "ngIfElse"], ["class", "line", 4, "ngIf"], [1, "charging-notes-footer"], [4, "ngIf"], ["width", "18", "height", "18", "viewBox", "0 0 18 18", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "icon-question"], ["width", "18", "height", "18", "rx", "9", "fill", "white", "fill-opacity", "0.3"], ["d", "M6.27734 4.79511C6.43601 4.65511 6.60868 4.52211 6.79534 4.39611C6.98668 4.27011 7.19201 4.16045 7.41134 4.06711C7.63068 3.97378 7.86868 3.90145 8.12534 3.85011C8.38201 3.79411 8.65968 3.76611 8.95834 3.76611C9.36434 3.76611 9.73301 3.82211 10.0643 3.93411C10.4003 4.04611 10.6873 4.20711 10.9253 4.41711C11.1633 4.62245 11.3477 4.87211 11.4783 5.16611C11.609 5.46011 11.6743 5.78911 11.6743 6.15311C11.6743 6.50778 11.623 6.81578 11.5203 7.07711C11.4177 7.33378 11.2893 7.55778 11.1353 7.74911C10.9813 7.94045 10.811 8.10611 10.6243 8.24611C10.4423 8.38611 10.2697 8.51911 10.1063 8.64511C9.94301 8.76645 9.80068 8.88778 9.67934 9.00911C9.56268 9.12578 9.49268 9.25878 9.46934 9.40811L9.30834 10.4301H8.12534L8.00634 9.28911C7.97834 9.06978 8.00868 8.87845 8.09734 8.71511C8.19068 8.54711 8.31201 8.39545 8.46134 8.26011C8.61534 8.12011 8.78568 7.98711 8.97234 7.86111C9.15901 7.73045 9.33401 7.59045 9.49734 7.44111C9.66068 7.28711 9.79601 7.11678 9.90334 6.93011C10.0153 6.73878 10.0713 6.51245 10.0713 6.25111C10.0713 6.08311 10.0387 5.93378 9.97334 5.80311C9.91268 5.66778 9.82634 5.55345 9.71434 5.46011C9.60234 5.36211 9.46701 5.28745 9.30834 5.23611C9.15434 5.18478 8.98634 5.15911 8.80434 5.15911C8.53834 5.15911 8.31201 5.18945 8.12534 5.25011C7.94334 5.30611 7.78701 5.37145 7.65634 5.44611C7.53034 5.51611 7.42301 5.58145 7.33434 5.64211C7.24568 5.69811 7.16634 5.72611 7.09634 5.72611C6.92834 5.72611 6.80701 5.65611 6.73234 5.51611L6.27734 4.79511ZM7.60034 13.0481C7.60034 12.9034 7.62601 12.7658 7.67734 12.6351C7.73334 12.5044 7.80801 12.3924 7.90134 12.2991C7.99468 12.2058 8.10668 12.1311 8.23734 12.0751C8.36801 12.0191 8.50801 11.9911 8.65734 11.9911C8.80668 11.9911 8.94434 12.0191 9.07034 12.0751C9.20101 12.1311 9.31301 12.2058 9.40634 12.2991C9.50434 12.3924 9.58134 12.5044 9.63734 12.6351C9.69334 12.7658 9.72134 12.9034 9.72134 13.0481C9.72134 13.1974 9.69334 13.3374 9.63734 13.4681C9.58134 13.5941 9.50434 13.7038 9.40634 13.7971C9.31301 13.8904 9.20101 13.9628 9.07034 14.0141C8.94434 14.0701 8.80668 14.0981 8.65734 14.0981C8.50801 14.0981 8.36801 14.0701 8.23734 14.0141C8.10668 13.9628 7.99468 13.8904 7.90134 13.7971C7.80801 13.7038 7.73334 13.5941 7.67734 13.4681C7.62601 13.3374 7.60034 13.1974 7.60034 13.0481Z", "fill", "white"]],
        template: function MeetingChargingPreviewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MeetingChargingPreviewComponent_div_0_Template, 28, 11, "div", 4);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.calc);
          }
        },
        dependencies: [i2.NgIf],
        styles: [".charging-notes-block.mobile[_ngcontent-%COMP%]   .charging-notes[_ngcontent-%COMP%]{border-radius:0}.charging-notes-block.mobile[_ngcontent-%COMP%]   .charging-notes-footer[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-bottom-right-radius:0}.charging-notes[_ngcontent-%COMP%]{width:360px;background:#fff;box-shadow:0 0 10px #0000001a;border-radius:10px}.charging-notes-body[_ngcontent-%COMP%]{padding:20px;line-height:22px}.charging-notes-title[_ngcontent-%COMP%]{font-size:14px;margin-bottom:10px}.charging-notes-footer[_ngcontent-%COMP%]{height:40px;background:#87d37c;color:#fff;display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:0 10px;border-bottom-left-radius:10px;border-bottom-right-radius:10px}.icon-question[_ngcontent-%COMP%]{cursor:pointer;min-width:18px;max-width:18px;width:18px}"],
        changeDetection: 0
      });
    }
  }
  return MeetingChargingPreviewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingSelectModule = /*#__PURE__*/(() => {
  class MeetingSelectModule {
    static {
      this.ɵfac = function MeetingSelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingSelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MeetingSelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, ClickOutsideModule, IconModule]
      });
    }
  }
  return MeetingSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingSelectAuthorModule = /*#__PURE__*/(() => {
  class MeetingSelectAuthorModule {
    static {
      this.ɵfac = function MeetingSelectAuthorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingSelectAuthorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MeetingSelectAuthorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, ClickOutsideModule, OnUiCoverModule]
      });
    }
  }
  return MeetingSelectAuthorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ClassroomPanelModule = /*#__PURE__*/(() => {
  class ClassroomPanelModule {
    static {
      this.ɵfac = function ClassroomPanelModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClassroomPanelModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ClassroomPanelModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, IconModule, OnUiCoverModule]
      });
    }
  }
  return ClassroomPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SimpleTabsComponent = /*#__PURE__*/(() => {
  class SimpleTabsComponent {
    constructor(cdr, deviceService) {
      this.cdr = cdr;
      this.deviceService = deviceService;
      this.isFixed = false;
      this.changed = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    ngOnInit() {
      this.activeTab = this.tabs[0];
    }
    onTabChange(tab) {
      this.activeTab = tab;
      this.changed.emit(this.activeTab);
    }
    // Device
    get isMobile() {
      return this.deviceService.isMobile();
    }
    get isTablet() {
      return this.deviceService.isTablet();
    }
    static {
      this.ɵfac = function SimpleTabsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SimpleTabsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DeviceDetectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SimpleTabsComponent,
        selectors: [["app-simple-tabs"]],
        inputs: {
          tabs: "tabs",
          isFixed: "isFixed"
        },
        outputs: {
          changed: "changed"
        },
        decls: 3,
        vars: 1,
        consts: [[1, "tabs-container"], [1, "tabs"], ["class", "tab-item", 4, "ngFor", "ngForOf"], [1, "tab-item"], [1, "tab"], [1, "tab__name", "normal", 3, "click"], [4, "ngIf"], ["class", "tab__icon", 4, "ngIf"], [1, "tab__icon"]],
        template: function SimpleTabsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
            i0.ɵɵtemplate(2, SimpleTabsComponent_li_2_Template, 7, 7, "li", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.tabs);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.tabs-container[_ngcontent-%COMP%]{overflow:auto hidden}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]{align-items:center;border:none;border-bottom:1px solid #EEEEEE;display:flex;margin:0;padding:0;min-width:fit-content}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]{list-style-type:none;margin:0 32px -1px 0}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]:last-child{margin-right:0}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]{text-decoration:none;position:relative}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab__name[_ngcontent-%COMP%]{border-top:solid 2px transparent;border-bottom:2px solid transparent;border-left:none;border-right:none;background:#fff0;box-sizing:border-box;cursor:pointer;transition:all .2s linear;-webkit-user-select:none;user-select:none;position:relative;outline:none;color:#5f6d7a;font-size:14px;line-height:30px;text-decoration:none;white-space:nowrap}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab__icon[_ngcontent-%COMP%]{width:18px;height:18px;position:absolute;top:-10px;right:-18px}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab__border[_ngcontent-%COMP%]{border-bottom:2px solid #5ab3e4;width:100%;position:absolute;bottom:-1px;display:none}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]:hover   .tab__name[_ngcontent-%COMP%]{color:#41a1d9;border-bottom:2px solid #EEEEEE}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab_active[_ngcontent-%COMP%]   .tab__name[_ngcontent-%COMP%]{color:#41a1d9;border-bottom:solid 2px #5ab3e4}.tabs-container[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab_active[_ngcontent-%COMP%]:hover   .tab__name[_ngcontent-%COMP%]{border-bottom:2px solid #5ab3e4}.tabs-container[_ngcontent-%COMP%]   .tabs.fixed[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]{position:fixed;left:0;right:0;width:100%;overflow-x:auto;background:#fff;z-index:80}"],
        changeDetection: 0
      });
    }
  }
  return SimpleTabsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SimpleTabsModule = /*#__PURE__*/(() => {
  class SimpleTabsModule {
    static {
      this.ɵfac = function SimpleTabsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SimpleTabsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SimpleTabsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, TranslateModule]
      });
    }
  }
  return SimpleTabsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingSelectClassModule = /*#__PURE__*/(() => {
  class MeetingSelectClassModule {
    static {
      this.ɵfac = function MeetingSelectClassModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingSelectClassModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MeetingSelectClassModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, ClickOutsideModule, IconModule, SimpleTabsModule, ClassroomPanelModule]
      });
    }
  }
  return MeetingSelectClassModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingSelectPresetModule = /*#__PURE__*/(() => {
  class MeetingSelectPresetModule {
    static {
      this.ɵfac = function MeetingSelectPresetModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingSelectPresetModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MeetingSelectPresetModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, IconModule]
      });
    }
  }
  return MeetingSelectPresetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingStepModule = /*#__PURE__*/(() => {
  class MeetingStepModule {
    static {
      this.ɵfac = function MeetingStepModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingStepModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MeetingStepModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return MeetingStepModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingFormModule = /*#__PURE__*/(() => {
  class MeetingFormModule {
    static {
      this.ɵfac = function MeetingFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MeetingFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, ReactiveFormsModule, SubjectSelectorModule, FormFieldModule, FormErrorsModule, MeetingSelectModule, MeetingSelectClassModule, MeetingStepModule, MeetingSelectPresetModule, MeetingSelectAuthorModule, FinancePlanBuyCreditsFormModule, RouterModule, OnUiButtonModule, OnUiSelectModule, OnUiInputModule, OnUiDateModule, OnUiTextareaModule, FormatPipeModule, OnUiCoverModule, MeetingSelectClassModule, MeetingSelectAuthorModule]
      });
    }
  }
  return MeetingFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @sample timezoneOffsetToHours(-4200) -> '-07:00'
 */
function timezoneOffsetToHours(offset) {
  const sign = offset >= 0 ? '-' : '+';
  function pad(num) {
    const norm = Math.floor(Math.abs(num));
    return (norm < 10 ? '0' : '') + norm;
  }
  return sign + pad(offset / 60) + ':' + pad(offset % 60);
}
/**
 * @sample timezone(new Date()) ->
 *     {
 *       abbreviation: 'GMT+0700 Новосибирск, стандартное время',
 *       offset_zone: 'GMT+0700',
 *       offset_hhmm: '-07:00',
 *     }
 */
function timezone(date) {
  const [, offset_zone, ...abbr] = new Date().toTimeString().split(' ');
  const abbreviation = abbr.join(' ').replace(/^\(/, '').replace(/\)$/, '');
  return {
    abbreviation,
    offset_zone,
    offset_hhmm: timezoneOffsetToHours(date.getTimezoneOffset())
  };
}
let PlanCard2Component = /*#__PURE__*/(() => {
  class PlanCard2Component extends ChangableComponent {
    set plan(plan) {
      this._plan = plan;
      if (!this.isAvailableSafeTransaction) {
        const terms = this._plan.details.tariff_terms.filter(el => el.label !== 'subscription-plans.terms.term4');
        this._plan.details.tariff_terms = terms;
      }
      if (this._plan.priceTier) {
        this._plan.priceTier = new CPriceTier(this._plan.priceTier);
      }
    }
    get plan() {
      return this._plan;
    }
    set current_plan_id(current_plan_id) {
      this._current_plan_id = current_plan_id;
    }
    constructor(deviceService, userService, features, authService, billingService, billingV2Service, cdr) {
      super(cdr);
      this.deviceService = deviceService;
      this.userService = userService;
      this.features = features;
      this.authService = authService;
      this.billingService = billingService;
      this.billingV2Service = billingV2Service;
      this.cdr = cdr;
      this.updatePlan = new EventEmitter();
      this.onChoose = new EventEmitter();
      this.needAuth = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this._myCurrency = Currency.defaultCurrency;
    }
    ngOnInit() {
      this.userService.me$.pipe(takeUntil(this.destroyed$)).subscribe(me => {
        this._myCurrency = me.currency_id;
        this.myCurrencyCode = Object.keys(CurrencyEnum)[Object.values(CurrencyEnum).indexOf(me.currency_id)].toUpperCase();
        if (this.myCurrencyCode === 'RUR') {
          this.myCurrencyCode = 'RUB';
        }
        this._me = me;
        this.getFormattedPrice();
      });
      this.getPriceTier(this._plan.price_tier_id).pipe(takeUntil(this.destroyed$)).subscribe(res => {
        this.currentPrice = Number(res.amount);
        this.billingV2Service.getCurrencyRate(res.currency_id).pipe(takeUntil(this.destroyed$)).subscribe(rate => {
          this.currencyRate = rate;
          this.getFormattedPrice();
        });
      });
    }
    getPriceTier(price_tier_id) {
      return this.billingService.getPriceTier$(price_tier_id);
    }
    replaceValues(line) {
      const begin = '{{ ';
      const end = ' }}';
      if (!this._plan || !this._plan.details) {
        return line;
      }
      let bracedWord = Parser.getBracedWord(line, begin, end).word;
      let isCommission = false;
      if (bracedWord === 'safe_trade_commission') {
        isCommission = true;
      }
      const details = this._plan.details;
      while (bracedWord) {
        const replace = details[bracedWord] === undefined ? bracedWord : isCommission ? `<span class="bold">${(100 - Number(details[bracedWord])).toString()}</span>` :
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        `<span class="bold">${details[bracedWord].toString()}</span>`;
        line = Parser.replaceBracedWord(line, bracedWord, replace, begin, end);
        bracedWord = Parser.getBracedWord(line, begin, end).word;
      }
      return line;
    }
    getFormattedPrice() {
      if (!this.currencyRate || !this.myCurrencyCode) {
        return '';
      }
      this.price = this.billingService.formatCurrencyAmount({
        amount: 0,
        currency_id: this._myCurrency || Currency.defaultCurrency
      });
      if (this._plan?.priceTier) {
        let currencyRate = 1;
        if (this.currencyRate.find(r => r.currency.toUpperCase() === this.myCurrencyCode.toUpperCase())) {
          currencyRate = Number(this.currencyRate.find(r => r.currency.toUpperCase() === this.myCurrencyCode.toUpperCase())?.rate);
        }
        this.price = this.billingService.formatCurrencyAmount({
          amount: Number(this.currentPrice) * Number(currencyRate),
          currency_id: this._myCurrency || Currency.defaultCurrency
        });
        this.detectChanges();
      }
    }
    onOpenActivatePlanModal() {
      if (!this.authService.isAuthenticated) {
        this.authService.showAuthModal();
      } else {
        this.onChoose.emit(this.plan);
      }
      this.detectChanges();
    }
    isCurrentPlan() {
      return this._plan?.id === this._current_plan_id;
    }
    get isAvailableSafeTransaction() {
      return this.features.isAvailable(FeatureEnum.safe_transaction);
    }
    static {
      this.ɵfac = function PlanCard2Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlanCard2Component)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(AbstractFeaturesService), i0.ɵɵdirectiveInject(AbstractAuthService), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PlanCard2Component,
        selectors: [["app-plan-card-2"]],
        inputs: {
          plan: "plan",
          current_plan_id: "current_plan_id",
          isLimitedVersion: "isLimitedVersion"
        },
        outputs: {
          updatePlan: "updatePlan",
          onChoose: "onChoose",
          needAuth: "needAuth"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 21,
        vars: 17,
        consts: [["activatePlanAction", ""], ["additional", ""], [1, "plan-card2"], [1, "left"], [1, "line-wrap"], ["class", "nameplate-text", 3, "background", 4, "ngIf"], [1, "title-block"], [1, "text-wrap"], [1, "title"], [4, "ngTemplateOutlet"], [1, "free-info"], [1, "actions"], [3, "ngIf", "ngIfElse"], [1, "properties-wrap"], ["class", "properties-item", 4, "ngFor", "ngForOf"], [1, "nameplate-text"], ["class", "current", "label", "subscription-plans.action-current", 4, "ngIf"], ["label", "subscription-plans.action-current", 1, "current"], ["label", "subscription-plans.action-activate2", 1, "secondary", 3, "click"], [1, "properties-item"], [1, "icon-wrap"], ["width", "12", "height", "9", "viewBox", "0 0 12 9", "stroke", "#87D37C"], [1, "label-wrap"], [1, "label", 3, "innerHTML"], [3, "ngIf"], [1, "side-wrap"], [1, "side-value"], [1, "side-text"], [1, "additional"], [1, "lessons-per-month"], [1, "price-wrap"], [1, "price"], [1, "period"]],
        template: function PlanCard2Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "article", 2)(1, "div", 3)(2, "div", 4);
            i0.ɵɵtemplate(3, PlanCard2Component_p_3_Template, 3, 5, "p", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 6)(5, "div", 7)(6, "p", 8);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(9, PlanCard2Component_ng_content_9_Template, 1, 0, "ng-content", 9);
            i0.ɵɵelementStart(10, "div", 10);
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 11);
            i0.ɵɵtemplate(14, PlanCard2Component_ng_template_14_Template, 1, 1, "ng-template", 12)(15, PlanCard2Component_ng_template_15_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "div", 13);
            i0.ɵɵtemplate(18, PlanCard2Component_div_18_Template, 8, 5, "div", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(19, PlanCard2Component_ng_template_19_Template, 11, 10, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const activatePlanAction_r4 = i0.ɵɵreference(16);
            const additional_r5 = i0.ɵɵreference(20);
            i0.ɵɵclassProp("is-limited", ctx.isLimitedVersion);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("background", ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.color);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.nameplate);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("color", ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.color);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 13, ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.title));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", additional_r5);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 15, "subscription-plans.free-for-students"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.isCurrentPlan())("ngIfElse", activatePlanAction_r4);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.tariff_terms);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i16.OnUiButtonComponent, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.plan-card2[_ngcontent-%COMP%]{border-radius:10px;background:#fff;box-sizing:border-box;display:flex;flex-direction:column;width:195px;transition:all .2s}.plan-card2.is-limited[_ngcontent-%COMP%]{width:264px}.plan-card2[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;flex:1 1 10px}.plan-card2[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .line-wrap[_ngcontent-%COMP%]{width:100%;height:8px;border-radius:30px;margin-bottom:15px;position:relative;text-align:center}.plan-card2[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .line-wrap[_ngcontent-%COMP%]   .nameplate-text[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:12px;line-height:16px;padding:5px 10px;border-radius:30px;color:#fff;margin:-10px auto;width:fit-content}.plan-card2[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]   .text-wrap[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 10px;font-size:16px;line-height:20px;text-transform:uppercase}.plan-card2[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .free-info[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 20px;color:#a4b0c3;font-size:12px;line-height:16px;color:#6d7381;padding:4px 10px;background:#f5f8fa;border-radius:30px}.plan-card2[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{margin-bottom:20px}.plan-card2[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]     on-ui-button .button{width:100%}.plan-card2[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]     on-ui-button .button .label{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;color:#fff}.plan-card2[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]     on-ui-button .button.current{background:#e6f6ff;border:1px solid #E6F6FF;cursor:not-allowed}.plan-card2[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]     on-ui-button .button.current .label{color:#5ab3e4}.plan-card2[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]{display:flex;margin-bottom:10px;padding:0 10px}.plan-card2[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;height:12px;width:20px;margin-top:3px}.plan-card2[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]{display:flex;flex:1 1 10px;flex-direction:column}.plan-card2[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;max-width:220px;white-space:normal}.plan-card2[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]{align-items:center;background:#feed7d;border-radius:20px;display:flex;height:27px;margin-top:10px;padding:0 10px;width:fit-content}.plan-card2[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-value[_ngcontent-%COMP%], .plan-card2[_ngcontent-%COMP%]   .properties-wrap[_ngcontent-%COMP%]   .properties-item[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-wrap[_ngcontent-%COMP%]   .side-text[_ngcontent-%COMP%]{color:#1e252b;font-size:14px;line-height:17px;white-space:nowrap}.plan-card2[_ngcontent-%COMP%]   .additional[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;margin-bottom:10px}.plan-card2[_ngcontent-%COMP%]   .additional[_ngcontent-%COMP%]   .lessons-per-month[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 10px;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b}.plan-card2[_ngcontent-%COMP%]   .additional[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]{display:flex;margin-bottom:5px}.plan-card2[_ngcontent-%COMP%]   .additional[_ngcontent-%COMP%]   .price-wrap[_ngcontent-%COMP%]   .price[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:24px;line-height:30px;font-family:LatoWeb,sans-serif}.plan-card2[_ngcontent-%COMP%]   .additional[_ngcontent-%COMP%]   .period[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;color:#6d7381}"],
        changeDetection: 0
      });
    }
  }
  return PlanCard2Component;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TrialComponent = /*#__PURE__*/(() => {
  class TrialComponent extends ChangableComponent {
    constructor(cdr, deviceService, userService, authService) {
      super(cdr);
      this.cdr = cdr;
      this.deviceService = deviceService;
      this.userService = userService;
      this.authService = authService;
      this.onChoose = new EventEmitter();
      this.onClickToTrial = new EventEmitter();
    }
    ngOnInit() {
      this.userService.me$.pipe(takeUntil$1(this.destroyed$)).subscribe(me => {
        this.currency_id = me.currency_id;
      });
    }
    get nextTrialPrice() {
      const nextPlan = this.plans.find(el => el.id === this.plan?.next_plan_id_after_trial);
      let currencyAmount = new CCurrencyAmount({
        amount: 0,
        currency_id: Currency.defaultCurrency
      });
      if (nextPlan?.priceTier) {
        currencyAmount = nextPlan?.priceTier?.getForCurrency(this.currency_id);
      }
      return currencyAmount?.formatFixed();
    }
    onTrialActivate() {
      this.onClickToTrial.emit();
      if (!this.authService.isAuthenticated) {
        this.authService.showAuthModal();
      } else {
        this.onChoose.emit();
      }
    }
    static {
      this.ɵfac = function TrialComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrialComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(AbstractAuthService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TrialComponent,
        selectors: [["app-trial"]],
        inputs: {
          plan: "plan",
          plans: "plans"
        },
        outputs: {
          onChoose: "onChoose",
          onClickToTrial: "onClickToTrial"
        },
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 15,
        vars: 15,
        consts: [[1, "trial-block"], [1, "left"], ["alt", "goal-1", 3, "src"], [1, "info-block"], [1, "offer"], [1, "days"], [1, "details"], [1, "right"], ["label", "subscription-plans.action-activate2", 1, "secondary", 3, "onclick"]],
        template: function TrialComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "img", 2);
            i0.ɵɵelementStart(3, "div", 3)(4, "p", 4);
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "p", 5);
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "p", 6);
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(13, "div", 7)(14, "on-ui-button", 8);
            i0.ɵɵlistener("onclick", function TrialComponent_Template_on_ui_button_onclick_14_listener() {
              return ctx.onTrialActivate();
            });
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("mobile", ctx.deviceService.isMobile());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("src", ctx.assetsUrl("/assets/images/goal-1.png"), i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 6, ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.nameplate));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 8, ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.subtitle));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(12, 10, ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.hint, i0.ɵɵpureFunction1(13, _c27, ctx.nextTrialPrice)));
          }
        },
        dependencies: [CommonModule, TranslateModule, i3.TranslatePipe, OnUiButtonModule, i16.OnUiButtonComponent],
        styles: ["@charset \"UTF-8\";.trial-block[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding:15px 30px;background:#feed7d}.trial-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{display:flex;align-items:center;gap:30px}.trial-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:170px}.trial-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .info-block[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:5px}.trial-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .info-block[_ngcontent-%COMP%]   .offer[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:20px;color:#41a1d9}.trial-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .info-block[_ngcontent-%COMP%]   .days[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:24px;line-height:30px}.trial-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .info-block[_ngcontent-%COMP%]   .details[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#6d7381}.trial-block[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]     on-ui-button .button{width:195px}.trial-block.mobile[_ngcontent-%COMP%]{flex-direction:column;gap:20px;padding:20px 15px}.trial-block.mobile[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{flex-direction:column;gap:20px}.trial-block.mobile[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:300px}.trial-block.mobile[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .info-block[_ngcontent-%COMP%]{align-items:center}.trial-block.mobile[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{width:100%}.trial-block.mobile[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]     on-ui-button .button{width:100%}"]
      });
    }
  }
  return TrialComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HintCardsComponent = /*#__PURE__*/(() => {
  class HintCardsComponent extends ChangableComponent {
    constructor(cdr, deviceService) {
      super(cdr);
      this.cdr = cdr;
      this.deviceService = deviceService;
    }
    ngOnInit() {}
    static {
      this.ɵfac = function HintCardsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HintCardsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DeviceDetectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HintCardsComponent,
        selectors: [["app-hint-cards"]],
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 10,
        vars: 23,
        consts: [[1, "cards"], [1, "section-1"], [3, "width", "height", "icon"], [1, "section-2"]],
        template: function HintCardsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "app-icon", 2)(3, "app-icon", 2)(4, "app-icon", 2)(5, "app-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 3);
            i0.ɵɵelement(7, "app-icon", 2)(8, "app-icon", 2)(9, "app-icon", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("mobile", ctx.deviceService.isMobile());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("width", 60)("height", 38)("icon", "master-card-hint");
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", 60)("height", 20)("icon", "visa");
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", 60)("height", 38)("icon", "apple-pay-hint");
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", 60)("height", 38)("icon", "google-pay-hint");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("width", 55)("height", 54)("icon", "verified-by-visa");
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", 80)("height", 52)("icon", "verified-by-master");
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", 71)("height", 69)("icon", "verified-by-pci");
          }
        },
        dependencies: [CommonModule, IconModule, IconComponent],
        styles: ["@charset \"UTF-8\";.cards[_ngcontent-%COMP%]{display:flex;justify-content:space-between;padding:0 30px}.cards[_ngcontent-%COMP%]   .section-1[_ngcontent-%COMP%], .cards[_ngcontent-%COMP%]   .section-2[_ngcontent-%COMP%]{display:flex;align-items:center;gap:10px}.cards.mobile[_ngcontent-%COMP%]{flex-direction:column;align-items:center;padding:15px 30px}.cards[_ngcontent-%COMP%]   .section-1[_ngcontent-%COMP%]{gap:30px}"]
      });
    }
  }
  return HintCardsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TrialHeaderDetailsComponent = /*#__PURE__*/(() => {
  class TrialHeaderDetailsComponent extends ChangableComponent {
    set plan(plan) {
      this._plan = plan;
    }
    get plan() {
      return this._plan;
    }
    constructor(screenService, deviceService, cdr) {
      super(cdr);
      this.screenService = screenService;
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    ngOnInit() {}
    screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    static {
      this.ɵfac = function TrialHeaderDetailsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrialHeaderDetailsComponent)(i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TrialHeaderDetailsComponent,
        selectors: [["app-trial-header-details"]],
        inputs: {
          plan: "plan",
          nextTrialPrice: "nextTrialPrice"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 25,
        vars: 21,
        consts: [[1, "headers-details", "no-steps", 3, "ngClass"], [1, "left-info"], [1, "avatar"], ["width", "61", "height", "61", "viewBox", "0 0 61 61"], [1, "info", "trial"], [1, "label", "normal"], [1, "title", "bold"], [1, "subtitle", "normal"], [1, "right-info"], [1, "text", "bold"], [1, "amount-holder", "bold"], [1, "amount"], [1, "sup-amount"]],
        template: function TrialHeaderDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(3, "svg", 3);
            i0.ɵɵelement(4, "use");
            i0.ɵɵelementEnd()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(5, "div", 4)(6, "span", 5);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "span", 6);
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "span", 7);
            i0.ɵɵtext(13);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(15, "div", 8)(16, "div", 9);
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "div", 10)(20, "span", 11);
            i0.ɵɵtext(21, "$0");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "span", 12);
            i0.ɵɵtext(23);
            i0.ɵɵpipe(24, "translate");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.screenClasses());
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("fill", ctx.plan == null ? null : ctx.plan.details == null ? null : ctx.plan.details.color);
            i0.ɵɵadvance();
            i0.ɵɵattribute("href", ctx.svgsetIcon("trial-plan"), null, "xlink");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(8, 8, "plans.special_offer"), " \uD83D\uDD25");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 10, "plans.30_days_for_free"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(14, 12, "plans.30_days_for_free_description", i0.ɵɵpureFunction1(19, _c27, ctx.nextTrialPrice)));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 15, "plans.trial_subscription_activation"));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" /", i0.ɵɵpipeBind1(24, 17, "plans.first_month"), "");
          }
        },
        dependencies: [i2.NgClass, i3.TranslatePipe],
        styles: [_c18]
      });
    }
  }
  return TrialHeaderDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TrialHeaderDetailsModule = /*#__PURE__*/(() => {
  class TrialHeaderDetailsModule {
    static {
      this.ɵfac = function TrialHeaderDetailsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrialHeaderDetailsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TrialHeaderDetailsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, OnUiCoverModule, TranslateModule]
      });
    }
  }
  return TrialHeaderDetailsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TrialFooterDetailsComponent = /*#__PURE__*/(() => {
  class TrialFooterDetailsComponent extends ChangableComponent {
    set plan(plan) {
      this._plan = plan;
    }
    get plan() {
      return this._plan;
    }
    constructor(screenService, deviceService, cdr) {
      super(cdr);
      this.screenService = screenService;
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    ngOnInit() {}
    get trialEndAt() {
      const currentDate = new Date(Date.now());
      return currentDate.setDate(currentDate.getDate() + 30);
    }
    screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    static {
      this.ɵfac = function TrialFooterDetailsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrialFooterDetailsComponent)(i0.ɵɵdirectiveInject(ScreenService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TrialFooterDetailsComponent,
        selectors: [["app-trial-footer-details"]],
        inputs: {
          plan: "plan",
          nextTrialPrice: "nextTrialPrice"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 14,
        consts: [[1, "footer-details", 3, "ngClass"], [1, "trial-info"], [1, "text"], [1, "info"]],
        template: function TrialFooterDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "dfnsFormat");
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.screenClasses());
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "plans.first_payment_date"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(8, 8, "plans.text_per_month", i0.ɵɵpureFunction2(11, _c28, i0.ɵɵpipeBind2(7, 5, ctx.trialEndAt, "dd MMMM yyyy"), ctx.nextTrialPrice)));
          }
        },
        dependencies: [i2.NgClass, i3.TranslatePipe, i6.FormatPipe],
        styles: ["@charset \"UTF-8\";.footer-details[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:flex-start;position:relative;gap:15px}.footer-details[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%]{width:105px;height:70px;flex-shrink:0;border-radius:10px}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .subject[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 5px;font-family:LatoWebBold,sans-serif;color:#a4b0c3;font-size:14px;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;line-height:14px;color:#41a1d9;width:200px}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:20px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word;line-break:normal;line-height:16px;width:100%}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]{margin-top:10px}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   .no-selected-user-service[_ngcontent-%COMP%]{color:#a4b0c3}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none;display:flex;align-items:center}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline;position:relative;padding-right:7px;margin-right:5px;text-transform:capitalize;color:#a4b0c3}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:before{content:\"\";width:2px;height:2px;background:#41a1d9;position:absolute;top:calc(50% - 1px);right:0}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{color:#1e252b}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .full-dates[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#41a1d9;cursor:pointer}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{padding-right:0;margin-right:0}.footer-details[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child:before{display:none}.footer-details[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]{color:#a4b0c3;font-family:LatoWeb,sans-serif;font-weight:inherit;font-size:10px;line-height:12px;position:absolute;z-index:1;top:-18px;left:120px;background:#f5f8fa;padding:2px 5px;border-radius:0 0 5px 5px}.footer-details.mobile[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{flex-wrap:wrap}.footer-details.mobile[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .more-info[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{white-space:nowrap}.footer-details[_ngcontent-%COMP%]   .trial-info[_ngcontent-%COMP%]{display:flex;flex-direction:column}.footer-details[_ngcontent-%COMP%]   .trial-info[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%], .footer-details[_ngcontent-%COMP%]   .trial-info[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px}.course-popover[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;gap:10px}.course-popover[_ngcontent-%COMP%]   .date-item[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px}"]
      });
    }
  }
  return TrialFooterDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TrialFooterDetailsModule = /*#__PURE__*/(() => {
  class TrialFooterDetailsModule {
    static {
      this.ɵfac = function TrialFooterDetailsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrialFooterDetailsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TrialFooterDetailsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, OnUiCoverModule, TranslateModule, FormatPipeModule]
      });
    }
  }
  return TrialFooterDetailsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Мастер подписки на триал */
let TrialCheckoutWizardDialogComponent = /*#__PURE__*/(() => {
  class TrialCheckoutWizardDialogComponent extends AbstractCheckoutWizard {
    set plan(plan) {
      this._plan = plan;
      this.activePlan = plan;
    }
    get plan() {
      return this._plan;
    }
    set plans(plans) {
      this._plans = plans;
    }
    get plans() {
      return this._plans;
    }
    set checkoutInfo(value) {
      this._checkoutInfo = value;
    }
    get checkoutInfo() {
      return this._checkoutInfo;
    }
    constructor(userService, billingV2Service, profileService, injector, cdr, store, billingService, deviceService, screenService) {
      super(injector, cdr);
      this.userService = userService;
      this.billingV2Service = billingV2Service;
      this.profileService = profileService;
      this.injector = injector;
      this.cdr = cdr;
      this.store = store;
      this.billingService = billingService;
      this.deviceService = deviceService;
      this.screenService = screenService;
      this.closed = new EventEmitter();
      this.succeed = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this.userHavePaymentMethods = null;
      this.payClicked = false;
      this.openAddAccountModal = false;
      this.ngDestroyed = new Subject();
      this._isCheckout = false;
    }
    ngOnInit() {
      super.ngOnInit();
      this.userService.me$.pipe(takeUntil$1(this.destroyed$)).subscribe(me => {
        this._me = me;
        this.currency_id = me.currency_id;
        this.prepareCheckoutInfo();
      });
      this.getUserPaymentMethods();
    }
    onClose() {
      this.closed.emit(true);
    }
    /** Инициализация шагов мастера */
    initWizardSteps() {
      this.steps.addStep(new StepByStepWizardStep({
        id: 'trial',
        title: 'Trial',
        context: this,
        checks: [],
        visible: true,
        active: false
      }));
      this.steps.addStep(new StepByStepWizardStep({
        id: 'payment',
        title: 'payment-checkout-wizard.steps.user-service.payment',
        context: this,
        checks: [],
        visible: true,
        active: false
      }));
      this.cdr.detectChanges();
    }
    /** Настройка шагов мастера под набор входных параметров */
    setupWizardSteps() {
      this.setupPaymentWidget();
      this.steps.goStep('trial');
    }
    /** Настройка данных для проведения платежа */
    setupPaymentWidget() {
      if (this._isCheckout) {
        return;
      }
      this.paymentWidgetService.payAmount$.pipe(tap$1(totalAmount => {
        this.totalAmount = totalAmount;
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    /** Выполнить обработку по активации шага мастера */
    onStepActivated() {}
    onPaymentSucceed() {
      this.setTimeout(() => {
        super.onPaymentSucceed();
        this.succeed.emit(true);
        this.onClose();
      }, 5000);
    }
    goNextStep() {
      this.steps.get('trial').complete = true;
      this.steps.goStep('payment');
      this.detectChanges();
    }
    ngAfterViewInit() {}
    prepareCheckoutInfo() {
      this.profileService.getSettings(this._me.id).pipe(tap$1(userSettings => {
        this._isCheckout = true;
        this.paymentOptions = {
          first_name: this._me.first_name,
          last_name: this._me.last_name,
          email: userSettings.email,
          phone: userSettings.mobile_phone,
          country: this._me.country?.alpha2Code,
          order_id: String(this.checkoutInfo.model.billing_order_id),
          charge_id: [String(this.checkoutInfo.model.billing_charge_id)]
        };
        this.detectChanges();
      }), catchError$1(err => {
        this.errorMessage = err.message;
        this.activateView('error');
        console.error(err);
        return throwError(err);
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    getUserPaymentMethods() {
      this.billingV2Service.getAccounts().pipe(tap$1(accounts => {
        this.userHavePaymentMethods = accounts.length > 0;
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    onPaymentConfigured(event) {
      super.onPaymentConfigured(event);
      this.selectedCardId = event.paymentMethod.paymentMethod.cardAccount.accountId;
    }
    onStartPayment() {
      this.payClicked = true;
      // super.onStartPayment();
      this.billingService.activatePlanV2({
        plan_id: this.plan.id,
        billing_account_id: this.selectedCardId
      }).pipe(tap$1(() => {
        this.activateView('success');
        this.onPaymentSucceed();
        this.detectChanges();
      }), catchError$1(err => {
        this.errorMessage = err.error ? err.error.message : JSON.stringify(err);
        this.activateView('fail');
        return throwError(err);
      }), takeUntil$1(this.destroyed$)).subscribe();
    }
    onAddAccount(providerId) {
      this.openAddAccountModal = true;
      this.addAccountProviderId = providerId;
    }
    onCloseAddAccount() {
      this.openAddAccountModal = false;
      this.afterAddAccountNeedUpdate = Date.now();
      this.detectChanges();
    }
    get trialEndAt() {
      const currentDate = new Date(Date.now());
      return currentDate.setDate(currentDate.getDate() + 30);
    }
    get nextTrialPrice() {
      if (!this.plans || !this.plan || !this.currency_id) {
        return;
      }
      const nextPlan = this.plans.find(el => el.id === this.plan?.next_plan_id_after_trial);
      let currencyAmount = new CCurrencyAmount({
        amount: 0,
        currency_id: Currency.defaultCurrency
      });
      if (nextPlan?.priceTier) {
        currencyAmount = nextPlan?.priceTier?.getForCurrency(this.currency_id);
      }
      return currencyAmount?.formatFixed();
    }
    screenClasses() {
      const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
      return {
        tablet: this.deviceService.isTablet(),
        mobile: this.deviceService.isMobile(),
        desktop: !this.deviceService.isTablet() && !this.deviceService.isMobile() || this.deviceService.isDesktop(),
        portrait: !this.deviceService.isDesktop() && isPortrait,
        landscape: !this.deviceService.isDesktop() && !isPortrait
      };
    }
    static {
      this.ɵfac = function TrialCheckoutWizardDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrialCheckoutWizardDialogComponent)(i0.ɵɵdirectiveInject(AbstractUserService), i0.ɵɵdirectiveInject(AbstractBillingV2Service), i0.ɵɵdirectiveInject(AbstractProfileService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$1.Store), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(ScreenService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TrialCheckoutWizardDialogComponent,
        selectors: [["app-trial-checkout-wizard-dialog"]],
        inputs: {
          plan: "plan",
          plans: "plans",
          checkoutInfo: "checkoutInfo"
        },
        outputs: {
          closed: "closed",
          succeed: "succeed"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 11,
        vars: 3,
        consts: [["contentRef", ""], ["trialInfo", ""], ["successRef", ""], ["failedRef", ""], [3, "canClose", "closed", 4, "ngIf"], [3, "titleVisible", "withCloseButton", "customTitle", "closed", 4, "ngIf"], [3, "providerId", "closed", 4, "ngIf"], [3, "closed", "canClose"], [3, "ngTemplateOutlet"], [3, "closed", "titleVisible", "withCloseButton", "customTitle"], [1, "checkout-wizard-wrap"], [3, "steps", "showHeader", "showFooter", "showSteps"], ["header-details", ""], [3, "plan", "nextTrialPrice"], ["content", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], ["style", "font-size: 8px;", 4, "ngIf"], ["footer-details", ""], [1, "plan-footer"], ["class", "footer", 4, "ngIf"], ["footer-actions", "", 4, "ngIf"], [3, "options", "payClicked", "needUpdate", "buyTrial", "configured", "succeed", "failed", "processing", "addAccount", 4, "ngIf"], [3, "configured", "succeed", "failed", "processing", "addAccount", "options", "payClicked", "needUpdate", "buyTrial"], [4, "ngIf"], [2, "font-size", "8px"], [1, "footer"], ["footer-actions", ""], ["class", "primary", 3, "state", "label", "click", 4, "ngIf"], [3, "state", "disabled", "startLabel", "closeLabel", "cancelLabel", "retryLabel", "start", "retry", "cancel", 4, "ngIf"], [1, "primary", 3, "click", "state", "label"], [3, "start", "retry", "cancel", "state", "disabled", "startLabel", "closeLabel", "cancelLabel", "retryLabel"], [1, "trial-content", 3, "ngClass"], [1, "img"], [1, "info-wrap"], [1, "info-top"], [1, "title"], [1, "options"], [1, "option"], ["width", "12", "height", "9", "viewBox", "0 0 12 9", "stroke", "#87D37C", 1, "icon"], [1, "text"], [1, "info-bottom"], [1, "additional-info"], [1, "info"], [1, "finish-success"], ["width", "98", "height", "98", "viewBox", "0 0 98 98", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "icon"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#87D37C"], ["d", "M74.7524 38.2306L47.0937 65.7585C46.2639 66.5843 45.1747 67 44.0854 67C42.9962 67 41.9069 66.5843 41.0772 65.7585L27.2482 51.9945C25.5839 50.3389 25.5839 47.6619 27.2482 46.0063C28.9116 44.3498 31.6005 44.3498 33.2647 46.0063L44.0854 56.7761L68.7359 32.2423C70.3993 30.5859 73.0882 30.5859 74.7524 32.2423C76.4159 33.898 76.4159 36.5741 74.7524 38.2306Z", "fill", "#FAFAFA"], [1, "finish-fail"], ["d", "M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z", "fill", "#E86F79"], ["x", "29", "y", "35", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-45 29 35)", "fill", "white"], ["x", "35", "y", "70", "width", "8", "height", "50", "rx", "4", "transform", "rotate(-135 35 70)", "fill", "white"], [1, "description"], [3, "closed", "providerId"]],
        template: function TrialCheckoutWizardDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TrialCheckoutWizardDialogComponent_app_modal_0_Template, 3, 2, "app-modal", 4)(1, TrialCheckoutWizardDialogComponent_app_mobile_modal_1_Template, 5, 6, "app-mobile-modal", 5)(2, TrialCheckoutWizardDialogComponent_ng_template_2_Template, 16, 17, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, TrialCheckoutWizardDialogComponent_ng_template_4_Template, 27, 30, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, TrialCheckoutWizardDialogComponent_ng_template_6_Template, 7, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, TrialCheckoutWizardDialogComponent_ng_template_8_Template, 10, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(10, TrialCheckoutWizardDialogComponent_app_add_card_wizard_dialog_10_Template, 1, 1, "app-add-card-wizard-dialog", 6);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.deviceService.isDesktop());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.deviceService.isDesktop());
            i0.ɵɵadvance(9);
            i0.ɵɵproperty("ngIf", ctx.openAddAccountModal);
          }
        },
        dependencies: [i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, ModalComponent, ModalBodyComponent, MobileModalComponent, MobileModalBodyComponent, StepByStepWizardComponent, i16.OnUiButtonComponent, PaymentWidgetComponent, PayButtonComponent, AddCardWizardDialogComponent, TrialHeaderDetailsComponent, TrialFooterDetailsComponent, i2.AsyncPipe, i2.JsonPipe, i3.TranslatePipe, i6.FormatPipe],
        styles: ["@charset \"UTF-8\";.step-title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 20px;font-size:18px;line-height:24px;display:flex;justify-content:space-between;align-items:center}.trial-content[_ngcontent-%COMP%]{display:flex;min-height:240px}.trial-content[_ngcontent-%COMP%]   .img[_ngcontent-%COMP%]{background:url(/assets/images/plan-activate-form.jpg) no-repeat center;background-size:cover;border-radius:10px;height:242px;margin-right:30px;width:287px}.trial-content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px;justify-content:space-between}.trial-content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-top[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:10px}.trial-content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-top[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0;font-size:18px;line-height:24px}.trial-content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-top[_ngcontent-%COMP%]   .options[_ngcontent-%COMP%]{display:flex;flex-direction:column}.trial-content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-top[_ngcontent-%COMP%]   .options[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:12px;height:9px;display:flex}.trial-content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-top[_ngcontent-%COMP%]   .options[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;display:flex;align-items:center;gap:5px}.trial-content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%], .trial-content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .additional-info[_ngcontent-%COMP%]{display:flex;flex-direction:column}.trial-content[_ngcontent-%COMP%]   .info-wrap[_ngcontent-%COMP%]   .info-bottom[_ngcontent-%COMP%]   .additional-info[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#a4b0c3}.actions[_ngcontent-%COMP%]{border-top:1px solid #EEEEEE;display:flex;padding:30px;justify-content:space-between;gap:10px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]{display:flex}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]{border:1px solid #EEEEEE;background:#fff;box-sizing:border-box;border-radius:10px;color:#1e252b;cursor:pointer;outline:none;font-size:14px;line-height:18px;height:32px;padding:0 13px;-webkit-user-select:none;user-select:none;width:126px}.actions[_ngcontent-%COMP%]   .promo-wrap[_ngcontent-%COMP%]   .input-promo[_ngcontent-%COMP%]::placeholder{color:#ccc}.finish-success[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;flex:1;min-height:300px;width:100%}.finish-success[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 30px;font-size:24px;line-height:30px}.finish-success[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{width:98px;height:98px}.finish-success[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%], .finish-fail[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:20px 0 0;color:#a4b0c3;font-size:14px;line-height:18px;text-align:center}"],
        changeDetection: 0
      });
    }
  }
  return TrialCheckoutWizardDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaywallWrapperComponent = /*#__PURE__*/(() => {
  class PaywallWrapperComponent extends ChangableComponent {
    set preparedBusinessPlans(plans) {
      this.plans = plans;
      this.detectChanges();
    }
    set myBillingPlanId(planId) {
      this.activePlanId = planId;
    }
    constructor(deviceService, billingService, paymentWidget, webSocket, cdr) {
      super(cdr);
      this.deviceService = deviceService;
      this.billingService = billingService;
      this.paymentWidget = paymentWidget;
      this.webSocket = webSocket;
      this.cdr = cdr;
      this.update = new EventEmitter();
      this.onChoose = new EventEmitter();
      this.trialOpened = new EventEmitter();
      this.showTrialWizard = false;
    }
    ngOnInit() {
      this.loadData();
      this.webSocket.onNotice.pipe(takeUntil(this.destroyed$)).subscribe(data => {
        if ([NoticeTypeEnum.billing_operation_completed, NoticeTypeEnum.billing_operation_error].includes(data.notice.type)) {
          this.update.emit(true);
        }
      });
      this.paymentWidget.pay$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
        this.update.emit(true);
      });
    }
    loadData() {
      this.billingService.getActualTrialPlan().pipe(takeUntil(this.destroyed$)).subscribe(trialPlan => {
        this.trialPlan = trialPlan;
        this.detectChanges();
      });
    }
    get isLimitedVersion() {
      return this.tenant === TenantEnum.onclass_me;
    }
    planUpdated() {
      this.update.emit(true);
    }
    onPlanChoose(e) {
      this.onChoose.emit(e);
    }
    onTrialClick() {
      this.trialOpened.emit(true);
    }
    onTrialChoose() {
      this.selectedPlan = this.trialPlan;
      this.billingService.switchToPlanV2({
        plan_id: this.selectedPlan.id
      }).pipe(tap$1(response => {
        this.switchOperation = response;
        this.showTrialWizard = true;
      }), takeUntil(this.destroyed$)).subscribe();
    }
    moveLeft() {
      this.ds.moveLeft();
    }
    moveRight() {
      this.ds.moveRight();
    }
    onSuccessTrial() {
      this.selectedPlan = null;
      this.loadData();
      this.planUpdated();
    }
    closeTrial() {
      this.selectedPlan = null;
      this.showTrialWizard = false;
      this.loadData();
    }
    static {
      this.ɵfac = function PaywallWrapperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaywallWrapperComponent)(i0.ɵɵdirectiveInject(i1.DeviceDetectorService), i0.ɵɵdirectiveInject(AbstractBillingService), i0.ɵɵdirectiveInject(PaymentWidgetService), i0.ɵɵdirectiveInject(AbstractWebsocketService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaywallWrapperComponent,
        selectors: [["app-paywall-wrapper"]],
        viewQuery: function PaywallWrapperComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c30, 5, DragScrollComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ds = _t.first);
          }
        },
        inputs: {
          isSeparate: "isSeparate",
          tenant: "tenant",
          preparedBusinessPlans: "preparedBusinessPlans",
          myBillingPlanId: "myBillingPlanId"
        },
        outputs: {
          update: "update",
          onChoose: "onChoose",
          trialOpened: "trialOpened"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 11,
        vars: 12,
        consts: [["dragScroll", ""], [1, "paywall-wrapper"], ["class", "header", 4, "ngIf"], [1, "plan-cards", "scroll"], [1, "carousel-wrap", 3, "snap-duration"], ["class", "card-wrap", "drag-scroll-item", "", 4, "ngFor", "ngForOf"], ["class", "actions", 4, "ngIf"], [3, "plan", "plans", "onClickToTrial", "onChoose", 4, "ngIf"], [3, "ngIf"], [4, "ngIf"], [1, "header"], [1, "title"], ["drag-scroll-item", "", 1, "card-wrap"], [3, "updatePlan", "onChoose", "plan", "current_plan_id", "isLimitedVersion"], [1, "actions"], [1, "button", 3, "click"], [1, "button-ico"], [1, "button", "button--right", 3, "click"], [3, "onClickToTrial", "onChoose", "plan", "plans"], [1, "text", 3, "innerHTML"], [3, "succeed", "closed", "plan", "plans", "checkoutInfo"]],
        template: function PaywallWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, PaywallWrapperComponent_div_1_Template, 4, 3, "div", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "drag-scroll", 4, 0);
            i0.ɵɵtemplate(5, PaywallWrapperComponent_div_5_Template, 2, 3, "div", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, PaywallWrapperComponent_div_6_Template, 7, 2, "div", 6)(7, PaywallWrapperComponent_app_trial_7_Template, 1, 2, "app-trial", 7)(8, PaywallWrapperComponent_ng_template_8_Template, 3, 3, "ng-template", 8)(9, PaywallWrapperComponent_app_hint_cards_9_Template, 1, 0, "app-hint-cards", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, PaywallWrapperComponent_ng_container_10_Template, 2, 3, "ng-container", 9);
          }
          if (rf & 2) {
            i0.ɵɵclassProp("mobile", !ctx.deviceService.isDesktop());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isSeparate);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("is-limited", ctx.isLimitedVersion);
            i0.ɵɵadvance();
            i0.ɵɵproperty("snap-duration", 200);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.plans);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.deviceService.isMobile());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.trialPlan);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isSeparate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isLimitedVersion);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showTrialWizard);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, PlanCard2Component, TrialComponent, HintCardsComponent, i8.DragScrollComponent, TrialCheckoutWizardDialogComponent, i8.DragScrollItemDirective, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";.paywall-wrapper[_ngcontent-%COMP%]{margin:-30px}.paywall-wrapper[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{align-items:center;border-radius:10px 10px 0 0;background:url(/assets/images/paywall-wrapper-header.jpg) no-repeat center;background-size:cover;display:flex;height:125px}.paywall-wrapper[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;font-size:24px;line-height:30px;color:#fff;margin:0 0 0 30px}.paywall-wrapper[_ngcontent-%COMP%]   .plan-cards[_ngcontent-%COMP%]{display:flex;padding:20px 30px 30px}.paywall-wrapper[_ngcontent-%COMP%]   .plan-cards[_ngcontent-%COMP%]     .drag-scroll-content{display:flex!important;gap:15px;padding-top:10px}.paywall-wrapper[_ngcontent-%COMP%]   .plan-cards.is-limited[_ngcontent-%COMP%]{gap:20px}.paywall-wrapper[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{background:#eee;border:none;height:1px;width:calc(100% - 60px);margin:0 0 0 30px}.paywall-wrapper[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#6d7381;padding:30px}.paywall-wrapper.mobile[_ngcontent-%COMP%]{background:#fff;margin:0}.paywall-wrapper.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{border-radius:0;background:url(/assets/images/paywall-wrapper-header-mobile.jpg) no-repeat center;background-size:cover}.paywall-wrapper.mobile[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{max-width:120px}.paywall-wrapper.mobile[_ngcontent-%COMP%]   .plan-cards[_ngcontent-%COMP%]{padding:20px 15px 30px}.paywall-wrapper.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{display:flex;justify-content:center;gap:20px;margin-bottom:20px}.paywall-wrapper.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .button-ico[_ngcontent-%COMP%]{fill:#fff;stroke:#41a1d9;height:22px;width:12px;transition:all .2s linear}.paywall-wrapper.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{background:#fff;border-radius:50%;box-shadow:0 0 10px #0000001a;cursor:pointer;height:50px;transition:all .2s linear;transform:rotate(180deg);width:50px;display:flex;align-items:center;justify-content:center}.paywall-wrapper.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .button--right[_ngcontent-%COMP%]{transform:rotate(0)}.paywall-wrapper.mobile[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .button--disabled[_ngcontent-%COMP%]{display:none}.paywall-wrapper.mobile[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{background:#eee;border:none;height:1px;width:calc(100% - 30px);margin:0 0 0 15px}.paywall-wrapper.mobile[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{padding:30px 15px}"],
        changeDetection: 0
      });
    }
  }
  return PaywallWrapperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable max-len */
let TrialCheckoutWizardDialogModule = /*#__PURE__*/(() => {
  class TrialCheckoutWizardDialogModule {
    static {
      this.ɵfac = function TrialCheckoutWizardDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrialCheckoutWizardDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TrialCheckoutWizardDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CommonModule, TranslateModule, ModalModule, MobileModalModule, StepByStepWizardModule, OnUiButtonModule, PaymentWidgetModule, PayButtonModule, ReactiveFormsModule, FormsModule, PlansHeaderDetailsModule, OnUiTextareaModule, SpinnersModule, AddCardWizardDialogModule, TrialHeaderDetailsModule, FormatPipeModule, TrialFooterDetailsModule]
      });
    }
  }
  return TrialCheckoutWizardDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlanCard2Module = /*#__PURE__*/(() => {
  class PlanCard2Module {
    static {
      this.ɵfac = function PlanCard2Module_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlanCard2Module)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PlanCard2Module
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, ModalModule, MobileModalModule, FinancePlanActivateFormModule, OnUiButtonModule, FinancePlanActivateFormV2Module]
      });
    }
  }
  return PlanCard2Module;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaywallWrapperModule = /*#__PURE__*/(() => {
  class PaywallWrapperModule {
    static {
      this.ɵfac = function PaywallWrapperModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaywallWrapperModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PaywallWrapperModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, PlanCard2Module, TranslateModule, TrialComponent, HintCardsComponent, DragScrollComponent, PlansCheckoutWizardDialogModule, TrialCheckoutWizardDialogModule]
      });
    }
  }
  return PaywallWrapperModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MeetingReferencesService = /*#__PURE__*/(() => {
  class MeetingReferencesService {
    constructor(configService, languageService, classroomsService, billingService, accountService, profileService, userService) {
      this.configService = configService;
      this.languageService = languageService;
      this.classroomsService = classroomsService;
      this.billingService = billingService;
      this.accountService = accountService;
      this.profileService = profileService;
      this.userService = userService;
    }
    get me$() {
      return this.userService.me$;
    }
    get uiLanguage$() {
      return this.languageService.language$;
    }
    get languages$() {
      return this.configService.languages$.pipe(filter(items => !!items?.length));
    }
    get subjectsV2$() {
      return this.configService.subjectsV2$.pipe(filter(x => !!x));
    }
    get subjectLevels2$() {
      return this.configService.subjectLevels2$.pipe(filter(x => !!x));
    }
    get userServiceCategories$() {
      return this.configService.userServiceCategories$.pipe(filter(items => !!items?.length));
    }
    get billingSettings$() {
      return this.billingService.getSettings$().pipe(filter(settings => !!settings));
    }
    get accountCheck$() {
      return this.accountService.accountCheck().pipe(filter(accountCheck => !!accountCheck));
    }
    get recommendedPlan$() {
      return this.billingService.getRecommendedPlan();
    }
    loadProfile(me) {
      return this.profileService.getProfile(me.id);
    }
    loadClassrooms(me) {
      return this.classroomsService.getClassrooms({
        author_id: me.id
      }, {
        page: 1,
        pageSize: 20,
        totalPages: 0,
        total: 0
      }, ['id', 'title', 'type', 'cover_id', 'stats']).pipe(map(response => response.results));
    }
    filterLanguages(me, languages, uiLanguage) {
      const spokenLanguages = me.spoken_languages || [];
      const filtered = languages.filter(lang => !!spokenLanguages.find(item => +item.language_id === +lang.id || lang.id === uiLanguage.id));
      return [...filtered].sort((a, b) => a.title.localeCompare(b.title));
    }
    prepareReferences() {
      return zip(this.me$, this.uiLanguage$, this.languages$, this.subjectsV2$, this.subjectLevels2$, this.userServiceCategories$, this.billingSettings$, this.accountCheck$, this.recommendedPlan$).pipe(switchMap(references => {
        const me = references[0];
        return zip(this.loadProfile(me), this.loadClassrooms(me)).pipe(map(([profile, classrooms]) => [...references, profile, classrooms]));
      }), map(([me, uiLanguage, languages, subjects, subjectLevels, categories, billingSettings, accountCheck, recommendedPlan, profile, classrooms]) => {
        const filteredLanguages = this.filterLanguages(me, languages, uiLanguage);
        return {
          languages: filteredLanguages,
          subjects,
          subjectLevels,
          uiLanguage,
          me,
          billingSettings,
          accountCheck,
          recommendedPlan,
          profile,
          classrooms,
          categories
        };
      }), take(1));
    }
    static {
      this.ɵfac = function MeetingReferencesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MeetingReferencesService)(i0.ɵɵinject(AbstractConfigService), i0.ɵɵinject(AbstractLanguageService), i0.ɵɵinject(AbstractClassroomsService), i0.ɵɵinject(AbstractBillingService), i0.ɵɵinject(AbstractAccountService), i0.ɵɵinject(AbstractProfileService), i0.ɵɵinject(AbstractUserService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MeetingReferencesService,
        factory: MeetingReferencesService.ɵfac
      });
    }
  }
  return MeetingReferencesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Lingo2FormsModule = /*#__PURE__*/(() => {
  class Lingo2FormsModule {
    static forRoot(config) {
      return {
        ngModule: Lingo2FormsModule,
        providers: [config.accountService, config.billingService, config.billingV2Service, config.currencyService, config.classroomsService, config.userService, config.featuresService, config.authService, config.filesService, config.meetingsService, config.screenService, config.dropzoneConfig, config.languageService, config.configService, config.profileService, config.websocketService]
      };
    }
    static {
      this.ɵfac = function Lingo2FormsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Lingo2FormsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Lingo2FormsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [DeviceService, ConfigService, IconsService, ScreenService, PlatformService, MeetingReferencesService],
        imports: [CommonModule, SharedModule, FinancePlanBuyCreditsFormModule, FinancePlanBuyCreditsFormV2Module, AgreementTermsFieldModule, PaymentFormUniversalModule, FinancePlanBuyCreditsFormModule, FinancePlanBuyCreditsFormV2Module, PaywallWrapperModule]
      });
    }
  }
  return Lingo2FormsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractAccountService, AbstractAuthService, AbstractBillingService, AbstractBillingV2Service, AbstractClassroomsService, AbstractConfigService, AbstractCurrenciesService, AbstractDropzoneConfig, AbstractFeaturesService, AbstractFilesService, AbstractLanguageService, AbstractMeetingsService, AbstractProfileService, AbstractScreenService, AbstractUserService, AbstractWebsocketService, AgreementTermsFieldComponent, AgreementTermsFieldModule, AuthorItemComponent, BankCardType, CircleToSquareSpinnerComponent, ClockSpinnerComponent, FinancePlanActivateFormComponent, FinancePlanActivateFormModule, FinancePlanActivateFormV2Component, FinancePlanActivateFormV2Module, FinancePlanBuyCreditsFormComponent, FinancePlanBuyCreditsFormModule, FinancePlanBuyCreditsFormV2Component, FinancePlanBuyCreditsFormV2Module, FormErrorsComponent, FormErrorsModule, FormFieldComponent, FormFieldModule, IconComponent, IconModule, Lingo2FormsModule, LoadingBarComponent, LoadingLineComponent, MeetingChargingPreviewComponent, MeetingFormComponent, MeetingFormModule, MeetingHeaderComponent, MeetingReferencesService, MeetingSelectAuthorComponent, MeetingSelectAuthorModule, MeetingSelectClassComponent, MeetingSelectClassModule, MeetingSelectPresetComponent, NotAvailableTimeInformerComponent, PaymentFormCardSelectorComponent, PaymentFormCardSelectorModule, PaymentFormUniversalComponent, PaymentFormUniversalModule, PaywallWrapperComponent, PaywallWrapperModule, PlansCheckoutWizardDialogComponent, PlansCheckoutWizardDialogModule, PresetTypeEnum, Spinner1Component, Spinner2Component, Spinner3Component, SpinnersModule, SubjectSelectorComponent, SubjectSelectorModule, TabsEnum, teachableStatues, timezone, timezoneOffsetToHours };
